(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredea3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredea3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("el0Ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $a703babb3d7b9465$export$2e2bcd8739ae039);
/*!
 * Chartkick.js v5.0.1
 * Create beautiful charts with one line of JavaScript
 * https://github.com/ankane/chartkick.js
 * MIT License
 */ function $a703babb3d7b9465$var$isArray(variable) {
    return Object.prototype.toString.call(variable) === "[object Array]";
}
function $a703babb3d7b9465$var$isFunction(variable) {
    return variable instanceof Function;
}
function $a703babb3d7b9465$var$isPlainObject(variable) {
    // protect against prototype pollution, defense 2
    return Object.prototype.toString.call(variable) === "[object Object]" && !$a703babb3d7b9465$var$isFunction(variable) && variable instanceof Object;
}
// https://github.com/madrobby/zepto/blob/master/src/zepto.js
function $a703babb3d7b9465$var$extend(target, source) {
    for(var key in source){
        // protect against prototype pollution, defense 1
        if (key === "__proto__") continue;
        if ($a703babb3d7b9465$var$isPlainObject(source[key]) || $a703babb3d7b9465$var$isArray(source[key])) {
            if ($a703babb3d7b9465$var$isPlainObject(source[key]) && !$a703babb3d7b9465$var$isPlainObject(target[key])) target[key] = {};
            if ($a703babb3d7b9465$var$isArray(source[key]) && !$a703babb3d7b9465$var$isArray(target[key])) target[key] = [];
            $a703babb3d7b9465$var$extend(target[key], source[key]);
        } else if (source[key] !== undefined) target[key] = source[key];
    }
}
function $a703babb3d7b9465$var$merge(obj1, obj2) {
    var target = {};
    $a703babb3d7b9465$var$extend(target, obj1);
    $a703babb3d7b9465$var$extend(target, obj2);
    return target;
}
var $a703babb3d7b9465$var$DATE_PATTERN = /^(\d\d\d\d)(?:-)?(\d\d)(?:-)?(\d\d)$/i;
function $a703babb3d7b9465$var$negativeValues(series) {
    for(var i = 0; i < series.length; i++){
        var data = series[i].data;
        for(var j = 0; j < data.length; j++){
            if (data[j][1] < 0) return true;
        }
    }
    return false;
}
function $a703babb3d7b9465$var$toStr(obj) {
    return "" + obj;
}
function $a703babb3d7b9465$var$toFloat(obj) {
    return parseFloat(obj);
}
function $a703babb3d7b9465$var$toDate(obj) {
    if (obj instanceof Date) return obj;
    else if (typeof obj === "number") return new Date(obj * 1000); // ms
    else {
        var s = $a703babb3d7b9465$var$toStr(obj);
        var matches = s.match($a703babb3d7b9465$var$DATE_PATTERN);
        if (matches) {
            var year = parseInt(matches[1], 10);
            var month = parseInt(matches[2], 10) - 1;
            var day = parseInt(matches[3], 10);
            return new Date(year, month, day);
        } else {
            // try our best to get the str into iso8601
            // TODO be smarter about this
            var str = s.replace(/ /, "T").replace(" ", "").replace("UTC", "Z");
            // Date.parse returns milliseconds if valid and NaN if invalid
            return new Date(Date.parse(str) || s);
        }
    }
}
function $a703babb3d7b9465$var$toArr(obj) {
    if ($a703babb3d7b9465$var$isArray(obj)) return obj;
    else {
        var arr = [];
        for(var i in obj)if (Object.prototype.hasOwnProperty.call(obj, i)) arr.push([
            i,
            obj[i]
        ]);
        return arr;
    }
}
function $a703babb3d7b9465$var$jsOptionsFunc(defaultOptions, hideLegend, setTitle, setMin, setMax, setStacked, setXtitle, setYtitle) {
    return function(chart, opts, chartOptions) {
        var series = chart.data;
        var options = $a703babb3d7b9465$var$merge({}, defaultOptions);
        options = $a703babb3d7b9465$var$merge(options, chartOptions || {});
        if (chart.singleSeriesFormat || "legend" in opts) hideLegend(options, opts.legend, chart.singleSeriesFormat);
        if (opts.title) setTitle(options, opts.title);
        // min
        if ("min" in opts) setMin(options, opts.min);
        else if (!$a703babb3d7b9465$var$negativeValues(series)) setMin(options, 0);
        // max
        if (opts.max) setMax(options, opts.max);
        if ("stacked" in opts) setStacked(options, opts.stacked);
        if (opts.colors) options.colors = opts.colors;
        if (opts.xtitle) setXtitle(options, opts.xtitle);
        if (opts.ytitle) setYtitle(options, opts.ytitle);
        // merge library last
        options = $a703babb3d7b9465$var$merge(options, opts.library || {});
        return options;
    };
}
function $a703babb3d7b9465$var$sortByTime(a, b) {
    return a[0].getTime() - b[0].getTime();
}
function $a703babb3d7b9465$var$sortByNumberSeries(a, b) {
    return a[0] - b[0];
}
// needed since sort() without arguments does string comparison
function $a703babb3d7b9465$var$sortByNumber(a, b) {
    return a - b;
}
function $a703babb3d7b9465$var$every(values, fn) {
    for(var i = 0; i < values.length; i++){
        if (!fn(values[i])) return false;
    }
    return true;
}
function $a703babb3d7b9465$var$isDay(timeUnit) {
    return timeUnit === "day" || timeUnit === "week" || timeUnit === "month" || timeUnit === "year";
}
function $a703babb3d7b9465$var$calculateTimeUnit(values, maxDay) {
    if (maxDay === void 0) maxDay = false;
    if (values.length === 0) return null;
    var minute = $a703babb3d7b9465$var$every(values, function(d) {
        return d.getMilliseconds() === 0 && d.getSeconds() === 0;
    });
    if (!minute) return null;
    var hour = $a703babb3d7b9465$var$every(values, function(d) {
        return d.getMinutes() === 0;
    });
    if (!hour) return "minute";
    var day = $a703babb3d7b9465$var$every(values, function(d) {
        return d.getHours() === 0;
    });
    if (!day) return "hour";
    if (maxDay) return "day";
    var month = $a703babb3d7b9465$var$every(values, function(d) {
        return d.getDate() === 1;
    });
    if (!month) {
        var dayOfWeek = values[0].getDay();
        var week = $a703babb3d7b9465$var$every(values, function(d) {
            return d.getDay() === dayOfWeek;
        });
        return week ? "week" : "day";
    }
    var year = $a703babb3d7b9465$var$every(values, function(d) {
        return d.getMonth() === 0;
    });
    if (!year) return "month";
    return "year";
}
function $a703babb3d7b9465$var$isDate(obj) {
    return !isNaN($a703babb3d7b9465$var$toDate(obj)) && $a703babb3d7b9465$var$toStr(obj).length >= 6;
}
function $a703babb3d7b9465$var$isNumber(obj) {
    return typeof obj === "number";
}
var $a703babb3d7b9465$var$byteSuffixes = [
    "bytes",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB",
    "EB"
];
function $a703babb3d7b9465$var$formatValue(pre, value, options, axis) {
    pre = pre || "";
    if (options.prefix) {
        if (value < 0) {
            value = value * -1;
            pre += "-";
        }
        pre += options.prefix;
    }
    var suffix = options.suffix || "";
    var precision = options.precision;
    var round = options.round;
    if (options.byteScale) {
        var positive = value >= 0;
        if (!positive) value *= -1;
        var baseValue = axis ? options.byteScale : value;
        var suffixIdx;
        if (baseValue >= 1152921504606846976) {
            value /= 1152921504606846976;
            suffixIdx = 6;
        } else if (baseValue >= 1125899906842624) {
            value /= 1125899906842624;
            suffixIdx = 5;
        } else if (baseValue >= 1099511627776) {
            value /= 1099511627776;
            suffixIdx = 4;
        } else if (baseValue >= 1073741824) {
            value /= 1073741824;
            suffixIdx = 3;
        } else if (baseValue >= 1048576) {
            value /= 1048576;
            suffixIdx = 2;
        } else if (baseValue >= 1024) {
            value /= 1024;
            suffixIdx = 1;
        } else suffixIdx = 0;
        // TODO handle manual precision case
        if (precision === undefined && round === undefined) {
            if (value >= 1023.5) {
                if (suffixIdx < $a703babb3d7b9465$var$byteSuffixes.length - 1) {
                    value = 1.0;
                    suffixIdx += 1;
                }
            }
            precision = value >= 1000 ? 4 : 3;
        }
        suffix = " " + $a703babb3d7b9465$var$byteSuffixes[suffixIdx];
        // flip value back
        if (!positive) value *= -1;
    }
    if (precision !== undefined && round !== undefined) throw Error("Use either round or precision, not both");
    if (!axis) {
        if (precision !== undefined) {
            value = value.toPrecision(precision);
            if (!options.zeros) value = parseFloat(value);
        }
        if (round !== undefined) {
            if (round < 0) {
                var num = Math.pow(10, -1 * round);
                value = parseInt((1.0 * value / num).toFixed(0)) * num;
            } else {
                value = value.toFixed(round);
                if (!options.zeros) value = parseFloat(value);
            }
        }
    }
    if (options.thousands || options.decimal) {
        value = $a703babb3d7b9465$var$toStr(value);
        var parts = value.split(".");
        value = parts[0];
        if (options.thousands) value = value.replace(/\B(?=(\d{3})+(?!\d))/g, options.thousands);
        if (parts.length > 1) value += (options.decimal || ".") + parts[1];
    }
    return pre + value + suffix;
}
function $a703babb3d7b9465$var$seriesOption(chart, series, option) {
    if (option in series) return series[option];
    else if (option in chart.options) return chart.options[option];
    return null;
}
var $a703babb3d7b9465$var$baseOptions = {
    maintainAspectRatio: false,
    animation: false,
    plugins: {
        legend: {},
        tooltip: {
            displayColors: false,
            callbacks: {}
        },
        title: {
            font: {
                size: 20
            },
            color: "#333"
        }
    },
    interaction: {}
};
var $a703babb3d7b9465$var$defaultOptions$2 = {
    scales: {
        y: {
            ticks: {
                maxTicksLimit: 4
            },
            title: {
                font: {
                    size: 16
                },
                color: "#333"
            },
            grid: {}
        },
        x: {
            grid: {
                drawOnChartArea: false
            },
            title: {
                font: {
                    size: 16
                },
                color: "#333"
            },
            time: {},
            ticks: {}
        }
    }
};
// http://there4.io/2012/05/02/google-chart-color-list/
var $a703babb3d7b9465$var$defaultColors = [
    "#3366CC",
    "#DC3912",
    "#FF9900",
    "#109618",
    "#990099",
    "#3B3EAC",
    "#0099C6",
    "#DD4477",
    "#66AA00",
    "#B82E2E",
    "#316395",
    "#994499",
    "#22AA99",
    "#AAAA11",
    "#6633CC",
    "#E67300",
    "#8B0707",
    "#329262",
    "#5574A6",
    "#651067"
];
function $a703babb3d7b9465$var$hideLegend$2(options, legend, hideLegend) {
    if (legend !== undefined) {
        options.plugins.legend.display = !!legend;
        if (legend && legend !== true) options.plugins.legend.position = legend;
    } else if (hideLegend) options.plugins.legend.display = false;
}
function $a703babb3d7b9465$var$setTitle$2(options, title) {
    options.plugins.title.display = true;
    options.plugins.title.text = title;
}
function $a703babb3d7b9465$var$setMin$2(options, min) {
    if (min !== null) options.scales.y.min = $a703babb3d7b9465$var$toFloat(min);
}
function $a703babb3d7b9465$var$setMax$2(options, max) {
    options.scales.y.max = $a703babb3d7b9465$var$toFloat(max);
}
function $a703babb3d7b9465$var$setBarMin$1(options, min) {
    if (min !== null) options.scales.x.min = $a703babb3d7b9465$var$toFloat(min);
}
function $a703babb3d7b9465$var$setBarMax$1(options, max) {
    options.scales.x.max = $a703babb3d7b9465$var$toFloat(max);
}
function $a703babb3d7b9465$var$setStacked$2(options, stacked) {
    options.scales.x.stacked = !!stacked;
    options.scales.y.stacked = !!stacked;
}
function $a703babb3d7b9465$var$setXtitle$2(options, title) {
    options.scales.x.title.display = true;
    options.scales.x.title.text = title;
}
function $a703babb3d7b9465$var$setYtitle$2(options, title) {
    options.scales.y.title.display = true;
    options.scales.y.title.text = title;
}
// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
function $a703babb3d7b9465$var$addOpacity(hex, opacity) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? "rgba(" + parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " + parseInt(result[3], 16) + ", " + opacity + ")" : hex;
}
function $a703babb3d7b9465$var$notnull(x) {
    return x !== null && x !== undefined;
}
function $a703babb3d7b9465$var$setLabelSize(chart, data, options) {
    var maxLabelSize = Math.ceil(chart.element.offsetWidth / 4.0 / data.labels.length);
    if (maxLabelSize > 25) maxLabelSize = 25;
    else if (maxLabelSize < 10) maxLabelSize = 10;
    if (!options.scales.x.ticks.callback) options.scales.x.ticks.callback = function(value) {
        value = $a703babb3d7b9465$var$toStr(this.getLabelForValue(value));
        if (value.length > maxLabelSize) return value.substring(0, maxLabelSize - 2) + "...";
        else return value;
    };
}
function $a703babb3d7b9465$var$calculateScale(series) {
    var scale = 1;
    var max = $a703babb3d7b9465$var$maxAbsY(series);
    while(max >= 1024){
        scale *= 1024;
        max /= 1024;
    }
    return scale;
}
function $a703babb3d7b9465$var$setFormatOptions$1(chart, options, chartType) {
    // options to apply to x and r values for scatter and bubble
    var numericOptions = {
        thousands: chart.options.thousands,
        decimal: chart.options.decimal
    };
    // options to apply to y value
    var formatOptions = $a703babb3d7b9465$var$merge({
        prefix: chart.options.prefix,
        suffix: chart.options.suffix,
        precision: chart.options.precision,
        round: chart.options.round,
        zeros: chart.options.zeros
    }, numericOptions);
    if (chart.options.bytes) {
        var series = chart.data;
        if (chartType === "pie") series = [
            {
                data: series
            }
        ];
        // set step size
        formatOptions.byteScale = $a703babb3d7b9465$var$calculateScale(series);
    }
    if (chartType !== "pie") {
        var axis = options.scales.y;
        if (chartType === "bar") axis = options.scales.x;
        if (formatOptions.byteScale) {
            if (!axis.ticks.stepSize) axis.ticks.stepSize = formatOptions.byteScale / 2;
            if (!axis.ticks.maxTicksLimit) axis.ticks.maxTicksLimit = 4;
        }
        if (!axis.ticks.callback) axis.ticks.callback = function(value) {
            return $a703babb3d7b9465$var$formatValue("", value, formatOptions, true);
        };
        if ((chartType === "scatter" || chartType === "bubble") && !options.scales.x.ticks.callback) options.scales.x.ticks.callback = function(value) {
            return $a703babb3d7b9465$var$formatValue("", value, numericOptions, true);
        };
    }
    if (!options.plugins.tooltip.callbacks.label) {
        if (chartType === "scatter") options.plugins.tooltip.callbacks.label = function(context) {
            var label = context.dataset.label || '';
            if (label) label += ': ';
            var dataPoint = context.parsed;
            return label + '(' + $a703babb3d7b9465$var$formatValue('', dataPoint.x, numericOptions) + ', ' + $a703babb3d7b9465$var$formatValue('', dataPoint.y, formatOptions) + ')';
        };
        else if (chartType === "bubble") options.plugins.tooltip.callbacks.label = function(context) {
            var label = context.dataset.label || '';
            if (label) label += ': ';
            var dataPoint = context.raw;
            return label + '(' + $a703babb3d7b9465$var$formatValue('', dataPoint.x, numericOptions) + ', ' + $a703babb3d7b9465$var$formatValue('', dataPoint.y, formatOptions) + ', ' + $a703babb3d7b9465$var$formatValue('', dataPoint.v, numericOptions) + ')';
        };
        else if (chartType === "pie") // need to use separate label for pie charts
        options.plugins.tooltip.callbacks.label = function(context) {
            return $a703babb3d7b9465$var$formatValue('', context.parsed, formatOptions);
        };
        else {
            var valueLabel = chartType === "bar" ? "x" : "y";
            options.plugins.tooltip.callbacks.label = function(context) {
                // don't show null values for stacked charts
                if (context.parsed[valueLabel] === null) return;
                var label = context.dataset.label || '';
                if (label) label += ': ';
                return $a703babb3d7b9465$var$formatValue(label, context.parsed[valueLabel], formatOptions);
            };
        }
    }
    // avoid formatting x-axis labels
    // by default, Chart.js applies locale
    if ((chartType === "line" || chartType === "area") && chart.xtype === "number") {
        if (!options.scales.x.ticks.callback) options.scales.x.ticks.callback = function(value) {
            return $a703babb3d7b9465$var$toStr(value);
        };
        if (!options.plugins.tooltip.callbacks.title) options.plugins.tooltip.callbacks.title = function(context) {
            return $a703babb3d7b9465$var$toStr(context[0].parsed.x);
        };
    }
}
function $a703babb3d7b9465$var$maxAbsY(series) {
    var max = 0;
    for(var i = 0; i < series.length; i++){
        var data = series[i].data;
        for(var j = 0; j < data.length; j++){
            var v = Math.abs(data[j][1]);
            if (v > max) max = v;
        }
    }
    return max;
}
function $a703babb3d7b9465$var$maxR(series) {
    // start at zero since radius must be positive
    var max = 0;
    for(var i = 0; i < series.length; i++){
        var data = series[i].data;
        for(var j = 0; j < data.length; j++){
            var v = data[j][2];
            if (v > max) max = v;
        }
    }
    return max;
}
var $a703babb3d7b9465$var$jsOptions$2 = $a703babb3d7b9465$var$jsOptionsFunc($a703babb3d7b9465$var$merge($a703babb3d7b9465$var$baseOptions, $a703babb3d7b9465$var$defaultOptions$2), $a703babb3d7b9465$var$hideLegend$2, $a703babb3d7b9465$var$setTitle$2, $a703babb3d7b9465$var$setMin$2, $a703babb3d7b9465$var$setMax$2, $a703babb3d7b9465$var$setStacked$2, $a703babb3d7b9465$var$setXtitle$2, $a703babb3d7b9465$var$setYtitle$2);
function $a703babb3d7b9465$var$prepareDefaultData(chart) {
    var series = chart.data;
    var rows = {};
    var keys = [];
    var labels = [];
    var values = [];
    for(var i = 0; i < series.length; i++){
        var data = series[i].data;
        for(var j = 0; j < data.length; j++){
            var d = data[j];
            var key = chart.xtype === "datetime" ? d[0].getTime() : d[0];
            if (!rows[key]) {
                rows[key] = new Array(series.length);
                keys.push(key);
            }
            rows[key][i] = d[1];
        }
    }
    if (chart.xtype === "datetime" || chart.xtype === "number") keys.sort($a703babb3d7b9465$var$sortByNumber);
    for(var i$1 = 0; i$1 < series.length; i$1++)values.push([]);
    for(var i$2 = 0; i$2 < keys.length; i$2++){
        var key$1 = keys[i$2];
        var label = chart.xtype === "datetime" ? new Date(key$1) : key$1;
        labels.push(label);
        var row = rows[key$1];
        for(var j$1 = 0; j$1 < series.length; j$1++){
            var v = row[j$1];
            // Chart.js doesn't like undefined
            values[j$1].push(v === undefined ? null : v);
        }
    }
    return {
        labels: labels,
        values: values
    };
}
function $a703babb3d7b9465$var$prepareBubbleData(chart) {
    var series = chart.data;
    var values = [];
    var max = $a703babb3d7b9465$var$maxR(series);
    for(var i = 0; i < series.length; i++){
        var data = series[i].data;
        var points = [];
        for(var j = 0; j < data.length; j++){
            var v = data[j];
            points.push({
                x: v[0],
                y: v[1],
                r: v[2] * 20 / max,
                // custom attribute, for tooltip
                v: v[2]
            });
        }
        values.push(points);
    }
    return {
        labels: [],
        values: values
    };
}
// scatter or numeric line/area
function $a703babb3d7b9465$var$prepareNumberData(chart) {
    var series = chart.data;
    var values = [];
    for(var i = 0; i < series.length; i++){
        var data = series[i].data;
        data.sort($a703babb3d7b9465$var$sortByNumberSeries);
        var points = [];
        for(var j = 0; j < data.length; j++){
            var v = data[j];
            points.push({
                x: v[0],
                y: v[1]
            });
        }
        values.push(points);
    }
    return {
        labels: [],
        values: values
    };
}
function $a703babb3d7b9465$var$prepareData(chart, chartType) {
    if (chartType === "bubble") return $a703babb3d7b9465$var$prepareBubbleData(chart);
    else if (chart.xtype === "number" && chartType !== "bar" && chartType !== "column") return $a703babb3d7b9465$var$prepareNumberData(chart);
    else return $a703babb3d7b9465$var$prepareDefaultData(chart);
}
function $a703babb3d7b9465$var$createDataTable(chart, options, chartType) {
    var ref = $a703babb3d7b9465$var$prepareData(chart, chartType);
    var labels = ref.labels;
    var values = ref.values;
    var series = chart.data;
    var datasets = [];
    var colors = chart.options.colors || $a703babb3d7b9465$var$defaultColors;
    for(var i = 0; i < series.length; i++){
        var s = series[i];
        // use colors for each bar for single series format
        var color = void 0;
        var backgroundColor = void 0;
        if (chart.options.colors && chart.singleSeriesFormat && (chartType === "bar" || chartType === "column") && !s.color && $a703babb3d7b9465$var$isArray(chart.options.colors) && !$a703babb3d7b9465$var$isArray(chart.options.colors[0])) {
            color = colors;
            backgroundColor = [];
            for(var j = 0; j < colors.length; j++)backgroundColor[j] = $a703babb3d7b9465$var$addOpacity(color[j], 0.5);
        } else {
            color = s.color || colors[i];
            backgroundColor = chartType !== "line" ? $a703babb3d7b9465$var$addOpacity(color, 0.5) : color;
        }
        var dataset = {
            label: s.name || "",
            data: values[i],
            fill: chartType === "area",
            borderColor: color,
            backgroundColor: backgroundColor,
            borderWidth: 2
        };
        var pointChart = chartType === "line" || chartType === "area" || chartType === "scatter" || chartType === "bubble";
        if (pointChart) {
            dataset.pointBackgroundColor = color;
            dataset.pointHoverBackgroundColor = color;
            dataset.pointHitRadius = 50;
        }
        if (chartType === "bubble") {
            dataset.pointBackgroundColor = backgroundColor;
            dataset.pointHoverBackgroundColor = backgroundColor;
            dataset.pointHoverBorderWidth = 2;
        }
        if (s.stack) dataset.stack = s.stack;
        var curve = $a703babb3d7b9465$var$seriesOption(chart, s, "curve");
        if (curve === false) dataset.tension = 0;
        else if (pointChart) dataset.tension = 0.4;
        var points = $a703babb3d7b9465$var$seriesOption(chart, s, "points");
        if (points === false) {
            dataset.pointRadius = 0;
            dataset.pointHoverRadius = 0;
        }
        dataset = $a703babb3d7b9465$var$merge(dataset, chart.options.dataset || {});
        dataset = $a703babb3d7b9465$var$merge(dataset, s.library || {});
        dataset = $a703babb3d7b9465$var$merge(dataset, s.dataset || {});
        datasets.push(dataset);
    }
    var xmin = chart.options.xmin;
    var xmax = chart.options.xmax;
    if (chart.xtype === "datetime") {
        if ($a703babb3d7b9465$var$notnull(xmin)) options.scales.x.min = $a703babb3d7b9465$var$toDate(xmin).getTime();
        if ($a703babb3d7b9465$var$notnull(xmax)) options.scales.x.max = $a703babb3d7b9465$var$toDate(xmax).getTime();
    } else if (chart.xtype === "number") {
        if ($a703babb3d7b9465$var$notnull(xmin)) options.scales.x.min = xmin;
        if ($a703babb3d7b9465$var$notnull(xmax)) options.scales.x.max = xmax;
    }
    if (chart.xtype === "datetime") {
        var timeUnit = $a703babb3d7b9465$var$calculateTimeUnit(labels);
        // for empty datetime chart
        if (labels.length === 0) {
            if ($a703babb3d7b9465$var$notnull(xmin)) labels.push($a703babb3d7b9465$var$toDate(xmin));
            if ($a703babb3d7b9465$var$notnull(xmax)) labels.push($a703babb3d7b9465$var$toDate(xmax));
        }
        if (labels.length > 0) {
            var minTime = ($a703babb3d7b9465$var$notnull(xmin) ? $a703babb3d7b9465$var$toDate(xmin) : labels[0]).getTime();
            var maxTime = ($a703babb3d7b9465$var$notnull(xmax) ? $a703babb3d7b9465$var$toDate(xmax) : labels[0]).getTime();
            for(var i$1 = 1; i$1 < labels.length; i$1++){
                var value = labels[i$1].getTime();
                if (value < minTime) minTime = value;
                if (value > maxTime) maxTime = value;
            }
            var timeDiff = (maxTime - minTime) / 86400000;
            if (!options.scales.x.time.unit) {
                var step;
                if (timeUnit === "year" || timeDiff > 3650) {
                    options.scales.x.time.unit = "year";
                    step = 365;
                } else if (timeUnit === "month" || timeDiff > 300) {
                    options.scales.x.time.unit = "month";
                    step = 30;
                } else if (timeUnit === "week" || timeUnit === "day" || timeDiff > 10) {
                    options.scales.x.time.unit = "day";
                    step = 1;
                } else if (timeUnit === "hour" || timeDiff > 0.5) {
                    options.scales.x.time.displayFormats = {
                        hour: "MMM d, h a"
                    };
                    options.scales.x.time.unit = "hour";
                    step = 1 / 24.0;
                } else if (timeUnit === "minute") {
                    options.scales.x.time.displayFormats = {
                        minute: "h:mm a"
                    };
                    options.scales.x.time.unit = "minute";
                    step = 1 / 24.0 / 60.0;
                }
                if (step && timeDiff > 0) {
                    // width not available for hidden elements
                    var width = chart.element.offsetWidth;
                    if (width > 0) {
                        var unitStepSize = Math.ceil(timeDiff / step / (width / 100.0));
                        if (timeUnit === "week" && step === 1) unitStepSize = Math.ceil(unitStepSize / 7.0) * 7;
                        options.scales.x.ticks.stepSize = unitStepSize;
                    }
                }
            }
            if (!options.scales.x.time.tooltipFormat) {
                if (timeUnit === "year") options.scales.x.time.tooltipFormat = "yyyy";
                else if (timeUnit === "month") options.scales.x.time.tooltipFormat = "MMM yyyy";
                else if (timeUnit === "week" || timeUnit === "day") options.scales.x.time.tooltipFormat = "PP";
                else if (timeUnit === "hour") options.scales.x.time.tooltipFormat = "MMM d, h a";
                else if (timeUnit === "minute") options.scales.x.time.tooltipFormat = "h:mm a";
            }
        }
    }
    return {
        labels: labels,
        datasets: datasets
    };
}
var $a703babb3d7b9465$var$defaultExport$2 = function defaultExport(library) {
    this.name = "chartjs";
    this.library = library;
};
$a703babb3d7b9465$var$defaultExport$2.prototype.renderLineChart = function renderLineChart(chart, chartType) {
    if (!chartType) chartType = "line";
    var chartOptions = {};
    var options = $a703babb3d7b9465$var$jsOptions$2(chart, $a703babb3d7b9465$var$merge(chartOptions, chart.options));
    $a703babb3d7b9465$var$setFormatOptions$1(chart, options, chartType);
    var data = $a703babb3d7b9465$var$createDataTable(chart, options, chartType);
    if (chart.xtype === "number") {
        options.scales.x.type = options.scales.x.type || "linear";
        options.scales.x.position = options.scales.x.position || "bottom";
    } else options.scales.x.type = chart.xtype === "string" ? "category" : "time";
    this.drawChart(chart, "line", data, options);
};
$a703babb3d7b9465$var$defaultExport$2.prototype.renderPieChart = function renderPieChart(chart) {
    var options = $a703babb3d7b9465$var$merge({}, $a703babb3d7b9465$var$baseOptions);
    if (chart.options.donut) options.cutout = "50%";
    if ("legend" in chart.options) $a703babb3d7b9465$var$hideLegend$2(options, chart.options.legend);
    if (chart.options.title) $a703babb3d7b9465$var$setTitle$2(options, chart.options.title);
    options = $a703babb3d7b9465$var$merge(options, chart.options.library || {});
    $a703babb3d7b9465$var$setFormatOptions$1(chart, options, "pie");
    var labels = [];
    var values = [];
    for(var i = 0; i < chart.data.length; i++){
        var point = chart.data[i];
        labels.push(point[0]);
        values.push(point[1]);
    }
    var dataset = {
        data: values,
        backgroundColor: chart.options.colors || $a703babb3d7b9465$var$defaultColors
    };
    dataset = $a703babb3d7b9465$var$merge(dataset, chart.options.dataset || {});
    var data = {
        labels: labels,
        datasets: [
            dataset
        ]
    };
    this.drawChart(chart, "pie", data, options);
};
$a703babb3d7b9465$var$defaultExport$2.prototype.renderColumnChart = function renderColumnChart(chart, chartType) {
    var options;
    if (chartType === "bar") {
        var barOptions = $a703babb3d7b9465$var$merge($a703babb3d7b9465$var$baseOptions, $a703babb3d7b9465$var$defaultOptions$2);
        barOptions.indexAxis = "y";
        // ensure gridlines have proper orientation
        barOptions.scales.x.grid.drawOnChartArea = true;
        barOptions.scales.y.grid.drawOnChartArea = false;
        delete barOptions.scales.y.ticks.maxTicksLimit;
        options = $a703babb3d7b9465$var$jsOptionsFunc(barOptions, $a703babb3d7b9465$var$hideLegend$2, $a703babb3d7b9465$var$setTitle$2, $a703babb3d7b9465$var$setBarMin$1, $a703babb3d7b9465$var$setBarMax$1, $a703babb3d7b9465$var$setStacked$2, $a703babb3d7b9465$var$setXtitle$2, $a703babb3d7b9465$var$setYtitle$2)(chart, chart.options);
    } else options = $a703babb3d7b9465$var$jsOptions$2(chart, chart.options);
    $a703babb3d7b9465$var$setFormatOptions$1(chart, options, chartType);
    var data = $a703babb3d7b9465$var$createDataTable(chart, options, "column");
    if (chartType !== "bar") $a703babb3d7b9465$var$setLabelSize(chart, data, options);
    if (!("mode" in options.interaction)) options.interaction.mode = "index";
    this.drawChart(chart, "bar", data, options);
};
$a703babb3d7b9465$var$defaultExport$2.prototype.renderAreaChart = function renderAreaChart(chart) {
    this.renderLineChart(chart, "area");
};
$a703babb3d7b9465$var$defaultExport$2.prototype.renderBarChart = function renderBarChart(chart) {
    this.renderColumnChart(chart, "bar");
};
$a703babb3d7b9465$var$defaultExport$2.prototype.renderScatterChart = function renderScatterChart(chart, chartType) {
    chartType = chartType || "scatter";
    var options = $a703babb3d7b9465$var$jsOptions$2(chart, chart.options);
    $a703babb3d7b9465$var$setFormatOptions$1(chart, options, chartType);
    if (!("showLine" in options)) options.showLine = false;
    var data = $a703babb3d7b9465$var$createDataTable(chart, options, chartType);
    options.scales.x.type = options.scales.x.type || "linear";
    options.scales.x.position = options.scales.x.position || "bottom";
    // prevent grouping hover and tooltips
    if (!("mode" in options.interaction)) options.interaction.mode = "nearest";
    this.drawChart(chart, chartType, data, options);
};
$a703babb3d7b9465$var$defaultExport$2.prototype.renderBubbleChart = function renderBubbleChart(chart) {
    this.renderScatterChart(chart, "bubble");
};
$a703babb3d7b9465$var$defaultExport$2.prototype.destroy = function destroy(chart) {
    if (chart.chart) chart.chart.destroy();
};
$a703babb3d7b9465$var$defaultExport$2.prototype.drawChart = function drawChart(chart, type, data, options) {
    this.destroy(chart);
    if (chart.destroyed) return;
    var chartOptions = {
        type: type,
        data: data,
        options: options
    };
    if (chart.options.code) window.console.log("new Chart(ctx, " + JSON.stringify(chartOptions) + ");");
    chart.element.innerHTML = "<canvas></canvas>";
    var ctx = chart.element.getElementsByTagName("CANVAS")[0];
    chart.chart = new this.library(ctx, chartOptions);
};
var $a703babb3d7b9465$var$defaultOptions$1 = {
    chart: {},
    xAxis: {
        title: {
            text: null
        },
        labels: {
            style: {
                fontSize: "12px"
            }
        }
    },
    yAxis: {
        title: {
            text: null
        },
        labels: {
            style: {
                fontSize: "12px"
            }
        }
    },
    title: {
        text: null
    },
    credits: {
        enabled: false
    },
    legend: {
        borderWidth: 0
    },
    tooltip: {
        style: {
            fontSize: "12px"
        }
    },
    plotOptions: {
        areaspline: {},
        area: {},
        series: {
            marker: {}
        }
    },
    time: {
        useUTC: false
    }
};
function $a703babb3d7b9465$var$hideLegend$1(options, legend, hideLegend) {
    if (legend !== undefined) {
        options.legend.enabled = !!legend;
        if (legend && legend !== true) {
            if (legend === "top" || legend === "bottom") options.legend.verticalAlign = legend;
            else {
                options.legend.layout = "vertical";
                options.legend.verticalAlign = "middle";
                options.legend.align = legend;
            }
        }
    } else if (hideLegend) options.legend.enabled = false;
}
function $a703babb3d7b9465$var$setTitle$1(options, title) {
    options.title.text = title;
}
function $a703babb3d7b9465$var$setMin$1(options, min) {
    options.yAxis.min = min;
}
function $a703babb3d7b9465$var$setMax$1(options, max) {
    options.yAxis.max = max;
}
function $a703babb3d7b9465$var$setStacked$1(options, stacked) {
    var stackedValue = stacked ? stacked === true ? "normal" : stacked : null;
    options.plotOptions.series.stacking = stackedValue;
    options.plotOptions.area.stacking = stackedValue;
    options.plotOptions.areaspline.stacking = stackedValue;
}
function $a703babb3d7b9465$var$setXtitle$1(options, title) {
    options.xAxis.title.text = title;
}
function $a703babb3d7b9465$var$setYtitle$1(options, title) {
    options.yAxis.title.text = title;
}
var $a703babb3d7b9465$var$jsOptions$1 = $a703babb3d7b9465$var$jsOptionsFunc($a703babb3d7b9465$var$defaultOptions$1, $a703babb3d7b9465$var$hideLegend$1, $a703babb3d7b9465$var$setTitle$1, $a703babb3d7b9465$var$setMin$1, $a703babb3d7b9465$var$setMax$1, $a703babb3d7b9465$var$setStacked$1, $a703babb3d7b9465$var$setXtitle$1, $a703babb3d7b9465$var$setYtitle$1);
function $a703babb3d7b9465$var$setFormatOptions(chart, options, chartType) {
    var formatOptions = {
        prefix: chart.options.prefix,
        suffix: chart.options.suffix,
        thousands: chart.options.thousands,
        decimal: chart.options.decimal,
        precision: chart.options.precision,
        round: chart.options.round,
        zeros: chart.options.zeros
    };
    // skip when axis is an array (like with min/max)
    if (chartType !== "pie" && !$a703babb3d7b9465$var$isArray(options.yAxis) && !options.yAxis.labels.formatter) options.yAxis.labels.formatter = function() {
        return $a703babb3d7b9465$var$formatValue("", this.value, formatOptions);
    };
    if (!options.tooltip.pointFormatter && !options.tooltip.pointFormat) options.tooltip.pointFormatter = function() {
        return '<span style="color:' + this.color + '">\u25CF</span> ' + $a703babb3d7b9465$var$formatValue(this.series.name + ': <b>', this.y, formatOptions) + '</b><br/>';
    };
}
var $a703babb3d7b9465$var$defaultExport$1 = function defaultExport(library) {
    this.name = "highcharts";
    this.library = library;
};
$a703babb3d7b9465$var$defaultExport$1.prototype.renderLineChart = function renderLineChart(chart, chartType) {
    chartType = chartType || "spline";
    var chartOptions = {};
    if (chartType === "areaspline") chartOptions = {
        plotOptions: {
            areaspline: {
                stacking: "normal"
            },
            area: {
                stacking: "normal"
            },
            series: {
                marker: {
                    enabled: false
                }
            }
        }
    };
    if (chart.options.curve === false) {
        if (chartType === "areaspline") chartType = "area";
        else if (chartType === "spline") chartType = "line";
    }
    var options = $a703babb3d7b9465$var$jsOptions$1(chart, chart.options, chartOptions);
    if (chart.xtype === "number") options.xAxis.type = options.xAxis.type || "linear";
    else options.xAxis.type = chart.xtype === "string" ? "category" : "datetime";
    if (!options.chart.type) options.chart.type = chartType;
    $a703babb3d7b9465$var$setFormatOptions(chart, options, chartType);
    var series = chart.data;
    for(var i = 0; i < series.length; i++){
        series[i].name = series[i].name || "Value";
        var data = series[i].data;
        if (chart.xtype === "datetime") for(var j = 0; j < data.length; j++)data[j][0] = data[j][0].getTime();
        else if (chart.xtype === "number") data.sort($a703babb3d7b9465$var$sortByNumberSeries);
        series[i].marker = {
            symbol: "circle"
        };
        if (chart.options.points === false) series[i].marker.enabled = false;
    }
    this.drawChart(chart, series, options);
};
$a703babb3d7b9465$var$defaultExport$1.prototype.renderScatterChart = function renderScatterChart(chart) {
    var options = $a703babb3d7b9465$var$jsOptions$1(chart, chart.options, {});
    options.chart.type = "scatter";
    this.drawChart(chart, chart.data, options);
};
$a703babb3d7b9465$var$defaultExport$1.prototype.renderPieChart = function renderPieChart(chart) {
    var chartOptions = $a703babb3d7b9465$var$merge($a703babb3d7b9465$var$defaultOptions$1, {});
    if (chart.options.colors) chartOptions.colors = chart.options.colors;
    if (chart.options.donut) chartOptions.plotOptions = {
        pie: {
            innerSize: "50%"
        }
    };
    if ("legend" in chart.options) $a703babb3d7b9465$var$hideLegend$1(chartOptions, chart.options.legend);
    if (chart.options.title) $a703babb3d7b9465$var$setTitle$1(chartOptions, chart.options.title);
    var options = $a703babb3d7b9465$var$merge(chartOptions, chart.options.library || {});
    $a703babb3d7b9465$var$setFormatOptions(chart, options, "pie");
    var series = [
        {
            type: "pie",
            name: chart.options.label || "Value",
            data: chart.data
        }
    ];
    this.drawChart(chart, series, options);
};
$a703babb3d7b9465$var$defaultExport$1.prototype.renderColumnChart = function renderColumnChart(chart, chartType) {
    chartType = chartType || "column";
    var series = chart.data;
    var options = $a703babb3d7b9465$var$jsOptions$1(chart, chart.options);
    var rows = [];
    var categories = [];
    options.chart.type = chartType;
    $a703babb3d7b9465$var$setFormatOptions(chart, options, chartType);
    for(var i = 0; i < series.length; i++){
        var s = series[i];
        for(var j = 0; j < s.data.length; j++){
            var d = s.data[j];
            if (!rows[d[0]]) {
                rows[d[0]] = new Array(series.length);
                categories.push(d[0]);
            }
            rows[d[0]][i] = d[1];
        }
    }
    if (chart.xtype === "number") categories.sort($a703babb3d7b9465$var$sortByNumber);
    options.xAxis.categories = categories;
    var newSeries = [];
    for(var i$1 = 0; i$1 < series.length; i$1++){
        var d$1 = [];
        for(var j$1 = 0; j$1 < categories.length; j$1++)d$1.push(rows[categories[j$1]][i$1] || 0);
        var d2 = {
            name: series[i$1].name || "Value",
            data: d$1
        };
        if (series[i$1].stack) d2.stack = series[i$1].stack;
        newSeries.push(d2);
    }
    this.drawChart(chart, newSeries, options);
};
$a703babb3d7b9465$var$defaultExport$1.prototype.renderBarChart = function renderBarChart(chart) {
    this.renderColumnChart(chart, "bar");
};
$a703babb3d7b9465$var$defaultExport$1.prototype.renderAreaChart = function renderAreaChart(chart) {
    this.renderLineChart(chart, "areaspline");
};
$a703babb3d7b9465$var$defaultExport$1.prototype.destroy = function destroy(chart) {
    if (chart.chart) chart.chart.destroy();
};
$a703babb3d7b9465$var$defaultExport$1.prototype.drawChart = function drawChart(chart, data, options) {
    this.destroy(chart);
    if (chart.destroyed) return;
    options.chart.renderTo = chart.element.id;
    options.series = data;
    if (chart.options.code) window.console.log("new Highcharts.Chart(" + JSON.stringify(options) + ");");
    chart.chart = new this.library.Chart(options);
};
var $a703babb3d7b9465$var$loaded = {};
var $a703babb3d7b9465$var$callbacks = [];
// Set chart options
var $a703babb3d7b9465$var$defaultOptions = {
    chartArea: {},
    fontName: "'Lucida Grande', 'Lucida Sans Unicode', Verdana, Arial, Helvetica, sans-serif",
    pointSize: 6,
    legend: {
        textStyle: {
            fontSize: 12,
            color: "#444"
        },
        alignment: "center",
        position: "right"
    },
    curveType: "function",
    hAxis: {
        textStyle: {
            color: "#666",
            fontSize: 12
        },
        titleTextStyle: {},
        gridlines: {
            color: "transparent"
        },
        baselineColor: "#ccc",
        viewWindow: {}
    },
    vAxis: {
        textStyle: {
            color: "#666",
            fontSize: 12
        },
        titleTextStyle: {},
        baselineColor: "#ccc",
        viewWindow: {}
    },
    tooltip: {
        textStyle: {
            color: "#666",
            fontSize: 12
        }
    }
};
function $a703babb3d7b9465$var$hideLegend(options, legend, hideLegend) {
    if (legend !== undefined) {
        var position;
        if (!legend) position = "none";
        else if (legend === true) position = "right";
        else position = legend;
        options.legend.position = position;
    } else if (hideLegend) options.legend.position = "none";
}
function $a703babb3d7b9465$var$setTitle(options, title) {
    options.title = title;
    options.titleTextStyle = {
        color: "#333",
        fontSize: "20px"
    };
}
function $a703babb3d7b9465$var$setMin(options, min) {
    options.vAxis.viewWindow.min = min;
}
function $a703babb3d7b9465$var$setMax(options, max) {
    options.vAxis.viewWindow.max = max;
}
function $a703babb3d7b9465$var$setBarMin(options, min) {
    options.hAxis.viewWindow.min = min;
}
function $a703babb3d7b9465$var$setBarMax(options, max) {
    options.hAxis.viewWindow.max = max;
}
function $a703babb3d7b9465$var$setStacked(options, stacked) {
    options.isStacked = stacked || false;
}
function $a703babb3d7b9465$var$setXtitle(options, title) {
    options.hAxis.title = title;
    options.hAxis.titleTextStyle.italic = false;
}
function $a703babb3d7b9465$var$setYtitle(options, title) {
    options.vAxis.title = title;
    options.vAxis.titleTextStyle.italic = false;
}
var $a703babb3d7b9465$var$jsOptions = $a703babb3d7b9465$var$jsOptionsFunc($a703babb3d7b9465$var$defaultOptions, $a703babb3d7b9465$var$hideLegend, $a703babb3d7b9465$var$setTitle, $a703babb3d7b9465$var$setMin, $a703babb3d7b9465$var$setMax, $a703babb3d7b9465$var$setStacked, $a703babb3d7b9465$var$setXtitle, $a703babb3d7b9465$var$setYtitle);
function $a703babb3d7b9465$var$resize(callback) {
    if (window.attachEvent) window.attachEvent("onresize", callback);
    else if (window.addEventListener) window.addEventListener("resize", callback, true);
    callback();
}
var $a703babb3d7b9465$var$defaultExport = function defaultExport(library) {
    this.name = "google";
    this.library = library;
};
$a703babb3d7b9465$var$defaultExport.prototype.renderLineChart = function renderLineChart(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, function() {
        var chartOptions = {};
        if (chart.options.curve === false) chartOptions.curveType = "none";
        if (chart.options.points === false) chartOptions.pointSize = 0;
        var options = $a703babb3d7b9465$var$jsOptions(chart, chart.options, chartOptions);
        var data = this$1$1.createDataTable(chart.data, chart.xtype);
        this$1$1.drawChart(chart, "LineChart", data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.renderPieChart = function renderPieChart(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, function() {
        var chartOptions = {
            chartArea: {
                top: "10%",
                height: "80%"
            },
            legend: {}
        };
        if (chart.options.colors) chartOptions.colors = chart.options.colors;
        if (chart.options.donut) chartOptions.pieHole = 0.5;
        if ("legend" in chart.options) $a703babb3d7b9465$var$hideLegend(chartOptions, chart.options.legend);
        if (chart.options.title) $a703babb3d7b9465$var$setTitle(chartOptions, chart.options.title);
        var options = $a703babb3d7b9465$var$merge($a703babb3d7b9465$var$merge($a703babb3d7b9465$var$defaultOptions, chartOptions), chart.options.library || {});
        var data = new this$1$1.library.visualization.DataTable();
        data.addColumn("string", "");
        data.addColumn("number", "Value");
        data.addRows(chart.data);
        this$1$1.drawChart(chart, "PieChart", data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.renderColumnChart = function renderColumnChart(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, function() {
        var options = $a703babb3d7b9465$var$jsOptions(chart, chart.options);
        var data = this$1$1.createDataTable(chart.data, chart.xtype);
        this$1$1.drawChart(chart, "ColumnChart", data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.renderBarChart = function renderBarChart(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, function() {
        var chartOptions = {
            hAxis: {
                gridlines: {
                    color: "#ccc"
                }
            }
        };
        var options = $a703babb3d7b9465$var$jsOptionsFunc($a703babb3d7b9465$var$defaultOptions, $a703babb3d7b9465$var$hideLegend, $a703babb3d7b9465$var$setTitle, $a703babb3d7b9465$var$setBarMin, $a703babb3d7b9465$var$setBarMax, $a703babb3d7b9465$var$setStacked, $a703babb3d7b9465$var$setXtitle, $a703babb3d7b9465$var$setYtitle)(chart, chart.options, chartOptions);
        var data = this$1$1.createDataTable(chart.data, chart.xtype);
        this$1$1.drawChart(chart, "BarChart", data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.renderAreaChart = function renderAreaChart(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, function() {
        var chartOptions = {
            isStacked: true,
            pointSize: 0,
            areaOpacity: 0.5
        };
        var options = $a703babb3d7b9465$var$jsOptions(chart, chart.options, chartOptions);
        var data = this$1$1.createDataTable(chart.data, chart.xtype);
        this$1$1.drawChart(chart, "AreaChart", data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.renderGeoChart = function renderGeoChart(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, "geochart", function() {
        var chartOptions = {
            legend: "none",
            colorAxis: {
                colors: chart.options.colors || [
                    "#f6c7b6",
                    "#ce502d"
                ]
            }
        };
        var options = $a703babb3d7b9465$var$merge($a703babb3d7b9465$var$merge($a703babb3d7b9465$var$defaultOptions, chartOptions), chart.options.library || {});
        var data = new this$1$1.library.visualization.DataTable();
        data.addColumn("string", "");
        data.addColumn("number", chart.options.label || "Value");
        data.addRows(chart.data);
        this$1$1.drawChart(chart, "GeoChart", data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.renderScatterChart = function renderScatterChart(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, function() {
        var chartOptions = {};
        var options = $a703babb3d7b9465$var$jsOptions(chart, chart.options, chartOptions);
        var series = chart.data;
        var rows2 = [];
        for(var i = 0; i < series.length; i++){
            series[i].name = series[i].name || "Value";
            var d = series[i].data;
            for(var j = 0; j < d.length; j++){
                var row = new Array(series.length + 1);
                row[0] = d[j][0];
                row[i + 1] = d[j][1];
                rows2.push(row);
            }
        }
        var data = new this$1$1.library.visualization.DataTable();
        data.addColumn("number", "");
        for(var i$1 = 0; i$1 < series.length; i$1++)data.addColumn("number", series[i$1].name);
        data.addRows(rows2);
        this$1$1.drawChart(chart, "ScatterChart", data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.renderTimeline = function renderTimeline(chart) {
    var this$1$1 = this;
    this.waitForLoaded(chart, "timeline", function() {
        var chartOptions = {
            legend: "none"
        };
        if (chart.options.colors) chartOptions.colors = chart.options.colors;
        var options = $a703babb3d7b9465$var$merge($a703babb3d7b9465$var$merge($a703babb3d7b9465$var$defaultOptions, chartOptions), chart.options.library || {});
        var data = new this$1$1.library.visualization.DataTable();
        data.addColumn({
            type: "string",
            id: "Name"
        });
        data.addColumn({
            type: "date",
            id: "Start"
        });
        data.addColumn({
            type: "date",
            id: "End"
        });
        data.addRows(chart.data);
        chart.element.style.lineHeight = "normal";
        this$1$1.drawChart(chart, "Timeline", data, options);
    });
};
// TODO remove resize events
$a703babb3d7b9465$var$defaultExport.prototype.destroy = function destroy(chart) {
    if (chart.chart) chart.chart.clearChart();
};
$a703babb3d7b9465$var$defaultExport.prototype.drawChart = function drawChart(chart, type, data, options) {
    this.destroy(chart);
    if (chart.destroyed) return;
    if (chart.options.code) window.console.log("var data = new google.visualization.DataTable(" + data.toJSON() + ");\nvar chart = new google.visualization." + type + "(element);\nchart.draw(data, " + JSON.stringify(options) + ");");
    chart.chart = new this.library.visualization[type](chart.element);
    $a703babb3d7b9465$var$resize(function() {
        chart.chart.draw(data, options);
    });
};
$a703babb3d7b9465$var$defaultExport.prototype.waitForLoaded = function waitForLoaded(chart, pack, callback) {
    var this$1$1 = this;
    if (!callback) {
        callback = pack;
        pack = "corechart";
    }
    $a703babb3d7b9465$var$callbacks.push({
        pack: pack,
        callback: callback
    });
    if ($a703babb3d7b9465$var$loaded[pack]) this.runCallbacks();
    else {
        $a703babb3d7b9465$var$loaded[pack] = true;
        // https://groups.google.com/forum/#!topic/google-visualization-api/fMKJcyA2yyI
        var loadOptions = {
            packages: [
                pack
            ],
            callback: function() {
                this$1$1.runCallbacks();
            }
        };
        var config = chart.__config();
        if (config.language) loadOptions.language = config.language;
        if (pack === "geochart" && config.mapsApiKey) loadOptions.mapsApiKey = config.mapsApiKey;
        this.library.charts.load("current", loadOptions);
    }
};
$a703babb3d7b9465$var$defaultExport.prototype.runCallbacks = function runCallbacks() {
    for(var i = 0; i < $a703babb3d7b9465$var$callbacks.length; i++){
        var cb = $a703babb3d7b9465$var$callbacks[i];
        var call = this.library.visualization && (cb.pack === "corechart" && this.library.visualization.LineChart || cb.pack === "timeline" && this.library.visualization.Timeline || cb.pack === "geochart" && this.library.visualization.GeoChart);
        if (call) {
            cb.callback();
            $a703babb3d7b9465$var$callbacks.splice(i, 1);
            i--;
        }
    }
};
// cant use object as key
$a703babb3d7b9465$var$defaultExport.prototype.createDataTable = function createDataTable(series, columnType) {
    var rows = [];
    var sortedLabels = [];
    for(var i = 0; i < series.length; i++){
        var s = series[i];
        series[i].name = series[i].name || "Value";
        for(var j = 0; j < s.data.length; j++){
            var d = s.data[j];
            var key = columnType === "datetime" ? d[0].getTime() : d[0];
            if (!rows[key]) {
                rows[key] = new Array(series.length);
                sortedLabels.push(key);
            }
            rows[key][i] = d[1];
        }
    }
    var rows2 = [];
    var values = [];
    for(var j$1 = 0; j$1 < sortedLabels.length; j$1++){
        var i$1 = sortedLabels[j$1];
        var value = void 0;
        if (columnType === "datetime") {
            value = new Date(i$1);
            values.push(value);
        } else value = i$1;
        rows2.push([
            value
        ].concat(rows[i$1]));
    }
    var day = true;
    if (columnType === "datetime") {
        rows2.sort($a703babb3d7b9465$var$sortByTime);
        var timeUnit = $a703babb3d7b9465$var$calculateTimeUnit(values, true);
        day = $a703babb3d7b9465$var$isDay(timeUnit);
    } else if (columnType === "number") {
        rows2.sort($a703babb3d7b9465$var$sortByNumberSeries);
        for(var i$2 = 0; i$2 < rows2.length; i$2++)rows2[i$2][0] = $a703babb3d7b9465$var$toStr(rows2[i$2][0]);
        columnType = "string";
    }
    // create datatable
    var data = new this.library.visualization.DataTable();
    columnType = columnType === "datetime" && day ? "date" : columnType;
    data.addColumn(columnType, "");
    for(var i$3 = 0; i$3 < series.length; i$3++)data.addColumn("number", series[i$3].name);
    data.addRows(rows2);
    return data;
};
var $a703babb3d7b9465$var$adapters = [];
function $a703babb3d7b9465$var$getAdapterType(library) {
    if (library) {
        if (library.product === "Highcharts") return $a703babb3d7b9465$var$defaultExport$1;
        else if (library.charts) return $a703babb3d7b9465$var$defaultExport;
        else if ($a703babb3d7b9465$var$isFunction(library)) return $a703babb3d7b9465$var$defaultExport$2;
    }
    throw new Error("Unknown adapter");
}
function $a703babb3d7b9465$var$addAdapter(library) {
    var adapterType = $a703babb3d7b9465$var$getAdapterType(library);
    for(var i = 0; i < $a703babb3d7b9465$var$adapters.length; i++){
        if ($a703babb3d7b9465$var$adapters[i].library === library) return;
    }
    $a703babb3d7b9465$var$adapters.push(new adapterType(library));
}
function $a703babb3d7b9465$var$loadAdapters() {
    if ("Chart" in window) $a703babb3d7b9465$var$addAdapter(window.Chart);
    if ("Highcharts" in window) $a703babb3d7b9465$var$addAdapter(window.Highcharts);
    if (window.google && window.google.charts) $a703babb3d7b9465$var$addAdapter(window.google);
}
// TODO remove chartType if cross-browser way
// to get the name of the chart class
function $a703babb3d7b9465$var$callAdapter(chartType, chart) {
    var fnName = "render" + chartType;
    var adapterName = chart.options.adapter;
    $a703babb3d7b9465$var$loadAdapters();
    for(var i = 0; i < $a703babb3d7b9465$var$adapters.length; i++){
        var adapter = $a703babb3d7b9465$var$adapters[i];
        if ((!adapterName || adapterName === adapter.name) && $a703babb3d7b9465$var$isFunction(adapter[fnName])) {
            chart.adapter = adapter.name;
            chart.__adapterObject = adapter;
            return adapter[fnName](chart);
        }
    }
    if ($a703babb3d7b9465$var$adapters.length > 0) throw new Error("No charting library found for " + chartType);
    else throw new Error("No charting libraries found - be sure to include one before your charts");
}
var $a703babb3d7b9465$export$2e2bcd8739ae039 = {
    charts: {},
    configure: function(options) {
        for(var key in options)if (Object.prototype.hasOwnProperty.call(options, key)) $a703babb3d7b9465$export$2e2bcd8739ae039.config[key] = options[key];
    },
    setDefaultOptions: function(opts) {
        $a703babb3d7b9465$export$2e2bcd8739ae039.options = opts;
    },
    eachChart: function(callback) {
        for(var chartId in $a703babb3d7b9465$export$2e2bcd8739ae039.charts)if (Object.prototype.hasOwnProperty.call($a703babb3d7b9465$export$2e2bcd8739ae039.charts, chartId)) callback($a703babb3d7b9465$export$2e2bcd8739ae039.charts[chartId]);
    },
    destroyAll: function() {
        for(var chartId in $a703babb3d7b9465$export$2e2bcd8739ae039.charts)if (Object.prototype.hasOwnProperty.call($a703babb3d7b9465$export$2e2bcd8739ae039.charts, chartId)) {
            $a703babb3d7b9465$export$2e2bcd8739ae039.charts[chartId].destroy();
            delete $a703babb3d7b9465$export$2e2bcd8739ae039.charts[chartId];
        }
    },
    config: {},
    options: {},
    adapters: $a703babb3d7b9465$var$adapters,
    addAdapter: $a703babb3d7b9465$var$addAdapter,
    use: function(adapter) {
        $a703babb3d7b9465$var$addAdapter(adapter);
        return $a703babb3d7b9465$export$2e2bcd8739ae039;
    }
};
function $a703babb3d7b9465$var$formatSeriesBubble(data) {
    var r = [];
    for(var i = 0; i < data.length; i++)r.push([
        $a703babb3d7b9465$var$toFloat(data[i][0]),
        $a703babb3d7b9465$var$toFloat(data[i][1]),
        $a703babb3d7b9465$var$toFloat(data[i][2])
    ]);
    return r;
}
// casts data to proper type
// sorting is left to adapters
function $a703babb3d7b9465$var$formatSeriesData(data, keyType) {
    if (keyType === "bubble") return $a703babb3d7b9465$var$formatSeriesBubble(data);
    var keyFunc;
    if (keyType === "number") keyFunc = $a703babb3d7b9465$var$toFloat;
    else if (keyType === "datetime") keyFunc = $a703babb3d7b9465$var$toDate;
    else keyFunc = $a703babb3d7b9465$var$toStr;
    var r = [];
    for(var i = 0; i < data.length; i++)r.push([
        keyFunc(data[i][0]),
        $a703babb3d7b9465$var$toFloat(data[i][1])
    ]);
    return r;
}
function $a703babb3d7b9465$var$detectXType(series, noDatetime, options) {
    if ($a703babb3d7b9465$var$dataEmpty(series)) {
        if ((options.xmin || options.xmax) && (!options.xmin || $a703babb3d7b9465$var$isDate(options.xmin)) && (!options.xmax || $a703babb3d7b9465$var$isDate(options.xmax))) return "datetime";
        else return "number";
    } else if ($a703babb3d7b9465$var$detectXTypeWithFunction(series, $a703babb3d7b9465$var$isNumber)) return "number";
    else if (!noDatetime && $a703babb3d7b9465$var$detectXTypeWithFunction(series, $a703babb3d7b9465$var$isDate)) return "datetime";
    else return "string";
}
function $a703babb3d7b9465$var$detectXTypeWithFunction(series, func) {
    for(var i = 0; i < series.length; i++){
        var data = $a703babb3d7b9465$var$toArr(series[i].data);
        for(var j = 0; j < data.length; j++){
            if (!func(data[j][0])) return false;
        }
    }
    return true;
}
// creates a shallow copy of each element of the array
// elements are expected to be objects
function $a703babb3d7b9465$var$copySeries(series) {
    var newSeries = [];
    for(var i = 0; i < series.length; i++){
        var copy = {};
        for(var j in series[i])if (Object.prototype.hasOwnProperty.call(series[i], j)) copy[j] = series[i][j];
        newSeries.push(copy);
    }
    return newSeries;
}
function $a703babb3d7b9465$var$processSeries(chart, keyType, noDatetime) {
    var opts = chart.options;
    var series = chart.rawData;
    // see if one series or multiple
    chart.singleSeriesFormat = !$a703babb3d7b9465$var$isArray(series) || !$a703babb3d7b9465$var$isPlainObject(series[0]);
    if (chart.singleSeriesFormat) series = [
        {
            name: opts.label,
            data: series
        }
    ];
    // convert to array
    // must come before dataEmpty check
    series = $a703babb3d7b9465$var$copySeries(series);
    for(var i = 0; i < series.length; i++)series[i].data = $a703babb3d7b9465$var$toArr(series[i].data);
    chart.xtype = keyType || (opts.discrete ? "string" : $a703babb3d7b9465$var$detectXType(series, noDatetime, opts));
    // right format
    for(var i$1 = 0; i$1 < series.length; i$1++)series[i$1].data = $a703babb3d7b9465$var$formatSeriesData(series[i$1].data, chart.xtype);
    return series;
}
function $a703babb3d7b9465$var$processSimple(chart) {
    var perfectData = $a703babb3d7b9465$var$toArr(chart.rawData);
    for(var i = 0; i < perfectData.length; i++)perfectData[i] = [
        $a703babb3d7b9465$var$toStr(perfectData[i][0]),
        $a703babb3d7b9465$var$toFloat(perfectData[i][1])
    ];
    return perfectData;
}
function $a703babb3d7b9465$var$dataEmpty(data, chartType) {
    if (chartType === "PieChart" || chartType === "GeoChart" || chartType === "Timeline") return data.length === 0;
    else {
        for(var i = 0; i < data.length; i++){
            if (data[i].data.length > 0) return false;
        }
        return true;
    }
}
function $a703babb3d7b9465$var$addDownloadButton(chart) {
    var download = chart.options.download;
    if (download === true) download = {};
    else if (typeof download === "string") download = {
        filename: download
    };
    var link = document.createElement("a");
    link.download = download.filename || "chart.png";
    link.style.position = "absolute";
    link.style.top = "20px";
    link.style.right = "20px";
    link.style.zIndex = 1000;
    link.style.lineHeight = "20px";
    link.target = "_blank"; // for safari
    var image = document.createElement("img");
    // icon from Font Awesome, modified to set fill color
    var svg = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--! Font Awesome Free 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path fill=\"#CCCCCC\" d=\"M344 240h-56L287.1 152c0-13.25-10.75-24-24-24h-16C234.7 128 223.1 138.8 223.1 152L224 240h-56c-9.531 0-18.16 5.656-22 14.38C142.2 263.1 143.9 273.3 150.4 280.3l88.75 96C243.7 381.2 250.1 384 256.8 384c7.781-.3125 13.25-2.875 17.75-7.844l87.25-96c6.406-7.031 8.031-17.19 4.188-25.88S353.5 240 344 240zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464z\"/></svg>";
    image.src = "data:image/svg+xml;utf8," + encodeURIComponent(svg);
    image.alt = "Download";
    image.style.width = "20px";
    image.style.height = "20px";
    image.style.border = "none";
    link.appendChild(image);
    var element = chart.element;
    element.style.position = "relative";
    chart.__downloadAttached = true;
    // mouseenter
    chart.__enterEvent = element.addEventListener("mouseover", function(e) {
        var related = e.relatedTarget;
        // check download option again to ensure it wasn't changed
        if ((!related || related !== this && !this.contains(related)) && chart.options.download) {
            link.href = chart.toImage(download);
            element.appendChild(link);
        }
    });
    // mouseleave
    chart.__leaveEvent = element.addEventListener("mouseout", function(e) {
        var related = e.relatedTarget;
        if (!related || related !== this && !this.contains(related)) {
            if (link.parentNode) link.parentNode.removeChild(link);
        }
    });
}
var $a703babb3d7b9465$var$pendingRequests = [];
var $a703babb3d7b9465$var$runningRequests = 0;
var $a703babb3d7b9465$var$maxRequests = 4;
function $a703babb3d7b9465$var$pushRequest(url, success, error) {
    $a703babb3d7b9465$var$pendingRequests.push([
        url,
        success,
        error
    ]);
    $a703babb3d7b9465$var$runNext();
}
function $a703babb3d7b9465$var$runNext() {
    if ($a703babb3d7b9465$var$runningRequests < $a703babb3d7b9465$var$maxRequests) {
        var request = $a703babb3d7b9465$var$pendingRequests.shift();
        if (request) {
            $a703babb3d7b9465$var$runningRequests++;
            $a703babb3d7b9465$var$getJSON(request[0], request[1], request[2]);
            $a703babb3d7b9465$var$runNext();
        }
    }
}
function $a703babb3d7b9465$var$requestComplete() {
    $a703babb3d7b9465$var$runningRequests--;
    $a703babb3d7b9465$var$runNext();
}
function $a703babb3d7b9465$var$getJSON(url, success, error) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function() {
        $a703babb3d7b9465$var$requestComplete();
        if (xhr.status === 200) success(JSON.parse(xhr.responseText));
        else error(xhr.statusText);
    };
    xhr.send();
}
// helpers
function $a703babb3d7b9465$var$setText(element, text) {
    element.textContent = text;
}
// TODO remove prefix for all messages
function $a703babb3d7b9465$var$chartError(element, message, noPrefix) {
    if (!noPrefix) message = "Error Loading Chart: " + message;
    $a703babb3d7b9465$var$setText(element, message);
    element.style.color = "#ff0000";
}
function $a703babb3d7b9465$var$errorCatcher(chart) {
    try {
        chart.__render();
    } catch (err) {
        $a703babb3d7b9465$var$chartError(chart.element, err.message);
        throw err;
    }
}
function $a703babb3d7b9465$var$fetchDataSource(chart, dataSource, showLoading) {
    // only show loading message for urls and callbacks
    if (showLoading && chart.options.loading && (typeof dataSource === "string" || typeof dataSource === "function")) $a703babb3d7b9465$var$setText(chart.element, chart.options.loading);
    if (typeof dataSource === "string") $a703babb3d7b9465$var$pushRequest(dataSource, function(data) {
        chart.rawData = data;
        $a703babb3d7b9465$var$errorCatcher(chart);
    }, function(message) {
        $a703babb3d7b9465$var$chartError(chart.element, message);
    });
    else if (typeof dataSource === "function") try {
        dataSource(function(data) {
            chart.rawData = data;
            $a703babb3d7b9465$var$errorCatcher(chart);
        }, function(message) {
            $a703babb3d7b9465$var$chartError(chart.element, message, true);
        });
    } catch (err) {
        $a703babb3d7b9465$var$chartError(chart.element, err, true);
    }
    else {
        chart.rawData = dataSource;
        $a703babb3d7b9465$var$errorCatcher(chart);
    }
}
function $a703babb3d7b9465$var$renderChart(chartType, chart) {
    if ($a703babb3d7b9465$var$dataEmpty(chart.data, chartType)) {
        var message = chart.options.empty || chart.options.messages && chart.options.messages.empty || "No data";
        $a703babb3d7b9465$var$setText(chart.element, message);
    } else {
        $a703babb3d7b9465$var$callAdapter(chartType, chart);
        // TODO add downloadSupported method to adapter
        if (chart.options.download && !chart.__downloadAttached && chart.adapter === "chartjs") $a703babb3d7b9465$var$addDownloadButton(chart);
    }
}
function $a703babb3d7b9465$var$getElement(element) {
    if (typeof element === "string") {
        var elementId = element;
        element = document.getElementById(element);
        if (!element) throw new Error("No element with id " + elementId);
    }
    return element;
}
// define classes
var $a703babb3d7b9465$var$Chart = function Chart(element, dataSource, options) {
    this.element = $a703babb3d7b9465$var$getElement(element);
    this.options = $a703babb3d7b9465$var$merge($a703babb3d7b9465$export$2e2bcd8739ae039.options, options || {});
    this.dataSource = dataSource;
    // TODO handle charts without an id for eachChart and destroyAll
    if (this.element.id) $a703babb3d7b9465$export$2e2bcd8739ae039.charts[this.element.id] = this;
    $a703babb3d7b9465$var$fetchDataSource(this, dataSource, true);
    if (this.options.refresh) this.startRefresh();
};
$a703babb3d7b9465$var$Chart.prototype.getElement = function getElement() {
    return this.element;
};
$a703babb3d7b9465$var$Chart.prototype.getDataSource = function getDataSource() {
    return this.dataSource;
};
$a703babb3d7b9465$var$Chart.prototype.getData = function getData() {
    return this.data;
};
$a703babb3d7b9465$var$Chart.prototype.getOptions = function getOptions() {
    return this.options;
};
$a703babb3d7b9465$var$Chart.prototype.getChartObject = function getChartObject() {
    return this.chart;
};
$a703babb3d7b9465$var$Chart.prototype.getAdapter = function getAdapter() {
    return this.adapter;
};
$a703babb3d7b9465$var$Chart.prototype.updateData = function updateData(dataSource, options) {
    this.dataSource = dataSource;
    if (options) this.__updateOptions(options);
    $a703babb3d7b9465$var$fetchDataSource(this, dataSource, true);
};
$a703babb3d7b9465$var$Chart.prototype.setOptions = function setOptions(options) {
    this.__updateOptions(options);
    this.redraw();
};
$a703babb3d7b9465$var$Chart.prototype.redraw = function redraw() {
    $a703babb3d7b9465$var$fetchDataSource(this, this.rawData);
};
$a703babb3d7b9465$var$Chart.prototype.refreshData = function refreshData() {
    if (typeof this.dataSource === "string") {
        // prevent browser from caching
        var sep = this.dataSource.indexOf("?") === -1 ? "?" : "&";
        var url = this.dataSource + sep + "_=" + new Date().getTime();
        $a703babb3d7b9465$var$fetchDataSource(this, url);
    } else if (typeof this.dataSource === "function") $a703babb3d7b9465$var$fetchDataSource(this, this.dataSource);
};
$a703babb3d7b9465$var$Chart.prototype.startRefresh = function startRefresh() {
    var this$1$1 = this;
    var refresh = this.options.refresh;
    if (refresh && typeof this.dataSource !== "string" && typeof this.dataSource !== "function") throw new Error("Data source must be a URL or callback for refresh");
    if (!this.intervalId) {
        if (refresh) this.intervalId = setInterval(function() {
            this$1$1.refreshData();
        }, refresh * 1000);
        else throw new Error("No refresh interval");
    }
};
$a703babb3d7b9465$var$Chart.prototype.stopRefresh = function stopRefresh() {
    if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
    }
};
$a703babb3d7b9465$var$Chart.prototype.toImage = function toImage(download) {
    // TODO move logic to adapter
    if (this.adapter === "chartjs") {
        if (download && download.background && download.background !== "transparent") {
            // https://stackoverflow.com/questions/30464750/chartjs-line-chart-set-background-color
            var canvas = this.chart.canvas;
            var ctx = this.chart.ctx;
            var tmpCanvas = document.createElement("canvas");
            var tmpCtx = tmpCanvas.getContext("2d");
            tmpCanvas.width = ctx.canvas.width;
            tmpCanvas.height = ctx.canvas.height;
            tmpCtx.fillStyle = download.background;
            tmpCtx.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);
            tmpCtx.drawImage(canvas, 0, 0);
            return tmpCanvas.toDataURL("image/png");
        } else return this.chart.toBase64Image();
    } else throw new Error("Feature only available for Chart.js");
};
$a703babb3d7b9465$var$Chart.prototype.destroy = function destroy() {
    this.destroyed = true;
    this.stopRefresh();
    if (this.__adapterObject) this.__adapterObject.destroy(this);
    if (this.__enterEvent) this.element.removeEventListener("mouseover", this.__enterEvent);
    if (this.__leaveEvent) this.element.removeEventListener("mouseout", this.__leaveEvent);
};
$a703babb3d7b9465$var$Chart.prototype.__updateOptions = function __updateOptions(options) {
    var updateRefresh = options.refresh && options.refresh !== this.options.refresh;
    this.options = $a703babb3d7b9465$var$merge($a703babb3d7b9465$export$2e2bcd8739ae039.options, options);
    if (updateRefresh) {
        this.stopRefresh();
        this.startRefresh();
    }
};
$a703babb3d7b9465$var$Chart.prototype.__render = function __render() {
    this.data = this.__processData();
    $a703babb3d7b9465$var$renderChart(this.__chartName(), this);
};
$a703babb3d7b9465$var$Chart.prototype.__config = function __config() {
    return $a703babb3d7b9465$export$2e2bcd8739ae039.config;
};
var $a703babb3d7b9465$var$LineChart = /*@__PURE__*/ function(Chart) {
    function LineChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) LineChart.__proto__ = Chart;
    LineChart.prototype = Object.create(Chart && Chart.prototype);
    LineChart.prototype.constructor = LineChart;
    LineChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSeries(this);
    };
    LineChart.prototype.__chartName = function __chartName() {
        return "LineChart";
    };
    return LineChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$PieChart = /*@__PURE__*/ function(Chart) {
    function PieChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) PieChart.__proto__ = Chart;
    PieChart.prototype = Object.create(Chart && Chart.prototype);
    PieChart.prototype.constructor = PieChart;
    PieChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSimple(this);
    };
    PieChart.prototype.__chartName = function __chartName() {
        return "PieChart";
    };
    return PieChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$ColumnChart = /*@__PURE__*/ function(Chart) {
    function ColumnChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) ColumnChart.__proto__ = Chart;
    ColumnChart.prototype = Object.create(Chart && Chart.prototype);
    ColumnChart.prototype.constructor = ColumnChart;
    ColumnChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSeries(this, null, true);
    };
    ColumnChart.prototype.__chartName = function __chartName() {
        return "ColumnChart";
    };
    return ColumnChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$BarChart = /*@__PURE__*/ function(Chart) {
    function BarChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) BarChart.__proto__ = Chart;
    BarChart.prototype = Object.create(Chart && Chart.prototype);
    BarChart.prototype.constructor = BarChart;
    BarChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSeries(this, null, true);
    };
    BarChart.prototype.__chartName = function __chartName() {
        return "BarChart";
    };
    return BarChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$AreaChart = /*@__PURE__*/ function(Chart) {
    function AreaChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) AreaChart.__proto__ = Chart;
    AreaChart.prototype = Object.create(Chart && Chart.prototype);
    AreaChart.prototype.constructor = AreaChart;
    AreaChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSeries(this);
    };
    AreaChart.prototype.__chartName = function __chartName() {
        return "AreaChart";
    };
    return AreaChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$GeoChart = /*@__PURE__*/ function(Chart) {
    function GeoChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) GeoChart.__proto__ = Chart;
    GeoChart.prototype = Object.create(Chart && Chart.prototype);
    GeoChart.prototype.constructor = GeoChart;
    GeoChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSimple(this);
    };
    GeoChart.prototype.__chartName = function __chartName() {
        return "GeoChart";
    };
    return GeoChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$ScatterChart = /*@__PURE__*/ function(Chart) {
    function ScatterChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) ScatterChart.__proto__ = Chart;
    ScatterChart.prototype = Object.create(Chart && Chart.prototype);
    ScatterChart.prototype.constructor = ScatterChart;
    ScatterChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSeries(this, "number");
    };
    ScatterChart.prototype.__chartName = function __chartName() {
        return "ScatterChart";
    };
    return ScatterChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$BubbleChart = /*@__PURE__*/ function(Chart) {
    function BubbleChart() {
        Chart.apply(this, arguments);
    }
    if (Chart) BubbleChart.__proto__ = Chart;
    BubbleChart.prototype = Object.create(Chart && Chart.prototype);
    BubbleChart.prototype.constructor = BubbleChart;
    BubbleChart.prototype.__processData = function __processData() {
        return $a703babb3d7b9465$var$processSeries(this, "bubble");
    };
    BubbleChart.prototype.__chartName = function __chartName() {
        return "BubbleChart";
    };
    return BubbleChart;
}($a703babb3d7b9465$var$Chart);
var $a703babb3d7b9465$var$Timeline = /*@__PURE__*/ function(Chart) {
    function Timeline() {
        Chart.apply(this, arguments);
    }
    if (Chart) Timeline.__proto__ = Chart;
    Timeline.prototype = Object.create(Chart && Chart.prototype);
    Timeline.prototype.constructor = Timeline;
    Timeline.prototype.__processData = function __processData() {
        var data = this.rawData;
        for(var i = 0; i < data.length; i++){
            data[i][1] = $a703babb3d7b9465$var$toDate(data[i][1]);
            data[i][2] = $a703babb3d7b9465$var$toDate(data[i][2]);
        }
        return data;
    };
    Timeline.prototype.__chartName = function __chartName() {
        return "Timeline";
    };
    return Timeline;
}($a703babb3d7b9465$var$Chart);
$a703babb3d7b9465$export$2e2bcd8739ae039.LineChart = $a703babb3d7b9465$var$LineChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.PieChart = $a703babb3d7b9465$var$PieChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.ColumnChart = $a703babb3d7b9465$var$ColumnChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.BarChart = $a703babb3d7b9465$var$BarChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.AreaChart = $a703babb3d7b9465$var$AreaChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.GeoChart = $a703babb3d7b9465$var$GeoChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.ScatterChart = $a703babb3d7b9465$var$ScatterChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.BubbleChart = $a703babb3d7b9465$var$BubbleChart;
$a703babb3d7b9465$export$2e2bcd8739ae039.Timeline = $a703babb3d7b9465$var$Timeline;
// not ideal, but allows for simpler integration
if (typeof window !== "undefined" && !window.Chartkick) {
    window.Chartkick = $a703babb3d7b9465$export$2e2bcd8739ae039;
    // clean up previous charts before Turbolinks loads new page
    document.addEventListener("turbolinks:before-render", function() {
        if ($a703babb3d7b9465$export$2e2bcd8739ae039.config.autoDestroy !== false) $a703babb3d7b9465$export$2e2bcd8739ae039.destroyAll();
    });
    // clean up previous charts before Turbo loads new page
    document.addEventListener("turbo:before-render", function() {
        if ($a703babb3d7b9465$export$2e2bcd8739ae039.config.autoDestroy !== false) $a703babb3d7b9465$export$2e2bcd8739ae039.destroyAll();
    });
    // use setTimeout so charting library can come later in same JS file
    setTimeout(function() {
        window.dispatchEvent(new Event("chartkick:load"));
    }, 0);
}
// backwards compatibility for esm require
$a703babb3d7b9465$export$2e2bcd8739ae039.default = $a703babb3d7b9465$export$2e2bcd8739ae039;

});

parcelRegister("fEUcM", function(module, exports) {

var $el0Ud = parcelRequire("el0Ud");

var $aOEPr = parcelRequire("aOEPr");
parcelRequire("48FUX");
(0, $el0Ud.default).use((0, $aOEPr.default));

});
parcelRegister("aOEPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dfe3e9d8091ad58$export$2e2bcd8739ae039);

var $5EHVc = parcelRequire("5EHVc");
(0, $5EHVc.Chart).register(...(0, $5EHVc.registerables));
var $7dfe3e9d8091ad58$export$2e2bcd8739ae039 = (0, $5EHVc.Chart);

});
parcelRegister("5EHVc", function(module, exports) {

$parcel$export(module.exports, "_adapters", () => $41e2c210a1c3aa9f$export$f32766ea09ec8bc4);
$parcel$export(module.exports, "Chart", () => $41e2c210a1c3aa9f$export$acaa6426d77a227e);
$parcel$export(module.exports, "registerables", () => $41e2c210a1c3aa9f$export$e8959e79e3af550f);
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $l7j26 = parcelRequire("l7j26");

class $41e2c210a1c3aa9f$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $l7j26.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $41e2c210a1c3aa9f$export$a424a0aa8f687495 = /* #__PURE__ */ new $41e2c210a1c3aa9f$var$Animator();
const $41e2c210a1c3aa9f$var$transparent = 'transparent';
const $41e2c210a1c3aa9f$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $l7j26.c)(from || $41e2c210a1c3aa9f$var$transparent);
        const c1 = c0.valid && (0, $l7j26.c)(to || $41e2c210a1c3aa9f$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $41e2c210a1c3aa9f$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $l7j26.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $l7j26.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $41e2c210a1c3aa9f$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $l7j26.e)[cfg.easing] || (0, $l7j26.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $l7j26.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $l7j26.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $41e2c210a1c3aa9f$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $l7j26.i)(config)) return;
        const animationOptions = Object.keys((0, $l7j26.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $l7j26.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $l7j26.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $41e2c210a1c3aa9f$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $41e2c210a1c3aa9f$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $41e2c210a1c3aa9f$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $41e2c210a1c3aa9f$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $41e2c210a1c3aa9f$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $41e2c210a1c3aa9f$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $41e2c210a1c3aa9f$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $41e2c210a1c3aa9f$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $41e2c210a1c3aa9f$var$scaleClip(xScale, allowedOverflow);
    const y = $41e2c210a1c3aa9f$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $41e2c210a1c3aa9f$var$toClip(value) {
    let t, r, b, l;
    if ((0, $l7j26.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $41e2c210a1c3aa9f$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $41e2c210a1c3aa9f$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $l7j26.g)(otherValue) && (singleMode || value === 0 || (0, $l7j26.s)(value) === (0, $l7j26.s)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $41e2c210a1c3aa9f$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $41e2c210a1c3aa9f$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $41e2c210a1c3aa9f$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $41e2c210a1c3aa9f$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $41e2c210a1c3aa9f$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $41e2c210a1c3aa9f$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $41e2c210a1c3aa9f$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $41e2c210a1c3aa9f$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $41e2c210a1c3aa9f$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $41e2c210a1c3aa9f$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $41e2c210a1c3aa9f$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $41e2c210a1c3aa9f$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $41e2c210a1c3aa9f$var$createDatasetContext(parent, index) {
    return (0, $l7j26.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $41e2c210a1c3aa9f$var$createDataContext(parent, index, element) {
    return (0, $l7j26.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $41e2c210a1c3aa9f$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $41e2c210a1c3aa9f$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $41e2c210a1c3aa9f$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $41e2c210a1c3aa9f$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $41e2c210a1c3aa9f$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $41e2c210a1c3aa9f$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $41e2c210a1c3aa9f$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $l7j26.v)(dataset.xAxisID, $41e2c210a1c3aa9f$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $l7j26.v)(dataset.yAxisID, $41e2c210a1c3aa9f$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $l7j26.v)(dataset.rAxisID, $41e2c210a1c3aa9f$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $l7j26.u)(this._data, this);
        if (meta._stacked) $41e2c210a1c3aa9f$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $l7j26.i)(data)) {
            const meta = this._cachedMeta;
            this._data = $41e2c210a1c3aa9f$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $l7j26.u)(_data, this);
                const meta = this._cachedMeta;
                $41e2c210a1c3aa9f$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $l7j26.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $41e2c210a1c3aa9f$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $41e2c210a1c3aa9f$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $41e2c210a1c3aa9f$var$updateStacks(this, meta._parsed);
            meta._stacked = $41e2c210a1c3aa9f$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $l7j26.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $l7j26.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $41e2c210a1c3aa9f$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $l7j26.f)(item, xAxisKey), index),
                y: yScale.parse((0, $l7j26.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $41e2c210a1c3aa9f$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $41e2c210a1c3aa9f$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $41e2c210a1c3aa9f$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $41e2c210a1c3aa9f$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $41e2c210a1c3aa9f$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $l7j26.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $l7j26.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $41e2c210a1c3aa9f$var$toClip((0, $l7j26.v)(this.options.clip, $41e2c210a1c3aa9f$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $41e2c210a1c3aa9f$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $41e2c210a1c3aa9f$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $l7j26.h)(index);
        if (cached) return $41e2c210a1c3aa9f$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $l7j26.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($41e2c210a1c3aa9f$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $41e2c210a1c3aa9f$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $41e2c210a1c3aa9f$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($41e2c210a1c3aa9f$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$41e2c210a1c3aa9f$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $41e2c210a1c3aa9f$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $41e2c210a1c3aa9f$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $l7j26._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $41e2c210a1c3aa9f$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $41e2c210a1c3aa9f$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $l7j26.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $41e2c210a1c3aa9f$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $l7j26.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $41e2c210a1c3aa9f$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $41e2c210a1c3aa9f$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $41e2c210a1c3aa9f$var$parseValue(entry, item, vScale, i) {
    if ((0, $l7j26.b)(entry)) $41e2c210a1c3aa9f$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $41e2c210a1c3aa9f$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($41e2c210a1c3aa9f$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $41e2c210a1c3aa9f$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $41e2c210a1c3aa9f$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $l7j26.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $41e2c210a1c3aa9f$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $41e2c210a1c3aa9f$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $41e2c210a1c3aa9f$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$41e2c210a1c3aa9f$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$41e2c210a1c3aa9f$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $41e2c210a1c3aa9f$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $41e2c210a1c3aa9f$var$swap(edge, a, b);
        edge = $41e2c210a1c3aa9f$var$startEnd(edge, b, a);
    } else edge = $41e2c210a1c3aa9f$var$startEnd(edge, a, b);
    return edge;
}
function $41e2c210a1c3aa9f$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $41e2c210a1c3aa9f$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $41e2c210a1c3aa9f$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $41e2c210a1c3aa9f$export$e97d5dc64e999004 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $41e2c210a1c3aa9f$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $41e2c210a1c3aa9f$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $l7j26.f)(obj, iAxisKey), i);
            parsed.push($41e2c210a1c3aa9f$var$parseValue((0, $l7j26.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $41e2c210a1c3aa9f$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $l7j26.k)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $41e2c210a1c3aa9f$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $41e2c210a1c3aa9f$var$setBorderSkipped(properties, options, stack, index);
            $41e2c210a1c3aa9f$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $l7j26.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $l7j26.v)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $41e2c210a1c3aa9f$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $41e2c210a1c3aa9f$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $l7j26.s)(value) !== (0, $l7j26.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $l7j26.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $41e2c210a1c3aa9f$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $l7j26.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $l7j26.v)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $41e2c210a1c3aa9f$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $41e2c210a1c3aa9f$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $l7j26.v)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $41e2c210a1c3aa9f$export$19b5c4773f17abe extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $l7j26.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $l7j26.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $l7j26.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function $41e2c210a1c3aa9f$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $l7j26.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $l7j26.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $l7j26.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $l7j26.H), startY, endY);
        const minX = calcMin((0, $l7j26.P), startX, endX);
        const minY = calcMin((0, $l7j26.P) + (0, $l7j26.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $41e2c210a1c3aa9f$export$e04603e7d8b77172 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                fontColor: color,
                                hidden: !chart.getDataVisibility(i),
                                lineDash: style.borderDash,
                                lineDashOffset: style.borderDashOffset,
                                lineJoin: style.borderJoinStyle,
                                lineWidth: style.borderWidth,
                                strokeStyle: style.borderColor,
                                textAlign: textAlign,
                                pointStyle: pointStyle,
                                borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                index: i
                            };
                        });
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $l7j26.i)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $l7j26.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $l7j26.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $l7j26.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $l7j26.T);
        let max = -(0, $l7j26.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $l7j26.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $41e2c210a1c3aa9f$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $l7j26.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $l7j26.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $l7j26.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $l7j26.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $l7j26.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $41e2c210a1c3aa9f$export$3c9b5d28c11cbfd0 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $l7j26.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $l7j26.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $l7j26.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $l7j26.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $41e2c210a1c3aa9f$export$2a270b3a0d973c85 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $l7j26.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $l7j26.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $l7j26.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $l7j26.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $41e2c210a1c3aa9f$export$b21a3f1286706191 extends $41e2c210a1c3aa9f$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $41e2c210a1c3aa9f$export$48dbc6ac651bf8be extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $l7j26.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $41e2c210a1c3aa9f$export$b2f2bae6713db87 extends $41e2c210a1c3aa9f$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $l7j26.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $l7j26.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $l7j26.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $l7j26.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $41e2c210a1c3aa9f$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $41e2c210a1c3aa9f$export$e97d5dc64e999004,
    BubbleController: $41e2c210a1c3aa9f$export$19b5c4773f17abe,
    DoughnutController: $41e2c210a1c3aa9f$export$e04603e7d8b77172,
    LineController: $41e2c210a1c3aa9f$export$3c9b5d28c11cbfd0,
    PieController: $41e2c210a1c3aa9f$export$b21a3f1286706191,
    PolarAreaController: $41e2c210a1c3aa9f$export$2a270b3a0d973c85,
    RadarController: $41e2c210a1c3aa9f$export$48dbc6ac651bf8be,
    ScatterController: $41e2c210a1c3aa9f$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $41e2c210a1c3aa9f$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $41e2c210a1c3aa9f$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($41e2c210a1c3aa9f$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    parse() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    format() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    add() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    diff() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    startOf() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
    endOf() {
        return $41e2c210a1c3aa9f$var$abstract();
    }
}
var $41e2c210a1c3aa9f$export$f32766ea09ec8bc4 = {
    _date: $41e2c210a1c3aa9f$var$DateAdapterBase
};
function $41e2c210a1c3aa9f$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $l7j26.A) : (0, $l7j26.B);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $l7j26.k)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $l7j26.k)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $41e2c210a1c3aa9f$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $41e2c210a1c3aa9f$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $l7j26.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $41e2c210a1c3aa9f$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $l7j26.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $l7j26.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $41e2c210a1c3aa9f$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $41e2c210a1c3aa9f$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $41e2c210a1c3aa9f$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $41e2c210a1c3aa9f$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $41e2c210a1c3aa9f$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $41e2c210a1c3aa9f$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $41e2c210a1c3aa9f$export$a13296960cae0384 = {
    evaluateInteractionItems: $41e2c210a1c3aa9f$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $l7j26.z)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $l7j26.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $l7j26.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $41e2c210a1c3aa9f$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $l7j26.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $41e2c210a1c3aa9f$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $l7j26.z)(e, chart);
            return $41e2c210a1c3aa9f$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $l7j26.z)(e, chart);
            return $41e2c210a1c3aa9f$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $41e2c210a1c3aa9f$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $41e2c210a1c3aa9f$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $41e2c210a1c3aa9f$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$41e2c210a1c3aa9f$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $41e2c210a1c3aa9f$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $41e2c210a1c3aa9f$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $41e2c210a1c3aa9f$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$41e2c210a1c3aa9f$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $41e2c210a1c3aa9f$var$setLayoutDims(layouts, params) {
    const stacks = $41e2c210a1c3aa9f$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $41e2c210a1c3aa9f$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $41e2c210a1c3aa9f$var$wrapBoxes(boxes);
    const fullSize = $41e2c210a1c3aa9f$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'right'));
    const top = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $41e2c210a1c3aa9f$var$sortByWeight($41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $41e2c210a1c3aa9f$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $41e2c210a1c3aa9f$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $41e2c210a1c3aa9f$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $41e2c210a1c3aa9f$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $41e2c210a1c3aa9f$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $41e2c210a1c3aa9f$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $l7j26.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $41e2c210a1c3aa9f$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $41e2c210a1c3aa9f$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $41e2c210a1c3aa9f$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $41e2c210a1c3aa9f$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $41e2c210a1c3aa9f$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $41e2c210a1c3aa9f$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $41e2c210a1c3aa9f$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $41e2c210a1c3aa9f$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $41e2c210a1c3aa9f$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $41e2c210a1c3aa9f$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $41e2c210a1c3aa9f$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $l7j26.h)(stack.start)) y = stack.start;
            if (box.fullSize) $41e2c210a1c3aa9f$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $41e2c210a1c3aa9f$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $l7j26.h)(stack.start)) x = stack.start;
            if (box.fullSize) $41e2c210a1c3aa9f$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $41e2c210a1c3aa9f$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $41e2c210a1c3aa9f$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $l7j26.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $41e2c210a1c3aa9f$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $l7j26.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $41e2c210a1c3aa9f$var$updateMaxPadding(maxPadding, (0, $l7j26.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $41e2c210a1c3aa9f$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $41e2c210a1c3aa9f$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $41e2c210a1c3aa9f$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($41e2c210a1c3aa9f$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $41e2c210a1c3aa9f$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $41e2c210a1c3aa9f$var$handleMaxPadding(chartArea);
        $41e2c210a1c3aa9f$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $41e2c210a1c3aa9f$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $l7j26.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $41e2c210a1c3aa9f$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $41e2c210a1c3aa9f$export$a40a96b24b46cf35 extends $41e2c210a1c3aa9f$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $41e2c210a1c3aa9f$var$EXPANDO_KEY = '$chartjs';
const $41e2c210a1c3aa9f$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $41e2c210a1c3aa9f$var$isNullOrEmpty = (value)=>value === null || value === '';
function $41e2c210a1c3aa9f$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($41e2c210a1c3aa9f$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $l7j26.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($41e2c210a1c3aa9f$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $l7j26.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $41e2c210a1c3aa9f$var$eventListenerOptions = (0, $l7j26.K) ? {
    passive: true
} : false;
function $41e2c210a1c3aa9f$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $41e2c210a1c3aa9f$var$eventListenerOptions);
}
function $41e2c210a1c3aa9f$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $41e2c210a1c3aa9f$var$eventListenerOptions);
}
function $41e2c210a1c3aa9f$var$fromNativeEvent(event, chart) {
    const type = $41e2c210a1c3aa9f$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $l7j26.z)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $41e2c210a1c3aa9f$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $41e2c210a1c3aa9f$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $41e2c210a1c3aa9f$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$41e2c210a1c3aa9f$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $41e2c210a1c3aa9f$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $41e2c210a1c3aa9f$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$41e2c210a1c3aa9f$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $41e2c210a1c3aa9f$var$drpListeningCharts = new Map();
let $41e2c210a1c3aa9f$var$oldDevicePixelRatio = 0;
function $41e2c210a1c3aa9f$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $41e2c210a1c3aa9f$var$oldDevicePixelRatio) return;
    $41e2c210a1c3aa9f$var$oldDevicePixelRatio = dpr;
    $41e2c210a1c3aa9f$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $41e2c210a1c3aa9f$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$41e2c210a1c3aa9f$var$drpListeningCharts.size) window.addEventListener('resize', $41e2c210a1c3aa9f$var$onWindowResize);
    $41e2c210a1c3aa9f$var$drpListeningCharts.set(chart, resize);
}
function $41e2c210a1c3aa9f$var$unlistenDevicePixelRatioChanges(chart) {
    $41e2c210a1c3aa9f$var$drpListeningCharts.delete(chart);
    if (!$41e2c210a1c3aa9f$var$drpListeningCharts.size) window.removeEventListener('resize', $41e2c210a1c3aa9f$var$onWindowResize);
}
function $41e2c210a1c3aa9f$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $l7j26.I)(canvas);
    if (!container) return;
    const resize = (0, $l7j26.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $41e2c210a1c3aa9f$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $41e2c210a1c3aa9f$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $41e2c210a1c3aa9f$var$unlistenDevicePixelRatioChanges(chart);
}
function $41e2c210a1c3aa9f$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $l7j26.L)((event)=>{
        if (chart.ctx !== null) listener($41e2c210a1c3aa9f$var$fromNativeEvent(event, chart));
    }, chart);
    $41e2c210a1c3aa9f$var$addListener(canvas, type, proxy);
    return proxy;
}
class $41e2c210a1c3aa9f$export$f02da7f882cf6b2e extends $41e2c210a1c3aa9f$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $41e2c210a1c3aa9f$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY]) return false;
        const initial = canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $l7j26.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$41e2c210a1c3aa9f$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $41e2c210a1c3aa9f$var$createAttachObserver,
            detach: $41e2c210a1c3aa9f$var$createDetachObserver,
            resize: $41e2c210a1c3aa9f$var$createResizeObserver
        };
        const handler = handlers[type] || $41e2c210a1c3aa9f$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $41e2c210a1c3aa9f$var$releaseObserver,
            detach: $41e2c210a1c3aa9f$var$releaseObserver,
            resize: $41e2c210a1c3aa9f$var$releaseObserver
        };
        const handler = handlers[type] || $41e2c210a1c3aa9f$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $l7j26.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $l7j26.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function $41e2c210a1c3aa9f$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $l7j26.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $41e2c210a1c3aa9f$export$a40a96b24b46cf35;
    return $41e2c210a1c3aa9f$export$f02da7f882cf6b2e;
}
class $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $l7j26.x)(this.x) && (0, $l7j26.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $41e2c210a1c3aa9f$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $41e2c210a1c3aa9f$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $41e2c210a1c3aa9f$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $41e2c210a1c3aa9f$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $41e2c210a1c3aa9f$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, (0, $l7j26.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, last, (0, $l7j26.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $41e2c210a1c3aa9f$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $41e2c210a1c3aa9f$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $41e2c210a1c3aa9f$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $l7j26.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $41e2c210a1c3aa9f$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $41e2c210a1c3aa9f$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $41e2c210a1c3aa9f$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $l7j26.v)(majorStart, 0);
    const end = Math.min((0, $l7j26.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $41e2c210a1c3aa9f$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $41e2c210a1c3aa9f$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $41e2c210a1c3aa9f$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $41e2c210a1c3aa9f$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $41e2c210a1c3aa9f$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $41e2c210a1c3aa9f$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $41e2c210a1c3aa9f$var$garbageCollect(caches, length) {
    (0, $l7j26.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $41e2c210a1c3aa9f$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $41e2c210a1c3aa9f$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $l7j26.a0)(options.font, fallback);
    const padding = (0, $l7j26.E)(options.padding);
    const lines = (0, $l7j26.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $41e2c210a1c3aa9f$var$createScaleContext(parent, scale) {
    return (0, $l7j26.j)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $41e2c210a1c3aa9f$var$createTickContext(parent, index, tick) {
    return (0, $l7j26.j)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $41e2c210a1c3aa9f$var$titleAlign(align, position, reverse) {
    let ret = (0, $l7j26.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $41e2c210a1c3aa9f$var$reverseAlign(ret);
    return ret;
}
function $41e2c210a1c3aa9f$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $l7j26.a2)(align, left, right);
        if ((0, $l7j26.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $41e2c210a1c3aa9f$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $l7j26.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $41e2c210a1c3aa9f$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $l7j26.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, $l7j26.H) : (0, $l7j26.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $l7j26.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $l7j26.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $l7j26.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $l7j26.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $l7j26.O)(_userMin, _suggestedMin),
            max: (0, $l7j26.O)(_userMax, _suggestedMax),
            minDefined: (0, $l7j26.g)(_userMin),
            maxDefined: (0, $l7j26.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $l7j26.O)(min, (0, $l7j26.O)(max, min)),
            max: (0, $l7j26.O)(max, (0, $l7j26.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $l7j26.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $l7j26.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $41e2c210a1c3aa9f$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $41e2c210a1c3aa9f$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $l7j26.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $l7j26.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $l7j26.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $l7j26.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $l7j26.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $l7j26.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $l7j26.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $l7j26.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $41e2c210a1c3aa9f$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $l7j26.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $41e2c210a1c3aa9f$var$getTickMarkLength(options.grid) - tickOpts.padding - $41e2c210a1c3aa9f$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $l7j26.U)(Math.min(Math.asin((0, $l7j26.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $l7j26.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $l7j26.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $l7j26.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $l7j26.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $41e2c210a1c3aa9f$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $41e2c210a1c3aa9f$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $41e2c210a1c3aa9f$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $l7j26.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $l7j26.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $l7j26.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $41e2c210a1c3aa9f$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $41e2c210a1c3aa9f$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $l7j26.k)(label) && !(0, $l7j26.b)(label)) {
                width = (0, $l7j26.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $l7j26.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $l7j26.k)(nestedLabel) && !(0, $l7j26.b)(nestedLabel)) {
                    width = (0, $l7j26.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $41e2c210a1c3aa9f$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $l7j26.W)(this._alignToPixels ? (0, $l7j26.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $41e2c210a1c3aa9f$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $41e2c210a1c3aa9f$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $l7j26.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $41e2c210a1c3aa9f$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $l7j26.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $l7j26.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $l7j26.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $l7j26.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $41e2c210a1c3aa9f$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $l7j26.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $41e2c210a1c3aa9f$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $l7j26.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $l7j26.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $l7j26.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $l7j26.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $l7j26.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $l7j26.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $l7j26.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $l7j26.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $l7j26.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $l7j26.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $l7j26.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $l7j26.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $l7j26.$)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $l7j26.a0)(title.font);
        const padding = (0, $l7j26.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $l7j26.i)(position)) {
            offset += padding.bottom;
            if ((0, $l7j26.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $41e2c210a1c3aa9f$var$titleArgs(this, offset, position, align);
        (0, $l7j26.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $41e2c210a1c3aa9f$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $l7j26.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, $l7j26.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $41e2c210a1c3aa9f$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $l7j26.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $41e2c210a1c3aa9f$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($41e2c210a1c3aa9f$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $41e2c210a1c3aa9f$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $l7j26.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $l7j26.d)[scope]) {
            delete (0, $l7j26.d)[scope][id];
            if (this.override) delete (0, $l7j26.a3)[id];
        }
    }
}
function $41e2c210a1c3aa9f$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $l7j26.a4)(Object.create(null), [
        parentScope ? (0, $l7j26.d).get(parentScope) : {},
        (0, $l7j26.d).get(scope),
        item.defaults
    ]);
    (0, $l7j26.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $41e2c210a1c3aa9f$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $l7j26.d).describe(scope, item.descriptors);
}
function $41e2c210a1c3aa9f$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $l7j26.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $41e2c210a1c3aa9f$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $41e2c210a1c3aa9f$var$Registry {
    constructor(){
        this.controllers = new $41e2c210a1c3aa9f$var$TypedRegistry($41e2c210a1c3aa9f$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $41e2c210a1c3aa9f$var$TypedRegistry($41e2c210a1c3aa9f$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $41e2c210a1c3aa9f$var$TypedRegistry(Object, 'plugins');
        this.scales = new $41e2c210a1c3aa9f$var$TypedRegistry($41e2c210a1c3aa9f$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $l7j26.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $l7j26.a5)(method);
        (0, $l7j26.Q)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $l7j26.Q)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $41e2c210a1c3aa9f$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $41e2c210a1c3aa9f$var$Registry();
class $41e2c210a1c3aa9f$var$PluginService {
    constructor(){
        this._init = undefined;
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $l7j26.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $l7j26.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $l7j26.v)(config.options && config.options.plugins, {});
        const plugins = $41e2c210a1c3aa9f$var$allPlugins(config);
        return options === false && !all ? [] : $41e2c210a1c3aa9f$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $41e2c210a1c3aa9f$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($41e2c210a1c3aa9f$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $41e2c210a1c3aa9f$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $41e2c210a1c3aa9f$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $41e2c210a1c3aa9f$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $41e2c210a1c3aa9f$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $41e2c210a1c3aa9f$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $41e2c210a1c3aa9f$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $l7j26.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $41e2c210a1c3aa9f$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $41e2c210a1c3aa9f$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $41e2c210a1c3aa9f$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $41e2c210a1c3aa9f$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $41e2c210a1c3aa9f$var$determineAxis(id, ...scaleOptions) {
    if ($41e2c210a1c3aa9f$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $41e2c210a1c3aa9f$var$axisFromPosition(opts.position) || id.length > 1 && $41e2c210a1c3aa9f$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $41e2c210a1c3aa9f$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $41e2c210a1c3aa9f$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $41e2c210a1c3aa9f$var$getAxisFromDataset(id, 'x', boundDs[0]) || $41e2c210a1c3aa9f$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $41e2c210a1c3aa9f$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $l7j26.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $41e2c210a1c3aa9f$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $l7j26.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $41e2c210a1c3aa9f$var$determineAxis(id, scaleConf, $41e2c210a1c3aa9f$var$retrieveAxisFromDatasets(id, config), (0, $l7j26.d).scales[scaleConf.type]);
        const defaultId = $41e2c210a1c3aa9f$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $l7j26.ab)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $41e2c210a1c3aa9f$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $l7j26.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $41e2c210a1c3aa9f$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $l7j26.ab)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $l7j26.ab)(scale, [
            (0, $l7j26.d).scales[scale.type],
            (0, $l7j26.d).scale
        ]);
    });
    return scales;
}
function $41e2c210a1c3aa9f$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $l7j26.v)(options.plugins, {});
    options.scales = $41e2c210a1c3aa9f$var$mergeScaleConfig(config, options);
}
function $41e2c210a1c3aa9f$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $41e2c210a1c3aa9f$var$initConfig(config) {
    config = config || {};
    config.data = $41e2c210a1c3aa9f$var$initData(config.data);
    $41e2c210a1c3aa9f$var$initOptions(config);
    return config;
}
const $41e2c210a1c3aa9f$var$keyCache = new Map();
const $41e2c210a1c3aa9f$var$keysCached = new Set();
function $41e2c210a1c3aa9f$var$cachedKeys(cacheKey, generate) {
    let keys = $41e2c210a1c3aa9f$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $41e2c210a1c3aa9f$var$keyCache.set(cacheKey, keys);
        $41e2c210a1c3aa9f$var$keysCached.add(keys);
    }
    return keys;
}
const $41e2c210a1c3aa9f$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $l7j26.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $41e2c210a1c3aa9f$var$Config {
    constructor(config){
        this._config = $41e2c210a1c3aa9f$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $41e2c210a1c3aa9f$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $41e2c210a1c3aa9f$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $41e2c210a1c3aa9f$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $41e2c210a1c3aa9f$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $41e2c210a1c3aa9f$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $41e2c210a1c3aa9f$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, (0, $l7j26.a3)[type] || {}, key));
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, (0, $l7j26.d), key));
            keys.forEach((key)=>$41e2c210a1c3aa9f$var$addIfFound(scopes, (0, $l7j26.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($41e2c210a1c3aa9f$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $l7j26.a3)[type] || {},
            (0, $l7j26.d).datasets[type] || {},
            {
                type: type
            },
            (0, $l7j26.d),
            (0, $l7j26.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $41e2c210a1c3aa9f$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($41e2c210a1c3aa9f$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $l7j26.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $l7j26.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $41e2c210a1c3aa9f$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $l7j26.i)(context) ? (0, $l7j26.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $41e2c210a1c3aa9f$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $l7j26.a9)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $41e2c210a1c3aa9f$var$hasFunction = (value)=>(0, $l7j26.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $l7j26.a7)(value[key]));
function $41e2c210a1c3aa9f$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $l7j26.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $l7j26.a7)(value) || $41e2c210a1c3aa9f$var$hasFunction(value)) || indexable && (0, $l7j26.b)(value)) return true;
    }
    return false;
}
var $41e2c210a1c3aa9f$var$version = "4.5.1";
const $41e2c210a1c3aa9f$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $41e2c210a1c3aa9f$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $41e2c210a1c3aa9f$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $41e2c210a1c3aa9f$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $41e2c210a1c3aa9f$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $l7j26.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $41e2c210a1c3aa9f$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $l7j26.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $41e2c210a1c3aa9f$var$getCanvas(item) {
    if ((0, $l7j26.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $41e2c210a1c3aa9f$var$instances = {};
const $41e2c210a1c3aa9f$var$getChart = (key)=>{
    const canvas = $41e2c210a1c3aa9f$var$getCanvas(key);
    return Object.values($41e2c210a1c3aa9f$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $41e2c210a1c3aa9f$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $41e2c210a1c3aa9f$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $41e2c210a1c3aa9f$export$acaa6426d77a227e {
    static defaults = (0, $l7j26.d);
    static instances = $41e2c210a1c3aa9f$var$instances;
    static overrides = (0, $l7j26.a3);
    static registry = $41e2c210a1c3aa9f$export$4bb7493d241fd8a5;
    static version = $41e2c210a1c3aa9f$var$version;
    static getChart = $41e2c210a1c3aa9f$var$getChart;
    static register(...items) {
        $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.add(...items);
        $41e2c210a1c3aa9f$var$invalidatePlugins();
    }
    static unregister(...items) {
        $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.remove(...items);
        $41e2c210a1c3aa9f$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $41e2c210a1c3aa9f$var$Config(userConfig);
        const initialCanvas = $41e2c210a1c3aa9f$var$getCanvas(item);
        const existingChart = $41e2c210a1c3aa9f$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $41e2c210a1c3aa9f$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $l7j26.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $41e2c210a1c3aa9f$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $l7j26.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $41e2c210a1c3aa9f$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.listen(this, 'complete', $41e2c210a1c3aa9f$var$onAnimationsComplete);
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.listen(this, 'progress', $41e2c210a1c3aa9f$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $l7j26.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $41e2c210a1c3aa9f$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $l7j26.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $l7j26.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$41e2c210a1c3aa9f$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $l7j26.ae)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $l7j26.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $l7j26.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $41e2c210a1c3aa9f$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $l7j26.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $41e2c210a1c3aa9f$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $l7j26.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $41e2c210a1c3aa9f$var$positionIsHorizontal(scaleOptions.position, axis) !== $41e2c210a1c3aa9f$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $l7j26.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $l7j26.F)(scales, (scale)=>{
            $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($41e2c210a1c3aa9f$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $41e2c210a1c3aa9f$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $l7j26.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $41e2c210a1c3aa9f$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $l7j26.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $l7j26.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($41e2c210a1c3aa9f$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $l7j26.F)(this.scales, (scale)=>{
            $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $l7j26.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $41e2c210a1c3aa9f$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $l7j26.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $l7j26.F)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $l7j26.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($41e2c210a1c3aa9f$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$41e2c210a1c3aa9f$export$a424a0aa8f687495.running(this)) $41e2c210a1c3aa9f$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $41e2c210a1c3aa9f$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $l7j26.ah)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $l7j26.Y)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $l7j26.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $l7j26.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $41e2c210a1c3aa9f$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $l7j26.j)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $l7j26.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $41e2c210a1c3aa9f$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $l7j26.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $41e2c210a1c3aa9f$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $l7j26.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $l7j26.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $l7j26.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $l7j26.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $l7j26.aj)(e);
        const lastEvent = $41e2c210a1c3aa9f$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $l7j26.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $l7j26.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $l7j26.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $41e2c210a1c3aa9f$var$invalidatePlugins() {
    return (0, $l7j26.F)($41e2c210a1c3aa9f$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $41e2c210a1c3aa9f$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $l7j26.al)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $l7j26.al)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $l7j26.al)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $l7j26.P) / 2, startAngle + (0, $l7j26.P) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $l7j26.P) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $l7j26.P) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $l7j26.P) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $l7j26.P) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $41e2c210a1c3aa9f$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $l7j26.H), startAngle - (0, $l7j26.H));
    ctx.closePath();
    ctx.clip();
}
function $41e2c210a1c3aa9f$var$toRadiusCorners(value) {
    return (0, $l7j26.am)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $41e2c210a1c3aa9f$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $41e2c210a1c3aa9f$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $l7j26.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $l7j26.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $l7j26.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $41e2c210a1c3aa9f$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $l7j26.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $41e2c210a1c3aa9f$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $l7j26.H));
        }
        // The line from point 3 to point 4
        const p4 = $41e2c210a1c3aa9f$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $l7j26.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $l7j26.H));
        }
        // The line from point 7 to point 8
        const p8 = $41e2c210a1c3aa9f$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $41e2c210a1c3aa9f$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $l7j26.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $41e2c210a1c3aa9f$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $l7j26.T) || (0, $l7j26.T));
    }
    $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $41e2c210a1c3aa9f$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $l7j26.T) || (0, $l7j26.T));
    }
    if (inner) $41e2c210a1c3aa9f$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $l7j26.P) && borderRadius === 0 && borderJoinStyle !== 'miter') $41e2c210a1c3aa9f$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $41e2c210a1c3aa9f$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $41e2c210a1c3aa9f$export$d48203c759d6a1fc extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $l7j26.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $l7j26.v)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $l7j26.p)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $l7j26.T) || nonZeroBetween;
        const withinRadius = (0, $l7j26.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $l7j26.T) ? Math.floor(circumference / (0, $l7j26.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $l7j26.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $41e2c210a1c3aa9f$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $41e2c210a1c3aa9f$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $41e2c210a1c3aa9f$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $l7j26.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $l7j26.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $l7j26.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $l7j26.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $l7j26.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $l7j26.v)(style.borderColor, options.borderColor);
}
function $41e2c210a1c3aa9f$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $41e2c210a1c3aa9f$var$getLineMethod(options) {
    if (options.stepped) return 0, $l7j26.at;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $l7j26.au;
    return $41e2c210a1c3aa9f$var$lineTo;
}
function $41e2c210a1c3aa9f$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $41e2c210a1c3aa9f$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $41e2c210a1c3aa9f$var$pathVars(points, segment, params);
    const lineMethod = $41e2c210a1c3aa9f$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $41e2c210a1c3aa9f$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $41e2c210a1c3aa9f$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $41e2c210a1c3aa9f$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $41e2c210a1c3aa9f$var$fastPathSegment : $41e2c210a1c3aa9f$var$pathSegment;
}
function $41e2c210a1c3aa9f$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $l7j26.aq;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $l7j26.ar;
    return 0, $l7j26.as;
}
function $41e2c210a1c3aa9f$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $41e2c210a1c3aa9f$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $41e2c210a1c3aa9f$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $41e2c210a1c3aa9f$var$_getSegmentMethod(line);
    for (const segment of segments){
        $41e2c210a1c3aa9f$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $41e2c210a1c3aa9f$var$usePath2D = typeof Path2D === 'function';
function $41e2c210a1c3aa9f$var$draw(ctx, line, start, count) {
    if ($41e2c210a1c3aa9f$var$usePath2D && !line.options.segment) $41e2c210a1c3aa9f$var$strokePathWithCache(ctx, line, start, count);
    else $41e2c210a1c3aa9f$var$strokePathDirect(ctx, line, start, count);
}
class $41e2c210a1c3aa9f$export$55e463fa7bcd3469 extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $l7j26.an)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $l7j26.ao)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $l7j26.ap)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $41e2c210a1c3aa9f$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $41e2c210a1c3aa9f$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $41e2c210a1c3aa9f$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $41e2c210a1c3aa9f$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $41e2c210a1c3aa9f$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $41e2c210a1c3aa9f$export$bd159b522b230b7a extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $l7j26.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $l7j26.av)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $41e2c210a1c3aa9f$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $41e2c210a1c3aa9f$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $l7j26.S)(value, min, max);
}
function $41e2c210a1c3aa9f$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $l7j26.ax)(value);
    return {
        t: $41e2c210a1c3aa9f$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $41e2c210a1c3aa9f$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $41e2c210a1c3aa9f$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $41e2c210a1c3aa9f$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $41e2c210a1c3aa9f$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $l7j26.ay)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $l7j26.i)(value);
    return {
        topLeft: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $41e2c210a1c3aa9f$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $41e2c210a1c3aa9f$var$boundingRects(bar) {
    const bounds = $41e2c210a1c3aa9f$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $41e2c210a1c3aa9f$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $41e2c210a1c3aa9f$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $41e2c210a1c3aa9f$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $41e2c210a1c3aa9f$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $l7j26.ak)(x, bounds.left, bounds.right)) && (skipY || (0, $l7j26.ak)(y, bounds.top, bounds.bottom));
}
function $41e2c210a1c3aa9f$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $41e2c210a1c3aa9f$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $41e2c210a1c3aa9f$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $41e2c210a1c3aa9f$export$a16ed71bf4b07672 extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $41e2c210a1c3aa9f$var$boundingRects(this);
        const addRectPath = $41e2c210a1c3aa9f$var$hasRadius(outer.radius) ? (0, $l7j26.aw) : $41e2c210a1c3aa9f$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $41e2c210a1c3aa9f$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $41e2c210a1c3aa9f$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $41e2c210a1c3aa9f$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $41e2c210a1c3aa9f$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $41e2c210a1c3aa9f$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $41e2c210a1c3aa9f$export$d48203c759d6a1fc,
    BarElement: $41e2c210a1c3aa9f$export$a16ed71bf4b07672,
    LineElement: $41e2c210a1c3aa9f$export$55e463fa7bcd3469,
    PointElement: $41e2c210a1c3aa9f$export$bd159b522b230b7a
});
const $41e2c210a1c3aa9f$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $41e2c210a1c3aa9f$var$BACKGROUND_COLORS = /* #__PURE__ */ $41e2c210a1c3aa9f$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $41e2c210a1c3aa9f$var$getBorderColor(i) {
    return $41e2c210a1c3aa9f$var$BORDER_COLORS[i % $41e2c210a1c3aa9f$var$BORDER_COLORS.length];
}
function $41e2c210a1c3aa9f$var$getBackgroundColor(i) {
    return $41e2c210a1c3aa9f$var$BACKGROUND_COLORS[i % $41e2c210a1c3aa9f$var$BACKGROUND_COLORS.length];
}
function $41e2c210a1c3aa9f$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $41e2c210a1c3aa9f$var$getBorderColor(i);
    dataset.backgroundColor = $41e2c210a1c3aa9f$var$getBackgroundColor(i);
    return ++i;
}
function $41e2c210a1c3aa9f$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$41e2c210a1c3aa9f$var$getBorderColor(i++));
    return i;
}
function $41e2c210a1c3aa9f$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$41e2c210a1c3aa9f$var$getBackgroundColor(i++));
    return i;
}
function $41e2c210a1c3aa9f$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $41e2c210a1c3aa9f$export$e04603e7d8b77172) i = $41e2c210a1c3aa9f$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $41e2c210a1c3aa9f$export$2a270b3a0d973c85) i = $41e2c210a1c3aa9f$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $41e2c210a1c3aa9f$var$colorizeDefaultDataset(dataset, i);
    };
}
function $41e2c210a1c3aa9f$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $41e2c210a1c3aa9f$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $41e2c210a1c3aa9f$var$containsDefaultColorsDefenitions() {
    return (0, $l7j26.d).borderColor !== 'rgba(0,0,0,0.1)' || (0, $l7j26.d).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $41e2c210a1c3aa9f$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $41e2c210a1c3aa9f$var$containsColorsDefinitions(datasets) || $41e2c210a1c3aa9f$var$containsColorsDefinition(chartOptions) || elements && $41e2c210a1c3aa9f$var$containsColorsDefinitions(elements) || $41e2c210a1c3aa9f$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $41e2c210a1c3aa9f$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $41e2c210a1c3aa9f$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $41e2c210a1c3aa9f$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $l7j26.k)(minIndex) && !(0, $l7j26.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $41e2c210a1c3aa9f$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $41e2c210a1c3aa9f$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $41e2c210a1c3aa9f$var$cleanDecimatedDataset(dataset);
    });
}
function $41e2c210a1c3aa9f$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $l7j26.S)((0, $l7j26.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $l7j26.S)((0, $l7j26.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $41e2c210a1c3aa9f$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $41e2c210a1c3aa9f$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $l7j26.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $41e2c210a1c3aa9f$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $41e2c210a1c3aa9f$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $l7j26.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $41e2c210a1c3aa9f$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $41e2c210a1c3aa9f$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $41e2c210a1c3aa9f$var$cleanDecimatedData(chart);
    }
};
function $41e2c210a1c3aa9f$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, points);
        const bounds = $41e2c210a1c3aa9f$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $l7j26.ap)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $41e2c210a1c3aa9f$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $l7j26.az)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $41e2c210a1c3aa9f$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $41e2c210a1c3aa9f$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $41e2c210a1c3aa9f$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $l7j26.al)(start);
        end = (0, $l7j26.al)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $41e2c210a1c3aa9f$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $41e2c210a1c3aa9f$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $41e2c210a1c3aa9f$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $l7j26.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $41e2c210a1c3aa9f$var$_pointsFromSegments(boundary, line);
    return points.length ? new $41e2c210a1c3aa9f$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $41e2c210a1c3aa9f$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $41e2c210a1c3aa9f$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $l7j26.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $41e2c210a1c3aa9f$var$_decodeFill(line, index, count) {
    const fill = $41e2c210a1c3aa9f$var$parseFillOption(line);
    if ((0, $l7j26.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $l7j26.g)(target) && Math.floor(target) === target) return $41e2c210a1c3aa9f$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $41e2c210a1c3aa9f$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $41e2c210a1c3aa9f$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $l7j26.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $41e2c210a1c3aa9f$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $l7j26.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $41e2c210a1c3aa9f$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $l7j26.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $41e2c210a1c3aa9f$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $41e2c210a1c3aa9f$var$getLinesBelow(scale, index);
    linesBelow.push($41e2c210a1c3aa9f$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$41e2c210a1c3aa9f$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $41e2c210a1c3aa9f$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $41e2c210a1c3aa9f$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $41e2c210a1c3aa9f$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $41e2c210a1c3aa9f$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $41e2c210a1c3aa9f$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $l7j26.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $41e2c210a1c3aa9f$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $l7j26.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $41e2c210a1c3aa9f$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $l7j26.g)(fill)) return $41e2c210a1c3aa9f$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $41e2c210a1c3aa9f$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $41e2c210a1c3aa9f$var$computeBoundary(source);
    if (boundary instanceof $41e2c210a1c3aa9f$var$simpleArc) return boundary;
    return $41e2c210a1c3aa9f$var$_createBoundaryLine(boundary, line);
}
function $41e2c210a1c3aa9f$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $41e2c210a1c3aa9f$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $41e2c210a1c3aa9f$var$computeCircularBoundary(source);
    return $41e2c210a1c3aa9f$var$computeLinearBoundary(source);
}
function $41e2c210a1c3aa9f$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $41e2c210a1c3aa9f$var$_getTargetPixel(fill, scale);
    if ((0, $l7j26.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $41e2c210a1c3aa9f$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $41e2c210a1c3aa9f$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $41e2c210a1c3aa9f$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $41e2c210a1c3aa9f$var$_drawfill(ctx, source, area) {
    const target = $41e2c210a1c3aa9f$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $l7j26.ah)(chart, meta);
    if (target && line.points.length) {
        (0, $l7j26.Y)(ctx, area);
        $41e2c210a1c3aa9f$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $l7j26.$)(ctx);
    }
}
function $41e2c210a1c3aa9f$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $41e2c210a1c3aa9f$var$clipVertical(ctx, target, area.top);
            $41e2c210a1c3aa9f$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $41e2c210a1c3aa9f$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $41e2c210a1c3aa9f$var$clipHorizontal(ctx, target, area.left);
            $41e2c210a1c3aa9f$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $41e2c210a1c3aa9f$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $41e2c210a1c3aa9f$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $41e2c210a1c3aa9f$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $41e2c210a1c3aa9f$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$41e2c210a1c3aa9f$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $41e2c210a1c3aa9f$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $41e2c210a1c3aa9f$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $41e2c210a1c3aa9f$var$clipBounds(ctx, scale, clip, notShape && $41e2c210a1c3aa9f$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $41e2c210a1c3aa9f$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $41e2c210a1c3aa9f$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $41e2c210a1c3aa9f$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $41e2c210a1c3aa9f$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $41e2c210a1c3aa9f$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $41e2c210a1c3aa9f$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $41e2c210a1c3aa9f$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $41e2c210a1c3aa9f$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $41e2c210a1c3aa9f$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($41e2c210a1c3aa9f$var$_shouldApplyFill(source)) $41e2c210a1c3aa9f$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$41e2c210a1c3aa9f$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $41e2c210a1c3aa9f$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $41e2c210a1c3aa9f$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $41e2c210a1c3aa9f$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $41e2c210a1c3aa9f$var$Legend extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $l7j26.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $l7j26.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $41e2c210a1c3aa9f$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $41e2c210a1c3aa9f$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $l7j26.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $l7j26.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $l7j26.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $l7j26.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $l7j26.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $l7j26.Y)(ctx, this);
            this._draw();
            (0, $l7j26.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $l7j26.d).color;
        const rtlHelper = (0, $l7j26.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, $l7j26.a0)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $41e2c210a1c3aa9f$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $l7j26.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $l7j26.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $l7j26.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $l7j26.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $l7j26.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $l7j26.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $l7j26.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $l7j26.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $l7j26.ay)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $l7j26.aw)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $l7j26.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $l7j26.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $l7j26.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $l7j26.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $l7j26.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $l7j26.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $l7j26.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $41e2c210a1c3aa9f$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $l7j26.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $l7j26.a0)(titleOpts.font);
        const titlePadding = (0, $l7j26.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $l7j26.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $l7j26.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $l7j26.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $l7j26.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $l7j26.a1)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $l7j26.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $l7j26.a0)(titleOpts.font);
        const titlePadding = (0, $l7j26.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $l7j26.ak)(x, this.left, this.right) && (0, $l7j26.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $l7j26.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $l7j26.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$41e2c210a1c3aa9f$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $41e2c210a1c3aa9f$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $l7j26.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $l7j26.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $l7j26.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $41e2c210a1c3aa9f$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $41e2c210a1c3aa9f$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $41e2c210a1c3aa9f$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $41e2c210a1c3aa9f$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $41e2c210a1c3aa9f$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $41e2c210a1c3aa9f$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $41e2c210a1c3aa9f$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $41e2c210a1c3aa9f$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $41e2c210a1c3aa9f$export$ed247974535929c7 = {
    id: 'legend',
    _element: $41e2c210a1c3aa9f$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $41e2c210a1c3aa9f$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $l7j26.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $41e2c210a1c3aa9f$var$Title extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $l7j26.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $l7j26.E)(opts.padding);
        const textSize = lineCount * (0, $l7j26.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $l7j26.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $l7j26.a2)(align, bottom, top);
                rotation = (0, $l7j26.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $l7j26.a2)(align, top, bottom);
                rotation = (0, $l7j26.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $l7j26.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $l7j26.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $l7j26.a1)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $41e2c210a1c3aa9f$var$createTitle(chart, titleOpts) {
    const title = new $41e2c210a1c3aa9f$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $41e2c210a1c3aa9f$export$f99233281efd08a0 = {
    id: 'title',
    _element: $41e2c210a1c3aa9f$var$Title,
    start (chart, _args, options) {
        $41e2c210a1c3aa9f$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $41e2c210a1c3aa9f$var$map = new WeakMap();
var $41e2c210a1c3aa9f$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $41e2c210a1c3aa9f$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, options);
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.addBox(chart, title);
        $41e2c210a1c3aa9f$var$map.set(chart, title);
    },
    stop (chart) {
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.removeBox(chart, $41e2c210a1c3aa9f$var$map.get(chart));
        $41e2c210a1c3aa9f$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $41e2c210a1c3aa9f$var$map.get(chart);
        $41e2c210a1c3aa9f$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $41e2c210a1c3aa9f$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $l7j26.aF)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $41e2c210a1c3aa9f$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $l7j26.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $41e2c210a1c3aa9f$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $41e2c210a1c3aa9f$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $41e2c210a1c3aa9f$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $l7j26.a0)(options.bodyFont);
    const titleFont = (0, $l7j26.a0)(options.titleFont);
    const footerFont = (0, $l7j26.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $l7j26.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $l7j26.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $l7j26.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $l7j26.F)(body, (bodyItem)=>{
        (0, $l7j26.F)(bodyItem.before, maxLineWidth);
        (0, $l7j26.F)(bodyItem.lines, maxLineWidth);
        (0, $l7j26.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $l7j26.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $41e2c210a1c3aa9f$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $41e2c210a1c3aa9f$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $41e2c210a1c3aa9f$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($41e2c210a1c3aa9f$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $41e2c210a1c3aa9f$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $41e2c210a1c3aa9f$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $41e2c210a1c3aa9f$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $41e2c210a1c3aa9f$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $41e2c210a1c3aa9f$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $41e2c210a1c3aa9f$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $l7j26.ay)(cornerRadius);
    let x = $41e2c210a1c3aa9f$var$alignX(size, xAlign);
    const y = $41e2c210a1c3aa9f$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $l7j26.S)(x, 0, chart.width - size.width),
        y: (0, $l7j26.S)(y, 0, chart.height - size.height)
    };
}
function $41e2c210a1c3aa9f$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $l7j26.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $41e2c210a1c3aa9f$var$getBeforeAfterBodyLines(callback) {
    return $41e2c210a1c3aa9f$var$pushOrConcat([], $41e2c210a1c3aa9f$var$splitNewlines(callback));
}
function $41e2c210a1c3aa9f$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $l7j26.j)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $41e2c210a1c3aa9f$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $41e2c210a1c3aa9f$var$defaultCallbacks = {
    beforeTitle: (0, $l7j26.aG),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $l7j26.aG),
    beforeBody: (0, $l7j26.aG),
    beforeLabel: (0, $l7j26.aG),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $l7j26.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $l7j26.aG),
    afterBody: (0, $l7j26.aG),
    beforeFooter: (0, $l7j26.aG),
    footer: (0, $l7j26.aG),
    afterFooter: (0, $l7j26.aG)
};
function $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $41e2c210a1c3aa9f$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $41e2c210a1c3aa9f$var$Tooltip extends $41e2c210a1c3aa9f$export$db77ccec0bb4ccac {
    static positioners = $41e2c210a1c3aa9f$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $41e2c210a1c3aa9f$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $41e2c210a1c3aa9f$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(beforeTitle));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(title));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $41e2c210a1c3aa9f$var$getBeforeAfterBodyLines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $l7j26.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $41e2c210a1c3aa9f$var$overrideCallbacks(callbacks, context);
            $41e2c210a1c3aa9f$var$pushOrConcat(bodyItem.before, $41e2c210a1c3aa9f$var$splitNewlines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $41e2c210a1c3aa9f$var$pushOrConcat(bodyItem.lines, $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $41e2c210a1c3aa9f$var$pushOrConcat(bodyItem.after, $41e2c210a1c3aa9f$var$splitNewlines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $41e2c210a1c3aa9f$var$getBeforeAfterBodyLines($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $41e2c210a1c3aa9f$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(beforeFooter));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(footer));
        lines = $41e2c210a1c3aa9f$var$pushOrConcat(lines, $41e2c210a1c3aa9f$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($41e2c210a1c3aa9f$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $l7j26.F)(tooltipItems, (context)=>{
            const scoped = $41e2c210a1c3aa9f$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($41e2c210a1c3aa9f$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $41e2c210a1c3aa9f$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $41e2c210a1c3aa9f$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $41e2c210a1c3aa9f$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $41e2c210a1c3aa9f$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $l7j26.ay)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $l7j26.aA)(options.rtl, this.x, this.width);
            pt.x = $41e2c210a1c3aa9f$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $l7j26.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $l7j26.a0)(options.bodyFont);
        const colorX = $41e2c210a1c3aa9f$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $l7j26.av)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $l7j26.av)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $l7j26.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $l7j26.ay)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $l7j26.aw)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $l7j26.aw)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $l7j26.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $l7j26.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $41e2c210a1c3aa9f$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $l7j26.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $l7j26.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $l7j26.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $l7j26.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $l7j26.aA)(options.rtl, this.x, this.width);
            pt.x = $41e2c210a1c3aa9f$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $l7j26.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $l7j26.ay)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $41e2c210a1c3aa9f$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $41e2c210a1c3aa9f$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $41e2c210a1c3aa9f$var$determineAlignment(chart, options, positionAndSize);
            const point = $41e2c210a1c3aa9f$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $l7j26.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $l7j26.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $l7j26.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $l7j26.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $l7j26.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $41e2c210a1c3aa9f$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $41e2c210a1c3aa9f$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $41e2c210a1c3aa9f$var$Tooltip,
    positioners: $41e2c210a1c3aa9f$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $41e2c210a1c3aa9f$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $41e2c210a1c3aa9f$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $41e2c210a1c3aa9f$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $41e2c210a1c3aa9f$export$c537fa0d021d010b,
    Decimation: $41e2c210a1c3aa9f$export$be17f937e9aa7533,
    Filler: $41e2c210a1c3aa9f$export$d19ba4d812bed757,
    Legend: $41e2c210a1c3aa9f$export$ed247974535929c7,
    SubTitle: $41e2c210a1c3aa9f$export$d5c56664638992a4,
    Title: $41e2c210a1c3aa9f$export$f99233281efd08a0,
    Tooltip: $41e2c210a1c3aa9f$export$28c660c63b792dea
});
const $41e2c210a1c3aa9f$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $41e2c210a1c3aa9f$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $41e2c210a1c3aa9f$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $41e2c210a1c3aa9f$var$validIndex = (index, max)=>index === null ? null : (0, $l7j26.S)(Math.round(index), 0, max);
function $41e2c210a1c3aa9f$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $41e2c210a1c3aa9f$export$29e663ba4d09fe7 extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $41e2c210a1c3aa9f$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $l7j26.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $41e2c210a1c3aa9f$var$findOrAddLabel(labels, raw, (0, $l7j26.v)(index, raw), this._addedLabels);
        return $41e2c210a1c3aa9f$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $41e2c210a1c3aa9f$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $41e2c210a1c3aa9f$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $l7j26.k)(min);
    const maxDefined = !(0, $l7j26.k)(max);
    const countDefined = !(0, $l7j26.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $l7j26.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $l7j26.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $l7j26.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $l7j26.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $l7j26.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $l7j26.aL)(spacing), (0, $l7j26.aL)(niceMin));
    factor = Math.pow(10, (0, $l7j26.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $l7j26.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, $41e2c210a1c3aa9f$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $l7j26.aK)(ticks[ticks.length - 1].value, max, $41e2c210a1c3aa9f$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $41e2c210a1c3aa9f$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $l7j26.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $41e2c210a1c3aa9f$var$LinearScaleBase extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $l7j26.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $l7j26.s)(min);
            const maxSign = (0, $l7j26.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $41e2c210a1c3aa9f$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $l7j26.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $l7j26.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $41e2c210a1c3aa9f$export$e7f4e5e8656f0b93 extends $41e2c210a1c3aa9f$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $l7j26.aM).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $l7j26.g)(min) ? min : 0;
        this.max = (0, $l7j26.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $l7j26.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $41e2c210a1c3aa9f$var$log10Floor = (v)=>Math.floor((0, $l7j26.aN)(v));
const $41e2c210a1c3aa9f$var$changeExponent = (v, m)=>Math.pow(10, $41e2c210a1c3aa9f$var$log10Floor(v) + m);
function $41e2c210a1c3aa9f$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $41e2c210a1c3aa9f$var$log10Floor(tickVal));
    return remain === 1;
}
function $41e2c210a1c3aa9f$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $41e2c210a1c3aa9f$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $41e2c210a1c3aa9f$var$log10Floor(range);
    while($41e2c210a1c3aa9f$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($41e2c210a1c3aa9f$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $41e2c210a1c3aa9f$var$log10Floor(min));
}
function $41e2c210a1c3aa9f$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $l7j26.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = $41e2c210a1c3aa9f$var$log10Floor(min);
    let exp = $41e2c210a1c3aa9f$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $l7j26.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $41e2c210a1c3aa9f$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $l7j26.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $41e2c210a1c3aa9f$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $41e2c210a1c3aa9f$export$85295eaf7cb3ac3e extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $l7j26.aM).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $41e2c210a1c3aa9f$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $l7j26.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $l7j26.g)(min) ? Math.max(0, min) : null;
        this.max = (0, $l7j26.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $l7j26.g)(this._userMin)) this.min = min === $41e2c210a1c3aa9f$var$changeExponent(this.min, 0) ? $41e2c210a1c3aa9f$var$changeExponent(this.min, -1) : $41e2c210a1c3aa9f$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($41e2c210a1c3aa9f$var$changeExponent(min, -1));
                setMax($41e2c210a1c3aa9f$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($41e2c210a1c3aa9f$var$changeExponent(max, -1));
        if (max <= 0) setMax($41e2c210a1c3aa9f$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $41e2c210a1c3aa9f$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $l7j26.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $l7j26.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $l7j26.aN)(start);
        this._valueRange = (0, $l7j26.aN)(this.max) - (0, $l7j26.aN)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $l7j26.aN)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $41e2c210a1c3aa9f$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $l7j26.E)(tickOpts.backdropPadding);
        return (0, $l7j26.v)(tickOpts.font && tickOpts.font.size, (0, $l7j26.d).font.size) + padding.height;
    }
    return 0;
}
function $41e2c210a1c3aa9f$var$measureLabelSize(ctx, font, label) {
    label = (0, $l7j26.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $l7j26.aO)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $41e2c210a1c3aa9f$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $41e2c210a1c3aa9f$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $l7j26.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $l7j26.a0)(opts.font);
        const textSize = $41e2c210a1c3aa9f$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $l7j26.al)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $l7j26.U)(angleRadians));
        const hLimits = $41e2c210a1c3aa9f$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $41e2c210a1c3aa9f$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $41e2c210a1c3aa9f$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $41e2c210a1c3aa9f$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $41e2c210a1c3aa9f$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $41e2c210a1c3aa9f$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $l7j26.U)((0, $l7j26.al)(pointLabelPosition.angle + (0, $l7j26.H))));
    const y = $41e2c210a1c3aa9f$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $41e2c210a1c3aa9f$var$getTextAlignForAngle(angle);
    const left = $41e2c210a1c3aa9f$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $41e2c210a1c3aa9f$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $l7j26.C)({
        x: left,
        y: top
    }, area) || (0, $l7j26.C)({
        x: left,
        y: bottom
    }, area) || (0, $l7j26.C)({
        x: right,
        y: top
    }, area) || (0, $l7j26.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $41e2c210a1c3aa9f$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $41e2c210a1c3aa9f$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $l7j26.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $41e2c210a1c3aa9f$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $41e2c210a1c3aa9f$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $41e2c210a1c3aa9f$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $41e2c210a1c3aa9f$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $41e2c210a1c3aa9f$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $41e2c210a1c3aa9f$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $l7j26.k)(backdropColor)) {
        const borderRadius = (0, $l7j26.ay)(opts.borderRadius);
        const padding = (0, $l7j26.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $l7j26.aw)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $41e2c210a1c3aa9f$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $41e2c210a1c3aa9f$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $l7j26.a0)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $l7j26.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $41e2c210a1c3aa9f$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $l7j26.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $41e2c210a1c3aa9f$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $41e2c210a1c3aa9f$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $41e2c210a1c3aa9f$var$createPointLabelContext(parent, index, label) {
    return (0, $l7j26.j)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $41e2c210a1c3aa9f$export$cfafc36d95386d38 extends $41e2c210a1c3aa9f$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $l7j26.aM).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $l7j26.E)($41e2c210a1c3aa9f$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $l7j26.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $l7j26.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $41e2c210a1c3aa9f$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $41e2c210a1c3aa9f$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $l7j26.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $41e2c210a1c3aa9f$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $l7j26.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $l7j26.al)(index * angleMultiplier + (0, $l7j26.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $l7j26.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $l7j26.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $41e2c210a1c3aa9f$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $l7j26.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $41e2c210a1c3aa9f$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $41e2c210a1c3aa9f$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $41e2c210a1c3aa9f$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $l7j26.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $l7j26.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $l7j26.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $41e2c210a1c3aa9f$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $41e2c210a1c3aa9f$var$UNITS = /* #__PURE__ */ Object.keys($41e2c210a1c3aa9f$var$INTERVALS);
function $41e2c210a1c3aa9f$var$sorter(a, b) {
    return a - b;
}
function $41e2c210a1c3aa9f$var$parse(scale, input) {
    if ((0, $l7j26.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $l7j26.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $l7j26.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $41e2c210a1c3aa9f$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $41e2c210a1c3aa9f$var$UNITS.length;
    for(let i = $41e2c210a1c3aa9f$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $41e2c210a1c3aa9f$var$INTERVALS[$41e2c210a1c3aa9f$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $41e2c210a1c3aa9f$var$UNITS[i];
    }
    return $41e2c210a1c3aa9f$var$UNITS[ilen - 1];
}
function $41e2c210a1c3aa9f$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $41e2c210a1c3aa9f$var$UNITS.length - 1; i >= $41e2c210a1c3aa9f$var$UNITS.indexOf(minUnit); i--){
        const unit = $41e2c210a1c3aa9f$var$UNITS[i];
        if ($41e2c210a1c3aa9f$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $41e2c210a1c3aa9f$var$UNITS[minUnit ? $41e2c210a1c3aa9f$var$UNITS.indexOf(minUnit) : 0];
}
function $41e2c210a1c3aa9f$var$determineMajorUnit(unit) {
    for(let i = $41e2c210a1c3aa9f$var$UNITS.indexOf(unit) + 1, ilen = $41e2c210a1c3aa9f$var$UNITS.length; i < ilen; ++i){
        if ($41e2c210a1c3aa9f$var$INTERVALS[$41e2c210a1c3aa9f$var$UNITS[i]].common) return $41e2c210a1c3aa9f$var$UNITS[i];
    }
}
function $41e2c210a1c3aa9f$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $l7j26.aQ)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $41e2c210a1c3aa9f$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $41e2c210a1c3aa9f$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $41e2c210a1c3aa9f$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $41e2c210a1c3aa9f$export$a894c72689ff3ec extends $41e2c210a1c3aa9f$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $41e2c210a1c3aa9f$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $l7j26.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $41e2c210a1c3aa9f$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $l7j26.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $l7j26.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $l7j26.aP)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $41e2c210a1c3aa9f$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $41e2c210a1c3aa9f$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $41e2c210a1c3aa9f$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $41e2c210a1c3aa9f$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $l7j26.S)(start, 0, limit);
        end = (0, $l7j26.S)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $41e2c210a1c3aa9f$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $l7j26.v)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $l7j26.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$41e2c210a1c3aa9f$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $41e2c210a1c3aa9f$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($41e2c210a1c3aa9f$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $l7j26.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $l7j26.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $41e2c210a1c3aa9f$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($41e2c210a1c3aa9f$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $l7j26._)(values.sort($41e2c210a1c3aa9f$var$sorter));
    }
}
function $41e2c210a1c3aa9f$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $l7j26.B)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $l7j26.B)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $41e2c210a1c3aa9f$export$85df64a8eb6dc986 extends $41e2c210a1c3aa9f$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $41e2c210a1c3aa9f$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $41e2c210a1c3aa9f$var$interpolate(table, this.min);
        this._tableRange = $41e2c210a1c3aa9f$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($41e2c210a1c3aa9f$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $41e2c210a1c3aa9f$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $41e2c210a1c3aa9f$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $41e2c210a1c3aa9f$export$29e663ba4d09fe7,
    LinearScale: $41e2c210a1c3aa9f$export$e7f4e5e8656f0b93,
    LogarithmicScale: $41e2c210a1c3aa9f$export$85295eaf7cb3ac3e,
    RadialLinearScale: $41e2c210a1c3aa9f$export$cfafc36d95386d38,
    TimeScale: $41e2c210a1c3aa9f$export$a894c72689ff3ec,
    TimeSeriesScale: $41e2c210a1c3aa9f$export$85df64a8eb6dc986
});
const $41e2c210a1c3aa9f$export$e8959e79e3af550f = [
    $41e2c210a1c3aa9f$export$a6506504f799c5d5,
    $41e2c210a1c3aa9f$export$7a5d735b2ab6389d,
    $41e2c210a1c3aa9f$export$8b3ca321c77fdea6,
    $41e2c210a1c3aa9f$export$bcac1c16f1530ec2
];

});
parcelRegister("l7j26", function(module, exports) {

$parcel$export(module.exports, "aG", () => $f5f903f1e6cdf69b$export$53a70dd1ebbae346);
$parcel$export(module.exports, "ac", () => $f5f903f1e6cdf69b$export$2219238a014317b0);
$parcel$export(module.exports, "k", () => $f5f903f1e6cdf69b$export$342063e11d6c3cad);
$parcel$export(module.exports, "b", () => $f5f903f1e6cdf69b$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "i", () => $f5f903f1e6cdf69b$export$23f2a1d2818174ef);
$parcel$export(module.exports, "g", () => $f5f903f1e6cdf69b$export$39b482c5e57630a8);
$parcel$export(module.exports, "O", () => $f5f903f1e6cdf69b$export$c4ce752e73470fba);
$parcel$export(module.exports, "v", () => $f5f903f1e6cdf69b$export$90a7f3efeed30595);
$parcel$export(module.exports, "m", () => $f5f903f1e6cdf69b$export$953cecd6e717a553);
$parcel$export(module.exports, "n", () => $f5f903f1e6cdf69b$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "Q", () => $f5f903f1e6cdf69b$export$3722cfe417b6ed86);
$parcel$export(module.exports, "F", () => $f5f903f1e6cdf69b$export$d66501df72047452);
$parcel$export(module.exports, "ai", () => $f5f903f1e6cdf69b$export$f38c853ae54ed474);
$parcel$export(module.exports, "a4", () => $f5f903f1e6cdf69b$export$efca4cbe5dd06740);
$parcel$export(module.exports, "ab", () => $f5f903f1e6cdf69b$export$555508cbc6add439);
$parcel$export(module.exports, "f", () => $f5f903f1e6cdf69b$export$2d1720544b23b823);
$parcel$export(module.exports, "a5", () => $f5f903f1e6cdf69b$export$a8550f7dbe79f93a);
$parcel$export(module.exports, "h", () => $f5f903f1e6cdf69b$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "a7", () => $f5f903f1e6cdf69b$export$a93c5207d687da10);
$parcel$export(module.exports, "ag", () => $f5f903f1e6cdf69b$export$ee7c8ad385a60b7b);
$parcel$export(module.exports, "aj", () => $f5f903f1e6cdf69b$export$3b513254972cfc9c);
$parcel$export(module.exports, "P", () => $f5f903f1e6cdf69b$export$56c0d5a1e737357d);
$parcel$export(module.exports, "T", () => $f5f903f1e6cdf69b$export$971d5caa766a69d7);
$parcel$export(module.exports, "H", () => $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "aN", () => $f5f903f1e6cdf69b$export$faec65b429be379);
$parcel$export(module.exports, "s", () => $f5f903f1e6cdf69b$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "aK", () => $f5f903f1e6cdf69b$export$23ebac1979863676);
$parcel$export(module.exports, "aI", () => $f5f903f1e6cdf69b$export$b9a6b53f9be3734);
$parcel$export(module.exports, "N", () => $f5f903f1e6cdf69b$export$a07804094c3ecf2d);
$parcel$export(module.exports, "x", () => $f5f903f1e6cdf69b$export$d141bba7fdc215a3);
$parcel$export(module.exports, "aJ", () => $f5f903f1e6cdf69b$export$a05254e7c3aeba6e);
$parcel$export(module.exports, "aH", () => $f5f903f1e6cdf69b$export$a33b77bbdbb8366c);
$parcel$export(module.exports, "t", () => $f5f903f1e6cdf69b$export$625550452a3fa3ec);
$parcel$export(module.exports, "U", () => $f5f903f1e6cdf69b$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "aL", () => $f5f903f1e6cdf69b$export$91477dc880baac21);
$parcel$export(module.exports, "D", () => $f5f903f1e6cdf69b$export$96f57966bedc81b4);
$parcel$export(module.exports, "aF", () => $f5f903f1e6cdf69b$export$cf2f7c5792f80b46);
$parcel$export(module.exports, "al", () => $f5f903f1e6cdf69b$export$ab83b03e4111b1d0);
$parcel$export(module.exports, "p", () => $f5f903f1e6cdf69b$export$ffb5f4729a158638);
$parcel$export(module.exports, "S", () => $f5f903f1e6cdf69b$export$25ce5a424b770e84);
$parcel$export(module.exports, "W", () => $f5f903f1e6cdf69b$export$71cec2538cb2c617);
$parcel$export(module.exports, "ak", () => $f5f903f1e6cdf69b$export$21579262ef46735b);
$parcel$export(module.exports, "aQ", () => $f5f903f1e6cdf69b$export$f96d196f7728bb5);
$parcel$export(module.exports, "B", () => $f5f903f1e6cdf69b$export$ef35774e6d314e91);
$parcel$export(module.exports, "A", () => $f5f903f1e6cdf69b$export$ebd11618f299a286);
$parcel$export(module.exports, "aP", () => $f5f903f1e6cdf69b$export$2ed0fc6709e59212);
$parcel$export(module.exports, "l", () => $f5f903f1e6cdf69b$export$882b5998b3b9117c);
$parcel$export(module.exports, "u", () => $f5f903f1e6cdf69b$export$3b14a55fb2447963);
$parcel$export(module.exports, "_", () => $f5f903f1e6cdf69b$export$71511d61b312f219);
$parcel$export(module.exports, "r", () => $f5f903f1e6cdf69b$export$43caf9889c228507);
$parcel$export(module.exports, "L", () => $f5f903f1e6cdf69b$export$61196ced6d74a310);
$parcel$export(module.exports, "ad", () => $f5f903f1e6cdf69b$export$4c3d22f3d993c33f);
$parcel$export(module.exports, "a1", () => $f5f903f1e6cdf69b$export$3c2fa207a37baaea);
$parcel$export(module.exports, "a2", () => $f5f903f1e6cdf69b$export$ce26c07117d59d6a);
$parcel$export(module.exports, "aC", () => $f5f903f1e6cdf69b$export$890c4ad488842ce7);
$parcel$export(module.exports, "q", () => $f5f903f1e6cdf69b$export$9e5f44173e64f162);
$parcel$export(module.exports, "w", () => $f5f903f1e6cdf69b$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "e", () => $f5f903f1e6cdf69b$export$f1e1789686576879);
$parcel$export(module.exports, "c", () => $f5f903f1e6cdf69b$export$db3b6bfb95261072);
$parcel$export(module.exports, "o", () => $f5f903f1e6cdf69b$export$ae1af26003f05816);
$parcel$export(module.exports, "aM", () => $f5f903f1e6cdf69b$export$9f4f30ee63539e24);
$parcel$export(module.exports, "a3", () => $f5f903f1e6cdf69b$export$6559d589eb85fbb6);
$parcel$export(module.exports, "a6", () => $f5f903f1e6cdf69b$export$2e2af4578d910ddf);
$parcel$export(module.exports, "d", () => $f5f903f1e6cdf69b$export$4368d992c4eafac0);
$parcel$export(module.exports, "V", () => $f5f903f1e6cdf69b$export$e7c866399fa523f5);
$parcel$export(module.exports, "aO", () => $f5f903f1e6cdf69b$export$c03999cb2f36933f);
$parcel$export(module.exports, "X", () => $f5f903f1e6cdf69b$export$78acf4525d8a74c4);
$parcel$export(module.exports, "af", () => $f5f903f1e6cdf69b$export$c9170ad7d4cd7e57);
$parcel$export(module.exports, "av", () => $f5f903f1e6cdf69b$export$d66dc83d8cfc8dd);
$parcel$export(module.exports, "aE", () => $f5f903f1e6cdf69b$export$158acd800e1ef08b);
$parcel$export(module.exports, "C", () => $f5f903f1e6cdf69b$export$e7094788287c5e9b);
$parcel$export(module.exports, "Y", () => $f5f903f1e6cdf69b$export$8743009a87fcb00f);
$parcel$export(module.exports, "$", () => $f5f903f1e6cdf69b$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "at", () => $f5f903f1e6cdf69b$export$493d36ec626b6698);
$parcel$export(module.exports, "au", () => $f5f903f1e6cdf69b$export$1fbe638ecf81657e);
$parcel$export(module.exports, "Z", () => $f5f903f1e6cdf69b$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "aw", () => $f5f903f1e6cdf69b$export$92108d983e8ee699);
$parcel$export(module.exports, "am", () => $f5f903f1e6cdf69b$export$1a82df3d29112e01);
$parcel$export(module.exports, "ax", () => $f5f903f1e6cdf69b$export$9fa96a7d116ea3ce);
$parcel$export(module.exports, "ay", () => $f5f903f1e6cdf69b$export$28f7fcd39efa255);
$parcel$export(module.exports, "E", () => $f5f903f1e6cdf69b$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "a0", () => $f5f903f1e6cdf69b$export$34aec0b863436764);
$parcel$export(module.exports, "a", () => $f5f903f1e6cdf69b$export$407448d2b89b1813);
$parcel$export(module.exports, "R", () => $f5f903f1e6cdf69b$export$db202ddc8be9136);
$parcel$export(module.exports, "j", () => $f5f903f1e6cdf69b$export$35e795649ee09318);
$parcel$export(module.exports, "a9", () => $f5f903f1e6cdf69b$export$a9c996f45e5784d0);
$parcel$export(module.exports, "a8", () => $f5f903f1e6cdf69b$export$c3950d9923825c02);
$parcel$export(module.exports, "aa", () => $f5f903f1e6cdf69b$export$7910e0436ed8d1de);
$parcel$export(module.exports, "y", () => $f5f903f1e6cdf69b$export$4a5767248b18ef41);
$parcel$export(module.exports, "an", () => $f5f903f1e6cdf69b$export$306ddfe3a8403e2);
$parcel$export(module.exports, "M", () => $f5f903f1e6cdf69b$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "I", () => $f5f903f1e6cdf69b$export$9bb611d729802a56);
$parcel$export(module.exports, "z", () => $f5f903f1e6cdf69b$export$df995fae86a55f06);
$parcel$export(module.exports, "G", () => $f5f903f1e6cdf69b$export$2329c99376c9d0a4);
$parcel$export(module.exports, "ae", () => $f5f903f1e6cdf69b$export$f787f51d84a910ad);
$parcel$export(module.exports, "K", () => $f5f903f1e6cdf69b$export$3466f893ebf79586);
$parcel$export(module.exports, "J", () => $f5f903f1e6cdf69b$export$b4171a6734a65d42);
$parcel$export(module.exports, "as", () => $f5f903f1e6cdf69b$export$6554612db691658e);
$parcel$export(module.exports, "aq", () => $f5f903f1e6cdf69b$export$8a5498727ef6be21);
$parcel$export(module.exports, "ar", () => $f5f903f1e6cdf69b$export$d24c54395ce0c509);
$parcel$export(module.exports, "aA", () => $f5f903f1e6cdf69b$export$91c6e00c14e7e6fd);
$parcel$export(module.exports, "aB", () => $f5f903f1e6cdf69b$export$9d398bebfec1c039);
$parcel$export(module.exports, "aD", () => $f5f903f1e6cdf69b$export$24baa2b76016ce0e);
$parcel$export(module.exports, "az", () => $f5f903f1e6cdf69b$export$3d12bd131bb975d1);
$parcel$export(module.exports, "ap", () => $f5f903f1e6cdf69b$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "ao", () => $f5f903f1e6cdf69b$export$7a38258bbe170828);
$parcel$export(module.exports, "ah", () => $f5f903f1e6cdf69b$export$995eb9fca571757);
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $865Gr = parcelRequire("865Gr");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $f5f903f1e6cdf69b$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $f5f903f1e6cdf69b$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $f5f903f1e6cdf69b$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $f5f903f1e6cdf69b$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $f5f903f1e6cdf69b$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $f5f903f1e6cdf69b$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $f5f903f1e6cdf69b$export$c4ce752e73470fba(value, defaultValue) {
    return $f5f903f1e6cdf69b$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $f5f903f1e6cdf69b$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $f5f903f1e6cdf69b$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $f5f903f1e6cdf69b$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $f5f903f1e6cdf69b$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $f5f903f1e6cdf69b$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($f5f903f1e6cdf69b$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($f5f903f1e6cdf69b$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $f5f903f1e6cdf69b$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $f5f903f1e6cdf69b$export$667d3bf0c5f83305(source) {
    if ($f5f903f1e6cdf69b$export$8b22cf2602fb60ce(source)) return source.map($f5f903f1e6cdf69b$export$667d3bf0c5f83305);
    if ($f5f903f1e6cdf69b$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $f5f903f1e6cdf69b$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $f5f903f1e6cdf69b$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $f5f903f1e6cdf69b$export$317a3d46287192d8(key, target, source, options) {
    if (!$f5f903f1e6cdf69b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($f5f903f1e6cdf69b$export$23f2a1d2818174ef(tval) && $f5f903f1e6cdf69b$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $f5f903f1e6cdf69b$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $f5f903f1e6cdf69b$export$667d3bf0c5f83305(sval);
}
function $f5f903f1e6cdf69b$export$efca4cbe5dd06740(target, source, options) {
    const sources = $f5f903f1e6cdf69b$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$f5f903f1e6cdf69b$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $f5f903f1e6cdf69b$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$f5f903f1e6cdf69b$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $f5f903f1e6cdf69b$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $f5f903f1e6cdf69b$export$efca4cbe5dd06740(target, source, {
        merger: $f5f903f1e6cdf69b$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $f5f903f1e6cdf69b$export$1ee57be6f6687d2c(key, target, source) {
    if (!$f5f903f1e6cdf69b$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($f5f903f1e6cdf69b$export$23f2a1d2818174ef(tval) && $f5f903f1e6cdf69b$export$23f2a1d2818174ef(sval)) $f5f903f1e6cdf69b$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $f5f903f1e6cdf69b$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $f5f903f1e6cdf69b$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $f5f903f1e6cdf69b$var$_getKeyResolver(key) {
    const keys = $f5f903f1e6cdf69b$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $f5f903f1e6cdf69b$export$2d1720544b23b823(obj, key) {
    const resolver = $f5f903f1e6cdf69b$var$keyResolvers[key] || ($f5f903f1e6cdf69b$var$keyResolvers[key] = $f5f903f1e6cdf69b$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $f5f903f1e6cdf69b$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $f5f903f1e6cdf69b$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $f5f903f1e6cdf69b$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $f5f903f1e6cdf69b$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $f5f903f1e6cdf69b$export$56c0d5a1e737357d = Math.PI;
const $f5f903f1e6cdf69b$export$971d5caa766a69d7 = 2 * $f5f903f1e6cdf69b$export$56c0d5a1e737357d;
const $f5f903f1e6cdf69b$export$2ec5befb9e6c97d4 = $f5f903f1e6cdf69b$export$971d5caa766a69d7 + $f5f903f1e6cdf69b$export$56c0d5a1e737357d;
const $f5f903f1e6cdf69b$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $f5f903f1e6cdf69b$export$39c1cc7c062529d4 = $f5f903f1e6cdf69b$export$56c0d5a1e737357d / 180;
const $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd = $f5f903f1e6cdf69b$export$56c0d5a1e737357d / 2;
const $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88 = $f5f903f1e6cdf69b$export$56c0d5a1e737357d / 4;
const $f5f903f1e6cdf69b$export$c18d01048907ea92 = $f5f903f1e6cdf69b$export$56c0d5a1e737357d * 2 / 3;
const $f5f903f1e6cdf69b$export$faec65b429be379 = Math.log10;
const $f5f903f1e6cdf69b$export$2408f22a0fab9ae5 = Math.sign;
function $f5f903f1e6cdf69b$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $f5f903f1e6cdf69b$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $f5f903f1e6cdf69b$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($f5f903f1e6cdf69b$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $f5f903f1e6cdf69b$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $f5f903f1e6cdf69b$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $f5f903f1e6cdf69b$export$d141bba7fdc215a3(n) {
    return !$f5f903f1e6cdf69b$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $f5f903f1e6cdf69b$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $f5f903f1e6cdf69b$export$625550452a3fa3ec(degrees) {
    return degrees * ($f5f903f1e6cdf69b$export$56c0d5a1e737357d / 180);
}
function $f5f903f1e6cdf69b$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $f5f903f1e6cdf69b$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $f5f903f1e6cdf69b$export$91477dc880baac21(x) {
    if (!$f5f903f1e6cdf69b$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $f5f903f1e6cdf69b$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $f5f903f1e6cdf69b$export$56c0d5a1e737357d) angle += $f5f903f1e6cdf69b$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $f5f903f1e6cdf69b$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $f5f903f1e6cdf69b$export$f074adc9fbd50943(a, b) {
    return (a - b + $f5f903f1e6cdf69b$export$2ec5befb9e6c97d4) % $f5f903f1e6cdf69b$export$971d5caa766a69d7 - $f5f903f1e6cdf69b$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(a) {
    return (a % $f5f903f1e6cdf69b$export$971d5caa766a69d7 + $f5f903f1e6cdf69b$export$971d5caa766a69d7) % $f5f903f1e6cdf69b$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(angle);
    const s = $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(start);
    const e = $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(end);
    const angleToStart = $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $f5f903f1e6cdf69b$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $f5f903f1e6cdf69b$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $f5f903f1e6cdf69b$export$71cec2538cb2c617(value) {
    return $f5f903f1e6cdf69b$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $f5f903f1e6cdf69b$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $f5f903f1e6cdf69b$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $f5f903f1e6cdf69b$export$ef35774e6d314e91 = (table, key, value, last)=>$f5f903f1e6cdf69b$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $f5f903f1e6cdf69b$export$ebd11618f299a286 = (table, key, value)=>$f5f903f1e6cdf69b$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $f5f903f1e6cdf69b$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $f5f903f1e6cdf69b$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $f5f903f1e6cdf69b$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $f5f903f1e6cdf69b$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $f5f903f1e6cdf69b$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $f5f903f1e6cdf69b$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $f5f903f1e6cdf69b$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $f5f903f1e6cdf69b$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $f5f903f1e6cdf69b$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $f5f903f1e6cdf69b$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $f5f903f1e6cdf69b$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $f5f903f1e6cdf69b$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $f5f903f1e6cdf69b$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $f5f903f1e6cdf69b$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $f5f903f1e6cdf69b$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $f5f903f1e6cdf69b$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $f5f903f1e6cdf69b$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($f5f903f1e6cdf69b$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $f5f903f1e6cdf69b$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$f5f903f1e6cdf69b$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $f5f903f1e6cdf69b$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($f5f903f1e6cdf69b$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $f5f903f1e6cdf69b$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$f5f903f1e6cdf69b$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $f5f903f1e6cdf69b$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $f5f903f1e6cdf69b$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $f5f903f1e6cdf69b$var$atEdge = (t)=>t === 0 || t === 1;
const $f5f903f1e6cdf69b$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $f5f903f1e6cdf69b$export$971d5caa766a69d7 / p));
const $f5f903f1e6cdf69b$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $f5f903f1e6cdf69b$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $f5f903f1e6cdf69b$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($f5f903f1e6cdf69b$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$f5f903f1e6cdf69b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$f5f903f1e6cdf69b$var$atEdge(t) ? t : $f5f903f1e6cdf69b$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$f5f903f1e6cdf69b$var$atEdge(t) ? t : $f5f903f1e6cdf69b$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $f5f903f1e6cdf69b$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $f5f903f1e6cdf69b$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $f5f903f1e6cdf69b$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $f5f903f1e6cdf69b$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $f5f903f1e6cdf69b$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $f5f903f1e6cdf69b$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $f5f903f1e6cdf69b$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $f5f903f1e6cdf69b$export$db3b6bfb95261072(value) {
    return $f5f903f1e6cdf69b$export$738ab4df8bf92ae9(value) ? value : new (0, $865Gr.Color)(value);
}
function $f5f903f1e6cdf69b$export$d377dcb2b61d6c4e(value) {
    return $f5f903f1e6cdf69b$export$738ab4df8bf92ae9(value) ? value : new (0, $865Gr.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const $f5f903f1e6cdf69b$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $f5f903f1e6cdf69b$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $f5f903f1e6cdf69b$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $f5f903f1e6cdf69b$var$colors
        },
        numbers: {
            type: 'number',
            properties: $f5f903f1e6cdf69b$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $f5f903f1e6cdf69b$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $f5f903f1e6cdf69b$var$intlCache = new Map();
function $f5f903f1e6cdf69b$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $f5f903f1e6cdf69b$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $f5f903f1e6cdf69b$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $f5f903f1e6cdf69b$export$ae1af26003f05816(num, locale, options) {
    return $f5f903f1e6cdf69b$var$getNumberFormat(locale, options).format(num);
}
const $f5f903f1e6cdf69b$var$formatters = {
    values (value) {
        return $f5f903f1e6cdf69b$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $f5f903f1e6cdf69b$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $f5f903f1e6cdf69b$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $f5f903f1e6cdf69b$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($f5f903f1e6cdf69b$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $f5f903f1e6cdf69b$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $f5f903f1e6cdf69b$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $f5f903f1e6cdf69b$export$9f4f30ee63539e24 = {
    formatters: $f5f903f1e6cdf69b$var$formatters
};
function $f5f903f1e6cdf69b$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $f5f903f1e6cdf69b$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $f5f903f1e6cdf69b$export$6559d589eb85fbb6 = Object.create(null);
const $f5f903f1e6cdf69b$export$2e2af4578d910ddf = Object.create(null);
function $f5f903f1e6cdf69b$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $f5f903f1e6cdf69b$var$set(root, scope, values) {
    if (typeof scope === 'string') return $f5f903f1e6cdf69b$export$efca4cbe5dd06740($f5f903f1e6cdf69b$var$getScope$1(root, scope), values);
    return $f5f903f1e6cdf69b$export$efca4cbe5dd06740($f5f903f1e6cdf69b$var$getScope$1(root, ''), scope);
}
class $f5f903f1e6cdf69b$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$f5f903f1e6cdf69b$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$f5f903f1e6cdf69b$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$f5f903f1e6cdf69b$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $f5f903f1e6cdf69b$var$set(this, scope, values);
    }
    get(scope) {
        return $f5f903f1e6cdf69b$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $f5f903f1e6cdf69b$var$set($f5f903f1e6cdf69b$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $f5f903f1e6cdf69b$var$set($f5f903f1e6cdf69b$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $f5f903f1e6cdf69b$var$getScope$1(this, scope);
        const targetScopeObject = $f5f903f1e6cdf69b$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($f5f903f1e6cdf69b$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $f5f903f1e6cdf69b$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $f5f903f1e6cdf69b$export$4368d992c4eafac0 = /* #__PURE__ */ new $f5f903f1e6cdf69b$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $f5f903f1e6cdf69b$var$applyAnimationsDefaults,
    $f5f903f1e6cdf69b$var$applyLayoutsDefaults,
    $f5f903f1e6cdf69b$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $f5f903f1e6cdf69b$export$e171bab687b50e0(font) {
    if (!font || $f5f903f1e6cdf69b$export$342063e11d6c3cad(font.size) || $f5f903f1e6cdf69b$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $f5f903f1e6cdf69b$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$f5f903f1e6cdf69b$export$8b22cf2602fb60ce(thing)) longest = $f5f903f1e6cdf69b$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($f5f903f1e6cdf69b$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$f5f903f1e6cdf69b$export$8b22cf2602fb60ce(nestedThing)) longest = $f5f903f1e6cdf69b$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $f5f903f1e6cdf69b$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $f5f903f1e6cdf69b$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $f5f903f1e6cdf69b$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $f5f903f1e6cdf69b$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $f5f903f1e6cdf69b$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $f5f903f1e6cdf69b$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $f5f903f1e6cdf69b$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $f5f903f1e6cdf69b$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $f5f903f1e6cdf69b$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $f5f903f1e6cdf69b$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $f5f903f1e6cdf69b$export$56c0d5a1e737357d, rad - $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd, rad + $f5f903f1e6cdf69b$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $f5f903f1e6cdf69b$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $f5f903f1e6cdf69b$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $f5f903f1e6cdf69b$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $f5f903f1e6cdf69b$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $f5f903f1e6cdf69b$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$f5f903f1e6cdf69b$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $f5f903f1e6cdf69b$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $f5f903f1e6cdf69b$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $f5f903f1e6cdf69b$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $f5f903f1e6cdf69b$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $f5f903f1e6cdf69b$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $f5f903f1e6cdf69b$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$f5f903f1e6cdf69b$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $f5f903f1e6cdf69b$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $f5f903f1e6cdf69b$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $f5f903f1e6cdf69b$export$56c0d5a1e737357d, $f5f903f1e6cdf69b$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $f5f903f1e6cdf69b$export$56c0d5a1e737357d, $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$f5f903f1e6cdf69b$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $f5f903f1e6cdf69b$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $f5f903f1e6cdf69b$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $f5f903f1e6cdf69b$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($f5f903f1e6cdf69b$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $f5f903f1e6cdf69b$var$numberOrZero = (v)=>+v || 0;
function $f5f903f1e6cdf69b$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $f5f903f1e6cdf69b$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $f5f903f1e6cdf69b$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$f5f903f1e6cdf69b$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $f5f903f1e6cdf69b$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $f5f903f1e6cdf69b$export$9fa96a7d116ea3ce(value) {
    return $f5f903f1e6cdf69b$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $f5f903f1e6cdf69b$export$28f7fcd39efa255(value) {
    return $f5f903f1e6cdf69b$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $f5f903f1e6cdf69b$export$a9c23c6ac3fc3eca(value) {
    const obj = $f5f903f1e6cdf69b$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $f5f903f1e6cdf69b$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $f5f903f1e6cdf69b$export$4368d992c4eafac0.font;
    let size = $f5f903f1e6cdf69b$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $f5f903f1e6cdf69b$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($f5f903f1e6cdf69b$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $f5f903f1e6cdf69b$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $f5f903f1e6cdf69b$export$d29e374196577086($f5f903f1e6cdf69b$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $f5f903f1e6cdf69b$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $f5f903f1e6cdf69b$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $f5f903f1e6cdf69b$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $f5f903f1e6cdf69b$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $f5f903f1e6cdf69b$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $f5f903f1e6cdf69b$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $f5f903f1e6cdf69b$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $f5f903f1e6cdf69b$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $f5f903f1e6cdf69b$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$f5f903f1e6cdf69b$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $f5f903f1e6cdf69b$var$_cached(target, prop, ()=>$f5f903f1e6cdf69b$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $f5f903f1e6cdf69b$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $f5f903f1e6cdf69b$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $f5f903f1e6cdf69b$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $f5f903f1e6cdf69b$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$f5f903f1e6cdf69b$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$f5f903f1e6cdf69b$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $f5f903f1e6cdf69b$var$_cached(target, prop, ()=>$f5f903f1e6cdf69b$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $f5f903f1e6cdf69b$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $f5f903f1e6cdf69b$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $f5f903f1e6cdf69b$var$readKey = (prefix, name)=>prefix ? prefix + $f5f903f1e6cdf69b$export$a8550f7dbe79f93a(name) : name;
const $f5f903f1e6cdf69b$var$needsSubResolver = (prop, value)=>$f5f903f1e6cdf69b$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $f5f903f1e6cdf69b$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $f5f903f1e6cdf69b$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($f5f903f1e6cdf69b$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $f5f903f1e6cdf69b$var$_resolveScriptable(prop, value, target, receiver);
    if ($f5f903f1e6cdf69b$export$8b22cf2602fb60ce(value) && value.length) value = $f5f903f1e6cdf69b$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($f5f903f1e6cdf69b$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $f5f903f1e6cdf69b$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $f5f903f1e6cdf69b$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($f5f903f1e6cdf69b$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $f5f903f1e6cdf69b$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $f5f903f1e6cdf69b$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($f5f903f1e6cdf69b$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $f5f903f1e6cdf69b$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($f5f903f1e6cdf69b$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $f5f903f1e6cdf69b$var$resolveFallback(fallback, prop, value) {
    return $f5f903f1e6cdf69b$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $f5f903f1e6cdf69b$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $f5f903f1e6cdf69b$export$2d1720544b23b823(parent, key) : undefined;
function $f5f903f1e6cdf69b$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $f5f903f1e6cdf69b$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $f5f903f1e6cdf69b$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $f5f903f1e6cdf69b$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $f5f903f1e6cdf69b$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $f5f903f1e6cdf69b$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $f5f903f1e6cdf69b$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $f5f903f1e6cdf69b$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$f5f903f1e6cdf69b$var$subGetTarget(resolver, prop, value));
}
function $f5f903f1e6cdf69b$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $f5f903f1e6cdf69b$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $f5f903f1e6cdf69b$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($f5f903f1e6cdf69b$export$8b22cf2602fb60ce(target) && $f5f903f1e6cdf69b$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $f5f903f1e6cdf69b$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $f5f903f1e6cdf69b$var$_resolve($f5f903f1e6cdf69b$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $f5f903f1e6cdf69b$var$needsSubResolver(prop, value) ? $f5f903f1e6cdf69b$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $f5f903f1e6cdf69b$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $f5f903f1e6cdf69b$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $f5f903f1e6cdf69b$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $f5f903f1e6cdf69b$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $f5f903f1e6cdf69b$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($f5f903f1e6cdf69b$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $f5f903f1e6cdf69b$var$EPSILON = Number.EPSILON || 1e-14;
const $f5f903f1e6cdf69b$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $f5f903f1e6cdf69b$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $f5f903f1e6cdf69b$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $f5f903f1e6cdf69b$export$cf2f7c5792f80b46(current, previous);
    const d12 = $f5f903f1e6cdf69b$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $f5f903f1e6cdf69b$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $f5f903f1e6cdf69b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $f5f903f1e6cdf69b$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($f5f903f1e6cdf69b$export$23ebac1979863676(deltaK[i], 0, $f5f903f1e6cdf69b$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $f5f903f1e6cdf69b$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $f5f903f1e6cdf69b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $f5f903f1e6cdf69b$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $f5f903f1e6cdf69b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $f5f903f1e6cdf69b$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $f5f903f1e6cdf69b$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $f5f903f1e6cdf69b$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $f5f903f1e6cdf69b$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $f5f903f1e6cdf69b$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $f5f903f1e6cdf69b$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $f5f903f1e6cdf69b$var$monotoneAdjust(points, deltaK, mK);
    $f5f903f1e6cdf69b$var$monotoneCompute(points, mK, indexAxis);
}
function $f5f903f1e6cdf69b$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $f5f903f1e6cdf69b$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $f5f903f1e6cdf69b$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $f5f903f1e6cdf69b$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $f5f903f1e6cdf69b$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $f5f903f1e6cdf69b$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $f5f903f1e6cdf69b$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $f5f903f1e6cdf69b$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $f5f903f1e6cdf69b$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $f5f903f1e6cdf69b$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $f5f903f1e6cdf69b$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $f5f903f1e6cdf69b$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $f5f903f1e6cdf69b$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $f5f903f1e6cdf69b$export$fef3dfd9bad05307(el, property) {
    return $f5f903f1e6cdf69b$var$getComputedStyle(el).getPropertyValue(property);
}
const $f5f903f1e6cdf69b$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $f5f903f1e6cdf69b$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $f5f903f1e6cdf69b$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $f5f903f1e6cdf69b$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $f5f903f1e6cdf69b$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($f5f903f1e6cdf69b$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $f5f903f1e6cdf69b$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $f5f903f1e6cdf69b$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $f5f903f1e6cdf69b$var$getPositionedStyle(style, 'padding');
    const borders = $f5f903f1e6cdf69b$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $f5f903f1e6cdf69b$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $f5f903f1e6cdf69b$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $f5f903f1e6cdf69b$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $f5f903f1e6cdf69b$var$getComputedStyle(container);
            const containerBorder = $f5f903f1e6cdf69b$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $f5f903f1e6cdf69b$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $f5f903f1e6cdf69b$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $f5f903f1e6cdf69b$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $f5f903f1e6cdf69b$export$53c86fa97d611818,
        maxHeight: maxHeight || $f5f903f1e6cdf69b$export$53c86fa97d611818
    };
}
const $f5f903f1e6cdf69b$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $f5f903f1e6cdf69b$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $f5f903f1e6cdf69b$var$getComputedStyle(canvas);
    const margins = $f5f903f1e6cdf69b$var$getPositionedStyle(style, 'margin');
    const maxWidth = $f5f903f1e6cdf69b$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $f5f903f1e6cdf69b$export$53c86fa97d611818;
    const maxHeight = $f5f903f1e6cdf69b$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $f5f903f1e6cdf69b$export$53c86fa97d611818;
    const containerSize = $f5f903f1e6cdf69b$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $f5f903f1e6cdf69b$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $f5f903f1e6cdf69b$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $f5f903f1e6cdf69b$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $f5f903f1e6cdf69b$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $f5f903f1e6cdf69b$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $f5f903f1e6cdf69b$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $f5f903f1e6cdf69b$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = $f5f903f1e6cdf69b$var$round1(chart.height * pixelRatio);
    const deviceWidth = $f5f903f1e6cdf69b$var$round1(chart.width * pixelRatio);
    chart.height = $f5f903f1e6cdf69b$var$round1(chart.height);
    chart.width = $f5f903f1e6cdf69b$var$round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $f5f903f1e6cdf69b$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($f5f903f1e6cdf69b$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $f5f903f1e6cdf69b$export$b4171a6734a65d42(element, property) {
    const value = $f5f903f1e6cdf69b$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $f5f903f1e6cdf69b$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $f5f903f1e6cdf69b$export$6554612db691658e(p1, cp1, t);
    const b = $f5f903f1e6cdf69b$export$6554612db691658e(cp1, cp2, t);
    const c = $f5f903f1e6cdf69b$export$6554612db691658e(cp2, p2, t);
    const d = $f5f903f1e6cdf69b$export$6554612db691658e(a, b, t);
    const e = $f5f903f1e6cdf69b$export$6554612db691658e(b, c, t);
    return $f5f903f1e6cdf69b$export$6554612db691658e(d, e, t);
}
const $f5f903f1e6cdf69b$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $f5f903f1e6cdf69b$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $f5f903f1e6cdf69b$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $f5f903f1e6cdf69b$var$getRightToLeftAdapter(rectX, width) : $f5f903f1e6cdf69b$var$getLeftToRightAdapter();
}
function $f5f903f1e6cdf69b$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $f5f903f1e6cdf69b$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $f5f903f1e6cdf69b$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $f5f903f1e6cdf69b$export$ffb5f4729a158638,
        compare: $f5f903f1e6cdf69b$export$f074adc9fbd50943,
        normalize: $f5f903f1e6cdf69b$export$ab83b03e4111b1d0
    };
    return {
        between: $f5f903f1e6cdf69b$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $f5f903f1e6cdf69b$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $f5f903f1e6cdf69b$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $f5f903f1e6cdf69b$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $f5f903f1e6cdf69b$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $f5f903f1e6cdf69b$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $f5f903f1e6cdf69b$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($f5f903f1e6cdf69b$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($f5f903f1e6cdf69b$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $f5f903f1e6cdf69b$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $f5f903f1e6cdf69b$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $f5f903f1e6cdf69b$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $f5f903f1e6cdf69b$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $f5f903f1e6cdf69b$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $f5f903f1e6cdf69b$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $f5f903f1e6cdf69b$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $f5f903f1e6cdf69b$var$splitByStyles(line, $f5f903f1e6cdf69b$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $f5f903f1e6cdf69b$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $f5f903f1e6cdf69b$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $f5f903f1e6cdf69b$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $f5f903f1e6cdf69b$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $f5f903f1e6cdf69b$var$readStyle(segmentOptions.setContext($f5f903f1e6cdf69b$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($f5f903f1e6cdf69b$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $f5f903f1e6cdf69b$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $f5f903f1e6cdf69b$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$f5f903f1e6cdf69b$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $f5f903f1e6cdf69b$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $f5f903f1e6cdf69b$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $f5f903f1e6cdf69b$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $f5f903f1e6cdf69b$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $f5f903f1e6cdf69b$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $f5f903f1e6cdf69b$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $f5f903f1e6cdf69b$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $f5f903f1e6cdf69b$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

});
parcelRegister("865Gr", function(module, exports) {

$parcel$export(module.exports, "Color", () => $5e534ae1a972f4ab$export$892596cec99bc70e);
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $5e534ae1a972f4ab$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $5e534ae1a972f4ab$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $5e534ae1a972f4ab$export$bcc6e673dfa14d36(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $5e534ae1a972f4ab$export$869b26d4e1bbdb63(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $5e534ae1a972f4ab$export$dbf961a8d278dbef(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $5e534ae1a972f4ab$export$aa35ef1f24408ab9(v) {
    return $5e534ae1a972f4ab$export$837ba5c449269406($5e534ae1a972f4ab$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $5e534ae1a972f4ab$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $5e534ae1a972f4ab$var$hex = [
    ...'0123456789ABCDEF'
];
const $5e534ae1a972f4ab$var$h1 = (b)=>$5e534ae1a972f4ab$var$hex[b & 0xF];
const $5e534ae1a972f4ab$var$h2 = (b)=>$5e534ae1a972f4ab$var$hex[(b & 0xF0) >> 4] + $5e534ae1a972f4ab$var$hex[b & 0xF];
const $5e534ae1a972f4ab$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $5e534ae1a972f4ab$var$isShort = (v)=>$5e534ae1a972f4ab$var$eq(v.r) && $5e534ae1a972f4ab$var$eq(v.g) && $5e534ae1a972f4ab$var$eq(v.b) && $5e534ae1a972f4ab$var$eq(v.a);
function $5e534ae1a972f4ab$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $5e534ae1a972f4ab$var$map$1[str[1]] * 17,
            g: 255 & $5e534ae1a972f4ab$var$map$1[str[2]] * 17,
            b: 255 & $5e534ae1a972f4ab$var$map$1[str[3]] * 17,
            a: len === 5 ? $5e534ae1a972f4ab$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $5e534ae1a972f4ab$var$map$1[str[1]] << 4 | $5e534ae1a972f4ab$var$map$1[str[2]],
            g: $5e534ae1a972f4ab$var$map$1[str[3]] << 4 | $5e534ae1a972f4ab$var$map$1[str[4]],
            b: $5e534ae1a972f4ab$var$map$1[str[5]] << 4 | $5e534ae1a972f4ab$var$map$1[str[6]],
            a: len === 9 ? $5e534ae1a972f4ab$var$map$1[str[7]] << 4 | $5e534ae1a972f4ab$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $5e534ae1a972f4ab$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $5e534ae1a972f4ab$export$1b06654353ef9f67(v) {
    var f = $5e534ae1a972f4ab$var$isShort(v) ? $5e534ae1a972f4ab$var$h1 : $5e534ae1a972f4ab$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $5e534ae1a972f4ab$var$alpha(v.a, f) : undefined;
}
const $5e534ae1a972f4ab$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5e534ae1a972f4ab$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $5e534ae1a972f4ab$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $5e534ae1a972f4ab$var$hwb2rgbn(h, w, b) {
    const rgb = $5e534ae1a972f4ab$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $5e534ae1a972f4ab$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $5e534ae1a972f4ab$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $5e534ae1a972f4ab$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($5e534ae1a972f4ab$export$ed9bd8dcaeba14f6);
}
function $5e534ae1a972f4ab$export$4c15bd42559b811d(h, s, l) {
    return $5e534ae1a972f4ab$var$calln($5e534ae1a972f4ab$var$hsl2rgbn, h, s, l);
}
function $5e534ae1a972f4ab$export$e2710022c70fc9ee(h, w, b) {
    return $5e534ae1a972f4ab$var$calln($5e534ae1a972f4ab$var$hwb2rgbn, h, w, b);
}
function $5e534ae1a972f4ab$export$b785a357c84e4a04(h, s, v) {
    return $5e534ae1a972f4ab$var$calln($5e534ae1a972f4ab$var$hsv2rgbn, h, s, v);
}
function $5e534ae1a972f4ab$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $5e534ae1a972f4ab$export$5e91288c399be4f9(str) {
    const m = $5e534ae1a972f4ab$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(+m[5]) : $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $5e534ae1a972f4ab$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $5e534ae1a972f4ab$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $5e534ae1a972f4ab$export$b785a357c84e4a04(h, p1, p2);
    else v = $5e534ae1a972f4ab$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $5e534ae1a972f4ab$export$bb628a54ab399bc9(v, deg) {
    var h = $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v);
    h[0] = $5e534ae1a972f4ab$var$hue(h[0] + deg);
    h = $5e534ae1a972f4ab$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $5e534ae1a972f4ab$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $5e534ae1a972f4ab$export$aa35ef1f24408ab9(a[1]);
    const l = $5e534ae1a972f4ab$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$5e534ae1a972f4ab$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $5e534ae1a972f4ab$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $5e534ae1a972f4ab$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $5e534ae1a972f4ab$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($5e534ae1a972f4ab$var$names$1);
    const tkeys = Object.keys($5e534ae1a972f4ab$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $5e534ae1a972f4ab$var$map[k]);
        }
        k = parseInt($5e534ae1a972f4ab$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $5e534ae1a972f4ab$var$names;
function $5e534ae1a972f4ab$export$b2f06b640faad956(str) {
    if (!$5e534ae1a972f4ab$var$names) {
        $5e534ae1a972f4ab$var$names = $5e534ae1a972f4ab$var$unpack();
        $5e534ae1a972f4ab$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $5e534ae1a972f4ab$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $5e534ae1a972f4ab$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $5e534ae1a972f4ab$export$91aedb20f296e541(str) {
    const m = $5e534ae1a972f4ab$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(v) : $5e534ae1a972f4ab$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(r) : $5e534ae1a972f4ab$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(g) : $5e534ae1a972f4ab$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $5e534ae1a972f4ab$export$bcc6e673dfa14d36(b) : $5e534ae1a972f4ab$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $5e534ae1a972f4ab$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$5e534ae1a972f4ab$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $5e534ae1a972f4ab$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $5e534ae1a972f4ab$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $5e534ae1a972f4ab$var$interpolate(rgb1, rgb2, t) {
    const r = $5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb1.r));
    const g = $5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb1.g));
    const b = $5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6($5e534ae1a972f4ab$var$to(r + t * ($5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6($5e534ae1a972f4ab$var$to(g + t * ($5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6($5e534ae1a972f4ab$var$to(b + t * ($5e534ae1a972f4ab$var$from($5e534ae1a972f4ab$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $5e534ae1a972f4ab$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $5e534ae1a972f4ab$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $5e534ae1a972f4ab$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $5e534ae1a972f4ab$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $5e534ae1a972f4ab$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $5e534ae1a972f4ab$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $5e534ae1a972f4ab$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $5e534ae1a972f4ab$export$91aedb20f296e541(str);
    return $5e534ae1a972f4ab$export$5e91288c399be4f9(str);
}
class $5e534ae1a972f4ab$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $5e534ae1a972f4ab$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $5e534ae1a972f4ab$var$fromObject(input);
        else if (type === 'string') v = $5e534ae1a972f4ab$export$625a38b961e8b5e9(input) || $5e534ae1a972f4ab$export$b2f06b640faad956(input) || $5e534ae1a972f4ab$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $5e534ae1a972f4ab$var$clone(this._rgb);
        if (v) v.a = $5e534ae1a972f4ab$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $5e534ae1a972f4ab$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $5e534ae1a972f4ab$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $5e534ae1a972f4ab$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $5e534ae1a972f4ab$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $5e534ae1a972f4ab$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $5e534ae1a972f4ab$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $5e534ae1a972f4ab$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $5e534ae1a972f4ab$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $5e534ae1a972f4ab$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $5e534ae1a972f4ab$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $5e534ae1a972f4ab$export$2e2bcd8739ae039(input) {
    return new $5e534ae1a972f4ab$export$892596cec99bc70e(input);
}

});




parcelRegister("48FUX", function(module, exports) {
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */ 
var $5EHVc = parcelRequire("5EHVc");

var $l4b73 = parcelRequire("l4b73");
var $afGQf = parcelRequire("afGQf");
var $iF7VK = parcelRequire("iF7VK");
var $iIzcA = parcelRequire("iIzcA");
var $1YUHS = parcelRequire("1YUHS");
var $ieLCh = parcelRequire("ieLCh");
var $dn1OK = parcelRequire("dn1OK");
var $2jgJV = parcelRequire("2jgJV");
var $1mchh = parcelRequire("1mchh");
var $i24rg = parcelRequire("i24rg");
var $1jqew = parcelRequire("1jqew");
var $b3r9H = parcelRequire("b3r9H");
var $e2c7r = parcelRequire("e2c7r");
var $yA2GW = parcelRequire("yA2GW");
var $jsUaC = parcelRequire("jsUaC");
var $7isa4 = parcelRequire("7isa4");
var $cP3lO = parcelRequire("cP3lO");
var $7YJVF = parcelRequire("7YJVF");
var $8jKFG = parcelRequire("8jKFG");
var $g5QV1 = parcelRequire("g5QV1");
var $gA31E = parcelRequire("gA31E");
var $lhOVV = parcelRequire("lhOVV");
var $iWCQf = parcelRequire("iWCQf");
var $6UOLg = parcelRequire("6UOLg");
var $7hfjh = parcelRequire("7hfjh");
var $kUlnb = parcelRequire("kUlnb");
var $i1DkS = parcelRequire("i1DkS");
var $5ujzY = parcelRequire("5ujzY");
var $hEUsU = parcelRequire("hEUsU");
var $aNBww = parcelRequire("aNBww");
var $kdTO4 = parcelRequire("kdTO4");
var $4Rvit = parcelRequire("4Rvit");
var $7SEoW = parcelRequire("7SEoW");
var $d15Zh = parcelRequire("d15Zh");
var $jMRxa = parcelRequire("jMRxa");
var $az18O = parcelRequire("az18O");
var $2cZ4R = parcelRequire("2cZ4R");
var $9FGIH = parcelRequire("9FGIH");
var $7yyQt = parcelRequire("7yyQt");
const $30386cc1a1c9803b$var$FORMATS = {
    datetime: 'MMM d, yyyy, h:mm:ss aaaa',
    millisecond: 'h:mm:ss.SSS aaaa',
    second: 'h:mm:ss aaaa',
    minute: 'h:mm aaaa',
    hour: 'ha',
    day: 'MMM d',
    week: 'PP',
    month: 'MMM yyyy',
    quarter: 'qqq - yyyy',
    year: 'yyyy'
};
(0, $5EHVc._adapters)._date.override({
    _id: 'date-fns',
    formats: function() {
        return $30386cc1a1c9803b$var$FORMATS;
    },
    parse: function(value, fmt) {
        if (value === null || typeof value === 'undefined') return null;
        const type = typeof value;
        if (type === 'number' || value instanceof Date) value = (0, $7yyQt.toDate)(value);
        else if (type === 'string') {
            if (typeof fmt === 'string') value = (0, $hEUsU.parse)(value, fmt, new Date(), this.options);
            else value = (0, $aNBww.parseISO)(value, this.options);
        }
        return (0, $5ujzY.isValid)(value) ? value.getTime() : null;
    },
    format: function(time, fmt) {
        return (0, $i1DkS.format)(time, fmt, this.options);
    },
    add: function(time, amount, unit) {
        switch(unit){
            case 'millisecond':
                return (0, $iF7VK.addMilliseconds)(time, amount);
            case 'second':
                return (0, $dn1OK.addSeconds)(time, amount);
            case 'minute':
                return (0, $iIzcA.addMinutes)(time, amount);
            case 'hour':
                return (0, $afGQf.addHours)(time, amount);
            case 'day':
                return (0, $l4b73.addDays)(time, amount);
            case 'week':
                return (0, $2jgJV.addWeeks)(time, amount);
            case 'month':
                return (0, $1YUHS.addMonths)(time, amount);
            case 'quarter':
                return (0, $ieLCh.addQuarters)(time, amount);
            case 'year':
                return (0, $1mchh.addYears)(time, amount);
            default:
                return time;
        }
    },
    diff: function(max, min, unit) {
        switch(unit){
            case 'millisecond':
                return (0, $b3r9H.differenceInMilliseconds)(max, min);
            case 'second':
                return (0, $7isa4.differenceInSeconds)(max, min);
            case 'minute':
                return (0, $e2c7r.differenceInMinutes)(max, min);
            case 'hour':
                return (0, $1jqew.differenceInHours)(max, min);
            case 'day':
                return (0, $i24rg.differenceInDays)(max, min);
            case 'week':
                return (0, $cP3lO.differenceInWeeks)(max, min);
            case 'month':
                return (0, $yA2GW.differenceInMonths)(max, min);
            case 'quarter':
                return (0, $jsUaC.differenceInQuarters)(max, min);
            case 'year':
                return (0, $7YJVF.differenceInYears)(max, min);
            default:
                return 0;
        }
    },
    startOf: function(time, unit, weekday) {
        switch(unit){
            case 'second':
                return (0, $az18O.startOfSecond)(time);
            case 'minute':
                return (0, $7SEoW.startOfMinute)(time);
            case 'hour':
                return (0, $4Rvit.startOfHour)(time);
            case 'day':
                return (0, $kdTO4.startOfDay)(time);
            case 'week':
                return (0, $2cZ4R.startOfWeek)(time);
            case 'isoWeek':
                return (0, $2cZ4R.startOfWeek)(time, {
                    weekStartsOn: +weekday
                });
            case 'month':
                return (0, $d15Zh.startOfMonth)(time);
            case 'quarter':
                return (0, $jMRxa.startOfQuarter)(time);
            case 'year':
                return (0, $9FGIH.startOfYear)(time);
            default:
                return time;
        }
    },
    endOf: function(time, unit) {
        switch(unit){
            case 'second':
                return (0, $6UOLg.endOfSecond)(time);
            case 'minute':
                return (0, $gA31E.endOfMinute)(time);
            case 'hour':
                return (0, $g5QV1.endOfHour)(time);
            case 'day':
                return (0, $8jKFG.endOfDay)(time);
            case 'week':
                return (0, $7hfjh.endOfWeek)(time);
            case 'month':
                return (0, $lhOVV.endOfMonth)(time);
            case 'quarter':
                return (0, $iWCQf.endOfQuarter)(time);
            case 'year':
                return (0, $kUlnb.endOfYear)(time);
            default:
                return time;
        }
    }
});

});
parcelRegister("l4b73", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $f562977a5bac0984$export$dd412b56f1e4d8aa);

var $cMvsU = parcelRequire("cMvsU");

var $7yyQt = parcelRequire("7yyQt");
function $f562977a5bac0984$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, $cMvsU.constructFrom)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$f562977a5bac0984$export$2e2bcd8739ae039 = $f562977a5bac0984$export$dd412b56f1e4d8aa;

});
parcelRegister("cMvsU", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $94e2600e6614cc67$export$ead8a1812b171991);

var $9uNOU = parcelRequire("9uNOU");
function $94e2600e6614cc67$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $9uNOU.constructFromSymbol) in date) return date[0, $9uNOU.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$94e2600e6614cc67$export$2e2bcd8739ae039 = $94e2600e6614cc67$export$ead8a1812b171991;

});
parcelRegister("9uNOU", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", () => $6e9d8fa85a388a89$export$4fad13613e88edc8);
$parcel$export(module.exports, "millisecondsInDay", () => $6e9d8fa85a388a89$export$b76b1809a2898f9a);
$parcel$export(module.exports, "millisecondsInMinute", () => $6e9d8fa85a388a89$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $6e9d8fa85a388a89$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $6e9d8fa85a388a89$export$397c2d5776aa9055);
$parcel$export(module.exports, "constructFromSymbol", () => $6e9d8fa85a388a89$export$2a7b97929c48d47d);
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $6e9d8fa85a388a89$export$dfd9b671c89acc8e = 7;
const $6e9d8fa85a388a89$export$3913210603d8e9ae = 365.2425;
const $6e9d8fa85a388a89$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $6e9d8fa85a388a89$export$4dec998e48f9c246 = -$6e9d8fa85a388a89$export$81caae6e1cc7a622;
const $6e9d8fa85a388a89$export$4fad13613e88edc8 = 604800000;
const $6e9d8fa85a388a89$export$b76b1809a2898f9a = 86400000;
const $6e9d8fa85a388a89$export$91246f0b9bd9beff = 60000;
const $6e9d8fa85a388a89$export$7f72910d6dfd237a = 3600000;
const $6e9d8fa85a388a89$export$397c2d5776aa9055 = 1000;
const $6e9d8fa85a388a89$export$3633035e63cee86a = 525600;
const $6e9d8fa85a388a89$export$ab7da2ccd1075c38 = 43200;
const $6e9d8fa85a388a89$export$2423174df8cd3cd2 = 1440;
const $6e9d8fa85a388a89$export$f2f5ae5a8e2d8f9f = 60;
const $6e9d8fa85a388a89$export$3c58128db900d44e = 3;
const $6e9d8fa85a388a89$export$80d7e435f744f319 = 12;
const $6e9d8fa85a388a89$export$4db7641526e3241f = 4;
const $6e9d8fa85a388a89$export$698aec755e92c695 = 3600;
const $6e9d8fa85a388a89$export$a77c1a7ebebe2a5a = 60;
const $6e9d8fa85a388a89$export$815a9362476d2fe3 = $6e9d8fa85a388a89$export$698aec755e92c695 * 24;
const $6e9d8fa85a388a89$export$34804a017b31e2fe = $6e9d8fa85a388a89$export$815a9362476d2fe3 * 7;
const $6e9d8fa85a388a89$export$7271e9e3478110d1 = $6e9d8fa85a388a89$export$815a9362476d2fe3 * $6e9d8fa85a388a89$export$3913210603d8e9ae;
const $6e9d8fa85a388a89$export$8e6600bbdee7dabb = $6e9d8fa85a388a89$export$7271e9e3478110d1 / 12;
const $6e9d8fa85a388a89$export$be1dccf2de902d31 = $6e9d8fa85a388a89$export$8e6600bbdee7dabb * 3;
const $6e9d8fa85a388a89$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});


parcelRegister("7yyQt", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $5806bcec89744c32$export$e67a095c620b86fe);

var $cMvsU = parcelRequire("cMvsU");
function $5806bcec89744c32$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $cMvsU.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$5806bcec89744c32$export$2e2bcd8739ae039 = $5806bcec89744c32$export$e67a095c620b86fe;

});


parcelRegister("afGQf", function(module, exports) {

$parcel$export(module.exports, "addHours", () => $776c8997d647c338$export$4a4306ad4fa0e5e6);

var $iF7VK = parcelRequire("iF7VK");

var $9uNOU = parcelRequire("9uNOU");
function $776c8997d647c338$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $iF7VK.addMilliseconds)(date, amount * (0, $9uNOU.millisecondsInHour), options);
}
var // Fallback for modularized imports:
$776c8997d647c338$export$2e2bcd8739ae039 = $776c8997d647c338$export$4a4306ad4fa0e5e6;

});
parcelRegister("iF7VK", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", () => $d962352315874c28$export$baf757aaf0c95c94);

var $cMvsU = parcelRequire("cMvsU");

var $7yyQt = parcelRequire("7yyQt");
function $d962352315874c28$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $cMvsU.constructFrom)(options?.in || date, +(0, $7yyQt.toDate)(date) + amount);
}
var // Fallback for modularized imports:
$d962352315874c28$export$2e2bcd8739ae039 = $d962352315874c28$export$baf757aaf0c95c94;

});


parcelRegister("iIzcA", function(module, exports) {

$parcel$export(module.exports, "addMinutes", () => $da07a47066bdb9ee$export$2287e3d29250119e);

var $9uNOU = parcelRequire("9uNOU");

var $7yyQt = parcelRequire("7yyQt");
function $da07a47066bdb9ee$export$2287e3d29250119e(date, amount, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setTime(_date.getTime() + amount * (0, $9uNOU.millisecondsInMinute));
    return _date;
}
var // Fallback for modularized imports:
$da07a47066bdb9ee$export$2e2bcd8739ae039 = $da07a47066bdb9ee$export$2287e3d29250119e;

});

parcelRegister("1YUHS", function(module, exports) {

$parcel$export(module.exports, "addMonths", () => $171761cf899530ac$export$17c93e242b2d3a22);

var $cMvsU = parcelRequire("cMvsU");

var $7yyQt = parcelRequire("7yyQt");
function $171761cf899530ac$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, $cMvsU.constructFrom)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $cMvsU.constructFrom)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$171761cf899530ac$export$2e2bcd8739ae039 = $171761cf899530ac$export$17c93e242b2d3a22;

});

parcelRegister("ieLCh", function(module, exports) {

$parcel$export(module.exports, "addQuarters", () => $d46e786e79a943e0$export$c252a41d0fbed2ce);

var $1YUHS = parcelRequire("1YUHS");
function $d46e786e79a943e0$export$c252a41d0fbed2ce(date, amount, options) {
    return (0, $1YUHS.addMonths)(date, amount * 3, options);
}
var // Fallback for modularized imports:
$d46e786e79a943e0$export$2e2bcd8739ae039 = $d46e786e79a943e0$export$c252a41d0fbed2ce;

});

parcelRegister("dn1OK", function(module, exports) {

$parcel$export(module.exports, "addSeconds", () => $9bbed549b6c0cd32$export$3cb31b0df13be68);

var $iF7VK = parcelRequire("iF7VK");
function $9bbed549b6c0cd32$export$3cb31b0df13be68(date, amount, options) {
    return (0, $iF7VK.addMilliseconds)(date, amount * 1000, options);
}
var // Fallback for modularized imports:
$9bbed549b6c0cd32$export$2e2bcd8739ae039 = $9bbed549b6c0cd32$export$3cb31b0df13be68;

});

parcelRegister("2jgJV", function(module, exports) {

$parcel$export(module.exports, "addWeeks", () => $1aea574647ae6107$export$ef501a2bb4f3ee6b);

var $l4b73 = parcelRequire("l4b73");
function $1aea574647ae6107$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $l4b73.addDays)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$1aea574647ae6107$export$2e2bcd8739ae039 = $1aea574647ae6107$export$ef501a2bb4f3ee6b;

});

parcelRegister("1mchh", function(module, exports) {

$parcel$export(module.exports, "addYears", () => $0fd15e9d8250f2b1$export$3d83eec43f4ea476);

var $1YUHS = parcelRequire("1YUHS");
function $0fd15e9d8250f2b1$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $1YUHS.addMonths)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$0fd15e9d8250f2b1$export$2e2bcd8739ae039 = $0fd15e9d8250f2b1$export$3d83eec43f4ea476;

});

parcelRegister("i24rg", function(module, exports) {

$parcel$export(module.exports, "differenceInDays", () => $d20bdb5ce4d5c3bb$export$86415ebf4eb36b8c);

var $cgfL6 = parcelRequire("cgfL6");

var $fD3hg = parcelRequire("fD3hg");
function $d20bdb5ce4d5c3bb$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $cgfL6.normalizeDates)(options?.in, laterDate, earlierDate);
    const sign = $d20bdb5ce4d5c3bb$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $fD3hg.differenceInCalendarDays)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($d20bdb5ce4d5c3bb$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $d20bdb5ce4d5c3bb$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$d20bdb5ce4d5c3bb$export$2e2bcd8739ae039 = $d20bdb5ce4d5c3bb$export$86415ebf4eb36b8c;

});
parcelRegister("cgfL6", function(module, exports) {

$parcel$export(module.exports, "normalizeDates", () => $8ed334072e1c80b3$export$9f53b88e82f64d8d);

var $cMvsU = parcelRequire("cMvsU");
function $8ed334072e1c80b3$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $cMvsU.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

});

parcelRegister("fD3hg", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $b60d0a59df25f16c$export$4a02e9c37dab4871);

var $gr9Oc = parcelRequire("gr9Oc");

var $cgfL6 = parcelRequire("cgfL6");

var $9uNOU = parcelRequire("9uNOU");

var $kdTO4 = parcelRequire("kdTO4");
function $b60d0a59df25f16c$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $cgfL6.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $kdTO4.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, $kdTO4.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $9uNOU.millisecondsInDay));
}
var // Fallback for modularized imports:
$b60d0a59df25f16c$export$2e2bcd8739ae039 = $b60d0a59df25f16c$export$4a02e9c37dab4871;

});
parcelRegister("gr9Oc", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $bf76c6c68c67552d$export$113002b5eff6e430);

var $7yyQt = parcelRequire("7yyQt");
function $bf76c6c68c67552d$export$113002b5eff6e430(date) {
    const _date = (0, $7yyQt.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});

parcelRegister("kdTO4", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2);

var $7yyQt = parcelRequire("7yyQt");
function $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$eb904f8e2d8bb2b8$export$2e2bcd8739ae039 = $eb904f8e2d8bb2b8$export$63fa379ae8a9ba2;

});



parcelRegister("1jqew", function(module, exports) {

$parcel$export(module.exports, "differenceInHours", () => $0f4bea2bfe6a539f$export$5436ca250d4d6872);

var $kHvlI = parcelRequire("kHvlI");

var $cgfL6 = parcelRequire("cgfL6");

var $9uNOU = parcelRequire("9uNOU");
function $0f4bea2bfe6a539f$export$5436ca250d4d6872(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $cgfL6.normalizeDates)(options?.in, laterDate, earlierDate);
    const diff = (+laterDate_ - +earlierDate_) / (0, $9uNOU.millisecondsInHour);
    return (0, $kHvlI.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$0f4bea2bfe6a539f$export$2e2bcd8739ae039 = $0f4bea2bfe6a539f$export$5436ca250d4d6872;

});
parcelRegister("kHvlI", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $f120241e5fda9f45$export$b6474a47258c1211);
function $f120241e5fda9f45$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});


parcelRegister("b3r9H", function(module, exports) {

$parcel$export(module.exports, "differenceInMilliseconds", () => $80c50a0a80ea8dc0$export$7be94d13716b4bf6);

var $7yyQt = parcelRequire("7yyQt");
function $80c50a0a80ea8dc0$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $7yyQt.toDate)(laterDate) - +(0, $7yyQt.toDate)(earlierDate);
}
var // Fallback for modularized imports:
$80c50a0a80ea8dc0$export$2e2bcd8739ae039 = $80c50a0a80ea8dc0$export$7be94d13716b4bf6;

});

parcelRegister("e2c7r", function(module, exports) {

$parcel$export(module.exports, "differenceInMinutes", () => $a37aa72fc352895b$export$d904251335be481a);

var $kHvlI = parcelRequire("kHvlI");

var $9uNOU = parcelRequire("9uNOU");

var $b3r9H = parcelRequire("b3r9H");
function $a37aa72fc352895b$export$d904251335be481a(dateLeft, dateRight, options) {
    const diff = (0, $b3r9H.differenceInMilliseconds)(dateLeft, dateRight) / (0, $9uNOU.millisecondsInMinute);
    return (0, $kHvlI.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$a37aa72fc352895b$export$2e2bcd8739ae039 = $a37aa72fc352895b$export$d904251335be481a;

});

parcelRegister("yA2GW", function(module, exports) {

$parcel$export(module.exports, "differenceInMonths", () => $067f225cda3eabab$export$fc1ed482c2861792);

var $cgfL6 = parcelRequire("cgfL6");

var $eU6p7 = parcelRequire("eU6p7");

var $ewRVG = parcelRequire("ewRVG");

var $fm3xG = parcelRequire("fm3xG");
function $067f225cda3eabab$export$fc1ed482c2861792(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, $cgfL6.normalizeDates)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, $eU6p7.compareAsc)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, $ewRVG.differenceInCalendarMonths)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, $eU6p7.compareAsc)(workingLaterDate, earlierDate_) === -sign;
    if ((0, $fm3xG.isLastDayOfMonth)(laterDate_) && difference === 1 && (0, $eU6p7.compareAsc)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$067f225cda3eabab$export$2e2bcd8739ae039 = $067f225cda3eabab$export$fc1ed482c2861792;

});
parcelRegister("eU6p7", function(module, exports) {

$parcel$export(module.exports, "compareAsc", () => $ad9b435b04f1cc72$export$fe114145ae75d197);

var $7yyQt = parcelRequire("7yyQt");
function $ad9b435b04f1cc72$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $7yyQt.toDate)(dateLeft) - +(0, $7yyQt.toDate)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$ad9b435b04f1cc72$export$2e2bcd8739ae039 = $ad9b435b04f1cc72$export$fe114145ae75d197;

});

parcelRegister("ewRVG", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", () => $a93de31f4953d013$export$489984ac7c996389);

var $cgfL6 = parcelRequire("cgfL6");
function $a93de31f4953d013$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $cgfL6.normalizeDates)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$a93de31f4953d013$export$2e2bcd8739ae039 = $a93de31f4953d013$export$489984ac7c996389;

});

parcelRegister("fm3xG", function(module, exports) {

$parcel$export(module.exports, "isLastDayOfMonth", () => $b2dba884ecd2e2a6$export$c817d0312007ea5e);

var $8jKFG = parcelRequire("8jKFG");

var $lhOVV = parcelRequire("lhOVV");

var $7yyQt = parcelRequire("7yyQt");
function $b2dba884ecd2e2a6$export$c817d0312007ea5e(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    return +(0, $8jKFG.endOfDay)(_date, options) === +(0, $lhOVV.endOfMonth)(_date, options);
}
var // Fallback for modularized imports:
$b2dba884ecd2e2a6$export$2e2bcd8739ae039 = $b2dba884ecd2e2a6$export$c817d0312007ea5e;

});
parcelRegister("8jKFG", function(module, exports) {

$parcel$export(module.exports, "endOfDay", () => $60e44d01eb85bdc4$export$eb9a03f0e9aa6cea);

var $7yyQt = parcelRequire("7yyQt");
function $60e44d01eb85bdc4$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$60e44d01eb85bdc4$export$2e2bcd8739ae039 = $60e44d01eb85bdc4$export$eb9a03f0e9aa6cea;

});

parcelRegister("lhOVV", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", () => $f7f2b1d039dfeb2d$export$a2258d9c4118825c);

var $7yyQt = parcelRequire("7yyQt");
function $f7f2b1d039dfeb2d$export$a2258d9c4118825c(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$f7f2b1d039dfeb2d$export$2e2bcd8739ae039 = $f7f2b1d039dfeb2d$export$a2258d9c4118825c;

});



parcelRegister("jsUaC", function(module, exports) {

$parcel$export(module.exports, "differenceInQuarters", () => $e2bc341485fc71af$export$74b5c4055a405552);

var $kHvlI = parcelRequire("kHvlI");

var $yA2GW = parcelRequire("yA2GW");
function $e2bc341485fc71af$export$74b5c4055a405552(laterDate, earlierDate, options) {
    const diff = (0, $yA2GW.differenceInMonths)(laterDate, earlierDate, options) / 3;
    return (0, $kHvlI.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$e2bc341485fc71af$export$2e2bcd8739ae039 = $e2bc341485fc71af$export$74b5c4055a405552;

});

parcelRegister("7isa4", function(module, exports) {

$parcel$export(module.exports, "differenceInSeconds", () => $55000f1a72ca0916$export$c1889aec51783710);

var $kHvlI = parcelRequire("kHvlI");

var $b3r9H = parcelRequire("b3r9H");
function $55000f1a72ca0916$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $b3r9H.differenceInMilliseconds)(laterDate, earlierDate) / 1000;
    return (0, $kHvlI.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$55000f1a72ca0916$export$2e2bcd8739ae039 = $55000f1a72ca0916$export$c1889aec51783710;

});

parcelRegister("cP3lO", function(module, exports) {

$parcel$export(module.exports, "differenceInWeeks", () => $955cd8dc3fefd601$export$b5147a91dc40ddb7);

var $kHvlI = parcelRequire("kHvlI");

var $i24rg = parcelRequire("i24rg");
function $955cd8dc3fefd601$export$b5147a91dc40ddb7(laterDate, earlierDate, options) {
    const diff = (0, $i24rg.differenceInDays)(laterDate, earlierDate, options) / 7;
    return (0, $kHvlI.getRoundingMethod)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$955cd8dc3fefd601$export$2e2bcd8739ae039 = $955cd8dc3fefd601$export$b5147a91dc40ddb7;

});

parcelRegister("7YJVF", function(module, exports) {

$parcel$export(module.exports, "differenceInYears", () => $5cf1c38d71b2704c$export$ed6bf486f68899ca);

var $cgfL6 = parcelRequire("cgfL6");

var $eU6p7 = parcelRequire("eU6p7");

var $gD5RP = parcelRequire("gD5RP");
function $5cf1c38d71b2704c$export$ed6bf486f68899ca(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $cgfL6.normalizeDates)(options?.in, laterDate, earlierDate);
    // -1 if the left date is earlier than the right date
    // 2023-12-31 - 2024-01-01 = -1
    const sign = (0, $eU6p7.compareAsc)(laterDate_, earlierDate_);
    // First calculate the difference in calendar years
    // 2024-01-01 - 2023-12-31 = 1 year
    const diff = Math.abs((0, $gD5RP.differenceInCalendarYears)(laterDate_, earlierDate_));
    // Now we need to calculate if the difference is full. To do that we set
    // both dates to the same year and check if the both date's month and day
    // form a full year.
    laterDate_.setFullYear(1584);
    earlierDate_.setFullYear(1584);
    // For it to be true, when the later date is indeed later than the earlier date
    // (2026-02-01 - 2023-12-10 = 3 years), the difference is full if
    // the normalized later date is also later than the normalized earlier date.
    // In our example, 1584-02-01 is earlier than 1584-12-10, so the difference
    // is partial, hence we need to subtract 1 from the difference 3 - 1 = 2.
    const partial = (0, $eU6p7.compareAsc)(laterDate_, earlierDate_) === -sign;
    const result = sign * (diff - +partial);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$5cf1c38d71b2704c$export$2e2bcd8739ae039 = $5cf1c38d71b2704c$export$ed6bf486f68899ca;

});
parcelRegister("gD5RP", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", () => $c1b4d6f0a3d32751$export$c06dce8b38891685);

var $cgfL6 = parcelRequire("cgfL6");
function $c1b4d6f0a3d32751$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $cgfL6.normalizeDates)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$c1b4d6f0a3d32751$export$2e2bcd8739ae039 = $c1b4d6f0a3d32751$export$c06dce8b38891685;

});


parcelRegister("g5QV1", function(module, exports) {

$parcel$export(module.exports, "endOfHour", () => $bb76298bab17cf5c$export$95ae95d2176c5f0);

var $7yyQt = parcelRequire("7yyQt");
function $bb76298bab17cf5c$export$95ae95d2176c5f0(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setMinutes(59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$bb76298bab17cf5c$export$2e2bcd8739ae039 = $bb76298bab17cf5c$export$95ae95d2176c5f0;

});

parcelRegister("gA31E", function(module, exports) {

$parcel$export(module.exports, "endOfMinute", () => $c1225af2ae0b1bfe$export$a06a772fc63bff07);

var $7yyQt = parcelRequire("7yyQt");
function $c1225af2ae0b1bfe$export$a06a772fc63bff07(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setSeconds(59, 999);
    return _date;
}
var // Fallback for modularized imports:
$c1225af2ae0b1bfe$export$2e2bcd8739ae039 = $c1225af2ae0b1bfe$export$a06a772fc63bff07;

});

parcelRegister("iWCQf", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", () => $dcabc5f08a029426$export$5f53493861eef879);

var $7yyQt = parcelRequire("7yyQt");
function $dcabc5f08a029426$export$5f53493861eef879(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$dcabc5f08a029426$export$2e2bcd8739ae039 = $dcabc5f08a029426$export$5f53493861eef879;

});

parcelRegister("6UOLg", function(module, exports) {

$parcel$export(module.exports, "endOfSecond", () => $508f59324ad1fe21$export$ef560ab2fa7b52a2);

var $7yyQt = parcelRequire("7yyQt");
function $508f59324ad1fe21$export$ef560ab2fa7b52a2(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setMilliseconds(999);
    return _date;
}
var // Fallback for modularized imports:
$508f59324ad1fe21$export$2e2bcd8739ae039 = $508f59324ad1fe21$export$ef560ab2fa7b52a2;

});

parcelRegister("7hfjh", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", () => $54c5ff31ac2edebd$export$ef8b6d9133084f4e);

var $aK3iq = parcelRequire("aK3iq");

var $7yyQt = parcelRequire("7yyQt");
function $54c5ff31ac2edebd$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$54c5ff31ac2edebd$export$2e2bcd8739ae039 = $54c5ff31ac2edebd$export$ef8b6d9133084f4e;

});
parcelRegister("aK3iq", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $7d20c1ccd7dd6a35$export$430a3269e24b912e);
let $7d20c1ccd7dd6a35$var$defaultOptions = {};
function $7d20c1ccd7dd6a35$export$430a3269e24b912e() {
    return $7d20c1ccd7dd6a35$var$defaultOptions;
}
function $7d20c1ccd7dd6a35$export$95365be1b0704abc(newOptions) {
    $7d20c1ccd7dd6a35$var$defaultOptions = newOptions;
}

});


parcelRegister("kUlnb", function(module, exports) {

$parcel$export(module.exports, "endOfYear", () => $f3899dd016cb5248$export$8b7aa55c66d5569e);

var $7yyQt = parcelRequire("7yyQt");
function $f3899dd016cb5248$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$f3899dd016cb5248$export$2e2bcd8739ae039 = $f3899dd016cb5248$export$8b7aa55c66d5569e;

});

parcelRegister("i1DkS", function(module, exports) {

$parcel$export(module.exports, "format", () => $d1f6d53b6dcbe5f6$export$d9468344d3651243);

var $j9YzS = parcelRequire("j9YzS");

var $aK3iq = parcelRequire("aK3iq");

var $eg22F = parcelRequire("eg22F");

var $dPmGw = parcelRequire("dPmGw");

var $bWEgL = parcelRequire("bWEgL");

var $5ujzY = parcelRequire("5ujzY");

var $7yyQt = parcelRequire("7yyQt");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $d1f6d53b6dcbe5f6$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $d1f6d53b6dcbe5f6$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $d1f6d53b6dcbe5f6$var$doubleQuoteRegExp = /''/g;
const $d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d1f6d53b6dcbe5f6$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $j9YzS.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $7yyQt.toDate)(date, options?.in);
    if (!(0, $5ujzY.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($d1f6d53b6dcbe5f6$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $dPmGw.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($d1f6d53b6dcbe5f6$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $d1f6d53b6dcbe5f6$var$cleanEscapedString(substring)
        };
        if ((0, $eg22F.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($d1f6d53b6dcbe5f6$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $bWEgL.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $bWEgL.isProtectedDayOfYearToken)(token)) (0, $bWEgL.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $eg22F.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $d1f6d53b6dcbe5f6$var$cleanEscapedString(input) {
    const matched = input.match($d1f6d53b6dcbe5f6$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($d1f6d53b6dcbe5f6$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$d1f6d53b6dcbe5f6$export$2e2bcd8739ae039 = $d1f6d53b6dcbe5f6$export$d9468344d3651243;

});
parcelRegister("j9YzS", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $df2dd90e7c50f6a9$export$137380d9ce54f7f);

var $fjnJQ = parcelRequire("fjnJQ");

var $475dX = parcelRequire("475dX");

var $bZZxd = parcelRequire("bZZxd");

var $gdDoQ = parcelRequire("gdDoQ");

var $aXQXD = parcelRequire("aXQXD");
const $df2dd90e7c50f6a9$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $fjnJQ.formatDistance),
    formatLong: (0, $475dX.formatLong),
    formatRelative: (0, $bZZxd.formatRelative),
    localize: (0, $gdDoQ.localize),
    match: (0, $aXQXD.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$df2dd90e7c50f6a9$export$2e2bcd8739ae039 = $df2dd90e7c50f6a9$export$137380d9ce54f7f;

});
parcelRegister("fjnJQ", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $b25b0b5411c28ac7$export$2c14ff85d6318973);
const $b25b0b5411c28ac7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $b25b0b5411c28ac7$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $b25b0b5411c28ac7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("475dX", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $2febde47bb98bab0$export$cbf60ecb96cbb82f);

var $cF8nj = parcelRequire("cF8nj");
const $2febde47bb98bab0$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $2febde47bb98bab0$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2febde47bb98bab0$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2febde47bb98bab0$export$cbf60ecb96cbb82f = {
    date: (0, $cF8nj.buildFormatLongFn)({
        formats: $2febde47bb98bab0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $cF8nj.buildFormatLongFn)({
        formats: $2febde47bb98bab0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $cF8nj.buildFormatLongFn)({
        formats: $2febde47bb98bab0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("cF8nj", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $937fcf7e723dd6d7$export$38e44e97ce4dbb7d);
function $937fcf7e723dd6d7$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("bZZxd", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0);
const $8bc51fb51fb6cd5f$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $8bc51fb51fb6cd5f$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$8bc51fb51fb6cd5f$var$formatRelativeLocale[token];

});

parcelRegister("gdDoQ", function(module, exports) {

$parcel$export(module.exports, "localize", () => $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63);

var $i0e32 = parcelRequire("i0e32");
const $bcec6c2f03a4d00e$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $bcec6c2f03a4d00e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $bcec6c2f03a4d00e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $bcec6c2f03a4d00e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $bcec6c2f03a4d00e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $bcec6c2f03a4d00e$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $bcec6c2f03a4d00e$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $bcec6c2f03a4d00e$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $bcec6c2f03a4d00e$var$ordinalNumber,
    era: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $i0e32.buildLocalizeFn)({
        values: $bcec6c2f03a4d00e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bcec6c2f03a4d00e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("i0e32", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $d1b31fbcf71c7062$export$63596d6ee8878b25);
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $d1b31fbcf71c7062$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("aXQXD", function(module, exports) {

$parcel$export(module.exports, "match", () => $7fb87efbf3834a7c$export$4659b591c19bdf3d);

var $4VX5I = parcelRequire("4VX5I");

var $k6RNN = parcelRequire("k6RNN");
const $7fb87efbf3834a7c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $7fb87efbf3834a7c$var$parseOrdinalNumberPattern = /\d+/i;
const $7fb87efbf3834a7c$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $7fb87efbf3834a7c$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $7fb87efbf3834a7c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $7fb87efbf3834a7c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $7fb87efbf3834a7c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $7fb87efbf3834a7c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $7fb87efbf3834a7c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $7fb87efbf3834a7c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $7fb87efbf3834a7c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $7fb87efbf3834a7c$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $k6RNN.buildMatchPatternFn)({
        matchPattern: $7fb87efbf3834a7c$var$matchOrdinalNumberPattern,
        parsePattern: $7fb87efbf3834a7c$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $4VX5I.buildMatchFn)({
        matchPatterns: $7fb87efbf3834a7c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7fb87efbf3834a7c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("4VX5I", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $397a5297d63bb64f$export$1430a0f35710914d);
function $397a5297d63bb64f$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $397a5297d63bb64f$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $397a5297d63bb64f$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $397a5297d63bb64f$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $397a5297d63bb64f$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("k6RNN", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $ea3e1a3193098a99$export$fdaf2fd6d7edde95);
function $ea3e1a3193098a99$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("eg22F", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $a61424cc6e7370c5$export$fe98a034cfb96d55);

var $iQCjQ = parcelRequire("iQCjQ");

var $h6qsS = parcelRequire("h6qsS");

var $e1RaR = parcelRequire("e1RaR");

var $5bAu7 = parcelRequire("5bAu7");

var $dFij3 = parcelRequire("dFij3");

var $9jrRw = parcelRequire("9jrRw");

var $l3957 = parcelRequire("l3957");
const $a61424cc6e7370c5$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $a61424cc6e7370c5$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $l3957.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $dFij3.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $9jrRw.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $9jrRw.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $e1RaR.getISOWeekYear)(date);
        // Padding
        return (0, $9jrRw.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $9jrRw.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $9jrRw.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $9jrRw.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $l3957.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $9jrRw.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $5bAu7.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $9jrRw.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $h6qsS.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $9jrRw.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $l3957.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $iQCjQ.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $9jrRw.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $9jrRw.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $9jrRw.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $9jrRw.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $a61424cc6e7370c5$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $l3957.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $l3957.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9jrRw.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $9jrRw.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $l3957.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $l3957.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $l3957.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $a61424cc6e7370c5$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $a61424cc6e7370c5$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $9jrRw.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $9jrRw.addLeadingZeros)(+date, token.length);
    }
};
function $a61424cc6e7370c5$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $9jrRw.addLeadingZeros)(minutes, 2);
}
function $a61424cc6e7370c5$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $9jrRw.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $a61424cc6e7370c5$var$formatTimezone(offset, delimiter);
}
function $a61424cc6e7370c5$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $9jrRw.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $9jrRw.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("iQCjQ", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $db8aceab23c59713$export$d3b42cd8452deec);

var $fD3hg = parcelRequire("fD3hg");

var $9FGIH = parcelRequire("9FGIH");

var $7yyQt = parcelRequire("7yyQt");
function $db8aceab23c59713$export$d3b42cd8452deec(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const diff = (0, $fD3hg.differenceInCalendarDays)(_date, (0, $9FGIH.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$db8aceab23c59713$export$2e2bcd8739ae039 = $db8aceab23c59713$export$d3b42cd8452deec;

});
parcelRegister("9FGIH", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $70a914b2bfa6cf87$export$f91e89d3d0406102);

var $7yyQt = parcelRequire("7yyQt");
function $70a914b2bfa6cf87$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $7yyQt.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$70a914b2bfa6cf87$export$2e2bcd8739ae039 = $70a914b2bfa6cf87$export$f91e89d3d0406102;

});


parcelRegister("h6qsS", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $c7378692dfd4ab30$export$7cabdc5698b63e2f);

var $9uNOU = parcelRequire("9uNOU");

var $lo97E = parcelRequire("lo97E");

var $1G94m = parcelRequire("1G94m");

var $7yyQt = parcelRequire("7yyQt");
function $c7378692dfd4ab30$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const diff = +(0, $lo97E.startOfISOWeek)(_date) - +(0, $1G94m.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $9uNOU.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$c7378692dfd4ab30$export$2e2bcd8739ae039 = $c7378692dfd4ab30$export$7cabdc5698b63e2f;

});
parcelRegister("lo97E", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $f922ea67b098f800$export$6173213f95a4431e);

var $2cZ4R = parcelRequire("2cZ4R");
function $f922ea67b098f800$export$6173213f95a4431e(date, options) {
    return (0, $2cZ4R.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$f922ea67b098f800$export$2e2bcd8739ae039 = $f922ea67b098f800$export$6173213f95a4431e;

});
parcelRegister("2cZ4R", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $19bc147add1de659$export$42c81a444fbfb5d4);

var $aK3iq = parcelRequire("aK3iq");

var $7yyQt = parcelRequire("7yyQt");
function $19bc147add1de659$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$19bc147add1de659$export$2e2bcd8739ae039 = $19bc147add1de659$export$42c81a444fbfb5d4;

});


parcelRegister("1G94m", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $1390bfa921613bda$export$236bdfa374eb69a9);

var $cMvsU = parcelRequire("cMvsU");

var $e1RaR = parcelRequire("e1RaR");

var $lo97E = parcelRequire("lo97E");
function $1390bfa921613bda$export$236bdfa374eb69a9(date, options) {
    const year = (0, $e1RaR.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, $cMvsU.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $lo97E.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$1390bfa921613bda$export$2e2bcd8739ae039 = $1390bfa921613bda$export$236bdfa374eb69a9;

});
parcelRegister("e1RaR", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $a36a67fbf4e7f789$export$3dbc52535f6f8fcc);

var $cMvsU = parcelRequire("cMvsU");

var $lo97E = parcelRequire("lo97E");

var $7yyQt = parcelRequire("7yyQt");
function $a36a67fbf4e7f789$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $cMvsU.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $lo97E.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $cMvsU.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $lo97E.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$a36a67fbf4e7f789$export$2e2bcd8739ae039 = $a36a67fbf4e7f789$export$3dbc52535f6f8fcc;

});



parcelRegister("5bAu7", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $3c6a47f4b80291d0$export$efe19b760242b2fc);

var $9uNOU = parcelRequire("9uNOU");

var $2cZ4R = parcelRequire("2cZ4R");

var $9oCza = parcelRequire("9oCza");

var $7yyQt = parcelRequire("7yyQt");
function $3c6a47f4b80291d0$export$efe19b760242b2fc(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const diff = +(0, $2cZ4R.startOfWeek)(_date, options) - +(0, $9oCza.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $9uNOU.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$3c6a47f4b80291d0$export$2e2bcd8739ae039 = $3c6a47f4b80291d0$export$efe19b760242b2fc;

});
parcelRegister("9oCza", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $6d7445628bc657f6$export$bb7b45bb8e74da0f);

var $aK3iq = parcelRequire("aK3iq");

var $cMvsU = parcelRequire("cMvsU");

var $dFij3 = parcelRequire("dFij3");

var $2cZ4R = parcelRequire("2cZ4R");
function $6d7445628bc657f6$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $dFij3.getWeekYear)(date, options);
    const firstWeek = (0, $cMvsU.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $2cZ4R.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$6d7445628bc657f6$export$2e2bcd8739ae039 = $6d7445628bc657f6$export$bb7b45bb8e74da0f;

});
parcelRegister("dFij3", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $9f2d4df197546c06$export$12d572480ceb6e58);

var $aK3iq = parcelRequire("aK3iq");

var $cMvsU = parcelRequire("cMvsU");

var $2cZ4R = parcelRequire("2cZ4R");

var $7yyQt = parcelRequire("7yyQt");
function $9f2d4df197546c06$export$12d572480ceb6e58(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $cMvsU.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $2cZ4R.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $cMvsU.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $2cZ4R.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$9f2d4df197546c06$export$2e2bcd8739ae039 = $9f2d4df197546c06$export$12d572480ceb6e58;

});



parcelRegister("9jrRw", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $6c7b80446273fbf1$export$c8306e720e213c0f);
function $6c7b80446273fbf1$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("l3957", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $f530ec37dbf8665a$export$b0d4b338e1516f13);

var $9jrRw = parcelRequire("9jrRw");
const $f530ec37dbf8665a$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $9jrRw.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $9jrRw.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $9jrRw.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $9jrRw.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("dPmGw", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $a111a280e7a3f1fa$export$70cc8fd02856fd58);
const $a111a280e7a3f1fa$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $a111a280e7a3f1fa$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $a111a280e7a3f1fa$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $a111a280e7a3f1fa$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $a111a280e7a3f1fa$var$timeLongFormatter(timePattern, formatLong));
};
const $a111a280e7a3f1fa$export$70cc8fd02856fd58 = {
    p: $a111a280e7a3f1fa$var$timeLongFormatter,
    P: $a111a280e7a3f1fa$var$dateTimeLongFormatter
};

});

parcelRegister("bWEgL", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $8b24592752d42d9c$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $8b24592752d42d9c$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $8b24592752d42d9c$export$f5f38f90ecaaf879);
const $8b24592752d42d9c$var$dayOfYearTokenRE = /^D+$/;
const $8b24592752d42d9c$var$weekYearTokenRE = /^Y+$/;
const $8b24592752d42d9c$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $8b24592752d42d9c$export$c6cc36aa33304772(token) {
    return $8b24592752d42d9c$var$dayOfYearTokenRE.test(token);
}
function $8b24592752d42d9c$export$c6b49d6dceb604a1(token) {
    return $8b24592752d42d9c$var$weekYearTokenRE.test(token);
}
function $8b24592752d42d9c$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $8b24592752d42d9c$var$message(token, format, input);
    console.warn(_message);
    if ($8b24592752d42d9c$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $8b24592752d42d9c$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("5ujzY", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $3feef11dde2315db$export$1ea939691cdc45b8);

var $51jqk = parcelRequire("51jqk");

var $7yyQt = parcelRequire("7yyQt");
function $3feef11dde2315db$export$1ea939691cdc45b8(date) {
    return !(!(0, $51jqk.isDate)(date) && typeof date !== "number" || isNaN(+(0, $7yyQt.toDate)(date)));
}
var // Fallback for modularized imports:
$3feef11dde2315db$export$2e2bcd8739ae039 = $3feef11dde2315db$export$1ea939691cdc45b8;

});
parcelRegister("51jqk", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $3a7c1ce5b86d595e$export$871608497c498473);
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $3a7c1ce5b86d595e$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$3a7c1ce5b86d595e$export$2e2bcd8739ae039 = $3a7c1ce5b86d595e$export$871608497c498473;

});



parcelRegister("hEUsU", function(module, exports) {

$parcel$export(module.exports, "parse", () => $cdb1f8eb83af40fb$export$98e6a39c04603d36);

var $j9YzS = parcelRequire("j9YzS");

var $dPmGw = parcelRequire("dPmGw");

var $bWEgL = parcelRequire("bWEgL");

var $cMvsU = parcelRequire("cMvsU");

var $hZQ2B = parcelRequire("hZQ2B");

var $7yyQt = parcelRequire("7yyQt");

var $5F8wQ = parcelRequire("5F8wQ");

var $kyQ90 = parcelRequire("kyQ90");
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $cdb1f8eb83af40fb$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $cdb1f8eb83af40fb$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $cdb1f8eb83af40fb$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $cdb1f8eb83af40fb$var$doubleQuoteRegExp = /''/g;
const $cdb1f8eb83af40fb$var$notWhitespaceRegExp = /\S/;
const $cdb1f8eb83af40fb$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $cdb1f8eb83af40fb$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $cMvsU.constructFrom)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $hZQ2B.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $j9YzS.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $7yyQt.toDate)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $5F8wQ.DateTimezoneSetter)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($cdb1f8eb83af40fb$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $dPmGw.longFormatters)) {
            const longFormatter = (0, $dPmGw.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($cdb1f8eb83af40fb$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $bWEgL.isProtectedWeekYearToken)(token)) (0, $bWEgL.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $bWEgL.isProtectedDayOfYearToken)(token)) (0, $bWEgL.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $kyQ90.parsers)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($cdb1f8eb83af40fb$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $cdb1f8eb83af40fb$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $cdb1f8eb83af40fb$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $7yyQt.toDate)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $cdb1f8eb83af40fb$var$cleanEscapedString(input) {
    return input.match($cdb1f8eb83af40fb$var$escapedStringRegExp)[1].replace($cdb1f8eb83af40fb$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$cdb1f8eb83af40fb$export$2e2bcd8739ae039 = $cdb1f8eb83af40fb$export$98e6a39c04603d36;

});
parcelRegister("hZQ2B", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $d1a080689c5f0d40$export$430a3269e24b912e);

var $aK3iq = parcelRequire("aK3iq");
function $d1a080689c5f0d40$export$430a3269e24b912e() {
    return Object.assign({}, (0, $aK3iq.getDefaultOptions)());
}
var // Fallback for modularized imports:
$d1a080689c5f0d40$export$2e2bcd8739ae039 = $d1a080689c5f0d40$export$430a3269e24b912e;

});

parcelRegister("5F8wQ", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $41f765bb200d544a$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateTimezoneSetter", () => $41f765bb200d544a$export$8be15fe85ad72f86);

var $cMvsU = parcelRequire("cMvsU");

var $gfF2L = parcelRequire("gfF2L");
const $41f765bb200d544a$var$TIMEZONE_UNIT_PRIORITY = 10;
class $41f765bb200d544a$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $41f765bb200d544a$export$9a09e32dd4990fd5 extends $41f765bb200d544a$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $41f765bb200d544a$export$8be15fe85ad72f86 extends $41f765bb200d544a$export$81d53e3678089a6 {
    priority = $41f765bb200d544a$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $cMvsU.constructFrom)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $cMvsU.constructFrom)(date, (0, $gfF2L.transpose)(date, this.context));
    }
}

});
parcelRegister("gfF2L", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $bd4de27a1b5e78ee$export$9cb09a71b7d66923);

var $cMvsU = parcelRequire("cMvsU");
function $bd4de27a1b5e78ee$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $bd4de27a1b5e78ee$var$isConstructor(constructor) ? new constructor(0) : (0, $cMvsU.constructFrom)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $bd4de27a1b5e78ee$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$bd4de27a1b5e78ee$export$2e2bcd8739ae039 = $bd4de27a1b5e78ee$export$9cb09a71b7d66923;

});


parcelRegister("kyQ90", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $ef7f6e5e784e4fa2$export$19131010e7fd8373);

var $gYJvl = parcelRequire("gYJvl");

var $lOPt9 = parcelRequire("lOPt9");

var $iuMX8 = parcelRequire("iuMX8");

var $lxRRW = parcelRequire("lxRRW");

var $4VNBj = parcelRequire("4VNBj");

var $d65Ic = parcelRequire("d65Ic");

var $8hfUv = parcelRequire("8hfUv");

var $4v5XY = parcelRequire("4v5XY");

var $5zQDp = parcelRequire("5zQDp");

var $6b0Fv = parcelRequire("6b0Fv");

var $8mlbV = parcelRequire("8mlbV");

var $kkkIm = parcelRequire("kkkIm");

var $77gCq = parcelRequire("77gCq");

var $8WFYu = parcelRequire("8WFYu");

var $kAilI = parcelRequire("kAilI");

var $9pDxV = parcelRequire("9pDxV");

var $lMRin = parcelRequire("lMRin");

var $iVSU6 = parcelRequire("iVSU6");

var $dPgdM = parcelRequire("dPgdM");

var $cvBnR = parcelRequire("cvBnR");

var $5tYXu = parcelRequire("5tYXu");

var $fokkr = parcelRequire("fokkr");

var $2za9d = parcelRequire("2za9d");

var $avR9g = parcelRequire("avR9g");

var $bYQdH = parcelRequire("bYQdH");

var $7bXdY = parcelRequire("7bXdY");

var $aXzb2 = parcelRequire("aXzb2");

var $g3ovD = parcelRequire("g3ovD");

var $45yr2 = parcelRequire("45yr2");

var $h7Gs6 = parcelRequire("h7Gs6");

var $5WTeF = parcelRequire("5WTeF");
const $ef7f6e5e784e4fa2$export$19131010e7fd8373 = {
    G: new (0, $gYJvl.EraParser)(),
    y: new (0, $lOPt9.YearParser)(),
    Y: new (0, $iuMX8.LocalWeekYearParser)(),
    R: new (0, $lxRRW.ISOWeekYearParser)(),
    u: new (0, $4VNBj.ExtendedYearParser)(),
    Q: new (0, $d65Ic.QuarterParser)(),
    q: new (0, $8hfUv.StandAloneQuarterParser)(),
    M: new (0, $4v5XY.MonthParser)(),
    L: new (0, $5zQDp.StandAloneMonthParser)(),
    w: new (0, $6b0Fv.LocalWeekParser)(),
    I: new (0, $8mlbV.ISOWeekParser)(),
    d: new (0, $kkkIm.DateParser)(),
    D: new (0, $77gCq.DayOfYearParser)(),
    E: new (0, $8WFYu.DayParser)(),
    e: new (0, $kAilI.LocalDayParser)(),
    c: new (0, $9pDxV.StandAloneLocalDayParser)(),
    i: new (0, $lMRin.ISODayParser)(),
    a: new (0, $iVSU6.AMPMParser)(),
    b: new (0, $dPgdM.AMPMMidnightParser)(),
    B: new (0, $cvBnR.DayPeriodParser)(),
    h: new (0, $5tYXu.Hour1to12Parser)(),
    H: new (0, $fokkr.Hour0to23Parser)(),
    K: new (0, $2za9d.Hour0To11Parser)(),
    k: new (0, $avR9g.Hour1To24Parser)(),
    m: new (0, $bYQdH.MinuteParser)(),
    s: new (0, $7bXdY.SecondParser)(),
    S: new (0, $aXzb2.FractionOfSecondParser)(),
    X: new (0, $g3ovD.ISOTimezoneWithZParser)(),
    x: new (0, $45yr2.ISOTimezoneParser)(),
    t: new (0, $h7Gs6.TimestampSecondsParser)(),
    T: new (0, $5WTeF.TimestampMillisecondsParser)()
};

});
parcelRegister("gYJvl", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $c5c58c2bcedebbf1$export$8e5a1d3f85a9688);

var $46xuD = parcelRequire("46xuD");
class $c5c58c2bcedebbf1$export$8e5a1d3f85a9688 extends (0, $46xuD.Parser) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}

});
parcelRegister("46xuD", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $2fd1b3fa9f226a10$export$7acfa6ed01010e37);

var $5F8wQ = parcelRequire("5F8wQ");
class $2fd1b3fa9f226a10$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $5F8wQ.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}

});


parcelRegister("lOPt9", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $fe26312ae949d7e7$export$48d352de7cd4a988);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $fe26312ae949d7e7$export$48d352de7cd4a988 extends (0, $46xuD.Parser) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $d7zOS.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}

});
parcelRegister("d7zOS", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $98d7b6d1a647224d$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $98d7b6d1a647224d$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $98d7b6d1a647224d$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $98d7b6d1a647224d$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $98d7b6d1a647224d$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $98d7b6d1a647224d$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $98d7b6d1a647224d$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $98d7b6d1a647224d$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $98d7b6d1a647224d$export$3d50627710b84d75);

var $9uNOU = parcelRequire("9uNOU");

var $eIicH = parcelRequire("eIicH");
function $98d7b6d1a647224d$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $98d7b6d1a647224d$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $98d7b6d1a647224d$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $9uNOU.millisecondsInHour) + minutes * (0, $9uNOU.millisecondsInMinute) + seconds * (0, $9uNOU.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $98d7b6d1a647224d$export$d931c43c4608a164(dateString) {
    return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).anyDigitsSigned, dateString);
}
function $98d7b6d1a647224d$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).singleDigit, dateString);
        case 2:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).twoDigits, dateString);
        case 3:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).threeDigits, dateString);
        case 4:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).fourDigits, dateString);
        default:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $98d7b6d1a647224d$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388((0, $eIicH.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $98d7b6d1a647224d$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $98d7b6d1a647224d$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $98d7b6d1a647224d$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $98d7b6d1a647224d$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("eIicH", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $ab634ba02f4ef166$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $ab634ba02f4ef166$export$a7ee192b982af9c1);
const $ab634ba02f4ef166$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $ab634ba02f4ef166$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("iuMX8", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $d771005d0eb7eeef$export$b8ef38dfcf05d5db);

var $dFij3 = parcelRequire("dFij3");

var $2cZ4R = parcelRequire("2cZ4R");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $d771005d0eb7eeef$export$b8ef38dfcf05d5db extends (0, $46xuD.Parser) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $dFij3.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $d7zOS.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $2cZ4R.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $2cZ4R.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}

});

parcelRegister("lxRRW", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $faf6774c01432c8e$export$951d1df011fde06f);

var $lo97E = parcelRequire("lo97E");

var $cMvsU = parcelRequire("cMvsU");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $faf6774c01432c8e$export$951d1df011fde06f extends (0, $46xuD.Parser) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $d7zOS.parseNDigitsSigned)(4, dateString);
        return (0, $d7zOS.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $cMvsU.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $lo97E.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("4VNBj", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $3972f5f650221d84$export$bad9d2ea38e8f1a);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $3972f5f650221d84$export$bad9d2ea38e8f1a extends (0, $46xuD.Parser) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $d7zOS.parseNDigitsSigned)(4, dateString);
        return (0, $d7zOS.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("d65Ic", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $98904429aa0b094e$export$5cb0f701186dde1d);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $98904429aa0b094e$export$5cb0f701186dde1d extends (0, $46xuD.Parser) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("8hfUv", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $606c40b7cb50bbb6$export$300c0c2990e20e6d);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $606c40b7cb50bbb6$export$300c0c2990e20e6d extends (0, $46xuD.Parser) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("4v5XY", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $346eaf77891cc3e0$export$400dd8b40ef138a3);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $346eaf77891cc3e0$export$400dd8b40ef138a3 extends (0, $46xuD.Parser) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}

});

parcelRegister("5zQDp", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $40f90cc8b2f5c9e4$export$1d7eaa53eaa5deba extends (0, $46xuD.Parser) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("6b0Fv", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $47f449e66c13a265$export$c4005ffc174e07c0);

var $1hURb = parcelRequire("1hURb");

var $2cZ4R = parcelRequire("2cZ4R");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $47f449e66c13a265$export$c4005ffc174e07c0 extends (0, $46xuD.Parser) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $2cZ4R.startOfWeek)((0, $1hURb.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}

});
parcelRegister("1hURb", function(module, exports) {

$parcel$export(module.exports, "setWeek", () => $0f037b8b4b46fb5c$export$4b3066ce4afafd88);

var $5bAu7 = parcelRequire("5bAu7");

var $7yyQt = parcelRequire("7yyQt");
function $0f037b8b4b46fb5c$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $7yyQt.toDate)(date, options?.in);
    const diff = (0, $5bAu7.getWeek)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $7yyQt.toDate)(date_, options?.in);
}
var // Fallback for modularized imports:
$0f037b8b4b46fb5c$export$2e2bcd8739ae039 = $0f037b8b4b46fb5c$export$4b3066ce4afafd88;

});


parcelRegister("8mlbV", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $6160d0faa8efda89$export$6fc8dbedd560a6af);

var $9JXfi = parcelRequire("9JXfi");

var $lo97E = parcelRequire("lo97E");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $6160d0faa8efda89$export$6fc8dbedd560a6af extends (0, $46xuD.Parser) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $lo97E.startOfISOWeek)((0, $9JXfi.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}

});
parcelRegister("9JXfi", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", () => $7176460089065355$export$6542bebf6be94082);

var $h6qsS = parcelRequire("h6qsS");

var $7yyQt = parcelRequire("7yyQt");
function $7176460089065355$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const diff = (0, $h6qsS.getISOWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$7176460089065355$export$2e2bcd8739ae039 = $7176460089065355$export$6542bebf6be94082;

});


parcelRegister("kkkIm", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $ecc5be5b264591cb$export$e8d4b28a20981dd2);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
const $ecc5be5b264591cb$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $ecc5be5b264591cb$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $ecc5be5b264591cb$export$e8d4b28a20981dd2 extends (0, $46xuD.Parser) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $d7zOS.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $ecc5be5b264591cb$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $ecc5be5b264591cb$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("77gCq", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $52e613ff70efeac9$export$6cfe0d613455f615);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $52e613ff70efeac9$export$6cfe0d613455f615 extends (0, $46xuD.Parser) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $d7zOS.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("8WFYu", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $68344ccfc1ac5f7d$export$1b03c8b76262f7bd);

var $fi8ek = parcelRequire("fi8ek");

var $46xuD = parcelRequire("46xuD");
class $68344ccfc1ac5f7d$export$1b03c8b76262f7bd extends (0, $46xuD.Parser) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $fi8ek.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

});
parcelRegister("fi8ek", function(module, exports) {

$parcel$export(module.exports, "setDay", () => $b21eebce3582ac56$export$b04fdcda82decc6c);

var $aK3iq = parcelRequire("aK3iq");

var $l4b73 = parcelRequire("l4b73");

var $7yyQt = parcelRequire("7yyQt");
function $b21eebce3582ac56$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $aK3iq.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $7yyQt.toDate)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $l4b73.addDays)(date_, diff, options);
}
var // Fallback for modularized imports:
$b21eebce3582ac56$export$2e2bcd8739ae039 = $b21eebce3582ac56$export$b04fdcda82decc6c;

});


parcelRegister("kAilI", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $efc5673231dedfdd$export$44d1c127ab42c480);

var $fi8ek = parcelRequire("fi8ek");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $efc5673231dedfdd$export$44d1c127ab42c480 extends (0, $46xuD.Parser) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $fi8ek.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}

});

parcelRegister("9pDxV", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $6da51fe9d8b20690$export$e447a647caaaec1d);

var $fi8ek = parcelRequire("fi8ek");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $6da51fe9d8b20690$export$e447a647caaaec1d extends (0, $46xuD.Parser) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $d7zOS.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $fi8ek.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}

});

parcelRegister("lMRin", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $fdc76c097f6cd68b$export$693fb1e525095b2a);

var $dc6tA = parcelRequire("dc6tA");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $fdc76c097f6cd68b$export$693fb1e525095b2a extends (0, $46xuD.Parser) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $d7zOS.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $dc6tA.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}

});
parcelRegister("dc6tA", function(module, exports) {

$parcel$export(module.exports, "setISODay", () => $99b16b62472d13b2$export$1fd9df65adb0d1aa);

var $l4b73 = parcelRequire("l4b73");

var $1Ki1g = parcelRequire("1Ki1g");

var $7yyQt = parcelRequire("7yyQt");
function $99b16b62472d13b2$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $7yyQt.toDate)(date, options?.in);
    const currentDay = (0, $1Ki1g.getISODay)(date_, options);
    const diff = day - currentDay;
    return (0, $l4b73.addDays)(date_, diff, options);
}
var // Fallback for modularized imports:
$99b16b62472d13b2$export$2e2bcd8739ae039 = $99b16b62472d13b2$export$1fd9df65adb0d1aa;

});
parcelRegister("1Ki1g", function(module, exports) {

$parcel$export(module.exports, "getISODay", () => $14581097cfa3b846$export$c514f4c1a8ed5e9e);

var $7yyQt = parcelRequire("7yyQt");
function $14581097cfa3b846$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $7yyQt.toDate)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$14581097cfa3b846$export$2e2bcd8739ae039 = $14581097cfa3b846$export$c514f4c1a8ed5e9e;

});



parcelRegister("iVSU6", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $dc88239c6feac6f3$export$8d1e08492351df91);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $dc88239c6feac6f3$export$8d1e08492351df91 extends (0, $46xuD.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $d7zOS.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("dPgdM", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $a10c9f024d5ae86e$export$73ca2bd0a17d273);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $a10c9f024d5ae86e$export$73ca2bd0a17d273 extends (0, $46xuD.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $d7zOS.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("cvBnR", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $91b560efdd3bae18$export$bb9212adf05373db);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $91b560efdd3bae18$export$bb9212adf05373db extends (0, $46xuD.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $d7zOS.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}

});

parcelRegister("5tYXu", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $3fdef242ab121039$export$8a04050a727a1756);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $3fdef242ab121039$export$8a04050a727a1756 extends (0, $46xuD.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("fokkr", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $b348ddc307375f53$export$e56f4dea2c3e56dd);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $b348ddc307375f53$export$e56f4dea2c3e56dd extends (0, $46xuD.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("2za9d", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $1de6b8c9767b7cf2$export$cbbe855312f87d77);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $1de6b8c9767b7cf2$export$cbbe855312f87d77 extends (0, $46xuD.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}

});

parcelRegister("avR9g", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $7a7606d1d349befa$export$6008046d2b34b6a5);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $7a7606d1d349befa$export$6008046d2b34b6a5 extends (0, $46xuD.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}

});

parcelRegister("bYQdH", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $8b8dce150b01caf0$export$2b52670d9e2be53);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $8b8dce150b01caf0$export$2b52670d9e2be53 extends (0, $46xuD.Parser) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

});

parcelRegister("7bXdY", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $53c7803a7379f0da$export$94d46d540cf1366a);

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $53c7803a7379f0da$export$94d46d540cf1366a extends (0, $46xuD.Parser) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $d7zOS.parseNumericPattern)((0, $eIicH.numericPatterns).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $d7zOS.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

});

parcelRegister("aXzb2", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $7faab384a61dd982$export$b8e6f8b2d70893b1);

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $7faab384a61dd982$export$b8e6f8b2d70893b1 extends (0, $46xuD.Parser) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $d7zOS.mapValue)((0, $d7zOS.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

});

parcelRegister("g3ovD", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $bafff02f6dd76726$export$104d901d49fea29b);

var $cMvsU = parcelRequire("cMvsU");

var $gr9Oc = parcelRequire("gr9Oc");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $bafff02f6dd76726$export$104d901d49fea29b extends (0, $46xuD.Parser) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).basic, dateString);
            case "XXXX":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $cMvsU.constructFrom)(date, date.getTime() - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}

});

parcelRegister("45yr2", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $2fa25724cac045ce$export$12910e5204b52b9);

var $cMvsU = parcelRequire("cMvsU");

var $gr9Oc = parcelRequire("gr9Oc");

var $eIicH = parcelRequire("eIicH");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $2fa25724cac045ce$export$12910e5204b52b9 extends (0, $46xuD.Parser) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).basic, dateString);
            case "xxxx":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $d7zOS.parseTimezonePattern)((0, $eIicH.timezonePatterns).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $cMvsU.constructFrom)(date, date.getTime() - (0, $gr9Oc.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}

});

parcelRegister("h7Gs6", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $03378c78aec26a94$export$2cd8bf877a05e96);

var $cMvsU = parcelRequire("cMvsU");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $03378c78aec26a94$export$2cd8bf877a05e96 extends (0, $46xuD.Parser) {
    priority = 40;
    parse(dateString) {
        return (0, $d7zOS.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $cMvsU.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}

});

parcelRegister("5WTeF", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $454d372c89c9485d$export$6d8f69c6906d6368);

var $cMvsU = parcelRequire("cMvsU");

var $46xuD = parcelRequire("46xuD");

var $d7zOS = parcelRequire("d7zOS");
class $454d372c89c9485d$export$6d8f69c6906d6368 extends (0, $46xuD.Parser) {
    priority = 20;
    parse(dateString) {
        return (0, $d7zOS.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $cMvsU.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}

});



parcelRegister("aNBww", function(module, exports) {

$parcel$export(module.exports, "parseISO", () => $7dcb966690c372e6$export$4393d2ccbbedb219);

var $9uNOU = parcelRequire("9uNOU");

var $cMvsU = parcelRequire("cMvsU");

var $7yyQt = parcelRequire("7yyQt");
function $7dcb966690c372e6$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $cMvsU.constructFrom)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $7dcb966690c372e6$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $7dcb966690c372e6$var$parseYear(dateStrings.date, additionalDigits);
        date = $7dcb966690c372e6$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $7dcb966690c372e6$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $7dcb966690c372e6$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $7yyQt.toDate)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $7yyQt.toDate)(timestamp + time + offset, options?.in);
}
const $7dcb966690c372e6$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $7dcb966690c372e6$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $7dcb966690c372e6$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $7dcb966690c372e6$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $7dcb966690c372e6$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($7dcb966690c372e6$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($7dcb966690c372e6$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($7dcb966690c372e6$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $7dcb966690c372e6$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $7dcb966690c372e6$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $7dcb966690c372e6$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($7dcb966690c372e6$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $7dcb966690c372e6$var$parseDateUnit(captures[1]);
    const month = $7dcb966690c372e6$var$parseDateUnit(captures[2]) - 1;
    const day = $7dcb966690c372e6$var$parseDateUnit(captures[3]);
    const week = $7dcb966690c372e6$var$parseDateUnit(captures[4]);
    const dayOfWeek = $7dcb966690c372e6$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$7dcb966690c372e6$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $7dcb966690c372e6$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$7dcb966690c372e6$var$validateDate(year, month, day) || !$7dcb966690c372e6$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $7dcb966690c372e6$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $7dcb966690c372e6$var$parseTime(timeString) {
    const captures = timeString.match($7dcb966690c372e6$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $7dcb966690c372e6$var$parseTimeUnit(captures[1]);
    const minutes = $7dcb966690c372e6$var$parseTimeUnit(captures[2]);
    const seconds = $7dcb966690c372e6$var$parseTimeUnit(captures[3]);
    if (!$7dcb966690c372e6$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $9uNOU.millisecondsInHour) + minutes * (0, $9uNOU.millisecondsInMinute) + seconds * 1000;
}
function $7dcb966690c372e6$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $7dcb966690c372e6$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($7dcb966690c372e6$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$7dcb966690c372e6$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $9uNOU.millisecondsInHour) + minutes * (0, $9uNOU.millisecondsInMinute));
}
function $7dcb966690c372e6$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $7dcb966690c372e6$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $7dcb966690c372e6$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $7dcb966690c372e6$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($7dcb966690c372e6$var$daysInMonths[month] || ($7dcb966690c372e6$var$isLeapYearIndex(year) ? 29 : 28));
}
function $7dcb966690c372e6$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($7dcb966690c372e6$var$isLeapYearIndex(year) ? 366 : 365);
}
function $7dcb966690c372e6$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $7dcb966690c372e6$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $7dcb966690c372e6$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$7dcb966690c372e6$export$2e2bcd8739ae039 = $7dcb966690c372e6$export$4393d2ccbbedb219;

});

parcelRegister("4Rvit", function(module, exports) {

$parcel$export(module.exports, "startOfHour", () => $38a46391a308b1eb$export$24f91f68e7c9d9d5);

var $7yyQt = parcelRequire("7yyQt");
function $38a46391a308b1eb$export$24f91f68e7c9d9d5(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setMinutes(0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$38a46391a308b1eb$export$2e2bcd8739ae039 = $38a46391a308b1eb$export$24f91f68e7c9d9d5;

});

parcelRegister("7SEoW", function(module, exports) {

$parcel$export(module.exports, "startOfMinute", () => $5bccea67db034e66$export$c66440458c6aa793);

var $7yyQt = parcelRequire("7yyQt");
function $5bccea67db034e66$export$c66440458c6aa793(date, options) {
    const date_ = (0, $7yyQt.toDate)(date, options?.in);
    date_.setSeconds(0, 0);
    return date_;
}
var // Fallback for modularized imports:
$5bccea67db034e66$export$2e2bcd8739ae039 = $5bccea67db034e66$export$c66440458c6aa793;

});

parcelRegister("d15Zh", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", () => $97a0034df0672fa6$export$a5a3b454ada2268e);

var $7yyQt = parcelRequire("7yyQt");
function $97a0034df0672fa6$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$97a0034df0672fa6$export$2e2bcd8739ae039 = $97a0034df0672fa6$export$a5a3b454ada2268e;

});

parcelRegister("jMRxa", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", () => $e67c06c1cc60b504$export$69be7267a042ecb3);

var $7yyQt = parcelRequire("7yyQt");
function $e67c06c1cc60b504$export$69be7267a042ecb3(date, options) {
    const _date = (0, $7yyQt.toDate)(date, options?.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$e67c06c1cc60b504$export$2e2bcd8739ae039 = $e67c06c1cc60b504$export$69be7267a042ecb3;

});

parcelRegister("az18O", function(module, exports) {

$parcel$export(module.exports, "startOfSecond", () => $7b0e0edbd648a7c7$export$66c51f9715fdbff5);

var $7yyQt = parcelRequire("7yyQt");
function $7b0e0edbd648a7c7$export$66c51f9715fdbff5(date, options) {
    const date_ = (0, $7yyQt.toDate)(date, options?.in);
    date_.setMilliseconds(0);
    return date_;
}
var // Fallback for modularized imports:
$7b0e0edbd648a7c7$export$2e2bcd8739ae039 = $7b0e0edbd648a7c7$export$66c51f9715fdbff5;

});



parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v4.0.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.com/license/
 *
 * Date: 2026-01-18T00:20Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    module.exports = factory(global, true);
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    "use strict";
    if (!window1.document) throw new Error("jQuery requires a window with a document");
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    // Support: IE 11+
    // IE doesn't have Array#flat; provide a fallback.
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    // [[Class]] -> type pairs
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    // All support tests are defined in their respective modules.
    var support = {};
    function toType(obj) {
        if (obj == null) return obj + "";
        return typeof obj === "object" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    function isWindow(obj) {
        return obj != null && obj === obj.window;
    }
    function isArrayLike(obj) {
        var length = !!obj && obj.length, type = toType(obj);
        if (typeof obj === "function" || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var document$1 = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document$1;
        var i, script = doc.createElement("script");
        script.text = code;
        for(i in preservedScriptAttributes)if (node && node[i]) script[i] = node[i];
        if (doc.head.appendChild(script).parentNode) script.parentNode.removeChild(script);
    }
    var version = "4.0.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        }
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && typeof target !== "function") target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Note: an element does not contain itself
        contains: function(a, b) {
            var bup = b && b.parentNode;
            return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
            // IE doesn't have `contains` on SVG.
            (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
        },
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    // https://www.w3.org/TR/css3-selectors/#whitespace
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var isIE = document$1.documentMode;
    var rbuggyQSA = isIE && new RegExp(// Support: IE 9 - 11+
    // IE's :disabled selector does not pick up the children of disabled fieldsets
    ":enabled|:disabled|\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
    var identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+";
    var rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*");
    var rdescend = new RegExp(whitespace + "|>");
    var rsibling = /[+~]/;
    var documentElement$1 = document$1.documentElement;
    // Support: IE 9 - 11+
    // IE requires a prefix.
    var matches = documentElement$1.matches || documentElement$1.msMatchesSelector;
    /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
        var keys = [];
        function cache(key, value) {
            // Use (key + " ") to avoid collision with native prototype properties
            // (see https://github.com/jquery/sizzle/issues/157)
            if (keys.push(key + " ") > jQuery.expr.cacheLength) // Only keep the most recent entries
            delete cache[keys.shift()];
            return cache[key + " "] = value;
        }
        return cache;
    }
    /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
    }
    // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
    var attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]";
    var pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
    // 1. quoted (capture 3; capture 4 or capture 5)
    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
    ".*" + ")\\)|)";
    var filterMatchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i")
    };
    var rpseudo = new RegExp(pseudos);
    // CSS escapes
    // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    var runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 0x10000;
        if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
        return nonHex;
        // Replace a hexadecimal escape sequence with the encoded Unicode code point
        // Support: IE <=11+
        // For values outside the Basic Multilingual Plane (BMP), manually construct a
        // surrogate pair
        return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
    };
    function unescapeSelector(sel) {
        return sel.replace(runescape, funescape);
    }
    function selectorError(msg) {
        jQuery.error("Syntax error, unrecognized expression: " + msg);
    }
    var rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*");
    var tokenCache = createCache();
    function tokenize(selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
        if (cached) return parseOnly ? 0 : cached.slice(0);
        soFar = selector;
        groups = [];
        preFilters = jQuery.expr.preFilter;
        while(soFar){
            // Comma and first run
            if (!matched || (match = rcomma.exec(soFar))) {
                if (match) // Don't consume trailing commas as valid
                soFar = soFar.slice(match[0].length) || soFar;
                groups.push(tokens = []);
            }
            matched = false;
            // Combinators
            if (match = rleadingCombinator.exec(soFar)) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    // Cast descendant combinators to space
                    type: match[0].replace(rtrimCSS, " ")
                });
                soFar = soFar.slice(matched.length);
            }
            // Filters
            for(type in filterMatchExpr)if ((match = jQuery.expr.match[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    type: type,
                    matches: match
                });
                soFar = soFar.slice(matched.length);
            }
            if (!matched) break;
        }
        // Return the length of the invalid excess
        // if we're just parsing
        // Otherwise, throw an error or return tokens
        if (parseOnly) return soFar.length;
        return soFar ? selectorError(selector) : // Cache the tokens
        tokenCache(selector, groups).slice(0);
    }
    var preFilter = {
        ATTR: function(match) {
            match[1] = unescapeSelector(match[1]);
            // Move the given value to match[3] whether quoted or unquoted
            match[3] = unescapeSelector(match[3] || match[4] || match[5] || "");
            if (match[2] === "~=") match[3] = " " + match[3] + " ";
            return match.slice(0, 4);
        },
        CHILD: function(match) {
            /* matches from filterMatchExpr["CHILD"]
			1 type (only|nth|...)
			2 what (child|of-type)
			3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
			4 xn-component of xn+y argument ([+-]?\d*n|)
			5 sign of xn-component
			6 x of xn-component
			7 sign of y-component
			8 y of y-component
		*/ match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
                // nth-* requires argument
                if (!match[3]) selectorError(match[0]);
                // numeric x and y parameters for jQuery.expr.filter.CHILD
                // remember that false/true cast respectively to 0/1
                match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                match[5] = +(match[7] + match[8] || match[3] === "odd");
            // other types prohibit arguments
            } else if (match[3]) selectorError(match[0]);
            return match;
        },
        PSEUDO: function(match) {
            var excess, unquoted = !match[6] && match[2];
            if (filterMatchExpr.CHILD.test(match[0])) return null;
            // Accept quoted arguments as-is
            if (match[3]) match[2] = match[4] || match[5] || "";
            else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
            (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                // excess is a negative index
                match[0] = match[0].slice(0, excess);
                match[2] = unquoted.slice(0, excess);
            }
            // Return only captures needed by the pseudo filter method (type and argument)
            return match.slice(0, 3);
        }
    };
    function toSelector(tokens) {
        var i = 0, len = tokens.length, selector = "";
        for(; i < len; i++)selector += tokens[i].value;
        return selector;
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    function access(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (typeof value !== "function") raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    }
    // Only count HTML whitespace
    // Other whitespace should count in values
    // https://infra.spec.whatwg.org/#ascii-whitespace
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()];
            if (value !== undefined) {
                if (value === null || // For compat with previous handling of boolean attributes,
                // remove when `false` passed. For ARIA attributes -
                // many of which recognize a `"false"` value - continue to
                // set the `"false"` value as jQuery <4 did.
                value === false && name.toLowerCase().indexOf("aria-") !== 0) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value);
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = elem.getAttribute(name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {},
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Support: IE <=11+
    // An input loses its value after becoming a radio
    if (isIE) jQuery.attrHooks.type = {
        set: function(elem, value) {
            if (value === "radio" && nodeName(elem, "input")) {
                var val = elem.value;
                elem.setAttribute("type", value);
                if (val) elem.value = val;
                return value;
            }
        }
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var sort = arr.sort;
    var splice = arr.splice;
    var hasDuplicate;
    // Document order sorting
    function sortOrder(a, b) {
        // Flag for duplicate removal
        if (a === b) {
            hasDuplicate = true;
            return 0;
        }
        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) return compare;
        // Calculate position if both inputs belong to the same document
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
        1;
        // Disconnected nodes
        if (compare & 1) {
            // Choose the first element that is related to the document
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (a == document$1 || a.ownerDocument == document$1 && jQuery.contains(document$1, a)) return -1;
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (b == document$1 || b.ownerDocument == document$1 && jQuery.contains(document$1, b)) return 1;
            // Maintain original order
            return 0;
        }
        return compare & 4 ? -1 : 1;
    }
    /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
        var elem, duplicates = [], j = 0, i = 0;
        hasDuplicate = false;
        sort.call(results, sortOrder);
        if (hasDuplicate) {
            while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
            while(j--)splice.call(results, duplicates[j], 1);
        }
        return results;
    };
    jQuery.fn.uniqueSort = function() {
        return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
    };
    var i, outermostContext, // Local document vars
    document, documentElement, documentIsHTML, // Instance-specific data
    dirruns = 0, done = 0, classCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), // Regular expressions
    // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp(whitespace + "+", "g"), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = jQuery.extend({
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
    }, filterMatchExpr), rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, // Used for iframes; see `setDocument`.
    // Support: IE 9 - 11+
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE.
    unloadHandler = function() {
        setDocument();
    }, inDisabledFieldset = addCombinator(function(elem) {
        return elem.disabled === true && nodeName(elem, "fieldset");
    }, {
        dir: "parentNode",
        next: "legend"
    });
    function find(selector, context, results, seed) {
        var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
        nodeType = context ? context.nodeType : 9;
        results = results || [];
        // Return early from calls with invalid selector or context
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
        // Try to shortcut find operations (as opposed to filters) in HTML documents
        if (!seed) {
            setDocument(context);
            context = context || document;
            if (documentIsHTML) {
                // If the selector is sufficiently simple, try using a "get*By*" DOM method
                // (excepting DocumentFragment context, where the methods don't exist)
                if (nodeType !== 11 && (match = rquickExpr$1.exec(selector))) {
                    // ID selector
                    if (m = match[1]) {
                        // Document context
                        if (nodeType === 9) {
                            if (elem = context.getElementById(m)) push.call(results, elem);
                            return results;
                        // Element context
                        } else if (newContext && (elem = newContext.getElementById(m)) && jQuery.contains(context, elem)) {
                            push.call(results, elem);
                            return results;
                        }
                    // Type selector
                    } else if (match[2]) {
                        push.apply(results, context.getElementsByTagName(selector));
                        return results;
                    // Class selector
                    } else if ((m = match[3]) && context.getElementsByClassName) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                    }
                }
                // Take advantage of querySelectorAll
                if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                    newSelector = selector;
                    newContext = context;
                    // qSA considers elements outside a scoping root when evaluating child or
                    // descendant combinators, which is not what we want.
                    // In such cases, we work around the behavior by prefixing every selector in the
                    // list with an ID selector referencing the scope context.
                    // The technique has to be used as well when a leading combinator is used
                    // as such selectors are not recognized by querySelectorAll.
                    // Thanks to Andrew Dupont for this technique.
                    if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                        // Expand context for sibling selectors
                        newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                        // Outside of IE, if we're not changing the context we can
                        // use :scope instead of an ID.
                        // Support: IE 11+
                        // IE sometimes throws a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (newContext != context || isIE) {
                            // Capture the context ID, setting it first if necessary
                            if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                            else context.setAttribute("id", nid = jQuery.expando);
                        }
                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                        newSelector = groups.join(",");
                    }
                    try {
                        push.apply(results, newContext.querySelectorAll(newSelector));
                        return results;
                    } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                    } finally{
                        if (nid === jQuery.expando) context.removeAttribute("id");
                    }
                }
            }
        }
        // All others
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
    }
    /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
        fn[jQuery.expando] = true;
        return fn;
    }
    /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
        return function(elem) {
            return nodeName(elem, "input") && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
        return function(elem) {
            return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
        // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
        return function(elem) {
            // Only certain elements can match :enabled or :disabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
            if ("form" in elem) {
                // Check for inherited disabledness on relevant non-disabled elements:
                // * listed form-associated elements in a disabled fieldset
                //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                // * option elements in a disabled optgroup
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                // All such elements have a "form" property.
                if (elem.parentNode && elem.disabled === false) {
                    // Option elements defer to a parent optgroup if present
                    if ("label" in elem) {
                        if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                        else return elem.disabled === disabled;
                    }
                    // Support: IE 6 - 11+
                    // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                    return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                    elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                }
                return elem.disabled === disabled;
            // Try to winnow out elements that can't be disabled before trusting the disabled property.
            // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
            // even exist on them, let alone have a boolean value.
            } else if ("label" in elem) return elem.disabled === disabled;
            // Remaining elements are neither :enabled nor :disabled
            return false;
        };
    }
    /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
        return markFunction(function(argument) {
            argument = +argument;
            return markFunction(function(seed, matches) {
                var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                // Match elements found at the specified indexes
                while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
            });
        });
    }
    /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 */ function setDocument(node) {
        var subWindow, doc = node ? node.ownerDocument || node : document$1;
        // Return early if doc is invalid or already selected
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (doc == document || doc.nodeType !== 9) return;
        // Update global variables
        document = doc;
        documentElement = document.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document);
        // Support: IE 9 - 11+
        // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (isIE && document$1 != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) subWindow.addEventListener("unload", unloadHandler);
    }
    find.matches = function(expr, elements) {
        return find(expr, null, null, elements);
    };
    find.matchesSelector = function(elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
            return matches.call(elem, expr);
        } catch (e) {
            nonnativeSelectorCache(expr, true);
        }
        return find(expr, document, null, [
            elem
        ]).length > 0;
    };
    jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        find: {
            ID: function(id, context) {
                if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                    var elem = context.getElementById(id);
                    return elem ? [
                        elem
                    ] : [];
                }
            },
            TAG: function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            },
            CLASS: function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            }
        },
        relative: {
            ">": {
                dir: "parentNode",
                first: true
            },
            " ": {
                dir: "parentNode"
            },
            "+": {
                dir: "previousSibling",
                first: true
            },
            "~": {
                dir: "previousSibling"
            }
        },
        preFilter: preFilter,
        filter: {
            ID: function(id) {
                var attrId = unescapeSelector(id);
                return function(elem) {
                    return elem.getAttribute("id") === attrId;
                };
            },
            TAG: function(nodeNameSelector) {
                var expectedNodeName = unescapeSelector(nodeNameSelector).toLowerCase();
                return nodeNameSelector === "*" ? function() {
                    return true;
                } : function(elem) {
                    return nodeName(elem, expectedNodeName);
                };
            },
            CLASS: function(className) {
                var pattern = classCache[className + " "];
                return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                    return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                }));
            },
            ATTR: function(name, operator, check) {
                return function(elem) {
                    var result = jQuery.attr(elem, name);
                    if (result == null) return operator === "!=";
                    if (!operator) return true;
                    result += "";
                    if (operator === "=") return result === check;
                    if (operator === "!=") return result !== check;
                    if (operator === "^=") return check && result.indexOf(check) === 0;
                    if (operator === "*=") return check && result.indexOf(check) > -1;
                    if (operator === "$=") return check && result.slice(-check.length) === check;
                    if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                    if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                    return false;
                };
            },
            CHILD: function(type, what, _argument, first, last) {
                var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                function(elem) {
                    return !!elem.parentNode;
                } : function(elem, _context, xml) {
                    var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                    if (parent) {
                        // :(first|last|only)-(child|of-type)
                        if (simple) {
                            while(dir){
                                node = elem;
                                while(node = node[dir]){
                                    if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                }
                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir = type === "only" && !start && "nextSibling";
                            }
                            return true;
                        }
                        start = [
                            forward ? parent.firstChild : parent.lastChild
                        ];
                        // non-xml :nth-child(...) stores cache data on `parent`
                        if (forward && useCache) {
                            // Seek `elem` from a previously-cached index
                            outerCache = parent[jQuery.expando] || (parent[jQuery.expando] = {});
                            cache = outerCache[type] || [];
                            nodeIndex = cache[0] === dirruns && cache[1];
                            diff = nodeIndex && cache[2];
                            node = nodeIndex && parent.childNodes[nodeIndex];
                            while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                            (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                            if (node.nodeType === 1 && ++diff && node === elem) {
                                outerCache[type] = [
                                    dirruns,
                                    nodeIndex,
                                    diff
                                ];
                                break;
                            }
                        } else {
                            // Use previously-cached element index if available
                            if (useCache) {
                                outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                            }
                            // xml :nth-child(...)
                            // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                            if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                        outerCache = node[jQuery.expando] || (node[jQuery.expando] = {});
                                        outerCache[type] = [
                                            dirruns,
                                            diff
                                        ];
                                    }
                                    if (node === elem) break;
                                }
                            }
                        }
                        // Incorporate the offset, then check against cycle size
                        diff -= last;
                        return diff === first || diff % first === 0 && diff / first >= 0;
                    }
                };
            },
            PSEUDO: function(pseudo, argument) {
                // pseudo-class names are case-insensitive
                // https://www.w3.org/TR/selectors/#pseudo-classes
                // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                // Remember that setFilters inherits from pseudos
                var fn = jQuery.expr.pseudos[pseudo] || jQuery.expr.setFilters[pseudo.toLowerCase()] || selectorError("unsupported pseudo: " + pseudo);
                // The user may use createPseudo to indicate that
                // arguments are needed to create the filter function
                // just as jQuery does
                if (fn[jQuery.expando]) return fn(argument);
                return fn;
            }
        },
        pseudos: {
            // Potentially complex pseudos
            not: markFunction(function(selector) {
                // Trim the selector passed to compile
                // to avoid treating leading and trailing
                // spaces as combinators
                var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                return matcher[jQuery.expando] ? markFunction(function(seed, matches, _context, xml) {
                    var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                    // Match elements unmatched by `matcher`
                    while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                }) : function(elem, _context, xml) {
                    input[0] = elem;
                    matcher(input, null, xml, results);
                    // Don't keep the element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    input[0] = null;
                    return !results.pop();
                };
            }),
            has: markFunction(function(selector) {
                return function(elem) {
                    return find(selector, elem).length > 0;
                };
            }),
            contains: markFunction(function(text) {
                text = unescapeSelector(text);
                return function(elem) {
                    return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                };
            }),
            // "Whether an element is represented by a :lang() selector
            // is based solely on the element's language value
            // being equal to the identifier C,
            // or beginning with the identifier C immediately followed by "-".
            // The matching of C against the element's language value is performed case-insensitively.
            // The identifier C does not have to be a valid language name."
            // https://www.w3.org/TR/selectors/#lang-pseudo
            lang: markFunction(function(lang) {
                // lang value must be a valid identifier
                if (!ridentifier.test(lang || "")) selectorError("unsupported lang: " + lang);
                lang = unescapeSelector(lang).toLowerCase();
                return function(elem) {
                    var elemLang;
                    do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                        elemLang = elemLang.toLowerCase();
                        return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                    }
                    while ((elem = elem.parentNode) && elem.nodeType === 1);
                    return false;
                };
            }),
            // Miscellaneous
            target: function(elem) {
                var hash = window1.location && window1.location.hash;
                return hash && hash.slice(1) === elem.id;
            },
            root: function(elem) {
                return elem === documentElement;
            },
            focus: function(elem) {
                return elem === document.activeElement && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
            },
            // Boolean properties
            enabled: createDisabledPseudo(false),
            disabled: createDisabledPseudo(true),
            checked: function(elem) {
                // In CSS3, :checked should return both checked and selected elements
                // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
            },
            selected: function(elem) {
                // Support: IE <=11+
                // Accessing the selectedIndex property
                // forces the browser to treat the default option as
                // selected when in an optgroup.
                if (isIE && elem.parentNode) // eslint-disable-next-line no-unused-expressions
                elem.parentNode.selectedIndex;
                return elem.selected === true;
            },
            // Contents
            empty: function(elem) {
                // https://www.w3.org/TR/selectors/#empty-pseudo
                // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                //   but not by others (comment: 8; processing instruction: 7; etc.)
                // nodeType < 6 works because attributes (2) do not appear as children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                    if (elem.nodeType < 6) return false;
                }
                return true;
            },
            parent: function(elem) {
                return !jQuery.expr.pseudos.empty(elem);
            },
            // Element/input types
            header: function(elem) {
                return rheader.test(elem.nodeName);
            },
            input: function(elem) {
                return rinputs.test(elem.nodeName);
            },
            button: function(elem) {
                return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
            },
            text: function(elem) {
                return nodeName(elem, "input") && elem.type === "text";
            },
            // Position-in-collection
            first: createPositionalPseudo(function() {
                return [
                    0
                ];
            }),
            last: createPositionalPseudo(function(_matchIndexes, length) {
                return [
                    length - 1
                ];
            }),
            eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                return [
                    argument < 0 ? argument + length : argument
                ];
            }),
            even: createPositionalPseudo(function(matchIndexes, length) {
                var i = 0;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            odd: createPositionalPseudo(function(matchIndexes, length) {
                var i = 1;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i;
                if (argument < 0) i = argument + length;
                else if (argument > length) i = length;
                else i = argument;
                for(; --i >= 0;)matchIndexes.push(i);
                return matchIndexes;
            }),
            gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i = argument < 0 ? argument + length : argument;
                for(; ++i < length;)matchIndexes.push(i);
                return matchIndexes;
            })
        }
    };
    jQuery.expr.pseudos.nth = jQuery.expr.pseudos.eq;
    // Add button/input type pseudos
    for(i in {
        radio: true,
        checkbox: true,
        file: true,
        password: true,
        image: true
    })jQuery.expr.pseudos[i] = createInputPseudo(i);
    for(i in {
        submit: true,
        reset: true
    })jQuery.expr.pseudos[i] = createButtonPseudo(i);
    // Easy API for creating new setFilters
    function setFilters() {}
    setFilters.prototype = jQuery.expr.pseudos;
    jQuery.expr.setFilters = new setFilters();
    function addCombinator(matcher, combinator, base) {
        var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
        return combinator.first ? // Check against closest ancestor/preceding element
        function(elem, context, xml) {
            while(elem = elem[dir]){
                if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
            }
            return false;
        } : // Check against all ancestor/preceding elements
        function(elem, context, xml) {
            var oldCache, outerCache, newCache = [
                dirruns,
                doneName
            ];
            // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
            if (xml) {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    if (matcher(elem, context, xml)) return true;
                }
            } else {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                    if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                    else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                    return newCache[2] = oldCache[2];
                    else {
                        // Reuse newcache so results back-propagate to previous elements
                        outerCache[key] = newCache;
                        // A match means we're done; a fail means we have to keep checking
                        if (newCache[2] = matcher(elem, context, xml)) return true;
                    }
                }
            }
            return false;
        };
    }
    function elementMatcher(matchers) {
        return matchers.length > 1 ? function(elem, context, xml) {
            var i = matchers.length;
            while(i--){
                if (!matchers[i](elem, context, xml)) return false;
            }
            return true;
        } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
        var i = 0, len = contexts.length;
        for(; i < len; i++)find(selector, contexts[i], results);
        return results;
    }
    function condense(unmatched, map, filter, context, xml) {
        var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
        for(; i < len; i++){
            if (elem = unmatched[i]) {
                if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem);
                    if (mapped) map.push(i);
                }
            }
        }
        return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[jQuery.expando]) postFilter = setMatcher(postFilter);
        if (postFinder && !postFinder[jQuery.expando]) postFinder = setMatcher(postFinder, postSelector);
        return markFunction(function(seed, results, context, xml) {
            var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                context
            ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
            if (matcher) {
                // If we have a postFinder, or filtered seed, or non-seed postFilter
                // or preexisting results,
                matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results;
                // Find primary matches
                matcher(matcherIn, matcherOut, context, xml);
            } else matcherOut = matcherIn;
            // Apply postFilter
            if (postFilter) {
                temp = condense(matcherOut, postMap);
                postFilter(temp, [], context, xml);
                // Un-match failing elements by moving them back to matcherIn
                i = temp.length;
                while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
            if (seed) {
                if (postFinder || preFilter) {
                    if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                        temp.push(matcherIn[i] = elem);
                        postFinder(null, matcherOut = [], temp, xml);
                    }
                    // Move matched elements from seed to results to keep them synchronized
                    i = matcherOut.length;
                    while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                }
            } else {
                matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                if (postFinder) postFinder(null, results, matcherOut, xml);
                else push.apply(results, matcherOut);
            }
        });
    }
    function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = jQuery.expr.relative[tokens[0].type], implicitRelative = leadingRelative || jQuery.expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
        matchContext = addCombinator(function(elem) {
            return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
            return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [
            function(elem, context, xml) {
                // Support: IE 11+
                // IE sometimes throws a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                // Avoid hanging onto element
                // (see https://github.com/jquery/sizzle/issues/299)
                checkContext = null;
                return ret;
            }
        ];
        for(; i < len; i++)if (matcher = jQuery.expr.relative[tokens[i].type]) matchers = [
            addCombinator(elementMatcher(matchers), matcher)
        ];
        else {
            matcher = jQuery.expr.filter[tokens[i].type].apply(null, tokens[i].matches);
            // Return special upon seeing a positional matcher
            if (matcher[jQuery.expando]) {
                // Find the next relative operator (if any) for proper handling
                j = ++i;
                for(; j < len; j++){
                    if (jQuery.expr.relative[tokens[j].type]) break;
                }
                return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                tokens.slice(0, i - 1).concat({
                    value: tokens[i - 2].type === " " ? "*" : ""
                })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
            }
            matchers.push(matcher);
        }
        return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
            var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
            elems = seed || byElement && jQuery.expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
            dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1;
            if (outermost) // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            outermostContext = context == document || context || outermost;
            // Add elements passing elementMatchers directly to results
            for(; (elem = elems[i]) != null; i++){
                if (byElement && elem) {
                    j = 0;
                    // Support: IE 11+
                    // IE sometimes throws a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (!context && elem.ownerDocument != document) {
                        setDocument(elem);
                        xml = !documentIsHTML;
                    }
                    while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                        push.call(results, elem);
                        break;
                    }
                    if (outermost) dirruns = dirrunsUnique;
                }
                // Track unmatched elements for set filters
                if (bySet) {
                    // They will have gone through all possible matchers
                    if (elem = !matcher && elem) matchedCount--;
                    // Lengthen the array for every element, matched or not
                    if (seed) unmatched.push(elem);
                }
            }
            // `i` is now the count of elements visited above, and adding it to `matchedCount`
            // makes the latter nonnegative.
            matchedCount += i;
            // Apply set filters to unmatched elements
            // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
            // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
            // no element matchers and no seed.
            // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
            // case, which will result in a "00" `matchedCount` that differs from `i` but is also
            // numerically zero.
            if (bySet && i !== matchedCount) {
                j = 0;
                while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                if (seed) {
                    // Reintegrate element matches to eliminate the need for sorting
                    if (matchedCount > 0) {
                        while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                    }
                    // Discard index placeholder values to get only actual matches
                    setMatched = condense(setMatched);
                }
                // Add matches to results
                push.apply(results, setMatched);
                // Seedless set matches succeeding multiple successful matchers stipulate sorting
                if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
            }
            // Override manipulation of globals by nested matchers
            if (outermost) {
                dirruns = dirrunsUnique;
                outermostContext = contextBackup;
            }
            return unmatched;
        };
        return bySet ? markFunction(superMatcher) : superMatcher;
    }
    function compile(selector, match /* Internal Use Only */ ) {
        var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
        if (!cached) {
            // Generate a function of recursive functions that can be used to check each element
            if (!match) match = tokenize(selector);
            i = match.length;
            while(i--){
                cached = matcherFromTokens(match[i]);
                if (cached[jQuery.expando]) setMatchers.push(cached);
                else elementMatchers.push(cached);
            }
            // Cache the compiled function
            cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
            // Save selector and tokenization
            cached.selector = selector;
        }
        return cached;
    }
    /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
        var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];
        // Try to minimize operations if there is only one selector in the list and no seed
        // (the latter of which guarantees us context)
        if (match.length === 1) {
            // Reduce context if the leading compound selector is an ID
            tokens = match[0] = match[0].slice(0);
            if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && jQuery.expr.relative[tokens[1].type]) {
                context = (jQuery.expr.find.ID(unescapeSelector(token.matches[0]), context) || [])[0];
                if (!context) return results;
                else if (compiled) context = context.parentNode;
                selector = selector.slice(tokens.shift().value.length);
            }
            // Fetch a seed set for right-to-left matching
            i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
            while(i--){
                token = tokens[i];
                // Abort if we hit a combinator
                if (jQuery.expr.relative[type = token.type]) break;
                if (find = jQuery.expr.find[type]) // Search, expanding context for leading sibling combinators
                {
                    if (seed = find(unescapeSelector(token.matches[0]), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                            push.apply(results, seed);
                            return results;
                        }
                        break;
                    }
                }
            }
        }
        // Compile and execute a filtering function if one is not provided
        // Provide `match` to avoid retokenization if we modified the selector above
        (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
        return results;
    }
    // Initialize against the default document
    setDocument();
    jQuery.find = find;
    // These have always been private, but they used to be documented as part of
    // Sizzle so let's maintain them for now for backwards compatibility purposes.
    find.compile = compile;
    find.select = select;
    find.setDocument = setDocument;
    find.tokenize = tokenize;
    function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    }
    function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    }
    var rneedsContext = jQuery.expr.match.needsContext;
    // rsingleTag matches a string consisting of a single HTML element with no attributes
    // and captures the element's name
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function isObviousHtml(input) {
        return input[0] === "<" && input[input.length - 1] === ">" && input.length >= 3;
    }
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (typeof qualifier === "function") return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // HANDLE: $(DOMElement)
        if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (typeof selector === "function") return rootjQuery.ready !== undefined ? rootjQuery.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        else {
            // Handle obvious HTML strings
            match = selector + "";
            if (isObviousHtml(match)) // Assume that strings that start and end with <> are HTML and skip
            // the regex check. This also handles browser-supported HTML wrappers
            // like TrustedHTML.
            match = [
                null,
                selector,
                null
            ];
            else if (typeof selector === "string") match = rquickExpr.exec(selector);
            else return jQuery.makeArray(selector, this);
            // Match html or make sure no context is specified for #id
            // Note: match[1] may be a string or a TrustedHTML wrapper
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document$1, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (typeof this[match] === "function") this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document$1.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || rootjQuery).find(selector);
            else return this.constructor(context).find(selector);
        }
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document$1);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11+
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (typeof arg === "function") {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && typeof (method = value.promise) === "function") method.call(value).done(resolve).fail(reject);
            else if (value && typeof (method = value.then) === "function") method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            reject(value);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                catch: function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = typeof fns[tuple[4]] === "function" && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && typeof returned.promise === "function") returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (typeof then === "function") {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, typeof onProgress === "function" ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, typeof onFulfilled === "function" ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, typeof onRejected === "function" ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || typeof (resolveValues[i] && resolveValues[i].then) === "function") return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        if (error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception", error, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document$1, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document$1.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    if (document$1.readyState !== "loading") // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document$1.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Matches dashed string for camelizing
    var rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase
    function camelCase(string) {
        return string.replace(rdashAlpha, fcamelCase);
    }
    /**
 * Determines whether an object can have data
 */ function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    }
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = Object.create(null);
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return value;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45+
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11+
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.set(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.set(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    // isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
    // through the CSS cascade), which is useful in deciding whether or not to make it visible.
    // It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
    // * A hidden ancestor does not force an element to be classified as hidden.
    // * Being disconnected from the document does not force an element to be classified as hidden.
    // These differences improve the behavior of .toggle() et al. when applied to elements that are
    // detached or contained within hidden ancestors (gh-2404, gh-2863).
    function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && jQuery.css(elem, "display") === "none";
    }
    var ralphaStart = /^[a-z]/, // The regex visualized:
    //
    //                         /----------\
    //                        |            |    /-------\
    //                        |  / Top  \  |   |         |
    //         /--- Border ---+-| Right  |-+---+- Width -+---\
    //        |                 | Bottom |                    |
    //        |                  \ Left /                     |
    //        |                                               |
    //        |                              /----------\     |
    //        |          /-------------\    |            |    |- END
    //        |         |               |   |  / Top  \  |    |
    //        |         |  / Margin  \  |   | | Right  | |    |
    //        |---------+-|           |-+---+-| Bottom |-+----|
    //        |            \ Padding /         \ Left /       |
    // BEGIN -|                                               |
    //        |                /---------\                    |
    //        |               |           |                   |
    //        |               |  / Min \  |    / Width  \     |
    //         \--------------+-|       |-+---|          |---/
    //                           \ Max /       \ Height /
    rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function isAutoPx(prop) {
        // The first test is used to ensure that:
        // 1. The prop starts with a lowercase letter (as we uppercase it for the second regex).
        // 2. The prop is not empty.
        return ralphaStart.test(prop) && rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
    }
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (isAutoPx(prop) ? "px" : ""), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (!isAutoPx(prop) || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54 - 66+
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/;
    // Convert dashed to camelCase, handle vendor prefixes.
    // Used by the css & effects modules.
    // Support: IE <=9 - 11+
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function cssCamelCase(string) {
        return camelCase(string.replace(rmsPrefix, "ms-"));
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+
    // Check attachment across shadow DOM boundaries when possible (gh-3504).
    // Provide a fallback for browsers without Shadow DOM v1 support.
    if (!documentElement$1.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    };
    // rtagName captures the name from the first start tag in a string of HTML
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-open-state
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-name-state
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var wrapMap = {
        // Table parts need to be wrapped with `<table>` or they're
        // stripped to their contents when put in a div.
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do, so we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            "table"
        ],
        col: [
            "colgroup",
            "table"
        ],
        tr: [
            "tbody",
            "table"
        ],
        td: [
            "tr",
            "tbody",
            "table"
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll(context, tag) {
        // Support: IE <=9 - 11+
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") // Use slice to snapshot the live collection from gEBTN
        ret = arr.slice.call(context.getElementsByTagName(tag || "*"));
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object" && (elem.nodeType || isArrayLike(elem))) jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || arr;
                    // Create wrappers & descend into them.
                    j = wrap.length;
                    while(--j > -1)tmp = tmp.appendChild(context.createElement(wrap[j]));
                    tmp.innerHTML = jQuery.htmlPrefilter(elem);
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = typeof value === "function";
        if (valueIsFunction) return collection.each(function(index) {
            var self = collection.eq(index);
            args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.get(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce,
                                    crossOrigin: node.crossOrigin
                                }, doc);
                            } else DOMEval(node.textContent, node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement$1, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: Firefox <=42 - 66+
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11+
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: typeof hook === "function" ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: jQuery.extend(Object.create(null), {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    if (event.result !== undefined) // Setting `event.originalEvent.returnValue` in modern
                    // browsers does the same as just calling `preventDefault()`,
                    // the browsers ignore the value anyway.
                    // Incidentally, IE 11 is the only browser from our supported
                    // ones which respects the value returned from a `beforeunload`
                    // handler attached by `addEventListener`; other browsers do
                    // so only for inline handlers, so not setting the value
                    // directly shouldn't reduce any functionality.
                    event.preventDefault();
                }
            }
        })
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                // This controller function is invoked under multiple circumstances,
                // differentiated by the stored value in `saved`:
                // 1. For an outer synthetic `.trigger()`ed event (detected by
                //    `event.isTrigger & 1` and non-array `saved`), it records arguments
                //    as an array and fires an [inner] native event to prompt state
                //    changes that should be observed by registered listeners (such as
                //    checkbox toggling and focus updating), then clears the stored value.
                // 2. For an [inner] native event (detected by `saved` being
                //    an array), it triggers an inner synthetic event, records the
                //    result, and preempts propagation to further jQuery listeners.
                // 3. For an inner synthetic event (detected by `event.isTrigger & 1` and
                //    array `saved`), it prevents double-propagation of surrogate events
                //    but otherwise allows everything to proceed (particularly including
                //    further listeners).
                // Possible `saved` data shapes: `[...], `{ value }`, `false`.
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object),
                        // so this array will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is
                            // blurred by clicking outside of it, it invokes the handler
                            // synchronously. If that handler calls `.remove()` on
                            // the element, the data is cleared, leaving `result`
                            // undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling
                    // surrogate (focus or blur), assume that the surrogate already
                    // propagated from triggering the native event and prevent that
                    // from happening again here.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order.
                // Fire an inner synthetic event with the original arguments.
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(saved[0], saved.slice(1), this)
                    });
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? returnTrue : returnFalse;
            // Create target properties
            this.target = src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        // Support: IE 11+
        // Attach a single focusin/focusout handler on the document while someone wants focus/blur.
        // This is because the former are synchronous in IE while the latter are async. In other
        // browsers, all those handlers are invoked synchronously.
        function focusMappedHandler(nativeEvent) {
            // `eventHandle` would already wrap the event, but we need to change the `type` here.
            var event = jQuery.event.fix(nativeEvent);
            event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
            event.isSimulated = true;
            // focus/blur don't bubble while focusin/focusout do; simulate the former by only
            // invoking the handler at the lower level.
            if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
            // `jQuery.event.add`, so event handle will already have been set
            // by this point.
            dataPriv.get(this, "handle")(event);
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (isIE) this.addEventListener(delegateType, focusMappedHandler);
                else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                if (isIE) this.removeEventListener(delegateType, focusMappedHandler);
                else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11+
    // In IE using regex groups here causes severe slowdowns.
    rnoInnerhtml = /<script|<style|<link/i;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var type, i, l, events = dataPriv.get(src, "events");
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (events) {
            dataPriv.remove(dest, "handle events");
            for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) dataUser.set(dest, jQuery.extend({}, dataUser.get(src)));
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (isIE && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)// Support: IE <=11+
                // IE fails to set the defaultValue to the correct value when
                // cloning textareas.
                if (nodeName(destElements[i], "textarea")) destElements[i].defaultValue = srcElements[i].defaultValue;
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                push.apply(ret, elems);
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    function getStyles(elem) {
        // Support: IE <=11+ (trac-14150)
        // In IE popup's `window` is the opener window which makes `window.getComputedStyle( elem )`
        // break. Using `elem.ownerDocument.defaultView` avoids the issue.
        var view = elem.ownerDocument.defaultView;
        // `document.implementation.createHTMLDocument( "" )` has a `null` `defaultView`
        // property; check `defaultView` truthiness to fallback to window in such a case.
        if (!view) view = window1;
        return view.getComputedStyle(elem);
    }
    // A method for quickly swapping in/out CSS properties to get correct calculations.
    function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    }
    function curCSS(elem, name, computed) {
        var ret, isCustomProp = rcustomProp.test(name);
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for `.css('--customProperty')` (gh-3144)
        if (computed) {
            // A fallback to direct property access is needed as `computed`, being
            // the output of `getComputedStyle`, contains camelCased keys and
            // `getPropertyValue` requires kebab-case ones.
            //
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105 - 135+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
        }
        return ret !== undefined ? // Support: IE <=9 - 11+
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document$1.createElement("div").style;
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped vendor prefixed property
    function finalPropName(name) {
        if (name in emptyStyle) return name;
        return vendorPropName(name) || name;
    }
    var reliableTrDimensionsVal, reliableColDimensionsVal, table = document$1.createElement("table");
    // Executing table tests requires only one layout, so they're executed
    // at the same time to save the second computation.
    function computeTableStyleTests() {
        if (// This is a singleton, we need to execute it only once
        !table || // Finish early in limited (non-browser) environments
        !table.style) return;
        var trStyle, col = document$1.createElement("col"), tr = document$1.createElement("tr"), td = document$1.createElement("td");
        table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0";
        tr.style.cssText = "box-sizing:content-box;border:1px solid;height:1px";
        td.style.cssText = "height:9px;width:9px;padding:0";
        col.span = 2;
        documentElement$1.appendChild(table).appendChild(col).parentNode.appendChild(tr).appendChild(td).parentNode.appendChild(td.cloneNode(true));
        // Don't run until window is visible
        if (table.offsetWidth === 0) {
            documentElement$1.removeChild(table);
            return;
        }
        trStyle = window1.getComputedStyle(tr);
        // Support: Firefox 135+
        // Firefox always reports computed width as if `span` was 1.
        // Support: Safari 18.3+
        // In Safari, computed width for columns is always 0.
        // In both these browsers, using `offsetWidth` solves the issue.
        // Support: IE 11+
        // In IE, `<col>` computed width is `"auto"` unless `width` is set
        // explicitly via CSS so measurements there remain incorrect. Because of
        // the lack of a proper workaround, we accept this limitation, treating
        // IE as passing the test.
        reliableColDimensionsVal = isIE || Math.round(parseFloat(window1.getComputedStyle(col).width)) === 18;
        // Support: IE 10 - 11+
        // IE misreports `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Support: Firefox 70 - 135+
        // Only Firefox includes border widths
        // in computed dimensions for table rows. (gh-4529)
        reliableTrDimensionsVal = Math.round(parseFloat(trStyle.height) + parseFloat(trStyle.borderTopWidth) + parseFloat(trStyle.borderBottomWidth)) === tr.offsetHeight;
        documentElement$1.removeChild(table);
        // Nullify the table so it wouldn't be stored in the memory;
        // it will also be a sign that checks were already performed.
        table = null;
    }
    jQuery.extend(support, {
        reliableTrDimensions: function() {
            computeTableStyleTests();
            return reliableTrDimensionsVal;
        },
        reliableColDimensions: function() {
            computeTableStyleTests();
            return reliableColDimensionsVal;
        }
    });
    var cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = isIE || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        if (// Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        (val === "auto" || // Support: IE 9 - 11+
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        isIE && isBorderBox || !support.reliableColDimensions() && nodeName(elem, "col") || !support.reliableTrDimensions() && nodeName(elem, "tr")) && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If the value is a number, add `px` for certain CSS properties
                if (type === "number") value += ret && ret[3] || (isAutoPx(origName) ? "px" : "");
                // Support: IE <=9 - 11+
                // background-* props of a cloned element affect the source element (trac-8908)
                if (isIE && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Elements with `display: none` can have dimension info if
                // we invisibly show them.
                return jQuery.css(elem, "display") === "none" ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                isBorderBox = extra && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (isAutoPx(prop) ? "px" : "");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document$1.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, 13);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11+
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.set(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                // eslint-disable-next-line no-loop-func
                anim.done(function() {
                    // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = cssCamelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), percent = 1 - (remaining / animation.duration || 0), index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (typeof result.stop === "function") jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (typeof animation.opts.start === "function") animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (typeof props === "function") {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || easing || typeof speed === "function" && speed,
            duration: speed,
            easing: fn && easing || easing && typeof easing !== "function" && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (typeof opt.old === "function") opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11+
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = elem.getAttribute("tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || // href-less anchor's `tabIndex` property value is `0` and
                    // the `tabindex` attribute value: `null`. We want `-1`.
                    rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11+
    // Accessing the selectedIndex property forces the browser to respect
    // setting selected on the option. The getter ensures a default option
    // is selected when in an optgroup. ESLint rule "no-unused-expressions"
    // is disabled for this code since it considers such accessions noop.
    if (isIE) jQuery.propHooks.selected = {
        get: function(elem) {
            var parent = elem.parentNode;
            if (parent && parent.parentNode) // eslint-disable-next-line no-unused-expressions
            parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
                // eslint-disable-next-line no-unused-expressions
                parent.selectedIndex;
                if (parent.parentNode) // eslint-disable-next-line no-unused-expressions
                parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self;
            if (typeof value === "function") return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean") return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                // Toggle individual class names
                self = jQuery(this);
                for(i = 0; i < classNames.length; i++){
                    className = classNames[i];
                    // Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                }
            });
            return this;
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = typeof value === "function";
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        if (option.selected && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        if (option.selected = jQuery.inArray(jQuery(option).val(), values) > -1) optionSet = true;
                    }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    if (isIE) jQuery.valHooks.option = {
        get: function(elem) {
            var val = elem.getAttribute("value");
            return val != null ? val : // Support: IE <=10 - 11+
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            stripAndCollapse(jQuery.text(elem));
        }
    };
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
    });
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document$1
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document$1;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document$1)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && typeof elem[type] === "function" && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11+
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = typeof valueOrFunction === "function" ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document$1.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (typeof func === "function") {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))// Support: IE 11+
                            // `getResponseHeader( key )` in IE doesn't combine all header
                            // values for the provided key into a single result with values
                            // joined by commas as other browsers do. Instead, it returns
                            // them on separate lines.
                            responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document$1.createElement("a");
                // Support: IE <=8 - 11+
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11+
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an ESM-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted.
            // Handle the null callback placeholder.
            if (typeof data === "function" || data === null) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            scriptAttrs: options.crossOrigin ? {
                "crossOrigin": options.crossOrigin
            } : undefined,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (typeof html === "function") html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (typeof html === "function") return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = typeof html === "function";
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        return new window1.XMLHttpRequest();
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200
    };
    jQuery.ajaxTransport(function(options) {
        var callback;
        return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                            xhr.status, xhr.statusText);
                            else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") === "text" ? {
                                text: xhr.responseText
                            } : {
                                binary: xhr.response
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                xhr.onabort = xhr.onerror = xhr.ontimeout = callback("error");
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    function canUseScriptTag(s) {
        // A script tag can only be used for async, cross domain or forced-by-attrs requests.
        // Requests with headers cannot use a script tag. However, when both `scriptAttrs` &
        // `headers` options are specified, both are impossible to satisfy together; we
        // prefer `scriptAttrs` then.
        // Sync requests remain handled differently to preserve strict script ordering.
        return s.scriptAttrs || !s.headers && (s.crossDomain || // When dealing with JSONP (`s.dataTypes` include "json" then)
        // don't use a script tag so that error responses still may have
        // `responseJSON` set. Continue using a script tag for JSONP requests that:
        //   * are cross-domain as AJAX requests won't work without a CORS setup
        //   * have `scriptAttrs` set as that's a script-only functionality
        // Note that this means JSONP requests violate strict CSP script-src settings.
        // A proper solution is to migrate from using JSONP to a CORS setup.
        s.async && jQuery.inArray("json", s.dataTypes) < 0);
    }
    // Install script dataType. Don't specify `contents.script` so that an explicit
    // `dataType: "script"` is required (see gh-2432, gh-4822)
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        // These types of requests are handled via a script tag
        // so force their methods to GET.
        if (canUseScriptTag(s)) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        if (canUseScriptTag(s)) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document$1.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Get callback name, remembering preexisting value associated with it
        callbackName = s.jsonpCallback = typeof s.jsonpCallback === "function" ? s.jsonpCallback() : s.jsonpCallback;
        // Insert callback into url or form data
        if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
        else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
        // Use data converter to retrieve json after script execution
        s.converters["script json"] = function() {
            if (!responseContainer) jQuery.error(callbackName + " was not called");
            return responseContainer[0];
        };
        // Force json dataType
        s.dataTypes[0] = "json";
        // Install callback
        overwritten = window1[callbackName];
        window1[callbackName] = function() {
            responseContainer = arguments;
        };
        // Clean-up function (fires after converters)
        jqXHR.always(function() {
            // If previous value didn't exist - remove it
            if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
            else window1[callbackName] = overwritten;
            // Save back as free
            if (s[callbackName]) {
                // Make sure that re-using the options doesn't screw things around
                s.jsonpCallback = originalSettings.jsonpCallback;
                // Save the callback name for future use
                oldCallbacks.push(callbackName);
            }
            // Call if it was a function and we have a response
            if (responseContainer && typeof overwritten === "function") overwritten(responseContainer[0]);
            responseContainer = overwritten = undefined;
        });
        // Delegate to script
        return "script";
    });
    jQuery.ajaxPrefilter(function(s, origOptions) {
        // Binary data needs to be passed to XHR as-is without stringification.
        if (typeof s.data !== "string" && !jQuery.isPlainObject(s.data) && !Array.isArray(s.data) && // Don't disable data processing if explicitly set by the user.
        !("processData" in origOptions)) s.processData = false;
        // `Content-Type` for requests with `FormData` bodies needs to be set
        // by the browser as it needs to append the `boundary` it generated.
        if (s.data instanceof window1.FormData) s.contentType = false;
    });
    // Argument "data" should be string of html or a TrustedHTML wrapper of obvious HTML
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string" && !isObviousHtml(data + "")) return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var parsed, scripts;
        if (!context) // Stop scripts or inline event handlers from being executed immediately
        // by using DOMParser
        context = new window1.DOMParser().parseFromString("", "text/html");
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (typeof params === "function") {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (typeof options === "function") // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11+
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && offsetParent !== doc.documentElement && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent || doc.documentElement;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 && jQuery.css(offsetParent, "position") !== "static") {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement$1;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (typeof fn !== "function") return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.expr[":"] = jQuery.expr.filters = jQuery.expr.pseudos;
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, gh-557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("lJx7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb52fb6797430f0$export$2e2bcd8739ae039);
/*! DataTables Bootstrap 4 integration
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");

var $63jfO = parcelRequire("63jfO");
// Allow reassignment of the $ variable
let $bdb52fb6797430f0$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
/**
 * DataTables integration for Bootstrap 4.
 *
 * This file sets the defaults and adds options to DataTables to style its
 * controls using Bootstrap. See https://datatables.net/manual/styling/bootstrap
 * for further information.
 */ /* Set the defaults for DataTables initialisation */ $bdb52fb6797430f0$var$$.extend(true, (0, $63jfO.default).defaults, {
    renderer: 'bootstrap'
});
/* Default class modification */ $bdb52fb6797430f0$var$$.extend(true, (0, $63jfO.default).ext.classes, {
    container: "dt-container dt-bootstrap4",
    search: {
        input: "form-control form-control-sm"
    },
    length: {
        select: "custom-select custom-select-sm form-control form-control-sm"
    },
    processing: {
        container: "dt-processing card"
    },
    layout: {
        row: 'row justify-content-between',
        cell: 'd-md-flex justify-content-between align-items-center',
        tableCell: 'col-12',
        start: 'dt-layout-start col-md-auto mr-auto',
        end: 'dt-layout-end col-md-auto ml-auto',
        full: 'dt-layout-full col-md'
    }
});
/* Bootstrap paging button renderer */ (0, $63jfO.default).ext.renderer.pagingButton.bootstrap = function(settings, buttonType, content, active, disabled) {
    var btnClasses = [
        'dt-paging-button',
        'page-item'
    ];
    if (active) btnClasses.push('active');
    if (disabled) btnClasses.push('disabled');
    var li = $bdb52fb6797430f0$var$$('<li>').addClass(btnClasses.join(' '));
    var a = $bdb52fb6797430f0$var$$('<a>', {
        'href': disabled ? null : '#',
        'class': 'page-link'
    }).html(content).appendTo(li);
    return {
        display: li,
        clicker: a
    };
};
(0, $63jfO.default).ext.renderer.pagingContainer.bootstrap = function(settings, buttonEls) {
    return $bdb52fb6797430f0$var$$('<ul/>').addClass('pagination').append(buttonEls);
};
var $bdb52fb6797430f0$export$2e2bcd8739ae039 = (0, $63jfO.default);

});
parcelRegister("63jfO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $44bb6d473543b89d$export$2e2bcd8739ae039);
/*! DataTables 2.3.8
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");
// DataTables code uses $ internally, but we want to be able to
// reassign $ with the `use` method, so it is a regular var.
var $44bb6d473543b89d$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
var $44bb6d473543b89d$var$DataTable = function(selector, options) {
    // Check if called with a window or jQuery object for DOM less applications
    // This is for backwards compatibility
    if ($44bb6d473543b89d$var$DataTable.factory(selector, options)) return $44bb6d473543b89d$var$DataTable;
    // When creating with `new`, create a new DataTable, returning the API instance
    if (this instanceof $44bb6d473543b89d$var$DataTable) return $44bb6d473543b89d$var$$(selector).DataTable(options);
    else // Argument switching
    options = selector;
    var _that = this;
    var emptyInit = options === undefined;
    var len = this.length;
    if (emptyInit) options = {};
    // Method to get DT API instance from jQuery object
    this.api = function() {
        return new $44bb6d473543b89d$var$_Api(this);
    };
    this.each(function() {
        // For each initialisation we want to give it a clean initialisation
        // object that can be bashed around
        var o = {};
        var oInit = len > 1 ? $44bb6d473543b89d$var$_fnExtend(o, options, true) : options;
        var i = 0, iLen;
        var sId = this.getAttribute('id');
        var defaults = $44bb6d473543b89d$var$DataTable.defaults;
        var $this = $44bb6d473543b89d$var$$(this);
        // Sanity check
        if (this.nodeName.toLowerCase() != 'table') {
            $44bb6d473543b89d$var$_fnLog(null, 0, 'Non-table node initialisation (' + this.nodeName + ')', 2);
            return;
        }
        // Special case for options
        if (oInit.on && oInit.on.options) $44bb6d473543b89d$var$_fnListener($this, 'options', oInit.on.options);
        $this.trigger('options.dt', oInit);
        /* Backwards compatibility for the defaults */ $44bb6d473543b89d$var$_fnCompatOpts(defaults);
        $44bb6d473543b89d$var$_fnCompatCols(defaults.column);
        /* Convert the camel-case defaults to Hungarian */ $44bb6d473543b89d$var$_fnCamelToHungarian(defaults, defaults, true);
        $44bb6d473543b89d$var$_fnCamelToHungarian(defaults.column, defaults.column, true);
        /* Setting up the initialisation object */ $44bb6d473543b89d$var$_fnCamelToHungarian(defaults, $44bb6d473543b89d$var$$.extend(oInit, $44bb6d473543b89d$var$_fnEscapeObject($this.data())), true);
        /* Check to see if we are re-initialising a table */ var allSettings = $44bb6d473543b89d$var$DataTable.settings;
        for(i = 0, iLen = allSettings.length; i < iLen; i++){
            var s = allSettings[i];
            /* Base check on table node */ if (s.nTable == this || s.nTHead && s.nTHead.parentNode == this || s.nTFoot && s.nTFoot.parentNode == this) {
                var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
                var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
                if (emptyInit || bRetrieve) return s.oInstance;
                else if (bDestroy) {
                    new $44bb6d473543b89d$var$DataTable.Api(s).destroy();
                    break;
                } else {
                    $44bb6d473543b89d$var$_fnLog(s, 0, 'Cannot reinitialise DataTable', 3);
                    return;
                }
            }
            /* If the element we are initialising has the same ID as a table which was previously
			 * initialised, but the table nodes don't match (from before) then we destroy the old
			 * instance by simply deleting it. This is under the assumption that the table has been
			 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
			 */ if (s.sTableId == this.id) {
                allSettings.splice(i, 1);
                break;
            }
        }
        /* Ensure the table has an ID - required for accessibility */ if (sId === null || sId === "") {
            sId = "DataTables_Table_" + $44bb6d473543b89d$var$DataTable.ext._unique++;
            this.id = sId;
        }
        // Replacing an existing colgroup with our own. Not ideal, but a merge could take a lot of code
        $this.children('colgroup').remove();
        /* Create the settings object for this table and set some of the default parameters */ var oSettings = $44bb6d473543b89d$var$$.extend(true, {}, $44bb6d473543b89d$var$DataTable.models.oSettings, {
            "sDestroyWidth": $this[0].style.width,
            "sInstance": sId,
            "sTableId": sId,
            colgroup: $44bb6d473543b89d$var$$('<colgroup>'),
            fastData: function(row, column, type) {
                return $44bb6d473543b89d$var$_fnGetCellData(oSettings, row, column, type);
            }
        });
        oSettings.nTable = this;
        oSettings.oInit = oInit;
        allSettings.push(oSettings);
        // Make a single API instance available for internal handling
        oSettings.api = new $44bb6d473543b89d$var$_Api(oSettings);
        // Need to add the instance after the instance after the settings object has been added
        // to the settings array, so we can self reference the table instance if more than one
        oSettings.oInstance = _that.length === 1 ? _that : $this.dataTable();
        // Backwards compatibility, before we apply all the defaults
        $44bb6d473543b89d$var$_fnCompatOpts(oInit);
        // If the length menu is given, but the init display length is not, use the length menu
        if (oInit.aLengthMenu && !oInit.iDisplayLength) oInit.iDisplayLength = Array.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : $44bb6d473543b89d$var$$.isPlainObject(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0].value : oInit.aLengthMenu[0];
        // Apply the defaults and init options to make a single init object will all
        // options defined from defaults and instance options.
        oInit = $44bb6d473543b89d$var$_fnExtend($44bb6d473543b89d$var$$.extend(true, {}, defaults), oInit);
        // Map the initialisation options onto the settings object
        $44bb6d473543b89d$var$_fnMap(oSettings.oFeatures, oInit, [
            "bPaginate",
            "bLengthChange",
            "bFilter",
            "bSort",
            "bSortMulti",
            "bInfo",
            "bProcessing",
            "bAutoWidth",
            "bSortClasses",
            "bServerSide",
            "bDeferRender"
        ]);
        $44bb6d473543b89d$var$_fnMap(oSettings, oInit, [
            "ajax",
            "fnFormatNumber",
            "sServerMethod",
            "aaSorting",
            "aaSortingFixed",
            "aLengthMenu",
            "sPaginationType",
            "iStateDuration",
            "bSortCellsTop",
            "iTabIndex",
            "sDom",
            "fnStateLoadCallback",
            "fnStateSaveCallback",
            "renderer",
            "searchDelay",
            "rowId",
            "caption",
            "layout",
            "orderDescReverse",
            "orderIndicators",
            "orderHandler",
            "titleRow",
            "typeDetect",
            "columnTitleTag",
            [
                "iCookieDuration",
                "iStateDuration"
            ],
            [
                "oSearch",
                "oPreviousSearch"
            ],
            [
                "aoSearchCols",
                "aoPreSearchCols"
            ],
            [
                "iDisplayLength",
                "_iDisplayLength"
            ]
        ]);
        $44bb6d473543b89d$var$_fnMap(oSettings.oScroll, oInit, [
            [
                "sScrollX",
                "sX"
            ],
            [
                "sScrollXInner",
                "sXInner"
            ],
            [
                "sScrollY",
                "sY"
            ],
            [
                "bScrollCollapse",
                "bCollapse"
            ]
        ]);
        $44bb6d473543b89d$var$_fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");
        /* Callback functions which are array driven */ $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoDrawCallback', oInit.fnDrawCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoStateSaveParams', oInit.fnStateSaveParams);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoStateLoadParams', oInit.fnStateLoadParams);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoStateLoaded', oInit.fnStateLoaded);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoRowCallback', oInit.fnRowCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoHeaderCallback', oInit.fnHeaderCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoFooterCallback', oInit.fnFooterCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoInitComplete', oInit.fnInitComplete);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoPreDrawCallback', oInit.fnPreDrawCallback);
        oSettings.rowIdFn = $44bb6d473543b89d$var$_fnGetObjectDataFn(oInit.rowId);
        // Add event listeners
        if (oInit.on) Object.keys(oInit.on).forEach(function(key) {
            $44bb6d473543b89d$var$_fnListener($this, key, oInit.on[key]);
        });
        /* Browser support detection */ $44bb6d473543b89d$var$_fnBrowserDetect(oSettings);
        var oClasses = oSettings.oClasses;
        $44bb6d473543b89d$var$$.extend(oClasses, $44bb6d473543b89d$var$DataTable.ext.classes, oInit.oClasses);
        $this.addClass(oClasses.table);
        if (!oSettings.oFeatures.bPaginate) oInit.iDisplayStart = 0;
        if (oSettings.iInitDisplayStart === undefined) {
            /* Display start point, taking into account the save saving */ oSettings.iInitDisplayStart = oInit.iDisplayStart;
            oSettings._iDisplayStart = oInit.iDisplayStart;
        }
        var defer = oInit.iDeferLoading;
        if (defer !== null) {
            oSettings.deferLoading = true;
            var tmp = Array.isArray(defer);
            oSettings._iRecordsDisplay = tmp ? defer[0] : defer;
            oSettings._iRecordsTotal = tmp ? defer[1] : defer;
        }
        /*
		 * Columns
		 * See if we should load columns automatically or use defined ones
		 */ var columnsInit = [];
        var thead = this.getElementsByTagName('thead');
        var initHeaderLayout = $44bb6d473543b89d$var$_fnDetectHeader(oSettings, thead[0]);
        // If we don't have a columns array, then generate one with nulls
        if (oInit.aoColumns) columnsInit = oInit.aoColumns;
        else if (initHeaderLayout.length) for(i = 0, iLen = initHeaderLayout[0].length; i < iLen; i++)columnsInit.push(null);
        // Add the columns
        for(i = 0, iLen = columnsInit.length; i < iLen; i++)$44bb6d473543b89d$var$_fnAddColumn(oSettings);
        // Apply the column definitions
        $44bb6d473543b89d$var$_fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, columnsInit, initHeaderLayout, function(iCol, oDef) {
            $44bb6d473543b89d$var$_fnColumnOptions(oSettings, iCol, oDef);
        });
        /* HTML5 attribute detection - build an mData object automatically if the
		 * attributes are found
		 */ var rowOne = $this.children('tbody').find('tr:first-child').eq(0);
        if (rowOne.length) {
            var a = function(cell, name) {
                return cell.getAttribute('data-' + name) !== null ? name : null;
            };
            $44bb6d473543b89d$var$$(rowOne[0]).children('th, td').each(function(i, cell) {
                var col = oSettings.aoColumns[i];
                if (!col) $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Incorrect column count', 18);
                if (col.mData === i) {
                    var sort = a(cell, 'sort') || a(cell, 'order');
                    var filter = a(cell, 'filter') || a(cell, 'search');
                    if (sort !== null || filter !== null) {
                        col.mData = {
                            _: i + '.display',
                            sort: sort !== null ? i + '.@data-' + sort : undefined,
                            type: sort !== null ? i + '.@data-' + sort : undefined,
                            filter: filter !== null ? i + '.@data-' + filter : undefined
                        };
                        col._isArrayHost = true;
                        $44bb6d473543b89d$var$_fnColumnOptions(oSettings, i);
                    }
                }
            });
        }
        // Must be done after everything which can be overridden by the state saving!
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoDrawCallback', $44bb6d473543b89d$var$_fnSaveState);
        var features = oSettings.oFeatures;
        if (oInit.bStateSave) features.bStateSave = true;
        // If aaSorting is not defined, then we use the first indicator in asSorting
        // in case that has been altered, so the default sort reflects that option
        if (oInit.aaSorting === undefined) {
            var sorting = oSettings.aaSorting;
            for(i = 0, iLen = sorting.length; i < iLen; i++)sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
        }
        // Do a first pass on the sorting classes (allows any size changes to be taken into
        // account, and also will apply sorting disabled classes if disabled
        $44bb6d473543b89d$var$_fnSortingClasses(oSettings);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoDrawCallback', function() {
            if (oSettings.bSorted || $44bb6d473543b89d$var$_fnDataSource(oSettings) === 'ssp' || features.bDeferRender) $44bb6d473543b89d$var$_fnSortingClasses(oSettings);
        });
        /*
		 * Table HTML init
		 * Cache the header, body and footer as required, creating them if needed
		 */ var caption = $this.children('caption');
        if (oSettings.caption) {
            if (caption.length === 0) caption = $44bb6d473543b89d$var$$('<caption/>').prependTo($this);
            caption.html(oSettings.caption);
        }
        // Store the caption side, so we can remove the element from the document
        // when creating the element
        if (caption.length) {
            caption[0]._captionSide = caption.css('caption-side');
            oSettings.captionNode = caption[0];
        }
        // Place the colgroup element in the correct location for the HTML structure
        if (caption.length) oSettings.colgroup.insertAfter(caption);
        else oSettings.colgroup.prependTo(oSettings.nTable);
        if (thead.length === 0) thead = $44bb6d473543b89d$var$$('<thead/>').appendTo($this);
        oSettings.nTHead = thead[0];
        var tbody = $this.children('tbody');
        if (tbody.length === 0) tbody = $44bb6d473543b89d$var$$('<tbody/>').insertAfter(thead);
        oSettings.nTBody = tbody[0];
        var tfoot = $this.children('tfoot');
        if (tfoot.length === 0) // If we are a scrolling table, and no footer has been given, then we need to create
        // a tfoot element for the caption element to be appended to
        tfoot = $44bb6d473543b89d$var$$('<tfoot/>').appendTo($this);
        oSettings.nTFoot = tfoot[0];
        // Copy the data index array
        oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
        // Initialisation complete - table can be drawn
        oSettings.bInitialised = true;
        // Language definitions
        var oLanguage = oSettings.oLanguage;
        $44bb6d473543b89d$var$$.extend(true, oLanguage, oInit.oLanguage);
        if (oLanguage.sUrl) // Get the language definitions from a file
        $44bb6d473543b89d$var$$.ajax({
            dataType: 'json',
            url: oLanguage.sUrl,
            success: function(json) {
                $44bb6d473543b89d$var$_fnCamelToHungarian(defaults.oLanguage, json);
                $44bb6d473543b89d$var$$.extend(true, oLanguage, json, oSettings.oInit.oLanguage);
                $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'i18n', [
                    oSettings
                ], true);
                $44bb6d473543b89d$var$_fnInitialise(oSettings);
            },
            error: function() {
                // Error occurred loading language file
                $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'i18n file loading error', 21);
                // Continue on as best we can
                $44bb6d473543b89d$var$_fnInitialise(oSettings);
            }
        });
        else {
            $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'i18n', [
                oSettings
            ], true);
            $44bb6d473543b89d$var$_fnInitialise(oSettings);
        }
    });
    _that = null;
    return this;
};
/**
 * DataTables extensions
 * 
 * This namespace acts as a collection area for plug-ins that can be used to
 * extend DataTables capabilities. Indeed many of the build in methods
 * use this method to provide their own capabilities (sorting methods for
 * example).
 *
 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
 * reasons
 *
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.ext = $44bb6d473543b89d$var$_ext = {
    /**
	 * DataTables build type (expanded by the download builder)
	 *
	 *  @type string
	 */ builder: "-source-",
    /**
	 * Buttons. For use with the Buttons extension for DataTables. This is
	 * defined here so other extensions can define buttons regardless of load
	 * order. It is _not_ used by DataTables core.
	 *
	 *  @type object
	 *  @default {}
	 */ buttons: {},
    /**
	 * ColumnControl buttons and content
	 *
	 *  @type object
	 */ ccContent: {},
    /**
	 * Element class names
	 *
	 *  @type object
	 *  @default {}
	 */ classes: {},
    /**
	 * Error reporting.
	 * 
	 * How should DataTables report an error. Can take the value 'alert',
	 * 'throw', 'none' or a function.
	 *
	 *  @type string|function
	 *  @default alert
	 */ errMode: "alert",
    /** HTML entity escaping */ escape: {
        /** When reading data-* attributes for initialisation options */ attributes: false
    },
    /**
	 * Legacy so v1 plug-ins don't throw js errors on load
	 */ feature: [],
    /**
	 * Feature plug-ins.
	 * 
	 * This is an object of callbacks which provide the features for DataTables
	 * to be initialised via the `layout` option.
	 */ features: {},
    /**
	 * Row searching.
	 * 
	 * This method of searching is complimentary to the default type based
	 * searching, and a lot more comprehensive as it allows you complete control
	 * over the searching logic. Each element in this array is a function
	 * (parameters described below) that is called for every row in the table,
	 * and your logic decides if it should be included in the searching data set
	 * or not.
	 *
	 * Searching functions have the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{array|object}` Data for the row to be processed (same as the
	 *    original format that was passed in as the data source, or an array
	 *    from a DOM data source
	 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	 *    can be useful to retrieve the `TR` element if you need DOM interaction.
	 *
	 * And the following return is expected:
	 *
	 * * {boolean} Include the row in the searched result set (true) or not
	 *   (false)
	 *
	 * Note that as with the main search ability in DataTables, technically this
	 * is "filtering", since it is subtractive. However, for consistency in
	 * naming we call it searching here.
	 *
	 *  @type array
	 *  @default []
	 *
	 *  @example
	 *    // The following example shows custom search being applied to the
	 *    // fourth column (i.e. the data[3] index) based on two input values
	 *    // from the end-user, matching the data in a certain range.
	 *    $.fn.dataTable.ext.search.push(
	 *      function( settings, data, dataIndex ) {
	 *        var min = document.getElementById('min').value * 1;
	 *        var max = document.getElementById('max').value * 1;
	 *        var version = data[3] == "-" ? 0 : data[3]*1;
	 *
	 *        if ( min == "" && max == "" ) {
	 *          return true;
	 *        }
	 *        else if ( min == "" && version < max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && "" == max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && version < max ) {
	 *          return true;
	 *        }
	 *        return false;
	 *      }
	 *    );
	 */ search: [],
    /**
	 * Selector extensions
	 *
	 * The `selector` option can be used to extend the options available for the
	 * selector modifier options (`selector-modifier` object data type) that
	 * each of the three built in selector types offer (row, column and cell +
	 * their plural counterparts). For example the Select extension uses this
	 * mechanism to provide an option to select only rows, columns and cells
	 * that have been marked as selected by the end user (`{selected: true}`),
	 * which can be used in conjunction with the existing built in selector
	 * options.
	 *
	 * Each property is an array to which functions can be pushed. The functions
	 * take three attributes:
	 *
	 * * Settings object for the host table
	 * * Options object (`selector-modifier` object type)
	 * * Array of selected item indexes
	 *
	 * The return is an array of the resulting item indexes after the custom
	 * selector has been applied.
	 *
	 *  @type object
	 */ selector: {
        cell: [],
        column: [],
        row: []
    },
    /**
	 * Legacy configuration options. Enable and disable legacy options that
	 * are available in DataTables.
	 *
	 *  @type object
	 */ legacy: {
        /**
		 * Enable / disable DataTables 1.9 compatible server-side processing
		 * requests
		 *
		 *  @type boolean
		 *  @default null
		 */ ajax: null
    },
    /**
	 * Pagination plug-in methods.
	 * 
	 * Each entry in this object is a function and defines which buttons should
	 * be shown by the pagination rendering method that is used for the table:
	 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	 * buttons are displayed in the document, while the functions here tell it
	 * what buttons to display. This is done by returning an array of button
	 * descriptions (what each button will do).
	 *
	 * Pagination types (the four built in options and any additional plug-in
	 * options defined here) can be used through the `paginationType`
	 * initialisation parameter.
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{int} page` The current page index
	 * 2. `{int} pages` The number of pages in the table
	 *
	 * Each function is expected to return an array where each element of the
	 * array can be one of:
	 *
	 * * `first` - Jump to first page when activated
	 * * `last` - Jump to last page when activated
	 * * `previous` - Show previous page when activated
	 * * `next` - Show next page when activated
	 * * `{int}` - Show page of the index given
	 * * `{array}` - A nested array containing the above elements to add a
	 *   containing 'DIV' element (might be useful for styling).
	 *
	 * Note that DataTables v1.9- used this object slightly differently whereby
	 * an object with two functions would be defined for each plug-in. That
	 * ability is still supported by DataTables 1.10+ to provide backwards
	 * compatibility, but this option of use is now decremented and no longer
	 * documented in DataTables 1.10+.
	 *
	 *  @type object
	 *  @default {}
	 *
	 *  @example
	 *    // Show previous, next and current page buttons only
	 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	 *      return [ 'previous', page, 'next' ];
	 *    };
	 */ pager: {},
    renderer: {
        pageButton: {},
        header: {}
    },
    /**
	 * Ordering plug-ins - custom data source
	 * 
	 * The extension options for ordering of data available here is complimentary
	 * to the default type based ordering that DataTables typically uses. It
	 * allows much greater control over the data that is being used to
	 * order a column, but is necessarily therefore more complex.
	 * 
	 * This type of ordering is useful if you want to do ordering based on data
	 * live from the DOM (for example the contents of an 'input' element) rather
	 * than just the static string that DataTables knows of.
	 * 
	 * The way these plug-ins work is that you create an array of the values you
	 * wish to be ordering for the column in question and then return that
	 * array. The data in the array much be in the index order of the rows in
	 * the table (not the currently ordering order!). Which order data gathering
	 * function is run here depends on the `dt-init columns.orderDataType`
	 * parameter that is used for the column (if any).
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{int}` Target column index
	 *
	 * Each function is expected to return an array:
	 *
	 * * `{array}` Data for the column to be ordering upon
	 *
	 *  @type array
	 *
	 *  @example
	 *    // Ordering using `input` node values
	 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	 *    {
	 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	 *        return $('input', td).val();
	 *      } );
	 *    }
	 */ order: {},
    /**
	 * Type based plug-ins.
	 *
	 * Each column in DataTables has a type assigned to it, either by automatic
	 * detection or by direct assignment using the `type` option for the column.
	 * The type of a column will effect how it is ordering and search (plug-ins
	 * can also make use of the column type if required).
	 *
	 * @namespace
	 */ type: {
        /**
		 * Automatic column class assignment
		 */ className: {},
        /**
		 * Type detection functions.
		 *
		 * The functions defined in this object are used to automatically detect
		 * a column's type, making initialisation of DataTables super easy, even
		 * when complex data is in the table.
		 *
		 * The functions defined take two parameters:
		 *
	     *  1. `{*}` Data from the column cell to be analysed
	     *  2. `{settings}` DataTables settings object. This can be used to
	     *     perform context specific type detection - for example detection
	     *     based on language settings such as using a comma for a decimal
	     *     place. Generally speaking the options from the settings will not
	     *     be required
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Data type detected, or null if unknown (and thus
		 *   pass it on to the other type detection functions.
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Currency type detection plug-in:
		 *    $.fn.dataTable.ext.type.detect.push(
		 *      function ( data, settings ) {
		 *        // Check the numeric part
		 *        if ( ! data.substring(1).match(/[0-9]/) ) {
		 *          return null;
		 *        }
		 *
		 *        // Check prefixed by currency
		 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
		 *          return 'currency';
		 *        }
		 *        return null;
		 *      }
		 *    );
		 */ detect: [],
        /**
		 * Automatic renderer assignment
		 */ render: {},
        /**
		 * Type based search formatting.
		 *
		 * The type based searching functions can be used to pre-format the
		 * data to be search on. For example, it can be used to strip HTML
		 * tags or to de-format telephone numbers for numeric only searching.
		 *
		 * Note that is a search is not defined for a column of a given type,
		 * no search formatting will be performed.
		 * 
		 * Pre-processing of searching data plug-ins - When you assign the sType
		 * for a column (or have it automatically detected for you by DataTables
		 * or a type detection plug-in), you will typically be using this for
		 * custom sorting, but it can also be used to provide custom searching
		 * by allowing you to pre-processing the data and returning the data in
		 * the format that should be searched upon. This is done by adding
		 * functions this object with a parameter name which matches the sType
		 * for that target column. This is the corollary of <i>afnSortData</i>
		 * for searching data.
		 *
		 * The functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for searching
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Formatted string that will be used for the searching.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
		 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
		 *    }
		 */ search: {},
        /**
		 * Type based ordering.
		 *
		 * The column type tells DataTables what ordering to apply to the table
		 * when a column is sorted upon. The order for each type that is defined,
		 * is defined by the functions available in this object.
		 *
		 * Each ordering option can be described by three properties added to
		 * this object:
		 *
		 * * `{type}-pre` - Pre-formatting function
		 * * `{type}-asc` - Ascending order function
		 * * `{type}-desc` - Descending order function
		 *
		 * All three can be used together, only `{type}-pre` or only
		 * `{type}-asc` and `{type}-desc` together. It is generally recommended
		 * that only `{type}-pre` is used, as this provides the optimal
		 * implementation in terms of speed, although the others are provided
		 * for compatibility with existing JavaScript sort functions.
		 *
		 * `{type}-pre`: Functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for ordering
		 *
		 * And return:
		 *
		 * * `{*}` Data to be sorted upon
		 *
		 * `{type}-asc` and `{type}-desc`: Functions are typical JavaScript sort
		 * functions, taking two parameters:
		 *
	     *  1. `{*}` Data to compare to the second parameter
	     *  2. `{*}` Data to compare to the first parameter
		 *
		 * And returning:
		 *
		 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
		 *   than the second parameter, ===0 if the two parameters are equal and
		 *   >0 if the first parameter should be sorted height than the second
		 *   parameter.
		 * 
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Numeric ordering of formatted numbers with a pre-formatter
		 *    $.extend( $.fn.dataTable.ext.type.order, {
		 *      "string-pre": function(x) {
		 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
		 *        return parseFloat( a );
		 *      }
		 *    } );
		 *
		 *  @example
		 *    // Case-sensitive string ordering, with no pre-formatting method
		 *    $.extend( $.fn.dataTable.ext.order, {
		 *      "string-case-asc": function(x,y) {
		 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		 *      },
		 *      "string-case-desc": function(x,y) {
		 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		 *      }
		 *    } );
		 */ order: {}
    },
    /**
	 * Unique DataTables instance counter
	 *
	 * @type int
	 * @private
	 */ _unique: 0,
    //
    // Depreciated
    // The following properties are retained for backwards compatibility only.
    // The should not be used in new projects and will be removed in a future
    // version
    //
    /**
	 * Version check function.
	 *  @type function
	 *  @depreciated Since 1.10
	 */ fnVersionCheck: $44bb6d473543b89d$var$DataTable.fnVersionCheck,
    /**
	 * Index for what 'this' index API functions should use
	 *  @type int
	 *  @deprecated Since v1.10
	 */ iApiIndex: 0,
    /**
	 * Software version
	 *  @type string
	 *  @deprecated Since v1.10
	 */ sVersion: $44bb6d473543b89d$var$DataTable.version
};
//
// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
//
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$_ext, {
    afnFiltering: $44bb6d473543b89d$var$_ext.search,
    aTypes: $44bb6d473543b89d$var$_ext.type.detect,
    ofnSearch: $44bb6d473543b89d$var$_ext.type.search,
    oSort: $44bb6d473543b89d$var$_ext.type.order,
    afnSortData: $44bb6d473543b89d$var$_ext.order,
    aoFeatures: $44bb6d473543b89d$var$_ext.feature,
    oStdClasses: $44bb6d473543b89d$var$_ext.classes,
    oPagination: $44bb6d473543b89d$var$_ext.pager
});
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$DataTable.ext.classes, {
    container: 'dt-container',
    empty: {
        row: 'dt-empty'
    },
    info: {
        container: 'dt-info'
    },
    layout: {
        row: 'dt-layout-row',
        cell: 'dt-layout-cell',
        tableRow: 'dt-layout-table',
        tableCell: '',
        start: 'dt-layout-start',
        end: 'dt-layout-end',
        full: 'dt-layout-full'
    },
    length: {
        container: 'dt-length',
        select: 'dt-input'
    },
    order: {
        canAsc: 'dt-orderable-asc',
        canDesc: 'dt-orderable-desc',
        isAsc: 'dt-ordering-asc',
        isDesc: 'dt-ordering-desc',
        none: 'dt-orderable-none',
        position: 'sorting_'
    },
    processing: {
        container: 'dt-processing'
    },
    scrolling: {
        body: 'dt-scroll-body',
        container: 'dt-scroll',
        footer: {
            self: 'dt-scroll-foot',
            inner: 'dt-scroll-footInner'
        },
        header: {
            self: 'dt-scroll-head',
            inner: 'dt-scroll-headInner'
        }
    },
    search: {
        container: 'dt-search',
        input: 'dt-input'
    },
    table: 'dataTable',
    tbody: {
        cell: '',
        row: ''
    },
    thead: {
        cell: '',
        row: ''
    },
    tfoot: {
        cell: '',
        row: ''
    },
    paging: {
        active: 'current',
        button: 'dt-paging-button',
        container: 'dt-paging',
        disabled: 'disabled',
        nav: ''
    }
});
/*
 * It is useful to have variables which are scoped locally so only the
 * DataTables functions can access them and they don't leak into global space.
 * At the same time these functions are often useful over multiple files in the
 * core and API, so we list, or at least document, all variables which are used
 * by DataTables as private variables here. This also ensures that there is no
 * clashing of variable names and that they can easily referenced for reuse.
 */ // Defined else where
//  _selector_run
//  _selector_opts
//  _selector_row_indexes
var $44bb6d473543b89d$var$_ext; // DataTable.ext
var $44bb6d473543b89d$var$_Api; // DataTable.Api
var $44bb6d473543b89d$var$_api_register; // DataTable.Api.register
var $44bb6d473543b89d$var$_api_registerPlural; // DataTable.Api.registerPlural
var $44bb6d473543b89d$var$_re_dic = {};
var $44bb6d473543b89d$var$_re_new_lines = /[\r\n\u2028]/g;
var $44bb6d473543b89d$var$_re_html = /<([^>]*>)/g;
var $44bb6d473543b89d$var$_max_str_len = Math.pow(2, 28);
// This is not strict ISO8601 - Date.parse() is quite lax, although
// implementations differ between browsers.
var $44bb6d473543b89d$var$_re_date = /^\d{2,4}[./-]\d{1,2}[./-]\d{1,2}([T ]{1}\d{1,2}[:.]\d{2}([.:]\d{2})?)?$/;
// Escape regular expression special characters
var $44bb6d473543b89d$var$_re_escape_regex = new RegExp('(\\' + [
    '/',
    '.',
    '*',
    '+',
    '?',
    '|',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '\\',
    '$',
    '^',
    '-'
].join('|\\') + ')', 'g');
// https://en.wikipedia.org/wiki/Foreign_exchange_market
// - \u20BD - Russian ruble.
// - \u20a9 - South Korean Won
// - \u20BA - Turkish Lira
// - \u20B9 - Indian Rupee
// - R - Brazil (R$) and South Africa
// - fr - Swiss Franc
// - kr - Swedish krona, Norwegian krone and Danish krone
// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
// - Ƀ - Bitcoin
// - Ξ - Ethereum
//   standards as thousands separators.
var $44bb6d473543b89d$var$_re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
var $44bb6d473543b89d$var$_empty = function(d) {
    return !d || d === true || d === '-' ? true : false;
};
var $44bb6d473543b89d$var$_intVal = function(s) {
    var integer = parseInt(s, 10);
    return !isNaN(integer) && isFinite(s) ? integer : null;
};
// Convert from a formatted number with characters other than `.` as the
// decimal place, to a JavaScript number
var $44bb6d473543b89d$var$_numToDecimal = function(num, decimalPoint) {
    // Cache created regular expressions for speed as this function is called often
    if (!$44bb6d473543b89d$var$_re_dic[decimalPoint]) $44bb6d473543b89d$var$_re_dic[decimalPoint] = new RegExp($44bb6d473543b89d$var$_fnEscapeRegex(decimalPoint), 'g');
    return typeof num === 'string' && decimalPoint !== '.' ? num.replace(/\./g, '').replace($44bb6d473543b89d$var$_re_dic[decimalPoint], '.') : num;
};
var $44bb6d473543b89d$var$_isNumber = function(d, decimalPoint, formatted, allowEmpty) {
    var type = typeof d;
    var strType = type === 'string';
    if (type === 'number' || type === 'bigint') return true;
    // If empty return immediately so there must be a number if it is a
    // formatted string (this stops the string "k", or "kr", etc being detected
    // as a formatted number for currency
    if (allowEmpty && $44bb6d473543b89d$var$_empty(d)) return true;
    if (decimalPoint && strType) d = $44bb6d473543b89d$var$_numToDecimal(d, decimalPoint);
    if (formatted && strType) d = d.replace($44bb6d473543b89d$var$_re_formatted_numeric, '');
    return !isNaN(parseFloat(d)) && isFinite(d);
};
// A string without HTML in it can be considered to be HTML still
var $44bb6d473543b89d$var$_isHtml = function(d) {
    return $44bb6d473543b89d$var$_empty(d) || typeof d === 'string';
};
// Is a string a number surrounded by HTML?
var $44bb6d473543b89d$var$_htmlNumeric = function(d, decimalPoint, formatted, allowEmpty) {
    if (allowEmpty && $44bb6d473543b89d$var$_empty(d)) return true;
    // input and select strings mean that this isn't just a number
    if (typeof d === 'string' && d.match(/<(input|select)/i)) return null;
    var html = $44bb6d473543b89d$var$_isHtml(d);
    return !html ? null : $44bb6d473543b89d$var$_isNumber($44bb6d473543b89d$var$_stripHtml(d), decimalPoint, formatted, allowEmpty) ? true : null;
};
var $44bb6d473543b89d$var$_pluck = function(a, prop, prop2) {
    var out = [];
    var i = 0, iLen = a.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < iLen; i++)if (a[i] && a[i][prop]) out.push(a[i][prop][prop2]);
    } else {
        for(; i < iLen; i++)if (a[i]) out.push(a[i][prop]);
    }
    return out;
};
// Basically the same as _pluck, but rather than looping over `a` we use `order`
// as the indexes to pick from `a`
var $44bb6d473543b89d$var$_pluck_order = function(a, order, prop, prop2) {
    var out = [];
    var i = 0, iLen = order.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < iLen; i++)if (a[order[i]] && a[order[i]][prop]) out.push(a[order[i]][prop][prop2]);
    } else {
        for(; i < iLen; i++)if (a[order[i]]) out.push(a[order[i]][prop]);
    }
    return out;
};
var $44bb6d473543b89d$var$_range = function(len, start) {
    var out = [];
    var end;
    if (start === undefined) {
        start = 0;
        end = len;
    } else {
        end = start;
        start = len;
    }
    for(var i = start; i < end; i++)out.push(i);
    return out;
};
var $44bb6d473543b89d$var$_removeEmpty = function(a) {
    var out = [];
    for(var i = 0, iLen = a.length; i < iLen; i++)if (a[i]) out.push(a[i]);
    return out;
};
// Replaceable function in api.util
var $44bb6d473543b89d$var$_stripHtml = function(input, replacement) {
    if (!input || typeof input !== 'string') return input;
    // Irrelevant check to workaround CodeQL's false positive on the regex
    if (input.length > $44bb6d473543b89d$var$_max_str_len) throw new Error('Exceeded max str len');
    var previous;
    input = input.replace($44bb6d473543b89d$var$_re_html, replacement || ''); // Complete tags
    // Safety for incomplete script tag - use do / while to ensure that
    // we get all instances
    do {
        previous = input;
        input = input.replace(/<script/i, '');
    }while (input !== previous);
    return previous;
};
// Replaceable function in api.util
var $44bb6d473543b89d$var$_escapeHtml = function(d) {
    if (Array.isArray(d)) d = d.join(',');
    return typeof d === 'string' ? d.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : d;
};
// Remove diacritics from a string by decomposing it and then removing
// non-ascii characters
var $44bb6d473543b89d$var$_normalize = function(str, both) {
    if (typeof str !== 'string') return str;
    // It is faster to just run `normalize` than it is to check if
    // we need to with a regex! (Check as it isn't available in old
    // Safari)
    var res = str.normalize ? str.normalize("NFD") : str;
    // Equally, here we check if a regex is needed or not
    return res.length !== str.length ? (both === true ? str + ' ' : '') + res.replace(/[\u0300-\u036f]/g, "") : res;
};
/**
 * Determine if all values in the array are unique. This means we can short
 * cut the _unique method at the cost of a single loop. A sorted array is used
 * to easily check the values.
 *
 * @param  {array} src Source array
 * @return {boolean} true if all unique, false otherwise
 * @ignore
 */ var $44bb6d473543b89d$var$_areAllUnique = function(src) {
    if (src.length < 2) return true;
    var sorted = src.slice().sort();
    var last = sorted[0];
    for(var i = 1, iLen = sorted.length; i < iLen; i++){
        if (sorted[i] === last) return false;
        last = sorted[i];
    }
    return true;
};
/**
 * Find the unique elements in a source array.
 *
 * @param  {array} src Source array
 * @return {array} Array of unique items
 * @ignore
 */ var $44bb6d473543b89d$var$_unique = function(src) {
    if (Array.from && Set) return Array.from(new Set(src));
    if ($44bb6d473543b89d$var$_areAllUnique(src)) return src.slice();
    // A faster unique method is to use object keys to identify used values,
    // but this doesn't work with arrays or objects, which we must also
    // consider. See jsperf.app/compare-array-unique-versions/4 for more
    // information.
    var out = [], val, i, iLen = src.length, j, k = 0;
    again: for(i = 0; i < iLen; i++){
        val = src[i];
        for(j = 0; j < k; j++){
            if (out[j] === val) continue again;
        }
        out.push(val);
        k++;
    }
    return out;
};
// Surprisingly this is faster than [].concat.apply
// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
var $44bb6d473543b89d$var$_flatten = function(out, val) {
    if (Array.isArray(val)) for(var i = 0; i < val.length; i++)$44bb6d473543b89d$var$_flatten(out, val[i]);
    else out.push(val);
    return out;
};
// Similar to jQuery's addClass, but use classList.add
function $44bb6d473543b89d$var$_addClass(el, name) {
    if (name) name.split(' ').forEach(function(n) {
        if (n) // `add` does deduplication, so no need to check `contains`
        el.classList.add(n);
    });
}
/**
 * DataTables utility methods
 * 
 * This namespace provides helper methods that DataTables uses internally to
 * create a DataTable, but which are not exclusively used only for DataTables.
 * These methods can be used by extension authors to save the duplication of
 * code.
 *
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.util = {
    /**
	 * Return a string with diacritic characters decomposed
	 * @param {*} mixed Function or string to normalize
	 * @param {*} both Return original string and the normalized string
	 * @returns String or undefined
	 */ diacritics: function(mixed, both) {
        var type = typeof mixed;
        if (type !== 'function') return $44bb6d473543b89d$var$_normalize(mixed, both);
        $44bb6d473543b89d$var$_normalize = mixed;
    },
    /**
	 * Debounce a function
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ debounce: function(fn, timeout) {
        var timer;
        return function() {
            var that = this;
            var args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(that, args);
            }, timeout || 250);
        };
    },
    /**
	 * Throttle the calls to a function. Arguments and context are maintained
	 * for the throttled function.
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ throttle: function(fn, freq) {
        var frequency = freq !== undefined ? freq : 200, last, timer;
        return function() {
            var that = this, now = +new Date(), args = arguments;
            if (last && now < last + frequency) {
                clearTimeout(timer);
                timer = setTimeout(function() {
                    last = undefined;
                    fn.apply(that, args);
                }, frequency);
            } else {
                last = now;
                fn.apply(that, args);
            }
        };
    },
    /**
	 * Escape a string such that it can be used in a regular expression
	 *
	 *  @param {string} val string to escape
	 *  @returns {string} escaped string
	 */ escapeRegex: function(val) {
        return val.replace($44bb6d473543b89d$var$_re_escape_regex, '\\$1');
    },
    /**
	 * Create a function that will write to a nested object or array
	 * @param {*} source JSON notation string
	 * @returns Write function
	 */ set: function(source) {
        if ($44bb6d473543b89d$var$$.isPlainObject(source)) /* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */ return $44bb6d473543b89d$var$DataTable.util.set(source._);
        else if (source === null) // Nothing to do when the data source is null
        return function() {};
        else if (typeof source === 'function') return function(data, val, meta) {
            source(data, 'set', val, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            // Like the get, we need to get data from a nested object
            var setData = function(data, val, src) {
                var a = $44bb6d473543b89d$var$_fnSplitObjNotation(src), b;
                var aLast = a[a.length - 1];
                var arrayNotation, funcNotation, o, innerSrc;
                for(var i = 0, iLen = a.length - 1; i < iLen; i++){
                    // Protect against prototype pollution
                    if (a[i] === '__proto__' || a[i] === 'constructor') throw new Error('Cannot set prototype values');
                    // Check if we are dealing with an array notation request
                    arrayNotation = a[i].match($44bb6d473543b89d$var$__reArray);
                    funcNotation = a[i].match($44bb6d473543b89d$var$__reFn);
                    if (arrayNotation) {
                        a[i] = a[i].replace($44bb6d473543b89d$var$__reArray, '');
                        data[a[i]] = [];
                        // Get the remainder of the nested object to set so we can recurse
                        b = a.slice();
                        b.splice(0, i + 1);
                        innerSrc = b.join('.');
                        // Traverse each entry in the array setting the properties requested
                        if (Array.isArray(val)) for(var j = 0, jLen = val.length; j < jLen; j++){
                            o = {};
                            setData(o, val[j], innerSrc);
                            data[a[i]].push(o);
                        }
                        else // We've been asked to save data to an array, but it
                        // isn't array data to be saved. Best that can be done
                        // is to just save the value.
                        data[a[i]] = val;
                        // The inner call to setData has already traversed through the remainder
                        // of the source and has set the data, thus we can exit here
                        return;
                    } else if (funcNotation) {
                        // Function call
                        a[i] = a[i].replace($44bb6d473543b89d$var$__reFn, '');
                        data = data[a[i]](val);
                    }
                    // If the nested object doesn't currently exist - since we are
                    // trying to set the value - create it
                    if (data[a[i]] === null || data[a[i]] === undefined) data[a[i]] = {};
                    data = data[a[i]];
                }
                // Last item in the input - i.e, the actual set
                if (aLast.match($44bb6d473543b89d$var$__reFn)) // Function call
                data = data[aLast.replace($44bb6d473543b89d$var$__reFn, '')](val);
                else // If array notation is used, we just want to strip it and use the property name
                // and assign the value. If it isn't used, then we get the result we want anyway
                data[aLast.replace($44bb6d473543b89d$var$__reArray, '')] = val;
            };
            return function(data, val) {
                return setData(data, val, source);
            };
        } else // Array or flat object mapping
        return function(data, val) {
            data[source] = val;
        };
    },
    /**
	 * Create a function that will read nested objects from arrays, based on JSON notation
	 * @param {*} source JSON notation string
	 * @returns Value read
	 */ get: function(source) {
        if ($44bb6d473543b89d$var$$.isPlainObject(source)) {
            // Build an object of get functions, and wrap them in a single call
            var o = {};
            $44bb6d473543b89d$var$$.each(source, function(key, val) {
                if (val) o[key] = $44bb6d473543b89d$var$DataTable.util.get(val);
            });
            return function(data, type, row, meta) {
                var t = o[type] || o._;
                return t !== undefined ? t(data, type, row, meta) : data;
            };
        } else if (source === null) // Give an empty string for rendering / sorting etc
        return function(data) {
            return data;
        };
        else if (typeof source === 'function') return function(data, type, row, meta) {
            return source(data, type, row, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            /* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */ var fetchData = function(data, type, src) {
                var arrayNotation, funcNotation, out, innerSrc;
                if (src !== "") {
                    var a = $44bb6d473543b89d$var$_fnSplitObjNotation(src);
                    for(var i = 0, iLen = a.length; i < iLen; i++){
                        // Check if we are dealing with special notation
                        arrayNotation = a[i].match($44bb6d473543b89d$var$__reArray);
                        funcNotation = a[i].match($44bb6d473543b89d$var$__reFn);
                        if (arrayNotation) {
                            // Array notation
                            a[i] = a[i].replace($44bb6d473543b89d$var$__reArray, '');
                            // Condition allows simply [] to be passed in
                            if (a[i] !== "") data = data[a[i]];
                            out = [];
                            // Get the remainder of the nested object to get
                            a.splice(0, i + 1);
                            innerSrc = a.join('.');
                            // Traverse each entry in the array getting the properties requested
                            if (Array.isArray(data)) for(var j = 0, jLen = data.length; j < jLen; j++)out.push(fetchData(data[j], type, innerSrc));
                            // If a string is given in between the array notation indicators, that
                            // is used to join the strings together, otherwise an array is returned
                            var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
                            data = join === "" ? out : out.join(join);
                            break;
                        } else if (funcNotation) {
                            // Function call
                            a[i] = a[i].replace($44bb6d473543b89d$var$__reFn, '');
                            data = data[a[i]]();
                            continue;
                        }
                        if (data === null || data[a[i]] === null) return null;
                        else if (data === undefined || data[a[i]] === undefined) return undefined;
                        data = data[a[i]];
                    }
                }
                return data;
            };
            return function(data, type) {
                return fetchData(data, type, source);
            };
        } else // Array or flat object mapping
        return function(data) {
            return data[source];
        };
    },
    stripHtml: function(mixed, replacement) {
        var type = typeof mixed;
        if (type === 'function') {
            $44bb6d473543b89d$var$_stripHtml = mixed;
            return;
        } else if (type === 'string') return $44bb6d473543b89d$var$_stripHtml(mixed, replacement);
        return mixed;
    },
    escapeHtml: function(mixed) {
        var type = typeof mixed;
        if (type === 'function') {
            $44bb6d473543b89d$var$_escapeHtml = mixed;
            return;
        } else if (type === 'string' || Array.isArray(mixed)) return $44bb6d473543b89d$var$_escapeHtml(mixed);
        return mixed;
    },
    unique: $44bb6d473543b89d$var$_unique
};
/**
 * Create a mapping object that allows camel case parameters to be looked up
 * for their Hungarian counterparts. The mapping is stored in a private
 * parameter called `_hungarianMap` which can be accessed on the source object.
 *  @param {object} o
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnHungarianMap(o) {
    var hungarian = 'a aa ai ao as b fn i m o s ', match, newKey, map = {};
    $44bb6d473543b89d$var$$.each(o, function(key) {
        match = key.match(/^([^A-Z]+?)([A-Z])/);
        if (match && hungarian.indexOf(match[1] + ' ') !== -1) {
            newKey = key.replace(match[0], match[2].toLowerCase());
            map[newKey] = key;
            if (match[1] === 'o') $44bb6d473543b89d$var$_fnHungarianMap(o[key]);
        }
    });
    o._hungarianMap = map;
}
/**
 * Convert from camel case parameters to Hungarian, based on a Hungarian map
 * created by _fnHungarianMap.
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCamelToHungarian(src, user, force) {
    if (!src._hungarianMap) $44bb6d473543b89d$var$_fnHungarianMap(src);
    var hungarianKey;
    $44bb6d473543b89d$var$$.each(user, function(key) {
        hungarianKey = src._hungarianMap[key];
        if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
            // For objects, we need to buzz down into the object to copy parameters
            if (hungarianKey.charAt(0) === 'o') {
                // Copy the camelCase options over to the hungarian
                if (!user[hungarianKey]) user[hungarianKey] = {};
                $44bb6d473543b89d$var$$.extend(true, user[hungarianKey], user[key]);
                $44bb6d473543b89d$var$_fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
            } else user[hungarianKey] = user[key];
        }
    });
}
/**
 * Map one parameter onto another
 *  @param {object} o Object to map
 *  @param {*} knew The new parameter name
 *  @param {*} old The old parameter name
 */ var $44bb6d473543b89d$var$_fnCompatMap = function(o, knew, old) {
    if (o[knew] !== undefined) o[old] = o[knew];
};
/**
 * Provide backwards compatibility for the main DT options. Note that the new
 * options are mapped onto the old parameters, so this is an external interface
 * change only.
 *  @param {object} init Object to map
 */ function $44bb6d473543b89d$var$_fnCompatOpts(init) {
    $44bb6d473543b89d$var$_fnCompatMap(init, 'ordering', 'bSort');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderMulti', 'bSortMulti');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderClasses', 'bSortClasses');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderCellsTop', 'bSortCellsTop');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'order', 'aaSorting');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderFixed', 'aaSortingFixed');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'paging', 'bPaginate');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'pagingType', 'sPaginationType');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'pageLength', 'iDisplayLength');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'searching', 'bFilter');
    // Boolean initialisation of x-scrolling
    if (typeof init.sScrollX === 'boolean') init.sScrollX = init.sScrollX ? '100%' : '';
    if (typeof init.scrollX === 'boolean') init.scrollX = init.scrollX ? '100%' : '';
    // Objects for ordering
    if (typeof init.bSort === 'object') {
        init.orderIndicators = init.bSort.indicators !== undefined ? init.bSort.indicators : true;
        init.orderHandler = init.bSort.handler !== undefined ? init.bSort.handler : true;
        init.bSort = true;
    } else if (init.bSort === false) {
        init.orderIndicators = false;
        init.orderHandler = false;
    } else if (init.bSort === true) {
        init.orderIndicators = true;
        init.orderHandler = true;
    }
    // Which cells are the title cells?
    if (typeof init.bSortCellsTop === 'boolean') init.titleRow = init.bSortCellsTop;
    // Column search objects are in an array, so it needs to be converted
    // element by element
    var searchCols = init.aoSearchCols;
    if (searchCols) {
        for(var i = 0, iLen = searchCols.length; i < iLen; i++)if (searchCols[i]) $44bb6d473543b89d$var$_fnCamelToHungarian($44bb6d473543b89d$var$DataTable.models.oSearch, searchCols[i]);
    }
    // Enable search delay if server-side processing is enabled
    if (init.serverSide && !init.searchDelay) init.searchDelay = 400;
}
/**
 * Provide backwards compatibility for column options. Note that the new options
 * are mapped onto the old parameters, so this is an external interface change
 * only.
 *  @param {object} init Object to map
 */ function $44bb6d473543b89d$var$_fnCompatCols(init) {
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderable', 'bSortable');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderData', 'aDataSort');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderSequence', 'asSorting');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderDataType', 'sortDataType');
    // orderData can be given as an integer
    var dataSort = init.aDataSort;
    if (typeof dataSort === 'number' && !Array.isArray(dataSort)) init.aDataSort = [
        dataSort
    ];
}
/**
 * Browser feature detection for capabilities, quirks
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnBrowserDetect(settings) {
    // We don't need to do this every time DataTables is constructed, the values
    // calculated are specific to the browser and OS configuration which we
    // don't expect to change between initialisations
    if (!$44bb6d473543b89d$var$DataTable.__browser) {
        var browser = {};
        $44bb6d473543b89d$var$DataTable.__browser = browser;
        // Scrolling feature / quirks detection
        var n = $44bb6d473543b89d$var$$('<div/>').css({
            position: 'fixed',
            top: 0,
            left: -1 * window.pageXOffset,
            height: 1,
            width: 1,
            overflow: 'hidden'
        }).append($44bb6d473543b89d$var$$('<div/>').css({
            position: 'absolute',
            top: 1,
            left: 1,
            width: 100,
            overflow: 'scroll'
        }).append($44bb6d473543b89d$var$$('<div/>').css({
            width: '100%',
            height: 10
        }))).appendTo('body');
        var outer = n.children();
        var inner = outer.children();
        // Get scrollbar width
        browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
        // In rtl text layout, some browsers (most, but not all) will place the
        // scrollbar on the left, rather than the right.
        browser.bScrollbarLeft = Math.round(inner.offset().left) !== 1;
        n.remove();
    }
    $44bb6d473543b89d$var$$.extend(settings.oBrowser, $44bb6d473543b89d$var$DataTable.__browser);
    settings.oScroll.iBarWidth = $44bb6d473543b89d$var$DataTable.__browser.barWidth;
}
/**
 * Add a column to the list used for the table with default values
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddColumn(oSettings) {
    // Add column to aoColumns array
    var oDefaults = $44bb6d473543b89d$var$DataTable.defaults.column;
    var iCol = oSettings.aoColumns.length;
    var oCol = $44bb6d473543b89d$var$$.extend({}, $44bb6d473543b89d$var$DataTable.models.oColumn, oDefaults, {
        "aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [
            iCol
        ],
        "mData": oDefaults.mData ? oDefaults.mData : iCol,
        idx: iCol,
        searchFixed: {},
        colEl: $44bb6d473543b89d$var$$('<col>').attr('data-dt-column', iCol)
    });
    oSettings.aoColumns.push(oCol);
    // Add search object for column specific search. Note that the `searchCols[ iCol ]`
    // passed into extend can be undefined. This allows the user to give a default
    // with only some of the parameters defined, and also not give a default
    var searchCols = oSettings.aoPreSearchCols;
    searchCols[iCol] = $44bb6d473543b89d$var$$.extend({}, $44bb6d473543b89d$var$DataTable.models.oSearch, searchCols[iCol]);
}
/**
 * Apply options for a column
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iCol column index to consider
 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnColumnOptions(oSettings, iCol, oOptions) {
    var oCol = oSettings.aoColumns[iCol];
    /* User specified column options */ if (oOptions !== undefined && oOptions !== null) {
        // Backwards compatibility
        $44bb6d473543b89d$var$_fnCompatCols(oOptions);
        // Map camel case parameters to their Hungarian counterparts
        $44bb6d473543b89d$var$_fnCamelToHungarian($44bb6d473543b89d$var$DataTable.defaults.column, oOptions, true);
        /* Backwards compatibility for mDataProp */ if (oOptions.mDataProp !== undefined && !oOptions.mData) oOptions.mData = oOptions.mDataProp;
        if (oOptions.sType) oCol._sManualType = oOptions.sType;
        // `class` is a reserved word in JavaScript, so we need to provide
        // the ability to use a valid name for the camel case input
        if (oOptions.className && !oOptions.sClass) oOptions.sClass = oOptions.className;
        var origClass = oCol.sClass;
        $44bb6d473543b89d$var$$.extend(oCol, oOptions);
        $44bb6d473543b89d$var$_fnMap(oCol, oOptions, "sWidth", "sWidthOrig");
        // Merge class from previously defined classes with this one, rather than just
        // overwriting it in the extend above
        if (origClass !== oCol.sClass) oCol.sClass = origClass + ' ' + oCol.sClass;
        /* iDataSort to be applied (backwards compatibility), but aDataSort will take
		 * priority if defined
		 */ if (oOptions.iDataSort !== undefined) oCol.aDataSort = [
            oOptions.iDataSort
        ];
        $44bb6d473543b89d$var$_fnMap(oCol, oOptions, "aDataSort");
    }
    /* Cache the data get and set functions for speed */ var mDataSrc = oCol.mData;
    var mData = $44bb6d473543b89d$var$_fnGetObjectDataFn(mDataSrc);
    // The `render` option can be given as an array to access the helper rendering methods.
    // The first element is the rendering method to use, the rest are the parameters to pass
    if (oCol.mRender && Array.isArray(oCol.mRender)) {
        var copy = oCol.mRender.slice();
        var name = copy.shift();
        oCol.mRender = $44bb6d473543b89d$var$DataTable.render[name].apply(window, copy);
    }
    oCol._render = oCol.mRender ? $44bb6d473543b89d$var$_fnGetObjectDataFn(oCol.mRender) : null;
    var attrTest = function(src) {
        return typeof src === 'string' && src.indexOf('@') !== -1;
    };
    oCol._bAttrSrc = $44bb6d473543b89d$var$$.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
    oCol._setter = null;
    oCol.fnGetData = function(rowData, type, meta) {
        var innerData = mData(rowData, type, undefined, meta);
        return oCol._render && type ? oCol._render(innerData, type, rowData, meta) : innerData;
    };
    oCol.fnSetData = function(rowData, val, meta) {
        return $44bb6d473543b89d$var$_fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
    };
    // Indicate if DataTables should read DOM data as an object or array
    // Used in _fnGetRowElements
    if (typeof mDataSrc !== 'number' && !oCol._isArrayHost) oSettings._rowReadObject = true;
    /* Feature sorting overrides column specific when off */ if (!oSettings.oFeatures.bSort) oCol.bSortable = false;
}
/**
 * Adjust the table column widths for new data. Note: you would probably want to
 * do a redraw after calling this function!
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings) {
    $44bb6d473543b89d$var$_fnCalculateColumnWidths(settings);
    $44bb6d473543b89d$var$_fnColumnSizes(settings);
    var scroll = settings.oScroll;
    if (scroll.sY !== '' || scroll.sX !== '') $44bb6d473543b89d$var$_fnScrollDraw(settings);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'column-sizing', [
        settings
    ]);
}
/**
 * Apply column sizes
 *
 * @param {*} settings DataTables settings object
 */ function $44bb6d473543b89d$var$_fnColumnSizes(settings) {
    var cols = settings.aoColumns;
    for(var i = 0; i < cols.length; i++){
        var width = $44bb6d473543b89d$var$_fnColumnsSumWidth(settings, [
            i
        ], false, false);
        cols[i].colEl.css('width', width);
        if (settings.oScroll.sX) cols[i].colEl.css('min-width', width);
    }
}
/**
 * Convert the index of a visible column to the index in the data array (take account
 * of hidden columns)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iMatch Visible column index to lookup
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnVisibleToColumnIndex(oSettings, iMatch) {
    var aiVis = $44bb6d473543b89d$var$_fnGetColumns(oSettings, 'bVisible');
    return typeof aiVis[iMatch] === 'number' ? aiVis[iMatch] : null;
}
/**
 * Convert the index of an index in the data array and convert it to the visible
 *   column index (take account of hidden columns)
 *  @param {int} iMatch Column index to lookup
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnColumnIndexToVisible(oSettings, iMatch) {
    var aiVis = $44bb6d473543b89d$var$_fnGetColumns(oSettings, 'bVisible');
    var iPos = aiVis.indexOf(iMatch);
    return iPos !== -1 ? iPos : null;
}
/**
 * Get the number of visible columns
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the number of visible columns
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnVisibleColumns(settings) {
    var layout = settings.aoHeader;
    var columns = settings.aoColumns;
    var vis = 0;
    if (layout.length) {
        for(var i = 0, iLen = layout[0].length; i < iLen; i++)if (columns[i].bVisible && $44bb6d473543b89d$var$$(layout[0][i].cell).css('display') !== 'none') vis++;
    }
    return vis;
}
/**
 * Get an array of column indexes that match a given property
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sParam Parameter in aoColumns to look for - typically
 *    bVisible or bSearchable
 *  @returns {array} Array of indexes with matched properties
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetColumns(oSettings, sParam) {
    var a = [];
    oSettings.aoColumns.map(function(val, i) {
        if (val[sParam]) a.push(i);
    });
    return a;
}
/**
 * Allow the result from a type detection function to be `true` while
 * translating that into a string. Old type detection functions will
 * return the type name if it passes. An object store would be better,
 * but not backwards compatible.
 *
 * @param {*} typeDetect Object or function for type detection
 * @param {*} res Result from the type detection function
 * @returns Type name or false
 */ function $44bb6d473543b89d$var$_typeResult(typeDetect, res) {
    return res === true ? typeDetect._name : res;
}
/**
 * Calculate the 'type' of a column
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnColumnTypes(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var types = $44bb6d473543b89d$var$DataTable.ext.type.detect;
    var i, iLen, j, jen, k, ken;
    var col, detectedType, cache;
    // For each column, spin over the data type detection functions, seeing if one matches
    for(i = 0, iLen = columns.length; i < iLen; i++){
        col = columns[i];
        cache = [];
        if (!col.sType && col._sManualType) col.sType = col._sManualType;
        else if (!col.sType) {
            // With SSP type detection can be unreliable and error prone, so we provide a way
            // to turn it off.
            if (!settings.typeDetect) return;
            for(j = 0, jen = types.length; j < jen; j++){
                var typeDetect = types[j];
                // There can be either one, or three type detection functions
                var oneOf = typeDetect.oneOf;
                var allOf = typeDetect.allOf || typeDetect;
                var init = typeDetect.init;
                var one = false;
                detectedType = null;
                // Fast detect based on column assignment
                if (init) {
                    detectedType = $44bb6d473543b89d$var$_typeResult(typeDetect, init(settings, col, i));
                    if (detectedType) {
                        col.sType = detectedType;
                        break;
                    }
                }
                for(k = 0, ken = data.length; k < ken; k++){
                    if (!data[k]) continue;
                    // Use a cache array so we only need to get the type data
                    // from the formatter once (when using multiple detectors)
                    if (cache[k] === undefined) cache[k] = $44bb6d473543b89d$var$_fnGetCellData(settings, k, i, 'type');
                    // Only one data point in the column needs to match this function
                    if (oneOf && !one) one = $44bb6d473543b89d$var$_typeResult(typeDetect, oneOf(cache[k], settings));
                    // All data points need to match this function
                    detectedType = $44bb6d473543b89d$var$_typeResult(typeDetect, allOf(cache[k], settings));
                    // If null, then this type can't apply to this column, so
                    // rather than testing all cells, break out. There is an
                    // exception for the last type which is `html`. We need to
                    // scan all rows since it is possible to mix string and HTML
                    // types
                    if (!detectedType && j !== types.length - 3) break;
                    // Only a single match is needed for html type since it is
                    // bottom of the pile and very similar to string - but it
                    // must not be empty
                    if (detectedType === 'html' && !$44bb6d473543b89d$var$_empty(cache[k])) break;
                }
                // Type is valid for all data points in the column - use this
                // type
                if (oneOf && one && detectedType || !oneOf && detectedType) {
                    col.sType = detectedType;
                    break;
                }
            }
            // Fall back - if no type was detected, always use string
            if (!col.sType) col.sType = 'string';
        }
        // Set class names for header / footer for auto type classes
        var autoClass = $44bb6d473543b89d$var$_ext.type.className[col.sType];
        if (autoClass) {
            $44bb6d473543b89d$var$_columnAutoClass(settings.aoHeader, i, autoClass);
            $44bb6d473543b89d$var$_columnAutoClass(settings.aoFooter, i, autoClass);
        }
        var renderer = $44bb6d473543b89d$var$_ext.type.render[col.sType];
        // This can only happen once! There is no way to remove
        // a renderer. After the first time the renderer has
        // already been set so createTr will run the renderer itself.
        if (renderer && !col._render) {
            col._render = $44bb6d473543b89d$var$DataTable.util.get(renderer);
            $44bb6d473543b89d$var$_columnAutoRender(settings, i);
        }
    }
}
/**
 * Apply an auto detected renderer to data which doesn't yet have
 * a renderer
 */ function $44bb6d473543b89d$var$_columnAutoRender(settings, colIdx) {
    var data = settings.aoData;
    for(var i = 0; i < data.length; i++)if (data[i].nTr) {
        // We have to update the display here since there is no
        // invalidation check for the data
        var display = $44bb6d473543b89d$var$_fnGetCellData(settings, i, colIdx, 'display');
        data[i].displayData[colIdx] = display;
        $44bb6d473543b89d$var$_fnWriteCell(data[i].anCells[colIdx], display);
    // No need to update sort / filter data since it has
    // been invalidated and will be re-read with the
    // renderer now applied
    }
}
/**
 * Apply a class name to a column's header cells
 */ function $44bb6d473543b89d$var$_columnAutoClass(container, colIdx, className) {
    container.forEach(function(row) {
        if (row[colIdx] && row[colIdx].unique) $44bb6d473543b89d$var$_addClass(row[colIdx].cell, className);
    });
}
/**
 * Take the column definitions and static columns arrays and calculate how
 * they relate to column indexes. The callback function will then apply the
 * definition found for a column to a suitable configuration object.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
 *  @param {array} aoCols The aoColumns array that defines columns individually
 *  @param {array} headerLayout Layout for header as it was loaded
 *  @param {function} fn Callback function - takes two parameters, the calculated
 *    column index and the definition for that column.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnApplyColumnDefs(oSettings, aoColDefs, aoCols, headerLayout, fn) {
    var i, iLen, j, jLen, k, kLen, def;
    var columns = oSettings.aoColumns;
    if (aoCols) {
        for(i = 0, iLen = aoCols.length; i < iLen; i++)if (aoCols[i] && aoCols[i].name) columns[i].sName = aoCols[i].name;
    }
    // Column definitions with aTargets
    if (aoColDefs) /* Loop over the definitions array - loop in reverse so first instance has priority */ for(i = aoColDefs.length - 1; i >= 0; i--){
        def = aoColDefs[i];
        /* Each definition can target multiple columns, as it is an array */ var aTargets = def.target !== undefined ? def.target : def.targets !== undefined ? def.targets : def.aTargets;
        if (!Array.isArray(aTargets)) aTargets = [
            aTargets
        ];
        for(j = 0, jLen = aTargets.length; j < jLen; j++){
            var target = aTargets[j];
            if (typeof target === 'number' && target >= 0) {
                /* Add columns that we don't yet know about */ while(columns.length <= target)$44bb6d473543b89d$var$_fnAddColumn(oSettings);
                /* Integer, basic index */ fn(target, def);
            } else if (typeof target === 'number' && target < 0) /* Negative integer, right to left column counting */ fn(columns.length + target, def);
            else if (typeof target === 'string') for(k = 0, kLen = columns.length; k < kLen; k++){
                if (target === '_all') // Apply to all columns
                fn(k, def);
                else if (target.indexOf(':name') !== -1) // Column selector
                {
                    if (columns[k].sName === target.replace(':name', '')) fn(k, def);
                } else // Cell selector
                headerLayout.forEach(function(row) {
                    if (row[k]) {
                        var cell = $44bb6d473543b89d$var$$(row[k].cell);
                        // Legacy support. Note that it means that we don't support
                        // an element name selector only, since they are treated as
                        // class names for 1.x compat.
                        if (target.match(/^[a-z][\w-]*$/i)) target = '.' + target;
                        if (cell.is(target)) fn(k, def);
                    }
                });
            }
        }
    }
    // Statically defined columns array
    if (aoCols) for(i = 0, iLen = aoCols.length; i < iLen; i++)fn(i, aoCols[i]);
}
/**
 * Get the width for a given set of columns
 *
 * @param {*} settings DataTables settings object
 * @param {*} targets Columns - comma separated string or array of numbers
 * @param {*} original Use the original width (true) or calculated (false)
 * @param {*} incVisible Include visible columns (true) or not (false)
 * @returns Combined CSS value
 */ function $44bb6d473543b89d$var$_fnColumnsSumWidth(settings, targets, original, incVisible) {
    if (!Array.isArray(targets)) targets = $44bb6d473543b89d$var$_fnColumnsFromHeader(targets);
    var sum = 0;
    var unit;
    var columns = settings.aoColumns;
    for(var i = 0, iLen = targets.length; i < iLen; i++){
        var column = columns[targets[i]];
        var definedWidth = original ? column.sWidthOrig : column.sWidth;
        if (!incVisible && column.bVisible === false) continue;
        if (definedWidth === null || definedWidth === undefined) return null; // can't determine a defined width - browser defined
        else if (typeof definedWidth === 'number') {
            unit = 'px';
            sum += definedWidth;
        } else {
            var matched = definedWidth.match(/([\d\.]+)([^\d]*)/);
            if (matched) {
                sum += matched[1] * 1;
                unit = matched.length === 3 ? matched[2] : 'px';
            }
        }
    }
    return sum + unit;
}
function $44bb6d473543b89d$var$_fnColumnsFromHeader(cell) {
    var attr = $44bb6d473543b89d$var$$(cell).closest('[data-dt-column]').attr('data-dt-column');
    if (!attr) return [];
    return attr.split(',').map(function(val) {
        return val * 1;
    });
}
/**
 * Add a data array to the table, creating DOM node etc. This is the parallel to
 * _fnGatherData, but for adding rows from a JavaScript source, rather than a
 * DOM source.
 *  @param {object} settings dataTables settings object
 *  @param {array} data data array to be added
 *  @param {node} [tr] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [tds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddData(settings, dataIn, tr, tds) {
    /* Create the object for storing information about this new row */ var rowIdx = settings.aoData.length;
    var rowModel = $44bb6d473543b89d$var$$.extend(true, {}, $44bb6d473543b89d$var$DataTable.models.oRow, {
        src: tr ? 'dom' : 'data',
        idx: rowIdx
    });
    rowModel._aData = dataIn;
    settings.aoData.push(rowModel);
    var columns = settings.aoColumns;
    for(var i = 0, iLen = columns.length; i < iLen; i++)// Invalidate the column types as the new data needs to be revalidated
    columns[i].sType = null;
    /* Add to the display array */ settings.aiDisplayMaster.push(rowIdx);
    var id = settings.rowIdFn(dataIn);
    if (id !== undefined) settings.aIds[id] = rowModel;
    /* Create the DOM information, or register it if already present */ if (tr || !settings.oFeatures.bDeferRender) $44bb6d473543b89d$var$_fnCreateTr(settings, rowIdx, tr, tds);
    return rowIdx;
}
/**
 * Add one or more TR elements to the table. Generally we'd expect to
 * use this for reading data from a DOM sourced table, but it could be
 * used for an TR element. Note that if a TR is given, it is used (i.e.
 * it is not cloned).
 *  @param {object} settings dataTables settings object
 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
 *  @returns {array} Array of indexes for the added rows
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddTr(settings, trs) {
    var row;
    // Allow an individual node to be passed in
    if (!(trs instanceof $44bb6d473543b89d$var$$)) trs = $44bb6d473543b89d$var$$(trs);
    return trs.map(function(i, el) {
        row = $44bb6d473543b89d$var$_fnGetRowElements(settings, el);
        return $44bb6d473543b89d$var$_fnAddData(settings, row.data, el, row.cells);
    });
}
/**
 * Get the data for a given cell from the internal cache, taking into account data mapping
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
 *  @returns {*} Cell data
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, colIdx, type) {
    if (type === 'search') type = 'filter';
    else if (type === 'order') type = 'sort';
    var row = settings.aoData[rowIdx];
    if (!row) return undefined;
    var draw = settings.iDraw;
    var col = settings.aoColumns[colIdx];
    var rowData = row._aData;
    var defaultContent = col.sDefaultContent;
    var cellData = col.fnGetData(rowData, type, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
    // Allow for a node being returned for non-display types
    if (type !== 'display' && cellData && typeof cellData === 'object' && cellData.nodeName) cellData = cellData.innerHTML;
    if (cellData === undefined) {
        if (settings.iDrawError != draw && defaultContent === null) {
            $44bb6d473543b89d$var$_fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == 'function' ? '{function}' : "'" + col.mData + "'") + " for row " + rowIdx + ", column " + colIdx, 4);
            settings.iDrawError = draw;
        }
        return defaultContent;
    }
    // When the data source is null and a specific data type is requested (i.e.
    // not the original data), we can use default column data
    if ((cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined) cellData = defaultContent;
    else if (typeof cellData === 'function') // If the data source is a function, then we run it and use the return,
    // executing in the scope of the data object (for instances)
    return cellData.call(rowData);
    if (cellData === null && type === 'display') return '';
    if (type === 'filter') {
        var formatters = $44bb6d473543b89d$var$DataTable.ext.type.search;
        if (formatters[col.sType]) cellData = formatters[col.sType](cellData);
    }
    return cellData;
}
/**
 * Set the value for a specific cell, into the internal data cache
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {*} val Value to set
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSetCellData(settings, rowIdx, colIdx, val) {
    var col = settings.aoColumns[colIdx];
    var rowData = settings.aoData[rowIdx]._aData;
    col.fnSetData(rowData, val, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
}
/**
 * Write a value to a cell
 * @param {*} td Cell
 * @param {*} val Value
 */ function $44bb6d473543b89d$var$_fnWriteCell(td, val) {
    if (val && typeof val === 'object' && val.nodeName) $44bb6d473543b89d$var$$(td).empty().append(val);
    else td.innerHTML = val;
}
// Private variable that is used to match action syntax in the data property object
var $44bb6d473543b89d$var$__reArray = /\[.*?\]$/;
var $44bb6d473543b89d$var$__reFn = /\(\)$/;
/**
 * Split string on periods, taking into account escaped periods
 * @param  {string} str String to split
 * @return {array} Split string
 */ function $44bb6d473543b89d$var$_fnSplitObjNotation(str) {
    var parts = str.match(/(\\.|[^.])+/g) || [
        ''
    ];
    return parts.map(function(s) {
        return s.replace(/\\\./g, '.');
    });
}
/**
 * Return a function that can be used to get data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data get function
 *  @memberof DataTable#oApi
 */ var $44bb6d473543b89d$var$_fnGetObjectDataFn = $44bb6d473543b89d$var$DataTable.util.get;
/**
 * Return a function that can be used to set data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data set function
 *  @memberof DataTable#oApi
 */ var $44bb6d473543b89d$var$_fnSetObjectDataFn = $44bb6d473543b89d$var$DataTable.util.set;
/**
 * Return an array with the full table data
 *  @param {object} oSettings dataTables settings object
 *  @returns array {array} aData Master data array
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetDataMaster(settings) {
    return $44bb6d473543b89d$var$_pluck(settings.aoData, '_aData');
}
/**
 * Nuke the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnClearTable(settings) {
    settings.aoData.length = 0;
    settings.aiDisplayMaster.length = 0;
    settings.aiDisplay.length = 0;
    settings.aIds = {};
}
/**
 * Mark cached data as invalid such that a re-read of the data will occur when
 * the cached data is next requested. Also update from the data source object.
 *
 * @param {object} settings DataTables settings object
 * @param {int}    rowIdx   Row index to invalidate
 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
 *     or 'data'
 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
 *     row will be invalidated
 * @memberof DataTable#oApi
 *
 * @todo For the modularisation of v1.11 this will need to become a callback, so
 *   the sort and filter methods can subscribe to it. That will required
 *   initialisation options for sorting, which is why it is not already baked in
 */ function $44bb6d473543b89d$var$_fnInvalidate(settings, rowIdx, src, colIdx) {
    var row = settings.aoData[rowIdx];
    var i, iLen;
    // Remove the cached data for the row
    row._aSortData = null;
    row._aFilterData = null;
    row.displayData = null;
    // Are we reading last data from DOM or the data object?
    if (src === 'dom' || (!src || src === 'auto') && row.src === 'dom') // Read the data from the DOM
    row._aData = $44bb6d473543b89d$var$_fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
    else {
        // Reading from data object, update the DOM
        var cells = row.anCells;
        var display = $44bb6d473543b89d$var$_fnGetRowDisplay(settings, rowIdx);
        if (cells) {
            if (colIdx !== undefined) $44bb6d473543b89d$var$_fnWriteCell(cells[colIdx], display[colIdx]);
            else for(i = 0, iLen = cells.length; i < iLen; i++)$44bb6d473543b89d$var$_fnWriteCell(cells[i], display[i]);
        }
    }
    // Column specific invalidation
    var cols = settings.aoColumns;
    if (colIdx !== undefined) {
        // Type - the data might have changed
        cols[colIdx].sType = null;
        // Max length string. Its a fairly cheep recalculation, so not worth
        // something more complicated
        cols[colIdx].wideStrings = null;
    } else {
        for(i = 0, iLen = cols.length; i < iLen; i++){
            cols[i].sType = null;
            cols[i].wideStrings = null;
        }
        // Update DataTables special `DT_*` attributes for the row
        $44bb6d473543b89d$var$_fnRowAttributes(settings, row);
    }
}
/**
 * Build a data source object from an HTML row, reading the contents of the
 * cells that are in the row.
 *
 * @param {object} settings DataTables settings object
 * @param {node|object} TR element from which to read data or existing row
 *   object from which to re-read the data from the cells
 * @param {int} [colIdx] Optional column index
 * @param {array|object} [d] Data source object. If `colIdx` is given then this
 *   parameter should also be given and will be used to write the data into.
 *   Only the column in question will be written
 * @returns {object} Object with two parameters: `data` the data read, in
 *   document order, and `cells` and array of nodes (they can be useful to the
 *   caller, so rather than needing a second traversal to get them, just return
 *   them from here).
 * @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetRowElements(settings, row, colIdx, d) {
    var tds = [], td = row.firstChild, name, col, i = 0, contents, columns = settings.aoColumns, objectRead = settings._rowReadObject;
    // Allow the data object to be passed in, or construct
    d = d !== undefined ? d : objectRead ? {} : [];
    var attr = function(str, td) {
        if (typeof str === 'string') {
            var idx = str.indexOf('@');
            if (idx !== -1) {
                var attr = str.substring(idx + 1);
                var setter = $44bb6d473543b89d$var$_fnSetObjectDataFn(str);
                setter(d, td.getAttribute(attr));
            }
        }
    };
    // Read data from a cell and store into the data object
    var cellProcess = function(cell) {
        if (colIdx === undefined || colIdx === i) {
            col = columns[i];
            contents = cell.innerHTML.trim();
            if (col && col._bAttrSrc) {
                var setter = $44bb6d473543b89d$var$_fnSetObjectDataFn(col.mData._);
                setter(d, contents);
                attr(col.mData.sort, cell);
                attr(col.mData.type, cell);
                attr(col.mData.filter, cell);
            } else // Depending on the `data` option for the columns the data can
            // be read to either an object or an array.
            if (objectRead) {
                if (!col._setter) // Cache the setter function
                col._setter = $44bb6d473543b89d$var$_fnSetObjectDataFn(col.mData);
                col._setter(d, contents);
            } else d[i] = contents;
        }
        i++;
    };
    if (td) // `tr` element was passed in
    while(td){
        name = td.nodeName.toUpperCase();
        if (name == "TD" || name == "TH") {
            cellProcess(td);
            tds.push(td);
        }
        td = td.nextSibling;
    }
    else {
        // Existing row object passed in
        tds = row.anCells;
        for(var j = 0, jen = tds.length; j < jen; j++)cellProcess(tds[j]);
    }
    // Read the ID from the DOM if present
    var rowNode = row.firstChild ? row : row.nTr;
    if (rowNode) {
        var id = rowNode.getAttribute('id');
        if (id) $44bb6d473543b89d$var$_fnSetObjectDataFn(settings.rowId)(d, id);
    }
    return {
        data: d,
        cells: tds
    };
}
/**
 * Render and cache a row's display data for the columns, if required
 * @returns 
 */ function $44bb6d473543b89d$var$_fnGetRowDisplay(settings, rowIdx) {
    var rowModal = settings.aoData[rowIdx];
    var columns = settings.aoColumns;
    if (!rowModal.displayData) {
        // Need to render and cache
        rowModal.displayData = [];
        for(var colIdx = 0, len = columns.length; colIdx < len; colIdx++)rowModal.displayData.push($44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, colIdx, 'display'));
    }
    return rowModal.displayData;
}
/**
 * Create a new TR element (and it's TD children) for a row
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow Row to consider
 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCreateTr(oSettings, iRow, nTrIn, anTds) {
    var row = oSettings.aoData[iRow], rowData = row._aData, cells = [], nTr, nTd, oCol, i, iLen, create, trClass = oSettings.oClasses.tbody.row;
    if (row.nTr === null) {
        nTr = nTrIn || document.createElement('tr');
        row.nTr = nTr;
        row.anCells = cells;
        $44bb6d473543b89d$var$_addClass(nTr, trClass);
        /* Use a private property on the node to allow reserve mapping from the node
		 * to the aoData array for fast look up
		 */ nTr._DT_RowIndex = iRow;
        /* Special parameters can be given by the data source to be used on the row */ $44bb6d473543b89d$var$_fnRowAttributes(oSettings, row);
        /* Process each column */ for(i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++){
            oCol = oSettings.aoColumns[i];
            create = nTrIn && anTds[i] ? false : true;
            nTd = create ? document.createElement(oCol.sCellType) : anTds[i];
            if (!nTd) $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Incorrect column count', 18);
            nTd._DT_CellIndex = {
                row: iRow,
                column: i
            };
            cells.push(nTd);
            var display = $44bb6d473543b89d$var$_fnGetRowDisplay(oSettings, iRow);
            // Need to create the HTML if new, or if a rendering function is defined
            if (create || (oCol.mRender || oCol.mData !== i) && (!$44bb6d473543b89d$var$$.isPlainObject(oCol.mData) || oCol.mData._ !== i + '.display')) $44bb6d473543b89d$var$_fnWriteCell(nTd, display[i]);
            // column class
            $44bb6d473543b89d$var$_addClass(nTd, oCol.sClass);
            // Visibility - add or remove as required
            if (oCol.bVisible && create) nTr.appendChild(nTd);
            else if (!oCol.bVisible && !create) nTd.parentNode.removeChild(nTd);
            if (oCol.fnCreatedCell) oCol.fnCreatedCell.call(oSettings.oInstance, nTd, $44bb6d473543b89d$var$_fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
        }
        $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoRowCreatedCallback', 'row-created', [
            nTr,
            rowData,
            iRow,
            cells
        ]);
    } else $44bb6d473543b89d$var$_addClass(row.nTr, trClass);
}
/**
 * Add attributes to a row based on the special `DT_*` parameters in a data
 * source object.
 *  @param {object} settings DataTables settings object
 *  @param {object} DataTables row object for the row to be modified
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnRowAttributes(settings, row) {
    var tr = row.nTr;
    var data = row._aData;
    if (tr) {
        var id = settings.rowIdFn(data);
        if (id) tr.id = id;
        if (data.DT_RowClass) {
            // Remove any classes added by DT_RowClass before
            var a = data.DT_RowClass.split(' ');
            row.__rowc = row.__rowc ? $44bb6d473543b89d$var$_unique(row.__rowc.concat(a)) : a;
            $44bb6d473543b89d$var$$(tr).removeClass(row.__rowc.join(' ')).addClass(data.DT_RowClass);
        }
        if (data.DT_RowAttr) $44bb6d473543b89d$var$$(tr).attr(data.DT_RowAttr);
        if (data.DT_RowData) $44bb6d473543b89d$var$$(tr).data(data.DT_RowData);
    }
}
/**
 * Create the HTML header for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnBuildHead(settings, side) {
    var classes = settings.oClasses;
    var columns = settings.aoColumns;
    var i, iLen, row;
    var target = side === 'header' ? settings.nTHead : settings.nTFoot;
    var titleProp = side === 'header' ? 'sTitle' : side;
    // Footer might be defined
    if (!target) return;
    // If no cells yet and we have content for them, then create
    if (side === 'header' || $44bb6d473543b89d$var$_pluck(settings.aoColumns, titleProp).join('')) {
        row = $44bb6d473543b89d$var$$('tr', target);
        // Add a row if needed
        if (!row.length) row = $44bb6d473543b89d$var$$('<tr/>').appendTo(target);
        // Add the number of cells needed to make up to the number of columns
        if (row.length === 1) {
            var cellCount = 0;
            $44bb6d473543b89d$var$$('td, th', row).each(function() {
                cellCount += this.colSpan;
            });
            for(i = cellCount, iLen = columns.length; i < iLen; i++)$44bb6d473543b89d$var$$('<th/>').html(columns[i][titleProp] || '').appendTo(row);
        }
    }
    var detected = $44bb6d473543b89d$var$_fnDetectHeader(settings, target, true);
    if (side === 'header') {
        settings.aoHeader = detected;
        $44bb6d473543b89d$var$$('tr', target).addClass(classes.thead.row);
    } else {
        settings.aoFooter = detected;
        $44bb6d473543b89d$var$$('tr', target).addClass(classes.tfoot.row);
    }
    // Every cell needs to be passed through the renderer
    $44bb6d473543b89d$var$$(target).children('tr').children('th, td').each(function() {
        $44bb6d473543b89d$var$_fnRenderer(settings, side)(settings, $44bb6d473543b89d$var$$(this), classes);
    });
}
/**
 * Build a layout structure for a header or footer
 *
 * @param {*} settings DataTables settings
 * @param {*} source Source layout array
 * @param {*} incColumns What columns should be included
 * @returns Layout array in column index order
 */ function $44bb6d473543b89d$var$_fnHeaderLayout(settings, source, incColumns) {
    var row, column, cell;
    var local = [];
    var structure = [];
    var columns = settings.aoColumns;
    var columnCount = columns.length;
    var rowspan, colspan;
    if (!source) return;
    // Default is to work on only visible columns
    if (!incColumns) incColumns = $44bb6d473543b89d$var$_range(columnCount).filter(function(idx) {
        return columns[idx].bVisible;
    });
    // Make a copy of the master layout array, but with only the columns we want
    for(row = 0; row < source.length; row++){
        // Remove any columns we haven't selected
        local[row] = source[row].slice().filter(function(cell, i) {
            return incColumns.includes(i);
        });
        // Prep the structure array - it needs an element for each row
        structure.push([]);
    }
    for(row = 0; row < local.length; row++)for(column = 0; column < local[row].length; column++){
        rowspan = 1;
        colspan = 1;
        // Check to see if there is already a cell (row/colspan) covering our target
        // insert point. If there is, then there is nothing to do.
        if (structure[row][column] === undefined) {
            cell = local[row][column].cell;
            // Expand for rowspan
            while(local[row + rowspan] !== undefined && local[row][column].cell == local[row + rowspan][column].cell){
                structure[row + rowspan][column] = null;
                rowspan++;
            }
            // And for colspan
            while(local[row][column + colspan] !== undefined && local[row][column].cell == local[row][column + colspan].cell){
                // Which also needs to go over rows
                for(var k = 0; k < rowspan; k++)structure[row + k][column + colspan] = null;
                colspan++;
            }
            var titleSpan = $44bb6d473543b89d$var$$('.dt-column-title', cell);
            structure[row][column] = {
                cell: cell,
                colspan: colspan,
                rowspan: rowspan,
                title: titleSpan.length ? titleSpan.html() : $44bb6d473543b89d$var$$(cell).html()
            };
        }
    }
    return structure;
}
/**
 * Draw the header (or footer) element based on the column visibility states.
 *
 *  @param object oSettings dataTables settings object
 *  @param array aoSource Layout array from _fnDetectHeader
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDrawHead(settings, source) {
    var layout = $44bb6d473543b89d$var$_fnHeaderLayout(settings, source);
    var tr, n;
    for(var row = 0; row < source.length; row++){
        tr = source[row].row;
        // All cells are going to be replaced, so empty out the row
        // Can't use $().empty() as that kills event handlers
        if (tr) while(n = tr.firstChild)tr.removeChild(n);
        for(var column = 0; column < layout[row].length; column++){
            var point = layout[row][column];
            if (point) $44bb6d473543b89d$var$$(point.cell).appendTo(tr).attr('rowspan', point.rowspan).attr('colspan', point.colspan);
        }
    }
}
/**
 * Insert the required TR nodes into the table for display
 *  @param {object} oSettings dataTables settings object
 *  @param ajaxComplete true after ajax call to complete rendering
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDraw(oSettings, ajaxComplete) {
    // Allow for state saving and a custom start position
    $44bb6d473543b89d$var$_fnStart(oSettings);
    /* Provide a pre-callback function which can be used to cancel the draw is false is returned */ var aPreDraw = $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoPreDrawCallback', 'preDraw', [
        oSettings
    ]);
    if (aPreDraw.indexOf(false) !== -1) {
        $44bb6d473543b89d$var$_fnProcessingDisplay(oSettings, false);
        return;
    }
    var anRows = [];
    var iRowCount = 0;
    var bServerSide = $44bb6d473543b89d$var$_fnDataSource(oSettings) == 'ssp';
    var aiDisplay = oSettings.aiDisplay;
    var iDisplayStart = oSettings._iDisplayStart;
    var iDisplayEnd = oSettings.fnDisplayEnd();
    var columns = oSettings.aoColumns;
    var body = $44bb6d473543b89d$var$$(oSettings.nTBody);
    oSettings.bDrawing = true;
    /* Server-side processing draw intercept */ if (oSettings.deferLoading) {
        oSettings.deferLoading = false;
        oSettings.iDraw++;
        $44bb6d473543b89d$var$_fnProcessingDisplay(oSettings, false);
    } else if (!bServerSide) oSettings.iDraw++;
    else if (!oSettings.bDestroying && !ajaxComplete) {
        // Show loading message for server-side processing
        if (oSettings.iDraw === 0) body.empty().append($44bb6d473543b89d$var$_emptyRow(oSettings));
        $44bb6d473543b89d$var$_fnAjaxUpdate(oSettings);
        return;
    }
    if (aiDisplay.length !== 0) {
        var iStart = bServerSide ? 0 : iDisplayStart;
        var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
        for(var j = iStart; j < iEnd; j++){
            var iDataIndex = aiDisplay[j];
            var aoData = oSettings.aoData[iDataIndex];
            // Row has been deleted - can't be displayed
            if (aoData === null) continue;
            // Row node hasn't been created yet
            if (aoData.nTr === null) $44bb6d473543b89d$var$_fnCreateTr(oSettings, iDataIndex);
            var nRow = aoData.nTr;
            // Add various classes as needed
            for(var i = 0; i < columns.length; i++){
                var col = columns[i];
                var td = aoData.anCells[i];
                $44bb6d473543b89d$var$_addClass(td, $44bb6d473543b89d$var$_ext.type.className[col.sType]); // auto class
                $44bb6d473543b89d$var$_addClass(td, oSettings.oClasses.tbody.cell); // all cells
            }
            // Row callback functions - might want to manipulate the row
            // iRowCount and j are not currently documented. Are they at all
            // useful?
            $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoRowCallback', null, [
                nRow,
                aoData._aData,
                iRowCount,
                j,
                iDataIndex
            ]);
            anRows.push(nRow);
            iRowCount++;
        }
    } else anRows[0] = $44bb6d473543b89d$var$_emptyRow(oSettings);
    /* Header and footer callbacks */ $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoHeaderCallback', 'header', [
        $44bb6d473543b89d$var$$(oSettings.nTHead).children('tr')[0],
        $44bb6d473543b89d$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoFooterCallback', 'footer', [
        $44bb6d473543b89d$var$$(oSettings.nTFoot).children('tr')[0],
        $44bb6d473543b89d$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    // replaceChildren is faster, but only became widespread in 2020,
    // so a fall back in jQuery is provided for older browsers.
    if (body[0].replaceChildren) body[0].replaceChildren.apply(body[0], anRows);
    else {
        body.children().detach();
        body.append($44bb6d473543b89d$var$$(anRows));
    }
    // Empty table needs a specific class
    $44bb6d473543b89d$var$$(oSettings.nTableWrapper).toggleClass('dt-empty-footer', $44bb6d473543b89d$var$$('tr', oSettings.nTFoot).length === 0);
    /* Call all required callback functions for the end of a draw */ $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoDrawCallback', 'draw', [
        oSettings
    ], true);
    /* Draw is complete, sorting and filtering must be as well */ oSettings.bSorted = false;
    oSettings.bFiltered = false;
    oSettings.bDrawing = false;
}
/**
 * Redraw the table - taking account of the various features which are enabled
 *  @param {object} oSettings dataTables settings object
 *  @param {boolean} [holdPosition] Keep the current paging position. By default
 *    the paging is reset to the first page
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnReDraw(settings, holdPosition, recompute) {
    var features = settings.oFeatures, sort = features.bSort, filter = features.bFilter;
    if (recompute === undefined || recompute === true) {
        // Resolve any column types that are unknown due to addition or invalidation
        $44bb6d473543b89d$var$_fnColumnTypes(settings);
        if (sort) $44bb6d473543b89d$var$_fnSort(settings);
        if (filter) $44bb6d473543b89d$var$_fnFilterComplete(settings, settings.oPreviousSearch);
        else // No filtering, so we want to just use the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
    }
    if (holdPosition !== true) settings._iDisplayStart = 0;
    else // Keep position, but make sure that there is actually data to display,
    // otherwise we need to rewind a bit (e.g. if rows were deleted)
    $44bb6d473543b89d$var$_fnLengthOverflow(settings);
    // Let any modules know about the draw hold position state (used by
    // scrolling internally)
    settings._drawHold = holdPosition;
    $44bb6d473543b89d$var$_fnDraw(settings);
    settings.api.one('draw', function() {
        settings._drawHold = false;
    });
}
/*
 * Table is empty - create a row with an empty message in it
 */ function $44bb6d473543b89d$var$_emptyRow(settings) {
    var oLang = settings.oLanguage;
    var zero = oLang.sZeroRecords;
    var dataSrc = $44bb6d473543b89d$var$_fnDataSource(settings);
    // Make use of the fact that settings.json is only set once the initial data has
    // been loaded. Show loading when that isn't the case
    if ((dataSrc === 'ssp' || dataSrc === 'ajax') && !settings.json) zero = oLang.sLoadingRecords;
    else if (oLang.sEmptyTable && settings.fnRecordsTotal() === 0) zero = oLang.sEmptyTable;
    return $44bb6d473543b89d$var$$('<tr/>').append($44bb6d473543b89d$var$$('<td />', {
        'colSpan': $44bb6d473543b89d$var$_fnVisibleColumns(settings),
        'class': settings.oClasses.empty.row
    }).html(zero))[0];
}
/**
 * Expand the layout items into an object for the rendering function
 */ function $44bb6d473543b89d$var$_layoutItems(row, align, items) {
    if (Array.isArray(items)) {
        for(var i = 0; i < items.length; i++)$44bb6d473543b89d$var$_layoutItems(row, align, items[i]);
        return;
    }
    var rowCell = row[align];
    // If it is an object, then there can be multiple features contained in it
    if ($44bb6d473543b89d$var$$.isPlainObject(items)) {
        // A feature plugin cannot be named "features" due to this check
        if (items.features) {
            if (items.rowId) row.id = items.rowId;
            if (items.rowClass) row.className = items.rowClass;
            rowCell.id = items.id;
            rowCell.className = items.className;
            $44bb6d473543b89d$var$_layoutItems(row, align, items.features);
        } else Object.keys(items).map(function(key) {
            rowCell.contents.push({
                feature: key,
                opts: items[key]
            });
        });
    } else rowCell.contents.push(items);
}
/**
 * Find, or create a layout row
 */ function $44bb6d473543b89d$var$_layoutGetRow(rows, rowNum, align) {
    var row;
    // Find existing rows
    for(var i = 0; i < rows.length; i++){
        row = rows[i];
        if (row.rowNum === rowNum) // full is on its own, but start and end share a row
        {
            if (align === 'full' && row.full || (align === 'start' || align === 'end') && (row.start || row.end)) {
                if (!row[align]) row[align] = {
                    contents: []
                };
                return row;
            }
        }
    }
    // If we get this far, then there was no match, create a new row
    row = {
        rowNum: rowNum
    };
    row[align] = {
        contents: []
    };
    rows.push(row);
    return row;
}
/**
 * Convert a `layout` object given by a user to the object structure needed
 * for the renderer. This is done twice, once for above and once for below
 * the table. Ordering must also be considered.
 *
 * @param {*} settings DataTables settings object
 * @param {*} layout Layout object to convert
 * @param {string} side `top` or `bottom`
 * @returns Converted array structure - one item for each row.
 */ function $44bb6d473543b89d$var$_layoutArray(settings, layout, side) {
    var rows = [];
    // Split out into an array
    $44bb6d473543b89d$var$$.each(layout, function(pos, items) {
        if (items === null) return;
        var parts = pos.match(/^([a-z]+)([0-9]*)([A-Za-z]*)$/);
        var rowNum = parts[2] ? parts[2] * 1 : 0;
        var align = parts[3] ? parts[3].toLowerCase() : 'full';
        // Filter out the side we aren't interested in
        if (parts[1] !== side) return;
        // Get or create the row we should attach to
        var row = $44bb6d473543b89d$var$_layoutGetRow(rows, rowNum, align);
        $44bb6d473543b89d$var$_layoutItems(row, align, items);
    });
    // Order by item identifier
    rows.sort(function(a, b) {
        var order1 = a.rowNum;
        var order2 = b.rowNum;
        // If both in the same row, then the row with `full` comes first
        if (order1 === order2) {
            var ret = a.full && !b.full ? -1 : 1;
            return side === 'bottom' ? ret * -1 : ret;
        }
        return order2 - order1;
    });
    // Invert for below the table
    if (side === 'bottom') rows.reverse();
    for(var row = 0; row < rows.length; row++){
        delete rows[row].rowNum;
        $44bb6d473543b89d$var$_layoutResolve(settings, rows[row]);
    }
    return rows;
}
/**
 * Convert the contents of a row's layout object to nodes that can be inserted
 * into the document by a renderer. Execute functions, look up plug-ins, etc.
 *
 * @param {*} settings DataTables settings object
 * @param {*} row Layout object for this row
 */ function $44bb6d473543b89d$var$_layoutResolve(settings, row) {
    var getFeature = function(feature, opts) {
        if (!$44bb6d473543b89d$var$_ext.features[feature]) $44bb6d473543b89d$var$_fnLog(settings, 0, 'Unknown feature: ' + feature);
        return $44bb6d473543b89d$var$_ext.features[feature].apply(this, [
            settings,
            opts
        ]);
    };
    var resolve = function(item) {
        if (!row[item]) return;
        var line = row[item].contents;
        for(var i = 0, iLen = line.length; i < iLen; i++){
            if (!line[i]) continue;
            else if (typeof line[i] === 'string') line[i] = getFeature(line[i], null);
            else if ($44bb6d473543b89d$var$$.isPlainObject(line[i])) // If it's an object, it just has feature and opts properties from
            // the transform in _layoutArray
            line[i] = getFeature(line[i].feature, line[i].opts);
            else if (typeof line[i].node === 'function') line[i] = line[i].node(settings);
            else if (typeof line[i] === 'function') {
                var inst = line[i](settings);
                line[i] = typeof inst.node === 'function' ? inst.node() : inst;
            }
        }
    };
    resolve('start');
    resolve('end');
    resolve('full');
}
/**
 * Add the options to the page HTML for the table
 *  @param {object} settings DataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddOptionsHtml(settings) {
    var classes = settings.oClasses;
    var table = $44bb6d473543b89d$var$$(settings.nTable);
    // Wrapper div around everything DataTables controls
    var insert = $44bb6d473543b89d$var$$('<div/>').attr({
        id: settings.sTableId + '_wrapper',
        'class': classes.container
    }).insertBefore(table);
    settings.nTableWrapper = insert[0];
    if (settings.sDom) // Legacy
    $44bb6d473543b89d$var$_fnLayoutDom(settings, settings.sDom, insert);
    else {
        var top = $44bb6d473543b89d$var$_layoutArray(settings, settings.layout, 'top');
        var bottom = $44bb6d473543b89d$var$_layoutArray(settings, settings.layout, 'bottom');
        var renderer = $44bb6d473543b89d$var$_fnRenderer(settings, 'layout');
        // Everything above - the renderer will actually insert the contents into the document
        top.forEach(function(item) {
            renderer(settings, insert, item);
        });
        // The table - always the center of attention
        renderer(settings, insert, {
            full: {
                table: true,
                contents: [
                    $44bb6d473543b89d$var$_fnFeatureHtmlTable(settings)
                ]
            }
        });
        // Everything below
        bottom.forEach(function(item) {
            renderer(settings, insert, item);
        });
    }
    // Processing floats on top, so it isn't an inserted feature
    $44bb6d473543b89d$var$_processingHtml(settings);
}
/**
 * Draw the table with the legacy DOM property
 * @param {*} settings DT settings object
 * @param {*} dom DOM string
 * @param {*} insert Insert point
 */ function $44bb6d473543b89d$var$_fnLayoutDom(settings, dom, insert) {
    var parts = dom.match(/(".*?")|('.*?')|./g);
    var featureNode, option, newNode, next, attr;
    for(var i = 0; i < parts.length; i++){
        featureNode = null;
        option = parts[i];
        if (option == '<') {
            // New container div
            newNode = $44bb6d473543b89d$var$$('<div/>');
            // Check to see if we should append an id and/or a class name to the container
            next = parts[i + 1];
            if (next[0] == "'" || next[0] == '"') {
                attr = next.replace(/['"]/g, '');
                var id = '', className;
                /* The attribute can be in the format of "#id.class", "#id" or "class" This logic
				 * breaks the string into parts and applies them as needed
				 */ if (attr.indexOf('.') != -1) {
                    var split = attr.split('.');
                    id = split[0];
                    className = split[1];
                } else if (attr[0] == "#") id = attr;
                else className = attr;
                newNode.attr('id', id.substring(1)).addClass(className);
                i++; // Move along the position array
            }
            insert.append(newNode);
            insert = newNode;
        } else if (option == '>') // End container div
        insert = insert.parent();
        else if (option == 't') // Table
        featureNode = $44bb6d473543b89d$var$_fnFeatureHtmlTable(settings);
        else $44bb6d473543b89d$var$DataTable.ext.feature.forEach(function(feature) {
            if (option == feature.cFeature) featureNode = feature.fnInit(settings);
        });
        // Add to the display
        if (featureNode) insert.append(featureNode);
    }
}
/**
 * Use the DOM source to create up an array of header cells. The idea here is to
 * create a layout grid (array) of rows x columns, which contains a reference
 * to the cell at that point in the grid (regardless of col/rowspan), such that
 * any column / row could be removed and the new grid constructed
 *  @param {node} thead The header/footer element for the table
 *  @returns {array} Calculated layout array
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDetectHeader(settings, thead, write) {
    var columns = settings.aoColumns;
    var rows = $44bb6d473543b89d$var$$(thead).children('tr');
    var row, cell;
    var i, k, l, iLen, shifted, column, colspan, rowspan;
    var titleRow = settings.titleRow;
    var isHeader = thead && thead.nodeName.toLowerCase() === 'thead';
    var layout = [];
    var unique;
    var shift = function(a, i, j) {
        var k = a[i];
        while(k[j])j++;
        return j;
    };
    // We know how many rows there are in the layout - so prep it
    for(i = 0, iLen = rows.length; i < iLen; i++)layout.push([]);
    for(i = 0, iLen = rows.length; i < iLen; i++){
        row = rows[i];
        column = 0;
        // For every cell in the row..
        cell = row.firstChild;
        while(cell){
            if (cell.nodeName.toUpperCase() == 'TD' || cell.nodeName.toUpperCase() == 'TH') {
                var cols = [];
                var jqCell = $44bb6d473543b89d$var$$(cell);
                // Get the col and rowspan attributes from the DOM and sanitise them
                colspan = cell.getAttribute('colspan') * 1;
                rowspan = cell.getAttribute('rowspan') * 1;
                colspan = !colspan || colspan === 0 || colspan === 1 ? 1 : colspan;
                rowspan = !rowspan || rowspan === 0 || rowspan === 1 ? 1 : rowspan;
                // There might be colspan cells already in this row, so shift our target
                // accordingly
                shifted = shift(layout, i, column);
                // Cache calculation for unique columns
                unique = colspan === 1 ? true : false;
                // Perform header setup
                if (write) {
                    if (unique) {
                        // Allow column options to be set from HTML attributes
                        $44bb6d473543b89d$var$_fnColumnOptions(settings, shifted, $44bb6d473543b89d$var$_fnEscapeObject(jqCell.data()));
                        // Get the width for the column. This can be defined from the
                        // width attribute, style attribute or `columns.width` option
                        var columnDef = columns[shifted];
                        var width = cell.getAttribute('width') || null;
                        var t = cell.style.width.match(/width:\s*(\d+[pxem%]+)/);
                        if (t) width = t[1];
                        columnDef.sWidthOrig = columnDef.sWidth || width;
                        if (isHeader) {
                            // Column title handling - can be user set, or read from the DOM
                            // This happens before the render, so the original is still in place
                            if (columnDef.sTitle !== null && !columnDef.autoTitle) {
                                if (titleRow === true && i === 0 || // top row
                                titleRow === false && i === rows.length - 1 || // bottom row
                                titleRow === i || // specific row
                                titleRow === null) cell.innerHTML = columnDef.sTitle;
                            }
                            if (!columnDef.sTitle && unique) {
                                columnDef.sTitle = $44bb6d473543b89d$var$_stripHtml(cell.innerHTML);
                                columnDef.autoTitle = true;
                            }
                        } else // Footer specific operations
                        if (columnDef.footer) cell.innerHTML = columnDef.footer;
                        // Fall back to the aria-label attribute on the table header if no ariaTitle is
                        // provided.
                        if (!columnDef.ariaTitle) columnDef.ariaTitle = jqCell.attr("aria-label") || columnDef.sTitle;
                        // Column specific class names
                        if (columnDef.className) jqCell.addClass(columnDef.className);
                    }
                    // Wrap the column title so we can write to it in future
                    if ($44bb6d473543b89d$var$$('.dt-column-title', cell).length === 0) $44bb6d473543b89d$var$$(document.createElement(settings.columnTitleTag)).addClass('dt-column-title').append(cell.childNodes).appendTo(cell);
                    if (settings.orderIndicators && isHeader && jqCell.filter(':not([data-dt-order=disable])').length !== 0 && jqCell.parent(':not([data-dt-order=disable])').length !== 0 && $44bb6d473543b89d$var$$('.dt-column-order', cell).length === 0) $44bb6d473543b89d$var$$(document.createElement(settings.columnTitleTag)).addClass('dt-column-order').appendTo(cell);
                    // We need to wrap the elements in the header in another element to use flexbox
                    // layout for those elements
                    var headerFooter = isHeader ? 'header' : 'footer';
                    if ($44bb6d473543b89d$var$$('div.dt-column-' + headerFooter, cell).length === 0) $44bb6d473543b89d$var$$('<div>').addClass('dt-column-' + headerFooter).append(cell.childNodes).appendTo(cell);
                }
                // If there is col / rowspan, copy the information into the layout grid
                for(l = 0; l < colspan; l++){
                    for(k = 0; k < rowspan; k++){
                        layout[i + k][shifted + l] = {
                            cell: cell,
                            unique: unique
                        };
                        layout[i + k].row = row;
                    }
                    cols.push(shifted + l);
                }
                // Assign an attribute so spanning cells can still be identified
                // as belonging to a column
                cell.setAttribute('data-dt-column', $44bb6d473543b89d$var$_unique(cols).join(','));
            }
            cell = cell.nextSibling;
        }
    }
    return layout;
}
/**
 * Set the start position for draw
 *  @param {object} oSettings dataTables settings object
 */ function $44bb6d473543b89d$var$_fnStart(oSettings) {
    var bServerSide = $44bb6d473543b89d$var$_fnDataSource(oSettings) == 'ssp';
    var iInitDisplayStart = oSettings.iInitDisplayStart;
    // Check and see if we have an initial draw position from state saving
    if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
        oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;
        oSettings.iInitDisplayStart = -1;
    }
}
/**
 * Create an Ajax call based on the table's settings, taking into account that
 * parameters can have multiple forms, and backwards compatibility.
 *
 * @param {object} oSettings dataTables settings object
 * @param {array} data Data to send to the server, required by
 *     DataTables - may be augmented by developer callbacks
 * @param {function} fn Callback function to run when data is obtained
 */ function $44bb6d473543b89d$var$_fnBuildAjax(oSettings, data, fn) {
    var ajaxData;
    var ajax = oSettings.ajax;
    var instance = oSettings.oInstance;
    var callback = function(json) {
        var status = oSettings.jqXHR ? oSettings.jqXHR.status : null;
        if (json === null || typeof status === 'number' && status == 204) {
            json = {};
            $44bb6d473543b89d$var$_fnAjaxDataSrc(oSettings, json, []);
        }
        var error = json.error || json.sError;
        if (error) $44bb6d473543b89d$var$_fnLog(oSettings, 0, error);
        // Microsoft often wrap JSON as a string in another JSON object
        // Let's handle that automatically
        if (json.d && typeof json.d === 'string') try {
            json = JSON.parse(json.d);
        } catch (e) {
        // noop
        }
        oSettings.json = json;
        $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'xhr', [
            oSettings,
            json,
            oSettings.jqXHR
        ], true);
        fn(json);
    };
    if ($44bb6d473543b89d$var$$.isPlainObject(ajax) && ajax.data) {
        ajaxData = ajax.data;
        var newData = typeof ajaxData === 'function' ? ajaxData(data, oSettings) // fn can manipulate data or return
         : ajaxData; // an object or array to merge
        // If the function returned something, use that alone
        data = typeof ajaxData === 'function' && newData ? newData : $44bb6d473543b89d$var$$.extend(true, data, newData);
        // Remove the data property as we've resolved it already and don't want
        // jQuery to do it again (it is restored at the end of the function)
        delete ajax.data;
    }
    var baseAjax = {
        url: typeof ajax === 'string' ? ajax : '',
        data: data,
        success: callback,
        dataType: 'json',
        cache: false,
        type: oSettings.sServerMethod,
        error: function(xhr, error) {
            var ret = $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'xhr', [
                oSettings,
                null,
                oSettings.jqXHR
            ], true);
            if (ret.indexOf(true) === -1) {
                if (error == 'parsererror') $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Invalid JSON response', 1);
                else if (xhr.readyState === 4) $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Ajax error', 7);
            }
            $44bb6d473543b89d$var$_fnProcessingDisplay(oSettings, false);
        }
    };
    // If `ajax` option is an object, extend and override our default base
    if ($44bb6d473543b89d$var$$.isPlainObject(ajax)) $44bb6d473543b89d$var$$.extend(baseAjax, ajax);
    // Store the data submitted for the API
    oSettings.oAjaxData = data;
    // Allow plug-ins and external processes to modify the data
    $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'preXhr', [
        oSettings,
        data,
        baseAjax
    ], true);
    // Custom Ajax option to submit the parameters as a JSON string
    if (baseAjax.submitAs === 'json' && typeof data === 'object') {
        baseAjax.data = JSON.stringify(data);
        if (!baseAjax.contentType) baseAjax.contentType = 'application/json; charset=utf-8';
    }
    if (typeof ajax === 'function') // Is a function - let the caller define what needs to be done
    oSettings.jqXHR = ajax.call(instance, data, callback, oSettings);
    else if (ajax.url === '') {
        // No url, so don't load any data. Just apply an empty data array
        // to the object for the callback.
        var empty = {};
        $44bb6d473543b89d$var$_fnAjaxDataSrc(oSettings, empty, []);
        callback(empty);
    } else // Object to extend the base settings
    oSettings.jqXHR = $44bb6d473543b89d$var$$.ajax(baseAjax);
    // Restore for next time around
    if (ajaxData) ajax.data = ajaxData;
}
/**
 * Update the table using an Ajax call
 *  @param {object} settings dataTables settings object
 *  @returns {boolean} Block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAjaxUpdate(settings) {
    settings.iDraw++;
    $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
    $44bb6d473543b89d$var$_fnBuildAjax(settings, $44bb6d473543b89d$var$_fnAjaxParameters(settings), function(json) {
        $44bb6d473543b89d$var$_fnAjaxUpdateDraw(settings, json);
    });
}
/**
 * Build up the parameters in an object needed for a server-side processing
 * request.
 *  @param {object} oSettings dataTables settings object
 *  @returns {bool} block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAjaxParameters(settings) {
    var columns = settings.aoColumns, features = settings.oFeatures, preSearch = settings.oPreviousSearch, preColSearch = settings.aoPreSearchCols, colData = function(idx, prop) {
        return typeof columns[idx][prop] === 'function' ? 'function' : columns[idx][prop];
    };
    return {
        draw: settings.iDraw,
        columns: columns.map(function(column, i) {
            return {
                data: colData(i, 'mData'),
                name: column.sName,
                searchable: column.bSearchable,
                orderable: column.bSortable,
                search: {
                    value: preColSearch[i].search,
                    regex: preColSearch[i].regex,
                    fixed: Object.keys(column.searchFixed).map(function(name) {
                        return {
                            name: name,
                            term: typeof column.searchFixed[name] !== 'function' ? column.searchFixed[name].toString() : 'function'
                        };
                    })
                }
            };
        }),
        order: $44bb6d473543b89d$var$_fnSortFlatten(settings).map(function(val) {
            return {
                column: val.col,
                dir: val.dir,
                name: colData(val.col, 'sName')
            };
        }),
        start: settings._iDisplayStart,
        length: features.bPaginate ? settings._iDisplayLength : -1,
        search: {
            value: preSearch.search,
            regex: preSearch.regex,
            fixed: Object.keys(settings.searchFixed).map(function(name) {
                return {
                    name: name,
                    term: typeof settings.searchFixed[name] !== 'function' ? settings.searchFixed[name].toString() : 'function'
                };
            })
        }
    };
}
/**
 * Data the data from the server (nuking the old) and redraw the table
 *  @param {object} oSettings dataTables settings object
 *  @param {object} json json data return from the server.
 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
 *  @param {array} json.aaData The data to display on this page
 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAjaxUpdateDraw(settings, json) {
    var data = $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json);
    var draw = $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, 'draw', json);
    var recordsTotal = $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, 'recordsTotal', json);
    var recordsFiltered = $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, 'recordsFiltered', json);
    if (draw !== undefined) {
        // Protect against out of sequence returns
        if (draw * 1 < settings.iDraw) return;
        settings.iDraw = draw * 1;
    }
    // No data in returned object, so rather than an array, we show an empty table
    if (!data) data = [];
    $44bb6d473543b89d$var$_fnClearTable(settings);
    settings._iRecordsTotal = parseInt(recordsTotal, 10);
    settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
    for(var i = 0, iLen = data.length; i < iLen; i++)$44bb6d473543b89d$var$_fnAddData(settings, data[i]);
    settings.aiDisplay = settings.aiDisplayMaster.slice();
    $44bb6d473543b89d$var$_fnColumnTypes(settings);
    $44bb6d473543b89d$var$_fnDraw(settings, true);
    $44bb6d473543b89d$var$_fnInitComplete(settings);
    $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
}
/**
 * Get the data from the JSON data source to use for drawing a table. Using
 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
 * source object, or from a processing function.
 *  @param {object} settings dataTables settings object
 *  @param  {object} json Data source object / array from the server
 *  @return {array} Array of data to use
 */ function $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json, write) {
    var dataProp = 'data';
    if ($44bb6d473543b89d$var$$.isPlainObject(settings.ajax) && settings.ajax.dataSrc !== undefined) {
        // Could in inside a `dataSrc` object, or not!
        var dataSrc = settings.ajax.dataSrc;
        // string, function and object are valid types
        if (typeof dataSrc === 'string' || typeof dataSrc === 'function') dataProp = dataSrc;
        else if (dataSrc.data !== undefined) dataProp = dataSrc.data;
    }
    if (!write) {
        if (dataProp === 'data') // If the default, then we still want to support the old style, and safely ignore
        // it if possible
        return json.aaData || json[dataProp];
        return dataProp !== '' ? $44bb6d473543b89d$var$_fnGetObjectDataFn(dataProp)(json) : json;
    }
    // set
    $44bb6d473543b89d$var$_fnSetObjectDataFn(dataProp)(json, write);
}
/**
 * Very similar to _fnAjaxDataSrc, but for the other SSP properties
 * @param {*} settings DataTables settings object
 * @param {*} param Target parameter
 * @param {*} json JSON data
 * @returns Resolved value
 */ function $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, param, json) {
    var dataSrc = $44bb6d473543b89d$var$$.isPlainObject(settings.ajax) ? settings.ajax.dataSrc : null;
    if (dataSrc && dataSrc[param]) // Get from custom location
    return $44bb6d473543b89d$var$_fnGetObjectDataFn(dataSrc[param])(json);
    // else - Default behaviour
    var old = '';
    // Legacy support
    if (param === 'draw') old = 'sEcho';
    else if (param === 'recordsTotal') old = 'iTotalRecords';
    else if (param === 'recordsFiltered') old = 'iTotalDisplayRecords';
    return json[old] !== undefined ? json[old] : json[param];
}
/**
 * Filter the table using both the global filter and column based filtering
 *  @param {object} settings dataTables settings object
 *  @param {object} input search information
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFilterComplete(settings, input) {
    var columnsSearch = settings.aoPreSearchCols;
    // In server-side processing all filtering is done by the server, so no point hanging around here
    if ($44bb6d473543b89d$var$_fnDataSource(settings) != 'ssp') {
        // Check if any of the rows were invalidated
        $44bb6d473543b89d$var$_fnFilterData(settings);
        // Start from the full data set
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Global filter first
        $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, input.search, input);
        $44bb6d473543b89d$var$$.each(settings.searchFixed, function(name, term) {
            $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, term, {});
        });
        // Then individual column filters
        for(var i = 0; i < columnsSearch.length; i++){
            var col = columnsSearch[i];
            $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, col.search, col, i);
            $44bb6d473543b89d$var$$.each(settings.aoColumns[i].searchFixed, function(name, term) {
                $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, term, {}, i);
            });
        }
        // And finally global filtering
        $44bb6d473543b89d$var$_fnFilterCustom(settings);
    }
    // Tell the draw function we have been filtering
    settings.bFiltered = true;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'search', [
        settings
    ]);
}
/**
 * Apply custom filtering functions
 * 
 * This is legacy now that we have named functions, but it is widely used
 * from 1.x, so it is not yet deprecated.
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFilterCustom(settings) {
    var filters = $44bb6d473543b89d$var$DataTable.ext.search;
    var displayRows = settings.aiDisplay;
    var row, rowIdx;
    for(var i = 0, iLen = filters.length; i < iLen; i++){
        var rows = [];
        // Loop over each row and see if it should be included
        for(var j = 0, jen = displayRows.length; j < jen; j++){
            rowIdx = displayRows[j];
            row = settings.aoData[rowIdx];
            if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) rows.push(rowIdx);
        }
        // So the array reference doesn't break set the results into the
        // existing array
        displayRows.length = 0;
        $44bb6d473543b89d$var$_fnArrayApply(displayRows, rows);
    }
}
/**
 * Filter the data table based on user input and draw the table
 */ function $44bb6d473543b89d$var$_fnFilter(searchRows, settings, input, options, column) {
    if (input === '') return;
    var i = 0;
    var matched = [];
    // Search term can be a function, regex or string - if a string we apply our
    // smart filtering regex (assuming the options require that)
    var searchFunc = typeof input === 'function' ? input : null;
    var rpSearch = input instanceof RegExp ? input : searchFunc ? null : $44bb6d473543b89d$var$_fnFilterCreateSearch(input, options);
    // Then for each row, does the test pass. If not, lop the row from the array
    for(i = 0; i < searchRows.length; i++){
        var row = settings.aoData[searchRows[i]];
        var data = column === undefined ? row._sFilterRow : row._aFilterData[column];
        if (searchFunc && searchFunc(data, row._aData, searchRows[i], column) || rpSearch && rpSearch.test(data)) matched.push(searchRows[i]);
    }
    // Mutate the searchRows array
    searchRows.length = matched.length;
    for(i = 0; i < matched.length; i++)searchRows[i] = matched[i];
}
/**
 * Build a regular expression object suitable for searching a table
 *  @param {string} sSearch string to search for
 *  @param {bool} bRegex treat as a regular expression or not
 *  @param {bool} bSmart perform smart filtering or not
 *  @param {bool} bCaseInsensitive Do case-insensitive matching or not
 *  @returns {RegExp} constructed object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFilterCreateSearch(search, inOpts) {
    var not = [];
    var options = $44bb6d473543b89d$var$$.extend({}, {
        boundary: false,
        caseInsensitive: true,
        exact: false,
        regex: false,
        smart: true
    }, inOpts);
    if (typeof search !== 'string') search = search.toString();
    // Remove diacritics if normalize is set up to do so
    search = $44bb6d473543b89d$var$_normalize(search);
    if (options.exact) return new RegExp('^' + $44bb6d473543b89d$var$_fnEscapeRegex(search) + '$', options.caseInsensitive ? 'i' : '');
    search = options.regex ? search : $44bb6d473543b89d$var$_fnEscapeRegex(search);
    if (options.smart) {
        /* For smart filtering we want to allow the search to work regardless of
		 * word order. We also want double quoted text to be preserved, so word
		 * order is important - a la google. And a negative look around for
		 * finding rows which don't contain a given string.
		 * 
		 * So this is the sort of thing we want to generate:
		 * 
		 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
		 */ var parts = search.match(/!?["\u201C][^"\u201D]+["\u201D]|[^ ]+/g) || [
            ''
        ];
        var a = parts.map(function(word) {
            var negative = false;
            var m;
            // Determine if it is a "does not include"
            if (word.charAt(0) === '!') {
                negative = true;
                word = word.substring(1);
            }
            // Strip the quotes from around matched phrases
            if (word.charAt(0) === '"') {
                m = word.match(/^"(.*)"$/);
                word = m ? m[1] : word;
            } else if (word.charAt(0) === '\u201C') {
                // Smart quote match (iPhone users)
                m = word.match(/^\u201C(.*)\u201D$/);
                word = m ? m[1] : word;
            }
            // For our "not" case, we need to modify the string that is
            // allowed to match at the end of the expression.
            if (negative) {
                if (word.length > 1) not.push('(?!' + word + ')');
                word = '';
            }
            return word.replace(/"/g, '');
        });
        var match = not.length ? not.join('') : '';
        var boundary = options.boundary ? '\\b' : '';
        search = '^(?=.*?' + boundary + a.join(')(?=.*?' + boundary) + ')(' + match + '.)*$';
    }
    return new RegExp(search, options.caseInsensitive ? 'i' : '');
}
/**
 * Escape a string such that it can be used in a regular expression
 *  @param {string} sVal string to escape
 *  @returns {string} escaped string
 *  @memberof DataTable#oApi
 */ var $44bb6d473543b89d$var$_fnEscapeRegex = $44bb6d473543b89d$var$DataTable.util.escapeRegex;
var $44bb6d473543b89d$var$__filter_div = $44bb6d473543b89d$var$$('<div>')[0];
var $44bb6d473543b89d$var$__filter_div_textContent = $44bb6d473543b89d$var$__filter_div.textContent !== undefined;
// Update the filtering data for each row if needed (by invalidation or first run)
function $44bb6d473543b89d$var$_fnFilterData(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var column;
    var j, jen, filterData, cellData, row;
    var wasInvalidated = false;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aFilterData) {
            filterData = [];
            for(j = 0, jen = columns.length; j < jen; j++){
                column = columns[j];
                if (column.bSearchable) {
                    cellData = $44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, j, 'filter');
                    // Search in DataTables is string based
                    if (cellData === null) cellData = '';
                    if (typeof cellData !== 'string' && cellData.toString) cellData = cellData.toString();
                } else cellData = '';
                // If it looks like there is an HTML entity in the string,
                // attempt to decode it so sorting works as expected. Note that
                // we could use a single line of jQuery to do this, but the DOM
                // method used here is much faster https://jsperf.com/html-decode
                if (cellData.indexOf && cellData.indexOf('&') !== -1) {
                    $44bb6d473543b89d$var$__filter_div.innerHTML = cellData;
                    cellData = $44bb6d473543b89d$var$__filter_div_textContent ? $44bb6d473543b89d$var$__filter_div.textContent : $44bb6d473543b89d$var$__filter_div.innerText;
                }
                if (cellData.replace) cellData = cellData.replace(/[\r\n\u2028]/g, '');
                filterData.push(cellData);
            }
            row._aFilterData = filterData;
            row._sFilterRow = filterData.join('  ');
            wasInvalidated = true;
        }
    }
    return wasInvalidated;
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnInitialise(settings) {
    var i;
    var init = settings.oInit;
    var deferLoading = settings.deferLoading;
    var dataSrc = $44bb6d473543b89d$var$_fnDataSource(settings);
    // Ensure that the table data is fully initialised
    if (!settings.bInitialised) {
        setTimeout(function() {
            $44bb6d473543b89d$var$_fnInitialise(settings);
        }, 200);
        return;
    }
    // Build the header / footer for the table
    $44bb6d473543b89d$var$_fnBuildHead(settings, 'header');
    $44bb6d473543b89d$var$_fnBuildHead(settings, 'footer');
    // Load the table's state (if needed) and then render around it and draw
    $44bb6d473543b89d$var$_fnLoadState(settings, init, function() {
        // Then draw the header / footer
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoHeader);
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoFooter);
        // Cache the paging start point, as the first redraw will reset it
        var iAjaxStart = settings.iInitDisplayStart;
        // Local data load
        // Check if there is data passing into the constructor
        if (init.aaData) for(i = 0; i < init.aaData.length; i++)$44bb6d473543b89d$var$_fnAddData(settings, init.aaData[i]);
        else if (deferLoading || dataSrc == 'dom') // Grab the data from the page
        $44bb6d473543b89d$var$_fnAddTr(settings, $44bb6d473543b89d$var$$(settings.nTBody).children('tr'));
        // Filter not yet applied - copy the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Enable features
        $44bb6d473543b89d$var$_fnAddOptionsHtml(settings);
        $44bb6d473543b89d$var$_fnSortInit(settings);
        $44bb6d473543b89d$var$_colGroup(settings);
        /* Okay to show that something is going on now */ $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
        $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'preInit', [
            settings
        ], true);
        // If there is default sorting required - let's do it. The sort function
        // will do the drawing for us. Otherwise we draw the table regardless of the
        // Ajax source - this allows the table to look initialised for Ajax sourcing
        // data (show 'loading' message possibly)
        $44bb6d473543b89d$var$_fnReDraw(settings);
        // Server-side processing init complete is done by _fnAjaxUpdateDraw
        if (dataSrc != 'ssp' || deferLoading) {
            // if there is an ajax source load the data
            if (dataSrc == 'ajax') $44bb6d473543b89d$var$_fnBuildAjax(settings, {}, function(json) {
                var aData = $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json);
                // Got the data - add it to the table
                for(i = 0; i < aData.length; i++)$44bb6d473543b89d$var$_fnAddData(settings, aData[i]);
                // Reset the init display for cookie saving. We've already done
                // a filter, and therefore cleared it before. So we need to make
                // it appear 'fresh'
                settings.iInitDisplayStart = iAjaxStart;
                $44bb6d473543b89d$var$_fnReDraw(settings);
                $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
                $44bb6d473543b89d$var$_fnInitComplete(settings);
            }, settings);
            else {
                $44bb6d473543b89d$var$_fnInitComplete(settings);
                $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
            }
        }
    });
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnInitComplete(settings) {
    if (settings._bInitComplete) return;
    var args = [
        settings,
        settings.json
    ];
    // If the footer element is empty after initialisation, then remove it
    let tfoot = $44bb6d473543b89d$var$$(settings.tfoot);
    if (tfoot.children().length === 0) tfoot.remove();
    settings._bInitComplete = true;
    // Table is fully set up and we have data, so calculate the
    // column widths
    $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'plugin-init', args, true);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, 'aoInitComplete', 'init', args, true);
}
function $44bb6d473543b89d$var$_fnLengthChange(settings, val) {
    var len = parseInt(val, 10);
    settings._iDisplayLength = len;
    $44bb6d473543b89d$var$_fnLengthOverflow(settings);
    // Fire length change event
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'length', [
        settings,
        len
    ]);
}
/**
 * Alter the display settings to change the page
 *  @param {object} settings DataTables settings object
 *  @param {string|int} action Paging action to take: "first", "previous",
 *    "next" or "last" or page number to jump to (integer)
 *  @param [bool] redraw Automatically draw the update or not
 *  @returns {bool} true page has changed, false - no change
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnPageChange(settings, action, redraw) {
    var start = settings._iDisplayStart, len = settings._iDisplayLength, records = settings.fnRecordsDisplay();
    if (records === 0 || len === -1) start = 0;
    else if (typeof action === "number") {
        start = action * len;
        if (start > records) start = 0;
    } else if (action == "first") start = 0;
    else if (action == "previous") {
        start = len >= 0 ? start - len : 0;
        if (start < 0) start = 0;
    } else if (action == "next") {
        if (start + len < records) start += len;
    } else if (action == "last") start = Math.floor((records - 1) / len) * len;
    else if (action === 'ellipsis') return;
    else $44bb6d473543b89d$var$_fnLog(settings, 0, "Unknown paging action: " + action, 5);
    var changed = settings._iDisplayStart !== start;
    settings._iDisplayStart = start;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, changed ? 'page' : 'page-nc', [
        settings
    ]);
    if (changed && redraw) $44bb6d473543b89d$var$_fnDraw(settings);
    return changed;
}
/**
 * Generate the node required for the processing node
 *  @param {object} settings DataTables settings object
 */ function $44bb6d473543b89d$var$_processingHtml(settings) {
    var table = settings.nTable;
    var scrolling = settings.oScroll.sX !== '' || settings.oScroll.sY !== '';
    if (settings.oFeatures.bProcessing) {
        var n = $44bb6d473543b89d$var$$('<div/>', {
            'id': settings.sTableId + '_processing',
            'class': settings.oClasses.processing.container,
            'role': 'status'
        }).html(settings.oLanguage.sProcessing).append('<div><div></div><div></div><div></div><div></div></div>');
        // Different positioning depending on if scrolling is enabled or not
        if (scrolling) n.prependTo($44bb6d473543b89d$var$$('div.dt-scroll', settings.nTableWrapper));
        else n.insertBefore(table);
        $44bb6d473543b89d$var$$(table).on('processing.dt.DT', function(e, s, show) {
            n.css('display', show ? 'block' : 'none');
        });
    }
}
/**
 * Display or hide the processing indicator
 *  @param {object} settings DataTables settings object
 *  @param {bool} show Show the processing indicator (true) or not (false)
 */ function $44bb6d473543b89d$var$_fnProcessingDisplay(settings, show) {
    // Ignore cases when we are still redrawing
    if (settings.bDrawing && show === false) return;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'processing', [
        settings,
        show
    ]);
}
/**
 * Show the processing element if an action takes longer than a given time
 *
 * @param {*} settings DataTables settings object
 * @param {*} enable Do (true) or not (false) async processing (local feature enablement)
 * @param {*} run Function to run
 */ function $44bb6d473543b89d$var$_fnProcessingRun(settings, enable, run) {
    if (!enable) // Immediate execution, synchronous
    run();
    else {
        $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
        // Allow the processing display to show if needed
        setTimeout(function() {
            run();
            $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
        }, 0);
    }
}
/**
 * Add any control elements for the table - specifically scrolling
 *  @param {object} settings dataTables settings object
 *  @returns {node} Node to add to the DOM
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFeatureHtmlTable(settings) {
    var table = $44bb6d473543b89d$var$$(settings.nTable);
    // Scrolling from here on in
    var scroll = settings.oScroll;
    if (scroll.sX === '' && scroll.sY === '') return settings.nTable;
    var scrollX = scroll.sX;
    var scrollY = scroll.sY;
    var classes = settings.oClasses.scrolling;
    var caption = settings.captionNode;
    var captionSide = caption ? caption._captionSide : null;
    var headerClone = $44bb6d473543b89d$var$$(table[0].cloneNode(false));
    var footerClone = $44bb6d473543b89d$var$$(table[0].cloneNode(false));
    var footer = table.children('tfoot');
    var _div = '<div/>';
    var size = function(s) {
        return !s ? null : $44bb6d473543b89d$var$_fnStringToCss(s);
    };
    if (!footer.length) footer = null;
    /*
	 * The HTML structure that we want to generate in this function is:
	 *  div - scroller
	 *    div - scroll head
	 *      div - scroll head inner
	 *        table - scroll head table
	 *          thead - thead
	 *    div - scroll body
	 *      table - table (master table)
	 *        thead - thead clone for sizing
	 *        tbody - tbody
	 *    div - scroll foot
	 *      div - scroll foot inner
	 *        table - scroll foot table
	 *          tfoot - tfoot
	 */ var scroller = $44bb6d473543b89d$var$$(_div, {
        'class': classes.container
    }).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.header.self
    }).css({
        overflow: 'hidden',
        position: 'relative',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.header.inner
    }).css({
        'box-sizing': 'content-box',
        width: scroll.sXInner || '100%'
    }).append(headerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'top' ? caption : null).append(table.children('thead'))))).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.body
    }).css({
        position: 'relative',
        overflow: 'auto',
        width: size(scrollX)
    }).append(table));
    if (footer) scroller.append($44bb6d473543b89d$var$$(_div, {
        'class': classes.footer.self
    }).css({
        overflow: 'hidden',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.footer.inner
    }).append(footerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'bottom' ? caption : null).append(table.children('tfoot')))));
    var children = scroller.children();
    var scrollHead = children[0];
    var scrollBody = children[1];
    var scrollFoot = footer ? children[2] : null;
    // When the body is scrolled, then we also want to scroll the headers
    $44bb6d473543b89d$var$$(scrollBody).on('scroll.DT', function() {
        var scrollLeft = this.scrollLeft;
        scrollHead.scrollLeft = scrollLeft;
        if (footer) scrollFoot.scrollLeft = scrollLeft;
    });
    // When focus is put on the header cells, we might need to scroll the body
    $44bb6d473543b89d$var$$('th, td', scrollHead).on('focus', function() {
        var scrollLeft = scrollHead.scrollLeft;
        scrollBody.scrollLeft = scrollLeft;
        if (footer) scrollBody.scrollLeft = scrollLeft;
    });
    $44bb6d473543b89d$var$$(scrollBody).css('max-height', scrollY);
    if (!scroll.bCollapse) $44bb6d473543b89d$var$$(scrollBody).css('height', scrollY);
    settings.nScrollHead = scrollHead;
    settings.nScrollBody = scrollBody;
    settings.nScrollFoot = scrollFoot;
    // On redraw - align columns
    settings.aoDrawCallback.push($44bb6d473543b89d$var$_fnScrollDraw);
    return scroller[0];
}
/**
 * Update the header, footer and body tables for resizing - i.e. column
 * alignment.
 *
 * Welcome to the most horrible function DataTables. The process that this
 * function follows is basically:
 *   1. Re-create the table inside the scrolling div
 *   2. Correct colgroup > col values if needed
 *   3. Copy colgroup > col over to header and footer
 *   4. Clean up
 *
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnScrollDraw(settings) {
    // Given that this is such a monster function, a lot of variables are use
    // to try and keep the minimised size as small as possible
    var scroll = settings.oScroll, barWidth = scroll.iBarWidth, divHeader = $44bb6d473543b89d$var$$(settings.nScrollHead), divHeaderInner = divHeader.children('div'), divHeaderTable = divHeaderInner.children('table'), divBodyEl = settings.nScrollBody, divBody = $44bb6d473543b89d$var$$(divBodyEl), divFooter = $44bb6d473543b89d$var$$(settings.nScrollFoot), divFooterInner = divFooter.children('div'), divFooterTable = divFooterInner.children('table'), header = $44bb6d473543b89d$var$$(settings.nTHead), table = $44bb6d473543b89d$var$$(settings.nTable), footer = settings.nTFoot && $44bb6d473543b89d$var$$('th, td', settings.nTFoot).length ? $44bb6d473543b89d$var$$(settings.nTFoot) : null, browser = settings.oBrowser, headerCopy, footerCopy;
    // If the scrollbar visibility has changed from the last draw, we need to
    // adjust the column sizes as the table width will have changed to account
    // for the scrollbar
    var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
    if (settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined) {
        settings.scrollBarVis = scrollBarVis;
        $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
        return; // adjust column sizing will call this function again
    } else settings.scrollBarVis = scrollBarVis;
    // 1. Re-create the table inside the scrolling div
    // Remove the old minimised thead and tfoot elements in the inner table
    table.children('thead, tfoot').remove();
    // Clone the current header and footer elements and then place it into the inner table
    headerCopy = header.clone().prependTo(table);
    headerCopy.find('th, td').removeAttr('tabindex');
    headerCopy.find('[id]').removeAttr('id');
    if (footer) {
        footerCopy = footer.clone().prependTo(table);
        footerCopy.find('[id]').removeAttr('id');
    }
    // 2. Correct colgroup > col values if needed
    // It is possible that the cell sizes are smaller than the content, so we need to
    // correct colgroup>col for such cases. This can happen if the auto width detection
    // uses a cell which has a longer string, but isn't the widest! For example 
    // "Chief Executive Officer (CEO)" is the longest string in the demo, but
    // "Systems Administrator" is actually the widest string since it doesn't collapse.
    // Note the use of translating into a column index to get the `col` element. This
    // is because of Responsive which might remove `col` elements, knocking the alignment
    // of the indexes out.
    if (settings.aiDisplay.length) {
        // Get the column sizes from the first row in the table. This should really be a
        // [].find, but it wasn't supported in Chrome until Sept 2015, and DT has 10 year
        // browser support
        var firstTr = null;
        var start = $44bb6d473543b89d$var$_fnDataSource(settings) !== 'ssp' ? settings._iDisplayStart : 0;
        for(i = start; i < start + settings.aiDisplay.length; i++){
            var idx = settings.aiDisplay[i];
            var tr = settings.aoData[idx].nTr;
            if (tr) {
                firstTr = tr;
                break;
            }
        }
        if (firstTr) {
            var colSizes = $44bb6d473543b89d$var$$(firstTr).children('th, td').map(function(vis) {
                return {
                    idx: $44bb6d473543b89d$var$_fnVisibleToColumnIndex(settings, vis),
                    width: $44bb6d473543b89d$var$$(this).outerWidth()
                };
            });
            // Check against what the colgroup > col is set to and correct if needed
            for(var i = 0; i < colSizes.length; i++){
                var colEl = settings.aoColumns[colSizes[i].idx].colEl[0];
                var colWidth = colEl.style.width.replace('px', '');
                if (colWidth !== colSizes[i].width) {
                    colEl.style.width = colSizes[i].width + 'px';
                    if (scroll.sX) colEl.style.minWidth = colSizes[i].width + 'px';
                }
            }
        }
    }
    // 3. Copy the colgroup over to the header and footer
    divHeaderTable.find('colgroup').remove();
    divHeaderTable.append(settings.colgroup.clone());
    if (footer) {
        divFooterTable.find('colgroup').remove();
        divFooterTable.append(settings.colgroup.clone());
    }
    // "Hide" the header and footer that we used for the sizing. We need to keep
    // the content of the cell so that the width applied to the header and body
    // both match, but we want to hide it completely.
    $44bb6d473543b89d$var$$('th, td', headerCopy).each(function() {
        $44bb6d473543b89d$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing" />');
    });
    if (footer) $44bb6d473543b89d$var$$('th, td', footerCopy).each(function() {
        $44bb6d473543b89d$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing" />');
    });
    // 4. Clean up
    // Figure out if there are scrollbar present - if so then we need the header and footer to
    // provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
    var isScrolling = Math.floor(table.height()) > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
    var paddingSide = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right');
    // Set the width's of the header and footer tables
    var outerWidth = table.outerWidth();
    divHeaderTable.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth));
    divHeaderInner.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    if (footer) {
        divFooterTable.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth));
        divFooterInner.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    }
    // Correct DOM ordering for colgroup - comes before the thead
    table.children('colgroup').prependTo(table);
    // Remove tabindex from the hidden row elements
    table.find('thead, tfoot').find('[tabindex]').removeAttr('tabindex');
    table.find('thead, tfoot').find('role').removeAttr('role');
    // Adjust the position of the header in case we loose the y-scrollbar
    divBody.trigger('scroll');
    // If sorting or filtering has occurred, jump the scrolling back to the top
    // only if we aren't holding the position
    if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) divBodyEl.scrollTop = 0;
}
/**
 * Calculate the width of columns for the table
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCalculateColumnWidths(settings) {
    // Not interested in doing column width calculation if auto-width is disabled
    if (!settings.oFeatures.bAutoWidth) return;
    var table = settings.nTable, columns = settings.aoColumns, scroll = settings.oScroll, scrollY = scroll.sY, scrollX = scroll.sX, scrollXInner = scroll.sXInner, visibleColumns = $44bb6d473543b89d$var$_fnGetColumns(settings, 'bVisible'), tableWidthAttr = table.getAttribute('width'), tableContainer = table.parentNode, i, j, column, columnIdx;
    var styleWidth = table.style.width;
    var containerWidth = $44bb6d473543b89d$var$_fnWrapperWidth(settings);
    // Don't re-run for the same width as the last time
    if (containerWidth === settings.containerWidth) return false;
    settings.containerWidth = containerWidth;
    // If there is no width applied as a CSS style or as an attribute, we assume that
    // the width is intended to be 100%, which is usually is in CSS, but it is very
    // difficult to correctly parse the rules to get the final result.
    if (!styleWidth && !tableWidthAttr) {
        table.style.width = '100%';
        styleWidth = '100%';
    }
    if (styleWidth && styleWidth.indexOf('%') !== -1) tableWidthAttr = styleWidth;
    // Let plug-ins know that we are doing a recalc, in case they have changed any of the
    // visible columns their own way (e.g. Responsive uses display:none).
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'column-calc', {
        visible: visibleColumns
    }, false);
    // Construct a worst case table with the widest, assign any user defined
    // widths, then insert it into  the DOM and allow the browser to do all
    // the hard work of calculating table widths
    var tmpTable = $44bb6d473543b89d$var$$(table.cloneNode()).css('visibility', 'hidden').css('margin', 0).removeAttr('id');
    // Clean up the table body
    tmpTable.append('<tbody/>');
    // Clone the table header and footer - we can't use the header / footer
    // from the cloned table, since if scrolling is active, the table's
    // real header and footer are contained in different table tags
    tmpTable.append($44bb6d473543b89d$var$$(settings.nTHead).clone()).append($44bb6d473543b89d$var$$(settings.nTFoot).clone());
    // Remove any assigned widths from the footer (from scrolling)
    tmpTable.find('tfoot th, tfoot td').css('width', '');
    // Apply custom sizing to the cloned header
    tmpTable.find('thead th, thead td').each(function() {
        // Get the `width` from the header layout
        var width = $44bb6d473543b89d$var$_fnColumnsSumWidth(settings, this, true, false);
        if (width) {
            this.style.width = width;
            // For scrollX we need to force the column width otherwise the
            // browser will collapse it. If this width is smaller than the
            // width the column requires, then it will have no effect
            if (scrollX) {
                this.style.minWidth = width;
                $44bb6d473543b89d$var$$(this).append($44bb6d473543b89d$var$$('<div/>').css({
                    width: width,
                    margin: 0,
                    padding: 0,
                    border: 0,
                    height: 1
                }));
            }
        } else this.style.width = '';
    });
    // Get the widest strings for each of the visible columns and add them to
    // our table to create a "worst case"
    var longestData = [];
    for(i = 0; i < visibleColumns.length; i++)longestData.push($44bb6d473543b89d$var$_fnGetWideStrings(settings, visibleColumns[i]));
    if (longestData.length) for(i = 0; i < longestData[0].length; i++){
        var tr = $44bb6d473543b89d$var$$('<tr/>').appendTo(tmpTable.find('tbody'));
        for(j = 0; j < visibleColumns.length; j++){
            columnIdx = visibleColumns[j];
            column = columns[columnIdx];
            var longest = longestData[j][i] || '';
            var autoClass = $44bb6d473543b89d$var$_ext.type.className[column.sType];
            var padding = column.sContentPadding || (scrollX ? '-' : '');
            var text = longest + padding;
            var insert = longest.indexOf('<') === -1 && longest.indexOf('&') === -1 ? document.createTextNode(text) : text;
            $44bb6d473543b89d$var$$('<td/>').addClass(autoClass).addClass(column.sClass).append(insert).appendTo(tr);
        }
    }
    // Tidy the temporary table - remove name attributes so there aren't
    // duplicated in the dom (radio elements for example)
    $44bb6d473543b89d$var$$('[name]', tmpTable).removeAttr('name');
    // Table has been built, attach to the document so we can work with it.
    // A holding element is used, positioned at the top of the container
    // with minimal height, so it has no effect on if the container scrolls
    // or not. Otherwise it might trigger scrolling when it actually isn't
    // needed
    var holder = $44bb6d473543b89d$var$$('<div/>').css(scrollX || scrollY ? {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 1,
        right: 0,
        overflow: 'hidden'
    } : {}).append(tmpTable).appendTo(tableContainer);
    // When scrolling (X or Y) we want to set the width of the table as 
    // appropriate. However, when not scrolling leave the table width as it
    // is. This results in slightly different, but I think correct behaviour
    if (scrollX && scrollXInner) tmpTable.width(scrollXInner);
    else if (scrollX) {
        tmpTable.css('width', 'auto');
        tmpTable.removeAttr('width');
        // If there is no width attribute or style, then allow the table to
        // collapse
        if (tmpTable.outerWidth() < tableContainer.clientWidth && tableWidthAttr) tmpTable.outerWidth(tableContainer.clientWidth);
    } else if (scrollY) tmpTable.outerWidth(tableContainer.clientWidth);
    else if (tableWidthAttr) tmpTable.outerWidth(tableWidthAttr);
    // Get the width of each column in the constructed table
    var total = 0;
    var bodyCells = tmpTable.find('tbody tr').eq(0).children();
    for(i = 0; i < visibleColumns.length; i++){
        // Use getBounding for sub-pixel accuracy, which we then want to round up!
        var bounding = bodyCells[i].getBoundingClientRect().width;
        // Total is tracked to remove any sub-pixel errors as the outerWidth
        // of the table might not equal the total given here
        total += bounding;
        // Width for each column to use
        columns[visibleColumns[i]].sWidth = $44bb6d473543b89d$var$_fnStringToCss(bounding);
    }
    table.style.width = $44bb6d473543b89d$var$_fnStringToCss(total);
    // Finished with the table - ditch it
    holder.remove();
    // If there is a width attr, we want to attach an event listener which
    // allows the table sizing to automatically adjust when the window is
    // resized. Use the width attr rather than CSS, since we can't know if the
    // CSS is a relative value or absolute - DOM read is always px.
    if (tableWidthAttr) table.style.width = $44bb6d473543b89d$var$_fnStringToCss(tableWidthAttr);
    if ((tableWidthAttr || scrollX) && !settings._reszEvt) {
        var resize = $44bb6d473543b89d$var$DataTable.util.throttle(function() {
            var newWidth = $44bb6d473543b89d$var$_fnWrapperWidth(settings);
            // Don't do it if destroying or the container width is 0
            if (!settings.bDestroying && newWidth !== 0) $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
        });
        // For browsers that support it (~2020 onwards for wide support) we can watch for the
        // container changing width.
        if (window.ResizeObserver) {
            // This is a tricky beast - if the element is visible when `.observe()` is called,
            // then the callback is immediately run. Which we don't want. If the element isn't
            // visible, then it isn't run, but we want it to run when it is then made visible.
            // This flag allows the above to be satisfied.
            var first = $44bb6d473543b89d$var$$(settings.nTableWrapper).is(':visible');
            // Use an empty div to attach the observer so it isn't impacted by height changes
            var resizer = $44bb6d473543b89d$var$$('<div>').css({
                width: '100%',
                height: 0
            }).addClass('dt-autosize').appendTo(settings.nTableWrapper);
            settings.resizeObserver = new ResizeObserver(function(e) {
                if (first) first = false;
                else resize();
            });
            settings.resizeObserver.observe(resizer[0]);
        } else // For old browsers, the best we can do is listen for a window resize
        $44bb6d473543b89d$var$$(window).on('resize.DT-' + settings.sInstance, resize);
        settings._reszEvt = true;
    }
}
/**
 * Get the width of the DataTables wrapper element
 *
 * @param {*} settings DataTables settings object
 * @returns Width
 */ function $44bb6d473543b89d$var$_fnWrapperWidth(settings) {
    return $44bb6d473543b89d$var$$(settings.nTableWrapper).is(':visible') ? $44bb6d473543b89d$var$$(settings.nTableWrapper).width() : 0;
}
/**
 * Get the widest strings for each column.
 *
 * It is very difficult to determine what the widest string actually is due to variable character
 * width and kerning. Doing an exact calculation with the DOM or even Canvas would kill performance
 * and this is a critical point, so we use two techniques to determine a collection of the longest
 * strings from the column, which will likely contain the widest strings:
 *
 * 1) Get the top three longest strings from the column
 * 2) Get the top three widest words (i.e. an unbreakable phrase)
 *
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {string[]} Array of the longest strings
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetWideStrings(settings, colIdx) {
    var column = settings.aoColumns[colIdx];
    // Do we need to recalculate (i.e. was invalidated), or just use the cached data?
    if (!column.wideStrings) {
        var allStrings = [];
        var collection = [];
        // Create an array with the string information for the column
        for(var i = 0, iLen = settings.aiDisplayMaster.length; i < iLen; i++){
            var rowIdx = settings.aiDisplayMaster[i];
            var data = $44bb6d473543b89d$var$_fnGetRowDisplay(settings, rowIdx)[colIdx];
            var cellString = data && typeof data === 'object' && data.nodeType ? data.innerHTML : data + '';
            // Remove id / name attributes from elements so they
            // don't interfere with existing elements
            cellString = cellString.replace(/id=".*?"/g, '').replace(/name=".*?"/g, '');
            // Don't want script, dialog or template tags in the width
            // calculations as they are hidden content
            cellString = cellString.replace(/<script[\s\S]*?<\/script>/gi, ' ').replace(/<dialog[\s\S]*?<\/dialog>/gi, ' ').replace(/<template[\s\S]*?<\/template>/gi, ' ');
            var noHtml = $44bb6d473543b89d$var$_stripHtml(cellString, ' ').replace(/&nbsp;/g, ' ');
            // The length is calculated on the text only, but we keep the HTML
            // in the string so it can be used in the calculation table
            collection.push({
                str: cellString,
                len: noHtml.length
            });
            allStrings.push(noHtml);
        }
        // Order and then cut down to the size we need
        collection.sort(function(a, b) {
            return b.len - a.len;
        }).splice(3);
        column.wideStrings = collection.map(function(item) {
            return item.str;
        });
        // Longest unbroken string
        let parts = allStrings.join(' ').split(' ');
        parts.sort(function(a, b) {
            return b.length - a.length;
        });
        if (parts.length) column.wideStrings.push(parts[0]);
        if (parts.length > 1) column.wideStrings.push(parts[1]);
        if (parts.length > 2) column.wideStrings.push(parts[3]);
    }
    return column.wideStrings;
}
/**
 * Append a CSS unit (only if required) to a string
 *  @param {string} value to css-ify
 *  @returns {string} value with css unit
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnStringToCss(s) {
    if (s === null) return '0px';
    if (typeof s == 'number') return s < 0 ? '0px' : s + 'px';
    // Check it has a unit character already
    return s.match(/\d$/) ? s + 'px' : s;
}
/**
 * Re-insert the `col` elements for current visibility
 *
 * @param {*} settings DT settings
 */ function $44bb6d473543b89d$var$_colGroup(settings) {
    var cols = settings.aoColumns;
    settings.colgroup.empty();
    for($44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < cols.length; $44bb6d473543b89d$var$i++)if (cols[$44bb6d473543b89d$var$i].bVisible) settings.colgroup.append(cols[$44bb6d473543b89d$var$i].colEl);
}
function $44bb6d473543b89d$var$_fnSortInit(settings) {
    var target = settings.nTHead;
    var headerRows = target.querySelectorAll('tr');
    var titleRow = settings.titleRow;
    var notSelector = ':not([data-dt-order="disable"]):not([data-dt-order="icon-only"])';
    // Legacy support for `orderCellsTop`
    if (titleRow === true) target = headerRows[0];
    else if (titleRow === false) target = headerRows[headerRows.length - 1];
    else if (titleRow !== null) target = headerRows[titleRow];
    // else - all rows
    if (settings.orderHandler) $44bb6d473543b89d$var$_fnSortAttachListener(settings, target, target === settings.nTHead ? 'tr' + notSelector + ' th' + notSelector + ', tr' + notSelector + ' td' + notSelector : 'th' + notSelector + ', td' + notSelector);
    // Need to resolve the user input array into our internal structure
    var order = [];
    $44bb6d473543b89d$var$_fnSortResolve(settings, order, settings.aaSorting);
    settings.aaSorting = order;
}
function $44bb6d473543b89d$var$_fnSortAttachListener(settings, node, selector, column, callback) {
    $44bb6d473543b89d$var$_fnBindAction(node, selector, function(e) {
        var run = false;
        var columns = column === undefined ? $44bb6d473543b89d$var$_fnColumnsFromHeader(e.target) : typeof column === 'function' ? column() : Array.isArray(column) ? column : [
            column
        ];
        if (columns.length) {
            for(var i = 0, iLen = columns.length; i < iLen; i++){
                var ret = $44bb6d473543b89d$var$_fnSortAdd(settings, columns[i], i, e.shiftKey);
                if (ret !== false) run = true;
                // If the first entry is no sort, then subsequent
                // sort columns are ignored
                if (settings.aaSorting.length === 1 && settings.aaSorting[0][1] === '') break;
            }
            if (run) $44bb6d473543b89d$var$_fnProcessingRun(settings, true, function() {
                $44bb6d473543b89d$var$_fnSort(settings);
                $44bb6d473543b89d$var$_fnSortDisplay(settings, settings.aiDisplay);
                $44bb6d473543b89d$var$_fnReDraw(settings, false, false);
                if (callback) callback();
            });
        }
    });
}
/**
 * Sort the display array to match the master's order
 * @param {*} settings
 */ function $44bb6d473543b89d$var$_fnSortDisplay(settings, display) {
    if (display.length < 2) return;
    var master = settings.aiDisplayMaster;
    var masterMap = {};
    var map = {};
    var i;
    // Rather than needing an `indexOf` on master array, we can create a map
    for(i = 0; i < master.length; i++)masterMap[master[i]] = i;
    // And then cache what would be the indexOf from the display
    for(i = 0; i < display.length; i++)map[display[i]] = masterMap[display[i]];
    display.sort(function(a, b) {
        // Short version of this function is simply `master.indexOf(a) - master.indexOf(b);`
        return map[a] - map[b];
    });
}
function $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, sort) {
    var push = function(a) {
        if ($44bb6d473543b89d$var$$.isPlainObject(a)) {
            if (a.idx !== undefined) // Index based ordering
            nestedSort.push([
                a.idx,
                a.dir
            ]);
            else if (a.name) {
                // Name based ordering
                var cols = $44bb6d473543b89d$var$_pluck(settings.aoColumns, 'sName');
                var idx = cols.indexOf(a.name);
                if (idx !== -1) nestedSort.push([
                    idx,
                    a.dir
                ]);
            }
        } else // Plain column index and direction pair
        nestedSort.push(a);
    };
    if ($44bb6d473543b89d$var$$.isPlainObject(sort)) // Object
    push(sort);
    else if (sort.length && typeof sort[0] === 'number') // 1D array
    push(sort);
    else if (sort.length) // 2D array
    for(var z = 0; z < sort.length; z++)push(sort[z]); // Object or array
}
function $44bb6d473543b89d$var$_fnSortFlatten(settings) {
    var i, k, kLen, aSort = [], extSort = $44bb6d473543b89d$var$DataTable.ext.type.order, aoColumns = settings.aoColumns, aDataSort, iCol, sType, srcCol, fixed = settings.aaSortingFixed, fixedObj = $44bb6d473543b89d$var$$.isPlainObject(fixed), nestedSort = [];
    if (!settings.oFeatures.bSort) return aSort;
    // Build the sort array, with pre-fix and post-fix options if they have been
    // specified
    if (Array.isArray(fixed)) $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, fixed);
    if (fixedObj && fixed.pre) $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, fixed.pre);
    $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, settings.aaSorting);
    if (fixedObj && fixed.post) $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, fixed.post);
    for(i = 0; i < nestedSort.length; i++){
        srcCol = nestedSort[i][0];
        if (aoColumns[srcCol]) {
            aDataSort = aoColumns[srcCol].aDataSort;
            for(k = 0, kLen = aDataSort.length; k < kLen; k++){
                iCol = aDataSort[k];
                sType = aoColumns[iCol].sType || 'string';
                if (nestedSort[i]._idx === undefined) nestedSort[i]._idx = aoColumns[iCol].asSorting.indexOf(nestedSort[i][1]);
                if (nestedSort[i][1]) aSort.push({
                    src: srcCol,
                    col: iCol,
                    dir: nestedSort[i][1],
                    index: nestedSort[i]._idx,
                    type: sType,
                    formatter: extSort[sType + "-pre"],
                    sorter: extSort[sType + "-" + nestedSort[i][1]]
                });
            }
        }
    }
    return aSort;
}
/**
 * Change the order of the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSort(oSettings, col, dir) {
    var i, iLen, aiOrig = [], extSort = $44bb6d473543b89d$var$DataTable.ext.type.order, aoData = oSettings.aoData, sortCol, displayMaster = oSettings.aiDisplayMaster, aSort;
    // Make sure the columns all have types defined
    $44bb6d473543b89d$var$_fnColumnTypes(oSettings);
    // Allow a specific column to be sorted, which will _not_ alter the display
    // master
    if (col !== undefined) {
        var srcCol = oSettings.aoColumns[col];
        aSort = [
            {
                src: col,
                col: col,
                dir: dir,
                index: 0,
                type: srcCol.sType,
                formatter: extSort[srcCol.sType + "-pre"],
                sorter: extSort[srcCol.sType + "-" + dir]
            }
        ];
        displayMaster = displayMaster.slice();
    } else aSort = $44bb6d473543b89d$var$_fnSortFlatten(oSettings);
    for(i = 0, iLen = aSort.length; i < iLen; i++){
        sortCol = aSort[i];
        // Load the data needed for the sort, for each cell
        $44bb6d473543b89d$var$_fnSortData(oSettings, sortCol.col);
    }
    /* No sorting required if server-side or no sorting array */ if ($44bb6d473543b89d$var$_fnDataSource(oSettings) != 'ssp' && aSort.length !== 0) {
        // Reset the initial positions on each pass so we get a stable sort
        for(i = 0, iLen = displayMaster.length; i < iLen; i++)aiOrig[i] = i;
        // If the first sort is desc, then reverse the array to preserve original
        // order, just in reverse
        if (aSort.length && aSort[0].dir === 'desc' && oSettings.orderDescReverse) aiOrig.reverse();
        /* Do the sort - here we want multi-column sorting based on a given data source (column)
		 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
		 * follow on its own, but this is what we want (example two column sorting):
		 *  fnLocalSorting = function(a,b){
		 *    var test;
		 *    test = oSort['string-asc']('data11', 'data12');
		 *      if (test !== 0)
		 *        return test;
		 *    test = oSort['numeric-desc']('data21', 'data22');
		 *    if (test !== 0)
		 *      return test;
		 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
		 *  }
		 * Basically we have a test for each sorting column, if the data in that column is equal,
		 * test the next column. If all columns match, then we use a numeric sort on the row
		 * positions in the original data array to provide a stable sort.
		 */ displayMaster.sort(function(a, b) {
            var x, y, k, test, sort, len = aSort.length, dataA = aoData[a]._aSortData, dataB = aoData[b]._aSortData;
            for(k = 0; k < len; k++){
                sort = aSort[k];
                // Data, which may have already been through a `-pre` function
                x = dataA[sort.col];
                y = dataB[sort.col];
                if (sort.sorter) {
                    // If there is a custom sorter (`-asc` or `-desc`) for this
                    // data type, use it
                    test = sort.sorter(x, y);
                    if (test !== 0) return test;
                } else {
                    // Otherwise, use generic sorting
                    test = x < y ? -1 : x > y ? 1 : 0;
                    if (test !== 0) return sort.dir === 'asc' ? test : -test;
                }
            }
            x = aiOrig[a];
            y = aiOrig[b];
            return x < y ? -1 : x > y ? 1 : 0;
        });
    } else if (aSort.length === 0) // Apply index order
    displayMaster.sort(function(x, y) {
        return x < y ? -1 : x > y ? 1 : 0;
    });
    if (col === undefined) {
        // Tell the draw function that we have sorted the data
        oSettings.bSorted = true;
        oSettings.sortDetails = aSort;
        $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'order', [
            oSettings,
            aSort
        ]);
    }
    return displayMaster;
}
/**
 * Function to run on user sort request
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {int} addIndex Counter
 *  @param {boolean} [shift=false] Shift click add
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSortAdd(settings, colIdx, addIndex, shift) {
    var col = settings.aoColumns[colIdx];
    var sorting = settings.aaSorting;
    var asSorting = col.asSorting;
    var nextSortIdx;
    var next = function(a, overflow) {
        var idx = a._idx;
        if (idx === undefined) idx = asSorting.indexOf(a[1]);
        return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
    };
    if (!col.bSortable) return false;
    // Convert to 2D array if needed
    if (typeof sorting[0] === 'number') sorting = settings.aaSorting = [
        sorting
    ];
    // If appending the sort then we are multi-column sorting
    if ((shift || addIndex) && settings.oFeatures.bSortMulti) {
        // Are we already doing some kind of sort on this column?
        var sortIdx = $44bb6d473543b89d$var$_pluck(sorting, '0').indexOf(colIdx);
        if (sortIdx !== -1) {
            // Yes, modify the sort
            nextSortIdx = next(sorting[sortIdx], true);
            if (nextSortIdx === null && sorting.length === 1) nextSortIdx = 0; // can't remove sorting completely
            if (nextSortIdx === null || asSorting[nextSortIdx] === '') sorting.splice(sortIdx, 1);
            else {
                sorting[sortIdx][1] = asSorting[nextSortIdx];
                sorting[sortIdx]._idx = nextSortIdx;
            }
        } else if (shift) {
            // No sort on this column yet, being added by shift click
            // add it as itself
            sorting.push([
                colIdx,
                asSorting[0],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        } else {
            // No sort on this column yet, being added from a colspan
            // so add with same direction as first column
            sorting.push([
                colIdx,
                sorting[0][1],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        }
    } else if (sorting.length && sorting[0][0] == colIdx) {
        // Single column - already sorting on this column, modify the sort
        nextSortIdx = next(sorting[0]);
        sorting.length = 1;
        sorting[0][1] = asSorting[nextSortIdx];
        sorting[0]._idx = nextSortIdx;
    } else {
        // Single column - sort only on this column
        sorting.length = 0;
        sorting.push([
            colIdx,
            asSorting[0]
        ]);
        sorting[0]._idx = 0;
    }
}
/**
 * Set the sorting classes on table's body, Note: it is safe to call this function
 * when bSort and bSortClasses are false
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSortingClasses(settings) {
    var oldSort = settings.aLastSort;
    var sortClass = settings.oClasses.order.position;
    var sort = $44bb6d473543b89d$var$_fnSortFlatten(settings);
    var features = settings.oFeatures;
    var i, iLen, colIdx;
    if (features.bSort && features.bSortClasses) {
        // Remove old sorting classes
        for(i = 0, iLen = oldSort.length; i < iLen; i++){
            colIdx = oldSort[i].src;
            // Remove column sorting
            $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_pluck(settings.aoData, 'anCells', colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
        }
        // Add new column sorting
        for(i = 0, iLen = sort.length; i < iLen; i++){
            colIdx = sort[i].src;
            $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_pluck(settings.aoData, 'anCells', colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
        }
    }
    settings.aLastSort = sort;
}
// Get the data to sort a column, be it from cache, fresh (populating the
// cache), or from a sort formatter
function $44bb6d473543b89d$var$_fnSortData(settings, colIdx) {
    // Custom sorting function - provided by the sort data type
    var column = settings.aoColumns[colIdx];
    var customSort = $44bb6d473543b89d$var$DataTable.ext.order[column.sSortDataType];
    var customData;
    if (customSort) customData = customSort.call(settings.oInstance, settings, colIdx, $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, colIdx));
    // Use / populate cache
    var row, cellData;
    var formatter = $44bb6d473543b89d$var$DataTable.ext.type.order[column.sType + "-pre"];
    var data = settings.aoData;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        // Sparse array
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aSortData) row._aSortData = [];
        if (!row._aSortData[colIdx] || customSort) {
            cellData = customSort ? customData[rowIdx] : $44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, colIdx, 'sort');
            row._aSortData[colIdx] = formatter ? formatter(cellData, settings) : cellData;
        }
    }
}
/**
 * State information for a table
 *
 * @param {*} settings
 * @returns State object
 */ function $44bb6d473543b89d$var$_fnSaveState(settings) {
    if (settings._bLoadingState) return;
    // Sort state saving uses [[idx, order]] structure.
    var sorting = [];
    $44bb6d473543b89d$var$_fnSortResolve(settings, sorting, settings.aaSorting);
    /* Store the interesting variables */ var columns = settings.aoColumns;
    var state = {
        time: +new Date(),
        start: settings._iDisplayStart,
        length: settings._iDisplayLength,
        order: sorting.map(function(sort) {
            // If a column name is available, use it
            return columns[sort[0]] && columns[sort[0]].sName ? [
                columns[sort[0]].sName,
                sort[1]
            ] : sort.slice();
        }),
        search: $44bb6d473543b89d$var$$.extend({}, settings.oPreviousSearch),
        columns: settings.aoColumns.map(function(col, i) {
            return {
                name: col.sName,
                visible: col.bVisible,
                search: $44bb6d473543b89d$var$$.extend({}, settings.aoPreSearchCols[i])
            };
        })
    };
    settings.oSavedState = state;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, "aoStateSaveParams", 'stateSaveParams', [
        settings,
        state
    ]);
    if (settings.oFeatures.bStateSave && !settings.bDestroying) settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
}
/**
 * Attempt to load a saved table state
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oInit DataTables init object so we can override settings
 *  @param {function} callback Callback to execute when the state has been loaded
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnLoadState(settings, init, callback) {
    if (!settings.oFeatures.bStateSave) {
        callback();
        return;
    }
    var loaded = function(state) {
        $44bb6d473543b89d$var$_fnImplementState(settings, state, callback);
    };
    var state = settings.fnStateLoadCallback.call(settings.oInstance, settings, loaded);
    if (state !== undefined) $44bb6d473543b89d$var$_fnImplementState(settings, state, callback);
    // otherwise, wait for the loaded callback to be executed
    return true;
}
function $44bb6d473543b89d$var$_fnImplementState(settings, s, callback) {
    var i, iLen;
    var columns = settings.aoColumns;
    var currentNames = $44bb6d473543b89d$var$_pluck(settings.aoColumns, 'sName');
    settings._bLoadingState = true;
    // When StateRestore was introduced the state could now be implemented at any time
    // Not just initialisation. To do this an api instance is required in some places
    var api = settings._bInitComplete ? new $44bb6d473543b89d$var$DataTable.Api(settings) : null;
    if (!s || !s.time) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Reject old data
    var duration = settings.iStateDuration;
    if (duration > 0 && s.time < +new Date() - duration * 1000) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Allow custom and plug-in manipulation functions to alter the saved data set and
    // cancelling of loading by returning false
    var abStateLoad = $44bb6d473543b89d$var$_fnCallbackFire(settings, 'aoStateLoadParams', 'stateLoadParams', [
        settings,
        s
    ]);
    if (abStateLoad.indexOf(false) !== -1) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Store the saved state so it might be accessed at any time
    settings.oLoadedState = $44bb6d473543b89d$var$$.extend(true, {}, s);
    // This is needed for ColReorder, which has to happen first to allow all
    // the stored indexes to be usable. It is not publicly documented.
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'stateLoadInit', [
        settings,
        s
    ], true);
    // Page Length
    if (s.length !== undefined) {
        // If already initialised just set the value directly so that the select element is also updated
        if (api) api.page.len(s.length);
        else settings._iDisplayLength = s.length;
    }
    // Restore key features
    if (s.start !== undefined) {
        if (api === null) {
            settings._iDisplayStart = s.start;
            settings.iInitDisplayStart = s.start;
        } else $44bb6d473543b89d$var$_fnPageChange(settings, s.start / settings._iDisplayLength);
    }
    // Order
    if (s.order !== undefined) {
        settings.aaSorting = [];
        $44bb6d473543b89d$var$$.each(s.order, function(i, col) {
            var set = [
                col[0],
                col[1]
            ];
            // A column name was stored and should be used for restore
            if (typeof col[0] === 'string') {
                // Find the name from the current list of column names
                var idx = currentNames.indexOf(col[0]);
                if (idx < 0) // If the column was not found ignore it and continue
                return;
                set[0] = idx;
            } else if (set[0] >= columns.length) // If the column index is out of bounds ignore it and continue
            return;
            settings.aaSorting.push(set);
        });
    }
    // Search
    if (s.search !== undefined) $44bb6d473543b89d$var$$.extend(settings.oPreviousSearch, s.search);
    // Columns
    if (s.columns) {
        var set = s.columns;
        var incoming = $44bb6d473543b89d$var$_pluck(s.columns, 'name');
        // Check if it is a 2.2 style state object with a `name` property for the columns, and if
        // the name was defined. If so, then create a new array that will map the state object
        // given, to the current columns (don't bother if they are already matching tho).
        if (incoming.join('').length && incoming.join('') !== currentNames.join('')) {
            set = [];
            // For each column, try to find the name in the incoming array
            for(i = 0; i < currentNames.length; i++)if (currentNames[i] != '') {
                var idx = incoming.indexOf(currentNames[i]);
                if (idx >= 0) set.push(s.columns[idx]);
                else // No matching column name in the state's columns, so this might be a new
                // column and thus can't have a state already.
                set.push({});
            } else // If no name, but other columns did have a name, then there is no knowing
            // where this one came from originally so it can't be restored.
            set.push({});
        }
        // If the number of columns to restore is different from current, then all bets are off.
        if (set.length === columns.length) {
            for(i = 0, iLen = set.length; i < iLen; i++){
                var col = set[i];
                // Visibility
                if (col.visible !== undefined) {
                    // If the api is defined, the table has been initialised so we need to use it rather than internal settings
                    if (api) // Don't redraw the columns on every iteration of this loop, we will do this at the end instead
                    api.column(i).visible(col.visible, false);
                    else columns[i].bVisible = col.visible;
                }
                // Search
                if (col.search !== undefined) $44bb6d473543b89d$var$$.extend(settings.aoPreSearchCols[i], col.search);
            }
            // If the api is defined then we need to adjust the columns once the visibility has been changed
            if (api) api.one('draw', function() {
                api.columns.adjust();
            });
        }
    }
    settings._bLoadingState = false;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, 'aoStateLoaded', 'stateLoaded', [
        settings,
        s
    ]);
    callback();
}
/**
 * Log an error message
 *  @param {object} settings dataTables settings object
 *  @param {int} level log error messages, or display them to the user
 *  @param {string} msg error message
 *  @param {int} tn Technical note id to get more information about the error.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnLog(settings, level, msg, tn) {
    msg = 'DataTables warning: ' + (settings ? 'table id=' + settings.sTableId + ' - ' : '') + msg;
    if (tn) msg += ". For more information about this error, please see https://datatables.net/tn/" + tn;
    if (!level) {
        // Backwards compatibility pre 1.10
        var ext = $44bb6d473543b89d$var$DataTable.ext;
        var type = ext.sErrMode || ext.errMode;
        if (settings) $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'dt-error', [
            settings,
            tn,
            msg
        ], true);
        if (type == 'alert') alert(msg);
        else if (type == 'throw') throw new Error(msg);
        else if (typeof type == 'function') type(settings, tn, msg);
    } else if (window.console && console.log) console.log(msg);
}
/**
 * See if a property is defined on one object, if so assign it to the other object
 *  @param {object} ret target object
 *  @param {object} src source object
 *  @param {string} name property
 *  @param {string} [mappedName] name to map too - optional, name used if not given
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnMap(ret, src, name, mappedName) {
    if (Array.isArray(name)) {
        $44bb6d473543b89d$var$$.each(name, function(i, val) {
            if (Array.isArray(val)) $44bb6d473543b89d$var$_fnMap(ret, src, val[0], val[1]);
            else $44bb6d473543b89d$var$_fnMap(ret, src, val);
        });
        return;
    }
    if (mappedName === undefined) mappedName = name;
    if (src[name] !== undefined) ret[mappedName] = src[name];
}
/**
 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
 * shallow copy arrays. The reason we need to do this, is that we don't want to
 * deep copy array init values (such as aaSorting) since the dev wouldn't be
 * able to override them, but we do want to deep copy arrays.
 *  @param {object} out Object to extend
 *  @param {object} extender Object from which the properties will be applied to
 *      out
 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
 *      independent copy with the exception of the `data` or `aaData` parameters
 *      if they are present. This is so you can pass in a collection to
 *      DataTables and have that used as your data source without breaking the
 *      references
 *  @returns {object} out Reference, just for convenience - out === the return.
 *  @memberof DataTable#oApi
 *  @todo This doesn't take account of arrays inside the deep copied objects.
 */ function $44bb6d473543b89d$var$_fnExtend(out, extender, breakRefs) {
    var val;
    for(var prop in extender)if (Object.prototype.hasOwnProperty.call(extender, prop)) {
        val = extender[prop];
        if ($44bb6d473543b89d$var$$.isPlainObject(val)) {
            if (!$44bb6d473543b89d$var$$.isPlainObject(out[prop])) out[prop] = {};
            $44bb6d473543b89d$var$$.extend(true, out[prop], val);
        } else if (breakRefs && prop !== 'data' && prop !== 'aaData' && Array.isArray(val)) out[prop] = val.slice();
        else out[prop] = val;
    }
    return out;
}
/**
 * Bind an event handler to allow a click or return key to activate the callback.
 * This is good for accessibility since a return on the keyboard will have the
 * same effect as a click, if the element has focus.
 *  @param {element} n Element to bind the action to
 *  @param {object|string} selector Selector (for delegated events) or data object
 *   to pass to the triggered function
 *  @param {function} fn Callback function for when the event is triggered
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnBindAction(n, selector, fn) {
    $44bb6d473543b89d$var$$(n).on('click.DT', selector, function(e) {
        fn(e);
    }).on('keypress.DT', selector, function(e) {
        if (e.which === 13) {
            e.preventDefault();
            fn(e);
        }
    }).on('selectstart.DT', selector, function() {
        // Don't want a double click resulting in text selection
        return false;
    });
}
/**
 * Register a callback function. Easily allows a callback function to be added to
 * an array store of callback functions that can then all be called together.
 *  @param {object} settings dataTables settings object
 *  @param {string} store Name of the array storage for the callbacks in oSettings
 *  @param {function} fn Function to be called back
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCallbackReg(settings, store, fn) {
    if (fn) settings[store].push(fn);
}
/**
 * Fire callback functions and trigger events. Note that the loop over the
 * callback array store is done backwards! Further note that you do not want to
 * fire off triggers in time sensitive applications (for example cell creation)
 * as its slow.
 *  @param {object} settings dataTables settings object
 *  @param {string} callbackArr Name of the array storage for the callbacks in
 *      oSettings
 *  @param {string} eventName Name of the jQuery custom event to trigger. If
 *      null no trigger is fired
 *  @param {array} args Array of arguments to pass to the callback function /
 *      trigger
 *  @param {boolean} [bubbles] True if the event should bubble
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCallbackFire(settings, callbackArr, eventName, args, bubbles) {
    var ret = [];
    if (callbackArr) ret = settings[callbackArr].slice().reverse().map(function(val) {
        return val.apply(settings.oInstance, args);
    });
    if (eventName !== null) {
        var e = $44bb6d473543b89d$var$$.Event(eventName + '.dt');
        var table = $44bb6d473543b89d$var$$(settings.nTable);
        // Expose the DataTables API on the event object for easy access
        e.dt = settings.api;
        table[bubbles ? 'trigger' : 'triggerHandler'](e, args);
        // If not yet attached to the document, trigger the event
        // on the body directly to sort of simulate the bubble
        if (bubbles && table.parents('body').length === 0) $44bb6d473543b89d$var$$('body').trigger(e, args);
        ret.push(e.result);
    }
    return ret;
}
function $44bb6d473543b89d$var$_fnLengthOverflow(settings) {
    var start = settings._iDisplayStart, end = settings.fnDisplayEnd(), len = settings._iDisplayLength;
    /* If we have space to show extra rows (backing up from the end point - then do so */ if (start >= end) start = end - len;
    // Keep the start record on the current page
    start -= start % len;
    if (len === -1 || start < 0) start = 0;
    settings._iDisplayStart = start;
}
function $44bb6d473543b89d$var$_fnRenderer(settings, type) {
    var renderer = settings.renderer;
    var host = $44bb6d473543b89d$var$DataTable.ext.renderer[type];
    if ($44bb6d473543b89d$var$$.isPlainObject(renderer) && renderer[type]) // Specific renderer for this type. If available use it, otherwise use
    // the default.
    return host[renderer[type]] || host._;
    else if (typeof renderer === 'string') // Common renderer - if there is one available for this type use it,
    // otherwise use the default
    return host[renderer] || host._;
    // Use the default
    return host._;
}
/**
 * Detect the data source being used for the table. Used to simplify the code
 * a little (ajax) and to make it compress a little smaller.
 *
 *  @param {object} settings dataTables settings object
 *  @returns {string} Data source
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDataSource(settings) {
    if (settings.oFeatures.bServerSide) return 'ssp';
    else if (settings.ajax) return 'ajax';
    return 'dom';
}
/**
 * Common replacement for language strings
 *
 * @param {*} settings DT settings object
 * @param {*} str String with values to replace
 * @param {*} entries Plural number for _ENTRIES_ - can be undefined
 * @returns String
 */ function $44bb6d473543b89d$var$_fnMacros(settings, str, entries) {
    // When infinite scrolling, we are always starting at 1. _iDisplayStart is
    // used only internally
    var formatter = settings.fnFormatNumber, start = settings._iDisplayStart + 1, len = settings._iDisplayLength, vis = settings.fnRecordsDisplay(), max = settings.fnRecordsTotal(), all = len === -1;
    return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, max)).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len))).replace(/_ENTRIES_/g, settings.api.i18n('entries', '', entries)).replace(/_ENTRIES-MAX_/g, settings.api.i18n('entries', '', max)).replace(/_ENTRIES-TOTAL_/g, settings.api.i18n('entries', '', vis));
}
/**
 * Add elements to an array as quickly as possible, but stack safe.
 *
 * @param {*} arr Array to add the data to
 * @param {*} data Data array that is to be added
 * @returns 
 */ function $44bb6d473543b89d$var$_fnArrayApply(arr, data) {
    if (!data) return;
    // Chrome can throw a max stack error if apply is called with
    // too large an array, but apply is faster.
    if (data.length < 10000) arr.push.apply(arr, data);
    else for($44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < data.length; $44bb6d473543b89d$var$i++)arr.push(data[$44bb6d473543b89d$var$i]);
}
/**
 * Add one or more listeners to the table
 *
 * @param {*} that JQ for the table
 * @param {*} name Event name
 * @param {*} src Listener(s)
 */ function $44bb6d473543b89d$var$_fnListener(that, name, src) {
    if (!Array.isArray(src)) src = [
        src
    ];
    for($44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < src.length; $44bb6d473543b89d$var$i++)that.on(name + '.dt', src[$44bb6d473543b89d$var$i]);
}
/**
 * Escape HTML entities in strings, in an object
 */ function $44bb6d473543b89d$var$_fnEscapeObject(obj) {
    if ($44bb6d473543b89d$var$DataTable.ext.escape.attributes) $44bb6d473543b89d$var$$.each(obj, function(key, val) {
        obj[key] = $44bb6d473543b89d$var$_escapeHtml(val);
    });
    return obj;
}
/**
 * Computed structure of the DataTables API, defined by the options passed to
 * `DataTable.Api.register()` when building the API.
 *
 * The structure is built in order to speed creation and extension of the Api
 * objects since the extensions are effectively pre-parsed.
 *
 * The array is an array of objects with the following structure, where this
 * base array represents the Api prototype base:
 *
 *     [
 *       {
 *         name:      'data'                -- string   - Property name
 *         val:       function () {},       -- function - Api method (or undefined if just an object
 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
 *       },
 *       {
 *         name:     'row'
 *         val:       {},
 *         methodExt: [ ... ],
 *         propExt:   [
 *           {
 *             name:      'data'
 *             val:       function () {},
 *             methodExt: [ ... ],
 *             propExt:   [ ... ]
 *           },
 *           ...
 *         ]
 *       }
 *     ]
 *
 * @type {Array}
 * @ignore
 */ var $44bb6d473543b89d$var$__apiStruct = [];
/**
 * `Array.prototype` reference.
 *
 * @type object
 * @ignore
 */ var $44bb6d473543b89d$var$__arrayProto = Array.prototype;
/**
 * Abstraction for `context` parameter of the `Api` constructor to allow it to
 * take several different forms for ease of use.
 *
 * Each of the input parameter types will be converted to a DataTables settings
 * object where possible.
 *
 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
 *   of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 *   * `DataTables.Api` - API instance
 * @return {array|null} Matching DataTables settings objects. `null` or
 *   `undefined` is returned if no matching DataTable is found.
 * @ignore
 */ var $44bb6d473543b89d$var$_toSettings = function(mixed) {
    var idx, jq;
    var settings = $44bb6d473543b89d$var$DataTable.settings;
    var tables = $44bb6d473543b89d$var$_pluck(settings, 'nTable');
    if (!mixed) return [];
    else if (mixed.nTable && mixed.oFeatures) // DataTables settings object
    return [
        mixed
    ];
    else if (mixed.nodeName && mixed.nodeName.toLowerCase() === 'table') {
        // Table node
        idx = tables.indexOf(mixed);
        return idx !== -1 ? [
            settings[idx]
        ] : null;
    } else if (mixed && typeof mixed.settings === 'function') return mixed.settings().toArray();
    else if (typeof mixed === 'string') // jQuery selector
    jq = $44bb6d473543b89d$var$$(mixed).get();
    else if (mixed instanceof $44bb6d473543b89d$var$$) // jQuery object (also DataTables instance)
    jq = mixed.get();
    if (jq) return settings.filter(function(v, idx) {
        return jq.includes(tables[idx]);
    });
};
/**
 * DataTables API class - used to control and interface with  one or more
 * DataTables enhanced tables.
 *
 * The API class is heavily based on jQuery, presenting a chainable interface
 * that you can use to interact with tables. Each instance of the API class has
 * a "context" - i.e. the tables that it will operate on. This could be a single
 * table, all tables on a page or a sub-set thereof.
 *
 * Additionally the API is designed to allow you to easily work with the data in
 * the tables, retrieving and manipulating it as required. This is done by
 * presenting the API class as an array like interface. The contents of the
 * array depend upon the actions requested by each method (for example
 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
 * return an array of objects or arrays depending upon your table's
 * configuration). The API object has a number of array like methods (`push`,
 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
 * `unique` etc) to assist your working with the data held in a table.
 *
 * Most methods (those which return an Api instance) are chainable, which means
 * the return from a method call also has all of the methods available that the
 * top level object had. For example, these two calls are equivalent:
 *
 *     // Not chained
 *     api.row.add( {...} );
 *     api.draw();
 *
 *     // Chained
 *     api.row.add( {...} ).draw();
 *
 * @class DataTable.Api
 * @param {array|object|string|jQuery} context DataTable identifier. This is
 *   used to define which DataTables enhanced tables this API will operate on.
 *   Can be one of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 * @param {array} [data] Data to initialise the Api instance with.
 *
 * @example
 *   // Direct initialisation during DataTables construction
 *   var api = $('#example').DataTable();
 *
 * @example
 *   // Initialisation using a DataTables jQuery object
 *   var api = $('#example').dataTable().api();
 *
 * @example
 *   // Initialisation as a constructor
 *   var api = new DataTable.Api( 'table.dataTable' );
 */ $44bb6d473543b89d$var$_Api = function(context, data) {
    if (!(this instanceof $44bb6d473543b89d$var$_Api)) return new $44bb6d473543b89d$var$_Api(context, data);
    var i;
    var settings = [];
    var ctxSettings = function(o) {
        var a = $44bb6d473543b89d$var$_toSettings(o);
        if (a) settings.push.apply(settings, a);
    };
    if (Array.isArray(context)) for(i = 0; i < context.length; i++)ctxSettings(context[i]);
    else ctxSettings(context);
    // Remove duplicates
    this.context = settings.length > 1 ? $44bb6d473543b89d$var$_unique(settings) : settings;
    // Initial data
    $44bb6d473543b89d$var$_fnArrayApply(this, data);
    // selector
    this.selector = {
        rows: null,
        cols: null,
        opts: null
    };
    $44bb6d473543b89d$var$_Api.extend(this, this, $44bb6d473543b89d$var$__apiStruct);
};
$44bb6d473543b89d$var$DataTable.Api = $44bb6d473543b89d$var$_Api;
// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
// isPlainObject.
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$_Api.prototype, {
    any: function() {
        return this.count() !== 0;
    },
    context: [],
    count: function() {
        return this.flatten().length;
    },
    each: function(fn) {
        for(var i = 0, iLen = this.length; i < iLen; i++)fn.call(this, this[i], i, this);
        return this;
    },
    eq: function(idx) {
        var ctx = this.context;
        return ctx.length > idx ? new $44bb6d473543b89d$var$_Api(ctx[idx], this[idx]) : null;
    },
    filter: function(fn) {
        var a = $44bb6d473543b89d$var$__arrayProto.filter.call(this, fn, this);
        return new $44bb6d473543b89d$var$_Api(this.context, a);
    },
    flatten: function() {
        var a = [];
        return new $44bb6d473543b89d$var$_Api(this.context, a.concat.apply(a, this.toArray()));
    },
    get: function(idx) {
        return this[idx];
    },
    join: $44bb6d473543b89d$var$__arrayProto.join,
    includes: function(find) {
        return this.indexOf(find) === -1 ? false : true;
    },
    indexOf: $44bb6d473543b89d$var$__arrayProto.indexOf,
    iterator: function(flatten, type, fn, alwaysNew) {
        var a = [], ret, i, iLen, j, jen, context = this.context, rows, items, item, selector = this.selector;
        // Argument shifting
        if (typeof flatten === 'string') {
            alwaysNew = fn;
            fn = type;
            type = flatten;
            flatten = false;
        }
        for(i = 0, iLen = context.length; i < iLen; i++){
            var apiInst = new $44bb6d473543b89d$var$_Api(context[i]);
            if (type === 'table') {
                ret = fn.call(apiInst, context[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'columns' || type === 'rows') {
                // this has same length as context - one entry for each table
                ret = fn.call(apiInst, context[i], this[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'every' || type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell') {
                // columns and rows share the same structure.
                // 'this' is an array of column indexes for each context
                items = this[i];
                if (type === 'column-rows') rows = $44bb6d473543b89d$var$_selector_row_indexes(context[i], selector.opts);
                for(j = 0, jen = items.length; j < jen; j++){
                    item = items[j];
                    if (type === 'cell') ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
                    else ret = fn.call(apiInst, context[i], item, i, j, rows);
                    if (ret !== undefined) a.push(ret);
                }
            }
        }
        if (a.length || alwaysNew) {
            var api = new $44bb6d473543b89d$var$_Api(context, flatten ? a.concat.apply([], a) : a);
            var apiSelector = api.selector;
            apiSelector.rows = selector.rows;
            apiSelector.cols = selector.cols;
            apiSelector.opts = selector.opts;
            return api;
        }
        return this;
    },
    lastIndexOf: $44bb6d473543b89d$var$__arrayProto.lastIndexOf,
    length: 0,
    map: function(fn) {
        var a = $44bb6d473543b89d$var$__arrayProto.map.call(this, fn, this);
        return new $44bb6d473543b89d$var$_Api(this.context, a);
    },
    pluck: function(prop) {
        var fn = $44bb6d473543b89d$var$DataTable.util.get(prop);
        return this.map(function(el) {
            return fn(el);
        });
    },
    pop: $44bb6d473543b89d$var$__arrayProto.pop,
    push: $44bb6d473543b89d$var$__arrayProto.push,
    reduce: $44bb6d473543b89d$var$__arrayProto.reduce,
    reduceRight: $44bb6d473543b89d$var$__arrayProto.reduceRight,
    reverse: $44bb6d473543b89d$var$__arrayProto.reverse,
    // Object with rows, columns and opts
    selector: null,
    shift: $44bb6d473543b89d$var$__arrayProto.shift,
    slice: function() {
        return new $44bb6d473543b89d$var$_Api(this.context, this);
    },
    sort: $44bb6d473543b89d$var$__arrayProto.sort,
    splice: $44bb6d473543b89d$var$__arrayProto.splice,
    toArray: function() {
        return $44bb6d473543b89d$var$__arrayProto.slice.call(this);
    },
    to$: function() {
        return $44bb6d473543b89d$var$$(this);
    },
    toJQuery: function() {
        return $44bb6d473543b89d$var$$(this);
    },
    unique: function() {
        return new $44bb6d473543b89d$var$_Api(this.context, $44bb6d473543b89d$var$_unique(this.toArray()));
    },
    unshift: $44bb6d473543b89d$var$__arrayProto.unshift
});
function $44bb6d473543b89d$var$_api_scope(scope, fn, struct) {
    return function() {
        var ret = fn.apply(scope || this, arguments);
        // Method extension
        $44bb6d473543b89d$var$_Api.extend(ret, ret, struct.methodExt);
        return ret;
    };
}
function $44bb6d473543b89d$var$_api_find(src, name) {
    for(var i = 0, iLen = src.length; i < iLen; i++){
        if (src[i].name === name) return src[i];
    }
    return null;
}
window.__apiStruct = $44bb6d473543b89d$var$__apiStruct;
$44bb6d473543b89d$var$_Api.extend = function(scope, obj, ext) {
    // Only extend API instances and static properties of the API
    if (!ext.length || !obj || !(obj instanceof $44bb6d473543b89d$var$_Api) && !obj.__dt_wrapper) return;
    var i, iLen, struct;
    for(i = 0, iLen = ext.length; i < iLen; i++){
        struct = ext[i];
        if (struct.name === '__proto__') continue;
        // Value
        obj[struct.name] = struct.type === 'function' ? $44bb6d473543b89d$var$_api_scope(scope, struct.val, struct) : struct.type === 'object' ? {} : struct.val;
        obj[struct.name].__dt_wrapper = true;
        // Property extension
        $44bb6d473543b89d$var$_Api.extend(scope, obj[struct.name], struct.propExt);
    }
};
//     [
//       {
//         name:      'data'                -- string   - Property name
//         val:       function () {},       -- function - Api method (or undefined if just an object
//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
//       },
//       {
//         name:     'row'
//         val:       {},
//         methodExt: [ ... ],
//         propExt:   [
//           {
//             name:      'data'
//             val:       function () {},
//             methodExt: [ ... ],
//             propExt:   [ ... ]
//           },
//           ...
//         ]
//       }
//     ]
$44bb6d473543b89d$var$_Api.register = $44bb6d473543b89d$var$_api_register = function(name, val) {
    if (Array.isArray(name)) {
        for(var j = 0, jen = name.length; j < jen; j++)$44bb6d473543b89d$var$_Api.register(name[j], val);
        return;
    }
    var i, iLen, heir = name.split('.'), struct = $44bb6d473543b89d$var$__apiStruct, key, method;
    for(i = 0, iLen = heir.length; i < iLen; i++){
        method = heir[i].indexOf('()') !== -1;
        key = method ? heir[i].replace('()', '') : heir[i];
        var src = $44bb6d473543b89d$var$_api_find(struct, key);
        if (!src) {
            src = {
                name: key,
                val: {},
                methodExt: [],
                propExt: [],
                type: 'object'
            };
            struct.push(src);
        }
        if (i === iLen - 1) {
            src.val = val;
            src.type = typeof val === 'function' ? 'function' : $44bb6d473543b89d$var$$.isPlainObject(val) ? 'object' : 'other';
        } else struct = method ? src.methodExt : src.propExt;
    }
};
$44bb6d473543b89d$var$_Api.registerPlural = $44bb6d473543b89d$var$_api_registerPlural = function(pluralName, singularName, val) {
    $44bb6d473543b89d$var$_Api.register(pluralName, val);
    $44bb6d473543b89d$var$_Api.register(singularName, function() {
        var ret = val.apply(this, arguments);
        if (ret === this) // Returned item is the API instance that was passed in, return it
        return this;
        else if (ret instanceof $44bb6d473543b89d$var$_Api) // New API instance returned, want the value from the first item
        // in the returned array for the singular result.
        return ret.length ? Array.isArray(ret[0]) ? new $44bb6d473543b89d$var$_Api(ret.context, ret[0]) : ret[0] : undefined;
        // Non-API return - just fire it back
        return ret;
    });
};
/**
 * Selector for HTML tables. Apply the given selector to the give array of
 * DataTables settings objects.
 *
 * @param {string|integer} [selector] jQuery selector string or integer
 * @param  {array} Array of DataTables settings objects to be filtered
 * @return {array}
 * @ignore
 */ var $44bb6d473543b89d$var$__table_selector = function(selector, a) {
    if (Array.isArray(selector)) {
        var result = [];
        selector.forEach(function(sel) {
            var inner = $44bb6d473543b89d$var$__table_selector(sel, a);
            $44bb6d473543b89d$var$_fnArrayApply(result, inner);
        });
        return result.filter(function(item) {
            return item;
        });
    }
    // Integer is used to pick out a table by index
    if (typeof selector === 'number') return [
        a[selector]
    ];
    // Perform a jQuery selector on the table nodes
    var nodes = a.map(function(el) {
        return el.nTable;
    });
    return $44bb6d473543b89d$var$$(nodes).filter(selector).map(function() {
        // Need to translate back from the table node to the settings
        var idx = nodes.indexOf(this);
        return a[idx];
    }).toArray();
};
/**
 * Context selector for the API's context (i.e. the tables the API instance
 * refers to.
 *
 * @name    DataTable.Api#tables
 * @param {string|integer} [selector] Selector to pick which tables the iterator
 *   should operate on. If not given, all tables in the current context are
 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
 *   select multiple tables or as an integer to select a single table.
 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
 */ $44bb6d473543b89d$var$_api_register('tables()', function(selector) {
    // A new instance is created if there was a selector specified
    return selector !== undefined && selector !== null ? new $44bb6d473543b89d$var$_Api($44bb6d473543b89d$var$__table_selector(selector, this.context)) : this;
});
$44bb6d473543b89d$var$_api_register('table()', function(selector) {
    var tables = this.tables(selector);
    var ctx = tables.context;
    // Truncate to the first matched table
    return ctx.length ? new $44bb6d473543b89d$var$_Api(ctx[0]) : tables;
});
// Common methods, combined to reduce size
[
    [
        'nodes',
        'node',
        'nTable'
    ],
    [
        'body',
        'body',
        'nTBody'
    ],
    [
        'header',
        'header',
        'nTHead'
    ],
    [
        'footer',
        'footer',
        'nTFoot'
    ]
].forEach(function(item) {
    $44bb6d473543b89d$var$_api_registerPlural('tables().' + item[0] + '()', 'table().' + item[1] + '()', function() {
        return this.iterator('table', function(ctx) {
            return ctx[item[2]];
        }, 1);
    });
});
// Structure methods
[
    [
        'header',
        'aoHeader'
    ],
    [
        'footer',
        'aoFooter'
    ]
].forEach(function(item) {
    $44bb6d473543b89d$var$_api_register('table().' + item[0] + '.structure()', function(selector) {
        var indexes = this.columns(selector).indexes().flatten().toArray();
        var ctx = this.context[0];
        var structure = $44bb6d473543b89d$var$_fnHeaderLayout(ctx, ctx[item[1]], indexes);
        // The structure is in column index order - but from this method we want the return to be
        // in the columns() selector API order. In order to do that we need to map from one form
        // to the other
        var orderedIndexes = indexes.slice().sort(function(a, b) {
            return a - b;
        });
        return structure.map(function(row) {
            return indexes.map(function(colIdx) {
                return row[orderedIndexes.indexOf(colIdx)];
            });
        });
    });
});
$44bb6d473543b89d$var$_api_registerPlural('tables().containers()', 'table().container()', function() {
    return this.iterator('table', function(ctx) {
        return ctx.nTableWrapper;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('tables().every()', function(fn) {
    var that = this;
    return this.iterator('table', function(s, i) {
        fn.call(that.table(i), i);
    });
});
$44bb6d473543b89d$var$_api_register('caption()', function(value, side) {
    var context = this.context;
    // Getter - return existing node's content
    if (value === undefined) {
        var caption = context[0].captionNode;
        return caption && context.length ? caption.innerHTML : null;
    }
    return this.iterator('table', function(ctx) {
        var table = $44bb6d473543b89d$var$$(ctx.nTable);
        var caption = $44bb6d473543b89d$var$$(ctx.captionNode);
        var container = $44bb6d473543b89d$var$$(ctx.nTableWrapper);
        // Create the node if it doesn't exist yet
        if (!caption.length) {
            caption = $44bb6d473543b89d$var$$('<caption/>').html(value);
            ctx.captionNode = caption[0];
            // If side isn't set, we need to insert into the document to let the
            // CSS decide so we can read it back, otherwise there is no way to
            // know if the CSS would put it top or bottom for scrolling
            if (!side) {
                table.prepend(caption);
                side = caption.css('caption-side');
            }
        }
        caption.html(value);
        if (side) {
            caption.css('caption-side', side);
            caption[0]._captionSide = side;
        }
        if (container.find('div.dataTables_scroll').length) {
            var selector = side === 'top' ? 'Head' : 'Foot';
            container.find('div.dataTables_scroll' + selector + ' table').prepend(caption);
        } else table.prepend(caption);
    }, 1);
});
$44bb6d473543b89d$var$_api_register('caption.node()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].captionNode : null;
});
/**
 * Redraw the tables in the current context.
 */ $44bb6d473543b89d$var$_api_register('draw()', function(paging) {
    return this.iterator('table', function(settings) {
        if (paging === 'page') $44bb6d473543b89d$var$_fnDraw(settings);
        else {
            if (typeof paging === 'string') paging = paging === 'full-hold' ? false : true;
            $44bb6d473543b89d$var$_fnReDraw(settings, paging === false);
        }
    });
});
/**
 * Get the current page index.
 *
 * @return {integer} Current page index (zero based)
 */ /**
 * Set the current page.
 *
 * Note that if you attempt to show a page which does not exist, DataTables will
 * not throw an error, but rather reset the paging.
 *
 * @param {integer|string} action The paging action to take. This can be one of:
 *  * `integer` - The page index to jump to
 *  * `string` - An action to take:
 *    * `first` - Jump to first page.
 *    * `next` - Jump to the next page
 *    * `previous` - Jump to previous page
 *    * `last` - Jump to the last page.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('page()', function(action) {
    if (action === undefined) return this.page.info().page; // not an expensive call
    // else, have an action to take on all tables
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnPageChange(settings, action);
    });
});
/**
 * Paging information for the first table in the current context.
 *
 * If you require paging information for another table, use the `table()` method
 * with a suitable selector.
 *
 * @return {object} Object with the following properties set:
 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
 *  * `pages` - Total number of pages
 *  * `start` - Display index for the first record shown on the current page
 *  * `end` - Display index for the last record shown on the current page
 *  * `length` - Display length (number of records). Note that generally `start
 *    + length = end`, but this is not always true, for example if there are
 *    only 2 records to show on the final page, with a length of 10.
 *  * `recordsTotal` - Full data set length
 *  * `recordsDisplay` - Data set length once the current filtering criterion
 *    are applied.
 */ $44bb6d473543b89d$var$_api_register('page.info()', function() {
    if (this.context.length === 0) return undefined;
    var settings = this.context[0], start = settings._iDisplayStart, len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1, visRecords = settings.fnRecordsDisplay(), all = len === -1;
    return {
        "page": all ? 0 : Math.floor(start / len),
        "pages": all ? 1 : Math.ceil(visRecords / len),
        "start": start,
        "end": settings.fnDisplayEnd(),
        "length": len,
        "recordsTotal": settings.fnRecordsTotal(),
        "recordsDisplay": visRecords,
        "serverSide": $44bb6d473543b89d$var$_fnDataSource(settings) === 'ssp'
    };
});
/**
 * Get the current page length.
 *
 * @return {integer} Current page length. Note `-1` indicates that all records
 *   are to be shown.
 */ /**
 * Set the current page length.
 *
 * @param {integer} Page length to set. Use `-1` to show all records.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('page.len()', function(len) {
    // Note that we can't call this function 'length()' because `length`
    // is a JavaScript property of functions which defines how many arguments
    // the function expects.
    if (len === undefined) return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
    // else, set the page length
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnLengthChange(settings, len);
    });
});
var $44bb6d473543b89d$var$__reload = function(settings, holdPosition, callback) {
    // Use the draw event to trigger a callback
    if (callback) {
        var api = new $44bb6d473543b89d$var$_Api(settings);
        api.one('draw', function() {
            callback(api.ajax.json());
        });
    }
    if ($44bb6d473543b89d$var$_fnDataSource(settings) == 'ssp') $44bb6d473543b89d$var$_fnReDraw(settings, holdPosition);
    else {
        $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
        // Cancel an existing request
        var xhr = settings.jqXHR;
        if (xhr && xhr.readyState !== 4) xhr.abort();
        // Trigger xhr
        $44bb6d473543b89d$var$_fnBuildAjax(settings, {}, function(json) {
            $44bb6d473543b89d$var$_fnClearTable(settings);
            var data = $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json);
            for(var i = 0, iLen = data.length; i < iLen; i++)$44bb6d473543b89d$var$_fnAddData(settings, data[i]);
            $44bb6d473543b89d$var$_fnReDraw(settings, holdPosition);
            $44bb6d473543b89d$var$_fnInitComplete(settings);
            $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
        });
    }
};
/**
 * Get the JSON response from the last Ajax request that DataTables made to the
 * server. Note that this returns the JSON from the first table in the current
 * context.
 *
 * @return {object} JSON received from the server.
 */ $44bb6d473543b89d$var$_api_register('ajax.json()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].json;
// else return undefined;
});
/**
 * Get the data submitted in the last Ajax request
 */ $44bb6d473543b89d$var$_api_register('ajax.params()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].oAjaxData;
// else return undefined;
});
/**
 * Reload tables from the Ajax data source. Note that this function will
 * automatically re-draw the table when the remote data has been loaded.
 *
 * @param {boolean} [reset=true] Reset (default) or hold the current paging
 *   position. A full re-sort and re-filter is performed when this method is
 *   called, which is why the pagination reset is the default action.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('ajax.reload()', function(callback, resetPaging) {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$__reload(settings, resetPaging === false, callback);
    });
});
/**
 * Get the current Ajax URL. Note that this returns the URL from the first
 * table in the current context.
 *
 * @return {string} Current Ajax source URL
 */ /**
 * Set the Ajax URL. Note that this will set the URL for all tables in the
 * current context.
 *
 * @param {string} url URL to set.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('ajax.url()', function(url) {
    var ctx = this.context;
    if (url === undefined) {
        // get
        if (ctx.length === 0) return undefined;
        ctx = ctx[0];
        return $44bb6d473543b89d$var$$.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax;
    }
    // set
    return this.iterator('table', function(settings) {
        if ($44bb6d473543b89d$var$$.isPlainObject(settings.ajax)) settings.ajax.url = url;
        else settings.ajax = url;
    });
});
/**
 * Load data from the newly set Ajax URL. Note that this method is only
 * available when `ajax.url()` is used to set a URL. Additionally, this method
 * has the same effect as calling `ajax.reload()` but is provided for
 * convenience when setting a new URL. Like `ajax.reload()` it will
 * automatically redraw the table once the remote data has been loaded.
 *
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('ajax.url().load()', function(callback, resetPaging) {
    // Same as a reload, but makes sense to present it for easy access after a
    // url change
    return this.iterator('table', function(ctx) {
        $44bb6d473543b89d$var$__reload(ctx, resetPaging === false, callback);
    });
});
var $44bb6d473543b89d$var$_selector_run = function(type, selector, selectFn, settings, opts) {
    var out = [], res, i, iLen, selectorType = typeof selector;
    // Can't just check for isArray here, as an API or jQuery instance might be
    // given with their array like look
    if (!selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined) selector = [
        selector
    ];
    for(i = 0, iLen = selector.length; i < iLen; i++){
        res = selectFn(typeof selector[i] === 'string' ? selector[i].trim() : selector[i]);
        // Remove empty items
        res = res.filter(function(item) {
            return item !== null && item !== undefined;
        });
        if (res && res.length) out = out.concat(res);
    }
    // selector extensions
    var ext = $44bb6d473543b89d$var$_ext.selector[type];
    if (ext.length) for(i = 0, iLen = ext.length; i < iLen; i++)out = ext[i](settings, opts, out);
    return $44bb6d473543b89d$var$_unique(out);
};
var $44bb6d473543b89d$var$_selector_opts = function(opts) {
    if (!opts) opts = {};
    // Backwards compatibility for 1.9- which used the terminology filter rather
    // than search
    if (opts.filter && opts.search === undefined) opts.search = opts.filter;
    return $44bb6d473543b89d$var$$.extend({
        columnOrder: 'implied',
        search: 'none',
        order: 'current',
        page: 'all'
    }, opts);
};
// Reduce the API instance to the first item found
var $44bb6d473543b89d$var$_selector_first = function(old) {
    var inst = new $44bb6d473543b89d$var$_Api(old.context[0]);
    // Use a push rather than passing to the constructor, since it will
    // merge arrays down automatically, which isn't what is wanted here
    if (old.length) inst.push(old[0]);
    inst.selector = old.selector;
    // Limit to a single row / column / cell
    if (inst.length && inst[0].length > 1) inst[0].splice(1);
    return inst;
};
var $44bb6d473543b89d$var$_selector_row_indexes = function(settings, opts) {
    var i, iLen, tmp, a = [], displayFiltered = settings.aiDisplay, displayMaster = settings.aiDisplayMaster;
    var search = opts.search, order = opts.order, page = opts.page; // all, current
    if ($44bb6d473543b89d$var$_fnDataSource(settings) == 'ssp') // In server-side processing mode, most options are irrelevant since
    // rows not shown don't exist and the index order is the applied order
    // Removed is a special case - for consistency just return an empty
    // array
    return search === 'removed' ? [] : $44bb6d473543b89d$var$_range(0, displayMaster.length);
    if (page == 'current') // Current page implies that order=current and filter=applied, since it is
    // fairly senseless otherwise, regardless of what order and search actually
    // are
    for(i = settings._iDisplayStart, iLen = settings.fnDisplayEnd(); i < iLen; i++)a.push(displayFiltered[i]);
    else if (order == 'current' || order == 'applied') {
        if (search == 'none') a = displayMaster.slice();
        else if (search == 'applied') a = displayFiltered.slice();
        else if (search == 'removed') {
            // O(n+m) solution by creating a hash map
            var displayFilteredMap = {};
            for(i = 0, iLen = displayFiltered.length; i < iLen; i++)displayFilteredMap[displayFiltered[i]] = null;
            displayMaster.forEach(function(item) {
                if (!Object.prototype.hasOwnProperty.call(displayFilteredMap, item)) a.push(item);
            });
        }
    } else if (order == 'index' || order == 'original') for(i = 0, iLen = settings.aoData.length; i < iLen; i++){
        if (!settings.aoData[i]) continue;
        if (search == 'none') a.push(i);
        else {
            tmp = displayFiltered.indexOf(i);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(i);
        }
    }
    else if (typeof order === 'number') {
        // Order the rows by the given column
        var ordered = $44bb6d473543b89d$var$_fnSort(settings, order, 'asc');
        if (search === 'none') a = ordered;
        else for(i = 0; i < ordered.length; i++){
            tmp = displayFiltered.indexOf(ordered[i]);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(ordered[i]);
        }
    }
    return a;
};
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Rows
 *
 * {}          - no selector - use all available rows
 * {integer}   - row aoData index
 * {node}      - TR node
 * {string}    - jQuery selector to apply to the TR elements
 * {array}     - jQuery array of nodes, or simply an array of TR nodes
 *
 */ var $44bb6d473543b89d$var$__row_selector = function(settings, selector, opts) {
    var rows;
    var run = function(sel) {
        var selInt = $44bb6d473543b89d$var$_intVal(sel);
        var aoData = settings.aoData;
        // Short cut - selector is a number and no options provided (default is
        // all records, so no need to check if the index is in there, since it
        // must be - dev error if the index doesn't exist).
        if (selInt !== null && !opts) return [
            selInt
        ];
        if (!rows) rows = $44bb6d473543b89d$var$_selector_row_indexes(settings, opts);
        if (selInt !== null && rows.indexOf(selInt) !== -1) // Selector - integer
        return [
            selInt
        ];
        else if (sel === null || sel === undefined || sel === '') // Selector - none
        return rows;
        // Selector - function
        if (typeof sel === 'function') return rows.map(function(idx) {
            var row = aoData[idx];
            return sel(idx, row._aData, row.nTr) ? idx : null;
        });
        // Selector - node
        if (sel.nodeName) {
            var rowIdx = sel._DT_RowIndex; // Property added by DT for fast lookup
            var cellIdx = sel._DT_CellIndex;
            if (rowIdx !== undefined) // Make sure that the row is actually still present in the table
            return aoData[rowIdx] && aoData[rowIdx].nTr === sel ? [
                rowIdx
            ] : [];
            else if (cellIdx) return aoData[cellIdx.row] && aoData[cellIdx.row].nTr === sel.parentNode ? [
                cellIdx.row
            ] : [];
            else {
                var host = $44bb6d473543b89d$var$$(sel).closest('*[data-dt-row]');
                return host.length ? [
                    host.data('dt-row')
                ] : [];
            }
        }
        // ID selector. Want to always be able to select rows by id, regardless
        // of if the tr element has been created or not, so can't rely upon
        // jQuery here - hence a custom implementation. This does not match
        // Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
        // but to select it using a CSS selector engine (like Sizzle or
        // querySelect) it would need to need to be escaped for some characters.
        // DataTables simplifies this for row selectors since you can select
        // only a row. A # indicates an id any anything that follows is the id -
        // unescaped.
        if (typeof sel === 'string' && sel.charAt(0) === '#') {
            // get row index from id
            var rowObj = settings.aIds[sel.replace(/^#/, '')];
            if (rowObj !== undefined) return [
                rowObj.idx
            ];
        // need to fall through to jQuery in case there is DOM id that
        // matches
        }
        // Get nodes in the order from the `rows` array with null values removed
        var nodes = $44bb6d473543b89d$var$_removeEmpty($44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, 'nTr'));
        // Selector - jQuery selector string, array of nodes or jQuery object/
        // As jQuery's .filter() allows jQuery objects to be passed in filter,
        // it also allows arrays, so this will cope with all three options
        return $44bb6d473543b89d$var$$(nodes).filter(sel).map(function() {
            return this._DT_RowIndex;
        }).toArray();
    };
    var matched = $44bb6d473543b89d$var$_selector_run('row', selector, run, settings, opts);
    if (opts.order === 'current' || opts.order === 'applied') $44bb6d473543b89d$var$_fnSortDisplay(settings, matched);
    return matched;
};
$44bb6d473543b89d$var$_api_register('rows()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($44bb6d473543b89d$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = $44bb6d473543b89d$var$_selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$__row_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in __row_selector?
    inst.selector.rows = selector;
    inst.selector.opts = opts;
    return inst;
});
$44bb6d473543b89d$var$_api_register('rows().nodes()', function() {
    return this.iterator('row', function(settings, row) {
        return settings.aoData[row].nTr || undefined;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('rows().data()', function() {
    return this.iterator(true, 'rows', function(settings, rows) {
        return $44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, '_aData');
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().cache()', 'row().cache()', function(type) {
    return this.iterator('row', function(settings, row) {
        var r = settings.aoData[row];
        return type === 'search' ? r._aFilterData : r._aSortData;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().invalidate()', 'row().invalidate()', function(src) {
    return this.iterator('row', function(settings, row) {
        $44bb6d473543b89d$var$_fnInvalidate(settings, row, src);
    });
});
$44bb6d473543b89d$var$_api_registerPlural('rows().indexes()', 'row().index()', function() {
    return this.iterator('row', function(settings, row) {
        return row;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().ids()', 'row().id()', function(hash) {
    var a = [];
    var context = this.context;
    // `iterator` will drop undefined values, but in this case we want them
    for(var i = 0, iLen = context.length; i < iLen; i++)for(var j = 0, jen = this[i].length; j < jen; j++){
        var id = context[i].rowIdFn(context[i].aoData[this[i][j]]._aData);
        a.push((hash === true ? '#' : '') + id);
    }
    return new $44bb6d473543b89d$var$_Api(context, a);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().remove()', 'row().remove()', function() {
    this.iterator('row', function(settings, row) {
        var data = settings.aoData;
        var rowData = data[row];
        // Delete from the display arrays
        var idx = settings.aiDisplayMaster.indexOf(row);
        if (idx !== -1) settings.aiDisplayMaster.splice(idx, 1);
        // For server-side processing tables - subtract the deleted row from the count
        if (settings._iRecordsDisplay > 0) settings._iRecordsDisplay--;
        // Check for an 'overflow' they case for displaying the table
        $44bb6d473543b89d$var$_fnLengthOverflow(settings);
        // Remove the row's ID reference if there is one
        var id = settings.rowIdFn(rowData._aData);
        if (id !== undefined) delete settings.aIds[id];
        data[row] = null;
    });
    return this;
});
$44bb6d473543b89d$var$_api_register('rows.add()', function(rows) {
    var newRows = this.iterator('table', function(settings) {
        var row, i, iLen;
        var out = [];
        for(i = 0, iLen = rows.length; i < iLen; i++){
            row = rows[i];
            if (row.nodeName && row.nodeName.toUpperCase() === 'TR') out.push($44bb6d473543b89d$var$_fnAddTr(settings, row)[0]);
            else out.push($44bb6d473543b89d$var$_fnAddData(settings, row));
        }
        return out;
    }, 1);
    // Return an Api.rows() extended instance, so rows().nodes() etc can be used
    var modRows = this.rows(-1);
    modRows.pop();
    $44bb6d473543b89d$var$_fnArrayApply(modRows, newRows);
    return modRows;
});
/**
 *
 */ $44bb6d473543b89d$var$_api_register('row()', function(selector, opts) {
    return $44bb6d473543b89d$var$_selector_first(this.rows(selector, opts));
});
$44bb6d473543b89d$var$_api_register('row().data()', function(data) {
    var ctx = this.context;
    if (data === undefined) // Get
    return ctx.length && this.length && this[0].length ? ctx[0].aoData[this[0]]._aData : undefined;
    // Set
    var row = ctx[0].aoData[this[0]];
    row._aData = data;
    // If the DOM has an id, and the data source is an array
    if (Array.isArray(data) && row.nTr && row.nTr.id) $44bb6d473543b89d$var$_fnSetObjectDataFn(ctx[0].rowId)(data, row.nTr.id);
    // Automatically invalidate
    $44bb6d473543b89d$var$_fnInvalidate(ctx[0], this[0], 'data');
    return this;
});
$44bb6d473543b89d$var$_api_register('row().node()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && this[0].length) {
        var row = ctx[0].aoData[this[0]];
        if (row && row.nTr) return row.nTr;
    }
    return null;
});
$44bb6d473543b89d$var$_api_register('row.add()', function(row) {
    // Allow a jQuery object to be passed in - only a single row is added from
    // it though - the first element in the set
    if (row instanceof $44bb6d473543b89d$var$$ && row.length) row = row[0];
    var rows = this.iterator('table', function(settings) {
        if (row.nodeName && row.nodeName.toUpperCase() === 'TR') return $44bb6d473543b89d$var$_fnAddTr(settings, row)[0];
        return $44bb6d473543b89d$var$_fnAddData(settings, row);
    });
    // Return an Api.rows() extended instance, with the newly added row selected
    return this.row(rows[0]);
});
$44bb6d473543b89d$var$$(document).on('plugin-init.dt', function(e, context) {
    var api = new $44bb6d473543b89d$var$_Api(context);
    api.on('stateSaveParams.DT', function(e, settings, d) {
        // This could be more compact with the API, but it is a lot faster as a simple
        // internal loop
        var idFn = settings.rowIdFn;
        var rows = settings.aiDisplayMaster;
        var ids = [];
        for(var i = 0; i < rows.length; i++){
            var rowIdx = rows[i];
            var data = settings.aoData[rowIdx];
            if (data._detailsShow) ids.push('#' + idFn(data._aData));
        }
        d.childRows = ids;
    });
    // For future state loads (e.g. with StateRestore)
    api.on('stateLoaded.DT', function(e, settings, state) {
        $44bb6d473543b89d$var$__details_state_load(api, state);
    });
    // And the initial load state
    $44bb6d473543b89d$var$__details_state_load(api, api.state.loaded());
});
var $44bb6d473543b89d$var$__details_state_load = function(api, state) {
    if (state && state.childRows) api.rows(state.childRows.map(function(id) {
        // Escape any `:` characters from the row id. Accounts for
        // already escaped characters.
        return id.replace(/([^:\\]*(?:\\.[^:\\]*)*):/g, "$1\\:");
    })).every(function() {
        $44bb6d473543b89d$var$_fnCallbackFire(api.settings()[0], null, 'requestChild', [
            this
        ]);
    });
};
var $44bb6d473543b89d$var$__details_add = function(ctx, row, data, klass) {
    // Convert to array of TR elements
    var rows = [];
    var addRow = function(r, k) {
        // Recursion to allow for arrays of jQuery objects
        if (Array.isArray(r) || r instanceof $44bb6d473543b89d$var$$) {
            for(var i = 0, iLen = r.length; i < iLen; i++)addRow(r[i], k);
            return;
        }
        // If we get a TR element, then just add it directly - up to the dev
        // to add the correct number of columns etc
        if (r.nodeName && r.nodeName.toLowerCase() === 'tr') {
            r.setAttribute('data-dt-row', row.idx);
            rows.push(r);
        } else {
            // Otherwise create a row with a wrapper
            var created = $44bb6d473543b89d$var$$('<tr><td></td></tr>').attr('data-dt-row', row.idx).addClass(k);
            $44bb6d473543b89d$var$$('td', created).addClass(k).html(r)[0].colSpan = $44bb6d473543b89d$var$_fnVisibleColumns(ctx);
            rows.push(created[0]);
        }
    };
    addRow(data, klass);
    if (row._details) row._details.detach();
    row._details = $44bb6d473543b89d$var$$(rows);
    // If the children were already shown, that state should be retained
    if (row._detailsShow) row._details.insertAfter(row.nTr);
};
// Make state saving of child row details async to allow them to be batch processed
var $44bb6d473543b89d$var$__details_state = $44bb6d473543b89d$var$DataTable.util.throttle(function(ctx) {
    $44bb6d473543b89d$var$_fnSaveState(ctx[0]);
}, 500);
var $44bb6d473543b89d$var$__details_remove = function(api, idx) {
    var ctx = api.context;
    if (ctx.length) {
        var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];
        if (row && row._details) {
            row._details.detach();
            row._detailsShow = undefined;
            row._details = undefined;
            $44bb6d473543b89d$var$$(row.nTr).removeClass('dt-hasChild');
            $44bb6d473543b89d$var$__details_state(ctx);
        }
    }
};
var $44bb6d473543b89d$var$__details_display = function(api, show) {
    var ctx = api.context;
    if (ctx.length && api.length) {
        var row = ctx[0].aoData[api[0]];
        if (row._details) {
            row._detailsShow = show;
            if (show) {
                row._details.insertAfter(row.nTr);
                $44bb6d473543b89d$var$$(row.nTr).addClass('dt-hasChild');
            } else {
                row._details.detach();
                $44bb6d473543b89d$var$$(row.nTr).removeClass('dt-hasChild');
            }
            $44bb6d473543b89d$var$_fnCallbackFire(ctx[0], null, 'childRow', [
                show,
                api.row(api[0])
            ]);
            $44bb6d473543b89d$var$__details_events(ctx[0]);
            $44bb6d473543b89d$var$__details_state(ctx);
        }
    }
};
var $44bb6d473543b89d$var$__details_events = function(settings) {
    var api = new $44bb6d473543b89d$var$_Api(settings);
    var namespace = '.dt.DT_details';
    var drawEvent = 'draw' + namespace;
    var colvisEvent = 'column-sizing' + namespace;
    var destroyEvent = 'destroy' + namespace;
    var data = settings.aoData;
    api.off(drawEvent + ' ' + colvisEvent + ' ' + destroyEvent);
    if ($44bb6d473543b89d$var$_pluck(data, '_details').length > 0) {
        // On each draw, insert the required elements into the document
        api.on(drawEvent, function(e, ctx) {
            if (settings !== ctx) return;
            api.rows({
                page: 'current'
            }).eq(0).each(function(idx) {
                // Internal data grab
                var row = data[idx];
                if (row._detailsShow) row._details.insertAfter(row.nTr);
            });
        });
        // Column visibility change - update the colspan
        api.on(colvisEvent, function(e, ctx) {
            if (settings !== ctx) return;
            // Update the colspan for the details rows (note, only if it already has
            // a colspan)
            var row, visible = $44bb6d473543b89d$var$_fnVisibleColumns(ctx);
            for(var i = 0, iLen = data.length; i < iLen; i++){
                row = data[i];
                if (row && row._details) row._details.each(function() {
                    var el = $44bb6d473543b89d$var$$(this).children('td');
                    if (el.length == 1) el.attr('colspan', visible);
                });
            }
        });
        // Table destroyed - nuke any child rows
        api.on(destroyEvent, function(e, ctx) {
            if (settings !== ctx) return;
            for(var i = 0, iLen = data.length; i < iLen; i++)if (data[i] && data[i]._details) $44bb6d473543b89d$var$__details_remove(api, i);
        });
    }
};
// Strings for the method names to help minification
var $44bb6d473543b89d$var$_emp = '';
var $44bb6d473543b89d$var$_child_obj = $44bb6d473543b89d$var$_emp + 'row().child';
var $44bb6d473543b89d$var$_child_mth = $44bb6d473543b89d$var$_child_obj + '()';
// data can be:
//  tr
//  string
//  jQuery or array of any of the above
$44bb6d473543b89d$var$_api_register($44bb6d473543b89d$var$_child_mth, function(data, klass) {
    var ctx = this.context;
    if (data === undefined) // get
    return ctx.length && this.length && ctx[0].aoData[this[0]] ? ctx[0].aoData[this[0]]._details : undefined;
    else if (data === true) // show
    this.child.show();
    else if (data === false) // remove
    $44bb6d473543b89d$var$__details_remove(this);
    else if (ctx.length && this.length) // set
    $44bb6d473543b89d$var$__details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
    return this;
});
$44bb6d473543b89d$var$_api_register([
    $44bb6d473543b89d$var$_child_obj + '.show()',
    $44bb6d473543b89d$var$_child_mth + '.show()' // only when `child()` was called with parameters (without
], function() {
    $44bb6d473543b89d$var$__details_display(this, true);
    return this;
});
$44bb6d473543b89d$var$_api_register([
    $44bb6d473543b89d$var$_child_obj + '.hide()',
    $44bb6d473543b89d$var$_child_mth + '.hide()' // only when `child()` was called with parameters (without
], function() {
    $44bb6d473543b89d$var$__details_display(this, false);
    return this;
});
$44bb6d473543b89d$var$_api_register([
    $44bb6d473543b89d$var$_child_obj + '.remove()',
    $44bb6d473543b89d$var$_child_mth + '.remove()' // only when `child()` was called with parameters (without
], function() {
    $44bb6d473543b89d$var$__details_remove(this);
    return this;
});
$44bb6d473543b89d$var$_api_register($44bb6d473543b89d$var$_child_obj + '.isShown()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && ctx[0].aoData[this[0]]) // _detailsShown as false or undefined will fall through to return false
    return ctx[0].aoData[this[0]]._detailsShow || false;
    return false;
});
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Columns
 *
 * {integer}           - column index (>=0 count from left, <0 count from right)
 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
 * "{string}:name"     - column name
 * "{string}"          - jQuery selector on column header nodes
 *
 */ // can be an array of these items, comma separated list, or an array of comma
// separated lists
var $44bb6d473543b89d$var$__re_column_selector = /^([^:]+)?:(name|title|visIdx|visible)$/;
// r1 and r2 are redundant - but it means that the parameters match for the
// iterator callback in columns().data()
var $44bb6d473543b89d$var$__columnData = function(settings, column, r1, r2, rows, type) {
    var a = [];
    for(var row = 0, iLen = rows.length; row < iLen; row++)a.push($44bb6d473543b89d$var$_fnGetCellData(settings, rows[row], column, type));
    return a;
};
var $44bb6d473543b89d$var$__column_header = function(settings, column, row) {
    var header = settings.aoHeader;
    var titleRow = settings.titleRow;
    var target = null;
    if (row !== undefined) target = row;
    else if (titleRow === true) target = 0;
    else if (titleRow === false) target = header.length - 1;
    else if (titleRow !== null) target = titleRow;
    else {
        // Automatic - find the _last_ unique cell from the top that is not empty (last for
        // backwards compatibility)
        for(var i = 0; i < header.length; i++)if (header[i][column].unique && $44bb6d473543b89d$var$$('.dt-column-title', header[i][column].cell).text()) target = i;
        if (target === null) target = 0;
    }
    return header[target][column].cell;
};
var $44bb6d473543b89d$var$__column_header_cells = function(header) {
    var out = [];
    for(var i = 0; i < header.length; i++)for(var j = 0; j < header[i].length; j++){
        var cell = header[i][j].cell;
        if (!out.includes(cell)) out.push(cell);
    }
    return out;
};
var $44bb6d473543b89d$var$__column_selector = function(settings, selector, opts) {
    var columns = settings.aoColumns, names, titles, nodes = $44bb6d473543b89d$var$__column_header_cells(settings.aoHeader);
    var run = function(s) {
        var selInt = $44bb6d473543b89d$var$_intVal(s);
        // Selector - all
        if (s === '') return $44bb6d473543b89d$var$_range(columns.length);
        // Selector - index
        if (selInt !== null) return [
            selInt >= 0 ? selInt : columns.length + selInt // Count from right (+ because its a negative value)
        ];
        // Selector = function
        if (typeof s === 'function') {
            var rows = $44bb6d473543b89d$var$_selector_row_indexes(settings, opts);
            return columns.map(function(col, idx) {
                return s(idx, $44bb6d473543b89d$var$__columnData(settings, idx, 0, 0, rows), $44bb6d473543b89d$var$__column_header(settings, idx)) ? idx : null;
            });
        }
        // jQuery or string selector
        var match = typeof s === 'string' ? s.match($44bb6d473543b89d$var$__re_column_selector) : '';
        if (match) switch(match[2]){
            case 'visIdx':
            case 'visible':
                // Selector is a column index
                if (match[1] && match[1].match(/^\d+$/)) {
                    var idx = parseInt(match[1], 10);
                    // Visible index given, convert to column index
                    if (idx < 0) {
                        // Counting from the right
                        var visColumns = columns.map(function(col, i) {
                            return col.bVisible ? i : null;
                        });
                        return [
                            visColumns[visColumns.length + idx]
                        ];
                    }
                    // Counting from the left
                    return [
                        $44bb6d473543b89d$var$_fnVisibleToColumnIndex(settings, idx)
                    ];
                }
                return columns.map(function(col, idx) {
                    // Not visible, can't match
                    if (!col.bVisible) return null;
                    if (col.responsiveVisible === false) return null;
                    // Selector
                    if (match[1]) return $44bb6d473543b89d$var$$(nodes[idx]).filter(match[1]).length > 0 ? idx : null;
                    // `:visible` on its own
                    return idx;
                });
            case 'name':
                // Don't get names, unless needed, and only get once if it is
                if (!names) names = $44bb6d473543b89d$var$_pluck(columns, 'sName');
                // match by name. `names` is column index complete and in order
                return names.map(function(name, i) {
                    return name === match[1] ? i : null;
                });
            case 'title':
                if (!titles) titles = $44bb6d473543b89d$var$_pluck(columns, 'sTitle');
                // match by column title
                return titles.map(function(title, i) {
                    return title === match[1] ? i : null;
                });
            default:
                return [];
        }
        // Cell in the table body
        if (s.nodeName && s._DT_CellIndex) return [
            s._DT_CellIndex.column
        ];
        // jQuery selector on the TH elements for the columns
        var jqResult = $44bb6d473543b89d$var$$(nodes).filter(s).map(function() {
            return $44bb6d473543b89d$var$_fnColumnsFromHeader(this); // `nodes` is column index complete and in order
        }).toArray().sort(function(a, b) {
            return a - b;
        });
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise a node which might have a `dt-column` data attribute, or be
        // a child or such an element
        var host = $44bb6d473543b89d$var$$(s).closest('*[data-dt-column]');
        return host.length ? [
            host.data('dt-column')
        ] : [];
    };
    var selected = $44bb6d473543b89d$var$_selector_run('column', selector, run, settings, opts);
    return opts.columnOrder && opts.columnOrder === 'index' ? selected.sort(function(a, b) {
        return a - b;
    }) : selected; // implied
};
var $44bb6d473543b89d$var$__setColumnVis = function(settings, column, vis) {
    var cols = settings.aoColumns, col = cols[column], data = settings.aoData, cells, i, iLen, tr;
    // Get
    if (vis === undefined) return col.bVisible;
    // Set
    // No change
    if (col.bVisible === vis) return false;
    if (vis) {
        // Insert column
        // Need to decide if we should use appendChild or insertBefore
        var insertBefore = $44bb6d473543b89d$var$_pluck(cols, 'bVisible').indexOf(true, column + 1);
        for(i = 0, iLen = data.length; i < iLen; i++)if (data[i]) {
            tr = data[i].nTr;
            cells = data[i].anCells;
            if (tr) // insertBefore can act like appendChild if 2nd arg is null
            tr.insertBefore(cells[column], cells[insertBefore] || null);
        }
    } else // Remove column
    $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_pluck(settings.aoData, 'anCells', column)).detach();
    // Common actions
    col.bVisible = vis;
    $44bb6d473543b89d$var$_colGroup(settings);
    return true;
};
$44bb6d473543b89d$var$_api_register('columns()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($44bb6d473543b89d$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = $44bb6d473543b89d$var$_selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$__column_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in _row_selector?
    inst.selector.cols = selector;
    inst.selector.opts = opts;
    return inst;
});
$44bb6d473543b89d$var$_api_registerPlural('columns().header()', 'column().header()', function(row) {
    return this.iterator('column', function(settings, column) {
        return $44bb6d473543b89d$var$__column_header(settings, column, row);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().footer()', 'column().footer()', function(row) {
    return this.iterator('column', function(settings, column) {
        var footer = settings.aoFooter;
        if (!footer.length) return null;
        return settings.aoFooter[row !== undefined ? row : 0][column].cell;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().data()', 'column().data()', function() {
    return this.iterator('column-rows', $44bb6d473543b89d$var$__columnData, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().render()', 'column().render()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $44bb6d473543b89d$var$__columnData(settings, column, i, j, rows, type);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().dataSrc()', 'column().dataSrc()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column].mData;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().cache()', 'column().cache()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, type === 'search' ? '_aFilterData' : '_aSortData', column);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().init()', 'column().init()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column];
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().names()', 'column().name()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column].sName;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().nodes()', 'column().nodes()', function() {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, 'anCells', column);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().titles()', 'column().title()', function(title, row) {
    return this.iterator('column', function(settings, column) {
        // Argument shifting
        if (typeof title === 'number') {
            row = title;
            title = undefined;
        }
        var span = $44bb6d473543b89d$var$$('.dt-column-title', this.column(column).header(row));
        if (title !== undefined) {
            span.html(title);
            return this;
        }
        return span.html();
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().types()', 'column().type()', function() {
    return this.iterator('column', function(settings, column) {
        var colObj = settings.aoColumns[column];
        var type = colObj.sType;
        // If the type was invalidated, then resolve it. This actually does
        // all columns at the moment. Would only happen once if getting all
        // column's data types.
        if (!type) {
            $44bb6d473543b89d$var$_fnColumnTypes(settings);
            type = colObj.sType;
        }
        return type;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().visible()', 'column().visible()', function(vis, calc) {
    var that = this;
    var changed = [];
    var ret = this.iterator('column', function(settings, column) {
        if (vis === undefined) return settings.aoColumns[column].bVisible;
         // else
        if ($44bb6d473543b89d$var$__setColumnVis(settings, column, vis)) changed.push(column);
    });
    // Group the column visibility changes
    if (vis !== undefined) this.iterator('table', function(settings) {
        // Redraw the header after changes
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoHeader);
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoFooter);
        // Update colspan for no records display. Child rows and extensions will use their own
        // listeners to do this - only need to update the empty table item here
        if (!settings.aiDisplay.length) $44bb6d473543b89d$var$$(settings.nTBody).find('td[colspan]').attr('colspan', $44bb6d473543b89d$var$_fnVisibleColumns(settings));
        $44bb6d473543b89d$var$_fnSaveState(settings);
        // Second loop once the first is done for events
        that.iterator('column', function(settings, column) {
            if (changed.includes(column)) $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'column-visibility', [
                settings,
                column,
                vis,
                calc
            ]);
        });
        if (changed.length && (calc === undefined || calc)) that.columns.adjust();
    });
    return ret;
});
$44bb6d473543b89d$var$_api_registerPlural('columns().widths()', 'column().width()', function() {
    // Injects a fake row into the table for just a moment so the widths can
    // be read, regardless of colspan in the header and rows being present in
    // the body
    var columns = this.columns(':visible').count();
    var row = $44bb6d473543b89d$var$$('<tr>').html('<td>' + Array(columns).join('</td><td>') + '</td>');
    $44bb6d473543b89d$var$$(this.table().body()).append(row);
    var widths = row.children().map(function() {
        return $44bb6d473543b89d$var$$(this).outerWidth();
    });
    row.remove();
    return this.iterator('column', function(settings, column) {
        var visIdx = $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, column);
        return visIdx !== null ? widths[visIdx] : 0;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().indexes()', 'column().index()', function(type) {
    return this.iterator('column', function(settings, column) {
        return type === 'visible' ? $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, column) : column;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('columns.adjust()', function() {
    return this.iterator('table', function(settings) {
        // Force a column sizing to happen with a manual call - otherwise it can skip
        // if the size hasn't changed
        settings.containerWidth = -1;
        $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
    }, 1);
});
$44bb6d473543b89d$var$_api_register('column.index()', function(type, idx) {
    if (this.context.length !== 0) {
        var ctx = this.context[0];
        if (type === 'fromVisible' || type === 'toData') return $44bb6d473543b89d$var$_fnVisibleToColumnIndex(ctx, idx);
        else if (type === 'fromData' || type === 'toVisible') return $44bb6d473543b89d$var$_fnColumnIndexToVisible(ctx, idx);
    }
});
$44bb6d473543b89d$var$_api_register('column()', function(selector, opts) {
    return $44bb6d473543b89d$var$_selector_first(this.columns(selector, opts));
});
var $44bb6d473543b89d$var$__cell_selector = function(settings, selector, opts) {
    var data = settings.aoData;
    var rows = $44bb6d473543b89d$var$_selector_row_indexes(settings, opts);
    var cells = $44bb6d473543b89d$var$_removeEmpty($44bb6d473543b89d$var$_pluck_order(data, rows, 'anCells'));
    var allCells = $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_flatten([], cells));
    var row;
    var columns = settings.aoColumns.length;
    var a, i, iLen, j, o, host;
    var run = function(s) {
        var fnSelector = typeof s === 'function';
        if (s === null || s === undefined || fnSelector) {
            // All cells and function selectors
            a = [];
            for(i = 0, iLen = rows.length; i < iLen; i++){
                row = rows[i];
                for(j = 0; j < columns; j++){
                    o = {
                        row: row,
                        column: j
                    };
                    if (fnSelector) {
                        // Selector - function
                        host = data[row];
                        if (s(o, $44bb6d473543b89d$var$_fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null)) a.push(o);
                    } else // Selector - all
                    a.push(o);
                }
            }
            return a;
        }
        // Selector - index
        if ($44bb6d473543b89d$var$$.isPlainObject(s)) // Valid cell index and its in the array of selectable rows
        return s.column !== undefined && s.row !== undefined && rows.indexOf(s.row) !== -1 ? [
            s
        ] : [];
        // Selector - jQuery filtered cells
        var jqResult = allCells.filter(s).map(function(i, el) {
            return {
                row: el._DT_CellIndex.row,
                column: el._DT_CellIndex.column
            };
        }).toArray();
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise the selector is a node, and there is one last option - the
        // element might be a child of an element which has dt-row and dt-column
        // data attributes
        host = $44bb6d473543b89d$var$$(s).closest('*[data-dt-row]');
        return host.length ? [
            {
                row: host.data('dt-row'),
                column: host.data('dt-column')
            }
        ] : [];
    };
    return $44bb6d473543b89d$var$_selector_run('cell', selector, run, settings, opts);
};
$44bb6d473543b89d$var$_api_register('cells()', function(rowSelector, columnSelector, opts) {
    // Argument shifting
    if ($44bb6d473543b89d$var$$.isPlainObject(rowSelector)) {
        // Indexes
        if (rowSelector.row === undefined) {
            // Selector options in first parameter
            opts = rowSelector;
            rowSelector = null;
        } else {
            // Cell index objects in first parameter
            opts = columnSelector;
            columnSelector = null;
        }
    }
    if ($44bb6d473543b89d$var$$.isPlainObject(columnSelector)) {
        opts = columnSelector;
        columnSelector = null;
    }
    // Cell selector
    if (columnSelector === null || columnSelector === undefined) return this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$__cell_selector(settings, rowSelector, $44bb6d473543b89d$var$_selector_opts(opts));
    });
    // The default built in options need to apply to row and columns
    var internalOpts = opts ? {
        page: opts.page,
        order: opts.order,
        search: opts.search
    } : {};
    // Row + column selector
    var columns = this.columns(columnSelector, internalOpts);
    var rows = this.rows(rowSelector, internalOpts);
    var i, iLen, j, jen;
    var cellsNoOpts = this.iterator('table', function(settings, idx) {
        var a = [];
        for(i = 0, iLen = rows[idx].length; i < iLen; i++)for(j = 0, jen = columns[idx].length; j < jen; j++)a.push({
            row: rows[idx][i],
            column: columns[idx][j]
        });
        return a;
    }, 1);
    // There is currently only one extension which uses a cell selector extension
    // It is a _major_ performance drag to run this if it isn't needed, so this is
    // an extension specific check at the moment
    var cells = opts && opts.selected ? this.cells(cellsNoOpts, opts) : cellsNoOpts;
    $44bb6d473543b89d$var$$.extend(cells.selector, {
        cols: columnSelector,
        rows: rowSelector,
        opts: opts
    });
    return cells;
});
$44bb6d473543b89d$var$_api_registerPlural('cells().nodes()', 'cell().node()', function() {
    return this.iterator('cell', function(settings, row, column) {
        var data = settings.aoData[row];
        return data && data.anCells ? data.anCells[column] : undefined;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('cells().data()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return $44bb6d473543b89d$var$_fnGetCellData(settings, row, column);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().cache()', 'cell().cache()', function(type) {
    type = type === 'search' ? '_aFilterData' : '_aSortData';
    return this.iterator('cell', function(settings, row, column) {
        return settings.aoData[row][type][column];
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().render()', 'cell().render()', function(type) {
    return this.iterator('cell', function(settings, row, column) {
        return $44bb6d473543b89d$var$_fnGetCellData(settings, row, column, type);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().indexes()', 'cell().index()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return {
            row: row,
            column: column,
            columnVisible: $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, column)
        };
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().invalidate()', 'cell().invalidate()', function(src) {
    return this.iterator('cell', function(settings, row, column) {
        $44bb6d473543b89d$var$_fnInvalidate(settings, row, src, column);
    });
});
$44bb6d473543b89d$var$_api_register('cell()', function(rowSelector, columnSelector, opts) {
    return $44bb6d473543b89d$var$_selector_first(this.cells(rowSelector, columnSelector, opts));
});
$44bb6d473543b89d$var$_api_register('cell().data()', function(data) {
    var ctx = this.context;
    var cell = this[0];
    if (data === undefined) // Get
    return ctx.length && cell.length ? $44bb6d473543b89d$var$_fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
    // Set
    $44bb6d473543b89d$var$_fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
    $44bb6d473543b89d$var$_fnInvalidate(ctx[0], cell[0].row, 'data', cell[0].column);
    return this;
});
/**
 * Get current ordering (sorting) that has been applied to the table.
 *
 * @returns {array} 2D array containing the sorting information for the first
 *   table in the current context. Each element in the parent array represents
 *   a column being sorted upon (i.e. multi-sorting with two columns would have
 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
 *   the column index that the sorting condition applies to, the second is the
 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
 *   index of the sorting order from the `column.sorting` initialisation array.
 */ /**
 * Set the ordering for the table.
 *
 * @param {integer} order Column index to sort upon.
 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 1D array of sorting information to be applied.
 * @param {array} [...] Optional additional sorting conditions
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 2D array of sorting information to be applied.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('order()', function(order, dir) {
    var ctx = this.context;
    var args = Array.prototype.slice.call(arguments);
    if (order === undefined) // get
    return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
    // set
    if (typeof order === 'number') // Simple column / direction passed in
    order = [
        [
            order,
            dir
        ]
    ];
    else if (args.length > 1) // Arguments passed in (list of 1D arrays)
    order = args;
    // otherwise a 2D array was passed in
    return this.iterator('table', function(settings) {
        var resolved = [];
        $44bb6d473543b89d$var$_fnSortResolve(settings, resolved, order);
        settings.aaSorting = resolved;
    });
});
/**
 * Attach a sort listener to an element for a given column
 *
 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
 *   listener to. This can take the form of a single DOM node, a jQuery
 *   collection of nodes or a jQuery selector which will identify the node(s).
 * @param {integer} column the column that a click on this node will sort on
 * @param {function} [callback] callback function when sort is run
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('order.listener()', function(node, column, callback) {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnSortAttachListener(settings, node, {}, column, callback);
    });
});
$44bb6d473543b89d$var$_api_register('order.fixed()', function(set) {
    if (!set) {
        var ctx = this.context;
        var fixed = ctx.length ? ctx[0].aaSortingFixed : undefined;
        return Array.isArray(fixed) ? {
            pre: fixed
        } : fixed;
    }
    return this.iterator('table', function(settings) {
        settings.aaSortingFixed = $44bb6d473543b89d$var$$.extend(true, {}, set);
    });
});
// Order by the selected column(s)
$44bb6d473543b89d$var$_api_register([
    'columns().order()',
    'column().order()'
], function(dir) {
    var that = this;
    if (!dir) return this.iterator('column', function(settings, idx) {
        var sort = $44bb6d473543b89d$var$_fnSortFlatten(settings);
        for(var i = 0, iLen = sort.length; i < iLen; i++){
            if (sort[i].col === idx) return sort[i].dir;
        }
        return null;
    }, 1);
    else return this.iterator('table', function(settings, i) {
        settings.aaSorting = that[i].map(function(col) {
            return [
                col,
                dir
            ];
        });
    });
});
$44bb6d473543b89d$var$_api_registerPlural('columns().orderable()', 'column().orderable()', function(directions) {
    return this.iterator('column', function(settings, idx) {
        var col = settings.aoColumns[idx];
        return directions ? col.asSorting : col.bSortable;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('processing()', function(show) {
    return this.iterator('table', function(ctx) {
        $44bb6d473543b89d$var$_fnProcessingDisplay(ctx, show);
    });
});
$44bb6d473543b89d$var$_api_register('search()', function(input, regex, smart, caseInsen) {
    var ctx = this.context;
    if (input === undefined) // get
    return ctx.length !== 0 ? ctx[0].oPreviousSearch.search : undefined;
    // set
    return this.iterator('table', function(settings) {
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        $44bb6d473543b89d$var$_fnFilterComplete(settings, $44bb6d473543b89d$var$$.extend(settings.oPreviousSearch, regex, {
            search: input
        }));
        else // Compat for the old options
        $44bb6d473543b89d$var$_fnFilterComplete(settings, $44bb6d473543b89d$var$$.extend(settings.oPreviousSearch, {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        }));
    });
});
$44bb6d473543b89d$var$_api_register('search.fixed()', function(name, search) {
    var ret = this.iterator(true, 'table', function(settings) {
        var fixed = settings.searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
$44bb6d473543b89d$var$_api_registerPlural('columns().search()', 'column().search()', function(input, regex, smart, caseInsen) {
    return this.iterator('column', function(settings, column) {
        var preSearch = settings.aoPreSearchCols;
        if (input === undefined) // get
        return preSearch[column].search;
        // set
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        $44bb6d473543b89d$var$$.extend(preSearch[column], regex, {
            search: input
        });
        else // Old style (with not all options available)
        $44bb6d473543b89d$var$$.extend(preSearch[column], {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        });
        $44bb6d473543b89d$var$_fnFilterComplete(settings, settings.oPreviousSearch);
    });
});
$44bb6d473543b89d$var$_api_register([
    'columns().search.fixed()',
    'column().search.fixed()'
], function(name, search) {
    var ret = this.iterator(true, 'column', function(settings, colIdx) {
        var fixed = settings.aoColumns[colIdx].searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name] || null;
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
/*
 * State API methods
 */ $44bb6d473543b89d$var$_api_register('state()', function(set, ignoreTime) {
    // getter
    if (!set) return this.context.length ? this.context[0].oSavedState : null;
    var setMutate = $44bb6d473543b89d$var$$.extend(true, {}, set);
    // setter
    return this.iterator('table', function(settings) {
        if (ignoreTime !== false) setMutate.time = +new Date() + 100;
        $44bb6d473543b89d$var$_fnImplementState(settings, setMutate, function() {});
    });
});
$44bb6d473543b89d$var$_api_register('state.clear()', function() {
    return this.iterator('table', function(settings) {
        // Save an empty object
        settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
    });
});
$44bb6d473543b89d$var$_api_register('state.loaded()', function() {
    return this.context.length ? this.context[0].oLoadedState : null;
});
$44bb6d473543b89d$var$_api_register('state.save()', function() {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnSaveState(settings);
    });
});
// Can be assigned in DateTable.use() - note luxon and moment vars are in helpers.js
var $44bb6d473543b89d$var$__bootstrap;
var $44bb6d473543b89d$var$__foundation;
/**
 * Set the libraries that DataTables uses, or the global objects.
 * Note that the arguments can be either way around (legacy support)
 * and the second is optional. See docs.
 */ $44bb6d473543b89d$var$DataTable.use = function(arg1, arg2) {
    // Reverse arguments for legacy support
    var module = typeof arg1 === 'string' ? arg2 : arg1;
    var type = typeof arg2 === 'string' ? arg2 : arg1;
    // Getter
    if (module === undefined && typeof type === 'string') switch(type){
        case 'lib':
        case 'jq':
            return $44bb6d473543b89d$var$$;
        case 'win':
            return window;
        case 'datetime':
            return $44bb6d473543b89d$var$DataTable.DateTime;
        case 'luxon':
            return $44bb6d473543b89d$var$__luxon;
        case 'moment':
            return $44bb6d473543b89d$var$__moment;
        case 'bootstrap':
            // Use local if set, otherwise try window, which could be undefined
            return $44bb6d473543b89d$var$__bootstrap || window.bootstrap;
        case 'foundation':
            // Ditto
            return $44bb6d473543b89d$var$__foundation || window.Foundation;
        default:
            return null;
    }
    // Setter
    if (type === 'lib' || type === 'jq' || module && module.fn && module.fn.jquery) $44bb6d473543b89d$var$$ = module;
    else if (type === 'win' || module && module.document) {
        window = module;
        document = module.document;
    } else if (type === 'datetime' || module && module.type === 'DateTime') $44bb6d473543b89d$var$DataTable.DateTime = module;
    else if (type === 'luxon' || module && module.FixedOffsetZone) $44bb6d473543b89d$var$__luxon = module;
    else if (type === 'moment' || module && module.isMoment) $44bb6d473543b89d$var$__moment = module;
    else if (type === 'bootstrap' || module && module.Modal && module.Modal.NAME === 'modal') // This is currently for BS5 only. BS3/4 attach to jQuery, so no need to use `.use()`
    $44bb6d473543b89d$var$__bootstrap = module;
    else if (type === 'foundation' || module && module.Reveal) $44bb6d473543b89d$var$__foundation = module;
};
/**
 * CommonJS factory function pass through. This will check if the arguments
 * given are a window object or a jQuery object. If so they are set
 * accordingly.
 * @param {*} root Window
 * @param {*} jq jQUery
 * @returns {boolean} Indicator
 */ $44bb6d473543b89d$var$DataTable.factory = function(root, jq) {
    var is = false;
    // Test if the first parameter is a window object
    if (root && root.document) {
        window = root;
        document = root.document;
    }
    // Test if the second parameter is a jQuery object
    if (jq && jq.fn && jq.fn.jquery) {
        $44bb6d473543b89d$var$$ = jq;
        is = true;
    }
    return is;
};
/**
 * Provide a common method for plug-ins to check the version of DataTables being
 * used, in order to ensure compatibility.
 *
 *  @param {string} version Version string to check for, in the format "X.Y.Z".
 *    Note that the formats "X" and "X.Y" are also acceptable.
 *  @param {string} [version2=current DataTables version] As above, but optional.
 *   If not given the current DataTables version will be used.
 *  @returns {boolean} true if this version of DataTables is greater or equal to
 *    the required version, or false if this version of DataTales is not
 *    suitable
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
 */ $44bb6d473543b89d$var$DataTable.versionCheck = function(version, version2) {
    var aThis = version2 ? version2.split('.') : $44bb6d473543b89d$var$DataTable.version.split('.');
    var aThat = version.split('.');
    var iThis, iThat;
    for(var i = 0, iLen = aThat.length; i < iLen; i++){
        iThis = parseInt(aThis[i], 10) || 0;
        iThat = parseInt(aThat[i], 10) || 0;
        // Parts are the same, keep comparing
        if (iThis === iThat) continue;
        // Parts are different, return immediately
        return iThis > iThat;
    }
    return true;
};
/**
 * Check if a `<table>` node is a DataTable table already or not.
 *
 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
 *      selector for the table to test. Note that if more than more than one
 *      table is passed on, only the first will be checked
 *  @returns {boolean} true the table given is a DataTable, or false otherwise
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
 *      $('#example').dataTable();
 *    }
 */ $44bb6d473543b89d$var$DataTable.isDataTable = function(table) {
    var t = $44bb6d473543b89d$var$$(table).get(0);
    var is = false;
    if (table instanceof $44bb6d473543b89d$var$DataTable.Api) return true;
    $44bb6d473543b89d$var$$.each($44bb6d473543b89d$var$DataTable.settings, function(i, o) {
        var head = o.nScrollHead ? $44bb6d473543b89d$var$$('table', o.nScrollHead)[0] : null;
        var foot = o.nScrollFoot ? $44bb6d473543b89d$var$$('table', o.nScrollFoot)[0] : null;
        if (o.nTable === t || head === t || foot === t) is = true;
    });
    return is;
};
/**
 * Get all DataTable tables that have been initialised - optionally you can
 * select to get only currently visible tables.
 *
 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
 *    or visible tables only.
 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
 *    DataTables
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    $.each( $.fn.dataTable.tables(true), function () {
 *      $(table).DataTable().columns.adjust();
 *    } );
 */ $44bb6d473543b89d$var$DataTable.tables = function(visible) {
    var api = false;
    if ($44bb6d473543b89d$var$$.isPlainObject(visible)) {
        api = visible.api;
        visible = visible.visible;
    }
    var a = $44bb6d473543b89d$var$DataTable.settings.filter(function(o) {
        return !visible || visible && $44bb6d473543b89d$var$$(o.nTable).is(':visible') ? true : false;
    }).map(function(o) {
        return o.nTable;
    });
    return api ? new $44bb6d473543b89d$var$_Api(a) : a;
};
/**
 * Convert from camel case parameters to Hungarian notation. This is made public
 * for the extensions to provide the same ability as DataTables core to accept
 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
 * parameters.
 *
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 */ $44bb6d473543b89d$var$DataTable.camelToHungarian = $44bb6d473543b89d$var$_fnCamelToHungarian;
/**
 *
 */ $44bb6d473543b89d$var$_api_register('$()', function(selector, opts) {
    var rows = this.rows(opts).nodes(), jqRows = $44bb6d473543b89d$var$$(rows);
    return $44bb6d473543b89d$var$$([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
});
// jQuery functions to operate on the tables
$44bb6d473543b89d$var$$.each([
    'on',
    'one',
    'off'
], function(i, key) {
    $44bb6d473543b89d$var$_api_register(key + '()', function() {
        var args = Array.prototype.slice.call(arguments);
        // Add the `dt` namespace automatically if it isn't already present
        args[0] = args[0].split(/\s/).map(function(e) {
            return !e.match(/\.dt\b/) ? e + '.dt' : e;
        }).join(' ');
        var inst = $44bb6d473543b89d$var$$(this.tables().nodes());
        inst[key].apply(inst, args);
        return this;
    });
});
$44bb6d473543b89d$var$_api_register('clear()', function() {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnClearTable(settings);
    });
});
$44bb6d473543b89d$var$_api_register('error()', function(msg) {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnLog(settings, 0, msg);
    });
});
$44bb6d473543b89d$var$_api_register('settings()', function() {
    return new $44bb6d473543b89d$var$_Api(this.context, this.context);
});
$44bb6d473543b89d$var$_api_register('init()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].oInit : null;
});
$44bb6d473543b89d$var$_api_register('data()', function() {
    return this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$_pluck(settings.aoData, '_aData');
    }).flatten();
});
$44bb6d473543b89d$var$_api_register('trigger()', function(name, args, bubbles) {
    return this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$_fnCallbackFire(settings, null, name, args, bubbles);
    }).flatten();
});
$44bb6d473543b89d$var$_api_register('ready()', function(fn) {
    var ctx = this.context;
    // Get status of first table
    if (!fn) return ctx.length ? ctx[0]._bInitComplete || false : null;
    // Function to run either once the table becomes ready or
    // immediately if it is already ready.
    return this.tables().every(function() {
        var api = this;
        if (this.context[0]._bInitComplete) fn.call(api);
        else this.on('init.dt.DT', function() {
            fn.call(api);
        });
    });
});
$44bb6d473543b89d$var$_api_register('destroy()', function(remove) {
    remove = remove || false;
    return this.iterator('table', function(settings) {
        var classes = settings.oClasses;
        var table = settings.nTable;
        var tbody = settings.nTBody;
        var thead = settings.nTHead;
        var tfoot = settings.nTFoot;
        var jqTable = $44bb6d473543b89d$var$$(table);
        var jqTbody = $44bb6d473543b89d$var$$(tbody);
        var jqWrapper = $44bb6d473543b89d$var$$(settings.nTableWrapper);
        var rows = settings.aoData.map(function(r) {
            return r ? r.nTr : null;
        });
        var orderClasses = classes.order;
        // Flag to note that the table is currently being destroyed - no action
        // should be taken
        settings.bDestroying = true;
        // Fire off the destroy callbacks for plug-ins etc
        $44bb6d473543b89d$var$_fnCallbackFire(settings, "aoDestroyCallback", "destroy", [
            settings
        ], true);
        // If not being removed from the document, make all columns visible
        if (!remove) new $44bb6d473543b89d$var$_Api(settings).columns().visible(true);
        // Container width change listener
        if (settings.resizeObserver) settings.resizeObserver.disconnect();
        // Blitz all `DT` namespaced events (these are internal events, the
        // lowercase, `dt` events are user subscribed and they are responsible
        // for removing them
        jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
        $44bb6d473543b89d$var$$(window).off('.DT-' + settings.sInstance);
        // When scrolling we had to break the table up - restore it
        if (table != thead.parentNode) {
            jqTable.children('thead').detach();
            jqTable.append(thead);
        }
        if (tfoot && table != tfoot.parentNode) {
            jqTable.children('tfoot').detach();
            jqTable.append(tfoot);
        }
        // Clean up the header / footer
        $44bb6d473543b89d$var$cleanHeader(thead, 'header');
        $44bb6d473543b89d$var$cleanHeader(tfoot, 'footer');
        settings.colgroup.remove();
        settings.aaSorting = [];
        settings.aaSortingFixed = [];
        $44bb6d473543b89d$var$_fnSortingClasses(settings);
        $44bb6d473543b89d$var$$(jqTable).find('th, td').removeClass($44bb6d473543b89d$var$$.map($44bb6d473543b89d$var$DataTable.ext.type.className, function(v) {
            return v;
        }).join(' '));
        $44bb6d473543b89d$var$$('th, td', thead).removeClass(orderClasses.none + ' ' + orderClasses.canAsc + ' ' + orderClasses.canDesc + ' ' + orderClasses.isAsc + ' ' + orderClasses.isDesc).css('width', '').removeAttr('aria-sort');
        // Add the TR elements back into the table in their original order
        jqTbody.children().detach();
        jqTbody.append(rows);
        var orig = settings.nTableWrapper.parentNode;
        var insertBefore = settings.nTableWrapper.nextSibling;
        // Remove the DataTables generated nodes, events and classes
        var removedMethod = remove ? 'remove' : 'detach';
        jqTable[removedMethod]();
        jqWrapper[removedMethod]();
        // If we need to reattach the table to the document
        if (!remove && orig) {
            // insertBefore acts like appendChild if !arg[1]
            orig.insertBefore(table, insertBefore);
            // Restore the width of the original table - was read from the style property,
            // so we can restore directly to that
            jqTable.css('width', settings.sDestroyWidth).removeClass(classes.table);
        }
        /* Remove the settings object from the settings array */ var idx = $44bb6d473543b89d$var$DataTable.settings.indexOf(settings);
        if (idx !== -1) $44bb6d473543b89d$var$DataTable.settings.splice(idx, 1);
    });
});
// Add the `every()` method for rows, columns and cells in a compact form
$44bb6d473543b89d$var$$.each([
    'column',
    'row',
    'cell'
], function(i, type) {
    $44bb6d473543b89d$var$_api_register(type + 's().every()', function(fn) {
        var opts = this.selector.opts;
        var api = this;
        var inst;
        var counter = 0;
        return this.iterator('every', function(settings, selectedIdx, tableIdx) {
            inst = api[type](selectedIdx, opts);
            if (type === 'cell') fn.call(inst, inst[0][0].row, inst[0][0].column, tableIdx, counter);
            else fn.call(inst, selectedIdx, tableIdx, counter);
            counter++;
        });
    });
});
// i18n method for extensions to be able to use the language object from the
// DataTable
$44bb6d473543b89d$var$_api_register('i18n()', function(token, def, plural) {
    var ctx = this.context[0];
    var resolved = $44bb6d473543b89d$var$_fnGetObjectDataFn(token)(ctx.oLanguage);
    if (resolved === undefined) resolved = def;
    if ($44bb6d473543b89d$var$$.isPlainObject(resolved)) resolved = plural !== undefined && resolved[plural] !== undefined ? resolved[plural] : plural === false ? resolved : resolved._;
    return typeof resolved === 'string' ? resolved.replace('%d', plural) // nb: plural might be undefined,
     : resolved;
});
// Needed for header and footer, so pulled into its own function
function $44bb6d473543b89d$var$cleanHeader(node, className) {
    $44bb6d473543b89d$var$$(node).find('.dt-column-order').remove();
    $44bb6d473543b89d$var$$(node).find('.dt-column-title').each(function() {
        var title = $44bb6d473543b89d$var$$(this).html();
        $44bb6d473543b89d$var$$(this).parent().parent().append(title);
        $44bb6d473543b89d$var$$(this).remove();
    });
    $44bb6d473543b89d$var$$(node).find('div.dt-column-' + className).remove();
    $44bb6d473543b89d$var$$('th, td', node).removeAttr('data-dt-column');
}
/**
 * Version string for plug-ins to check compatibility. Allowed format is
 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
 * only for non-release builds. See https://semver.org/ for more information.
 *  @member
 *  @type string
 *  @default Version number
 */ $44bb6d473543b89d$var$DataTable.version = "2.3.8";
/**
 * Private data store, containing all of the settings objects that are
 * created for the tables on a given page.
 *
 * Note that the `DataTable.settings` object is aliased to
 * `jQuery.fn.dataTableExt` through which it may be accessed and
 * manipulated, or `jQuery.fn.dataTable.settings`.
 *  @member
 *  @type array
 *  @default []
 *  @private
 */ $44bb6d473543b89d$var$DataTable.settings = [];
/**
 * Object models container, for the various models that DataTables has
 * available to it. These models define the objects that are used to hold
 * the active state and configuration of the table.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models = {};
/**
 * Template object for the way in which DataTables holds information about
 * search information for the global filter and individual column filters.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models.oSearch = {
    /**
	 * Flag to whether or not the filtering should be case-insensitive
	 */ "caseInsensitive": true,
    /**
	 * Applied search term
	 */ "search": "",
    /**
	 * Flag to indicate if the search term should be interpreted as a
	 * regular expression (true) or not (false) and therefore and special
	 * regex characters escaped.
	 */ "regex": false,
    /**
	 * Flag to indicate if DataTables is to use its smart filtering or not.
	 */ "smart": true,
    /**
	 * Flag to indicate if DataTables should only trigger a search when
	 * the return key is pressed.
	 */ "return": false
};
/**
 * Template object for the way in which DataTables holds information about
 * each individual row. This is the object format used for the settings
 * aoData array.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models.oRow = {
    /**
	 * TR element for the row
	 */ "nTr": null,
    /**
	 * Array of TD elements for each row. This is null until the row has been
	 * created.
	 */ "anCells": null,
    /**
	 * Data object from the original data source for the row. This is either
	 * an array if using the traditional form of DataTables, or an object if
	 * using mData options. The exact type will depend on the passed in
	 * data from the data source, or will be an array if using DOM a data
	 * source.
	 */ "_aData": [],
    /**
	 * Sorting data cache - this array is ostensibly the same length as the
	 * number of columns (although each index is generated only as it is
	 * needed), and holds the data that is used for sorting each column in the
	 * row. We do this cache generation at the start of the sort in order that
	 * the formatting of the sort data need be done only once for each cell
	 * per sort. This array should not be read from or written to by anything
	 * other than the master sorting methods.
	 */ "_aSortData": null,
    /**
	 * Per cell filtering data cache. As per the sort data cache, used to
	 * increase the performance of the filtering in DataTables
	 */ "_aFilterData": null,
    /**
	 * Filtering data cache. This is the same as the cell filtering cache, but
	 * in this case a string rather than an array. This is easily computed with
	 * a join on `_aFilterData`, but is provided as a cache so the join isn't
	 * needed on every search (memory traded for performance)
	 */ "_sFilterRow": null,
    /**
	 * Denote if the original data source was from the DOM, or the data source
	 * object. This is used for invalidating data, so DataTables can
	 * automatically read data from the original source, unless uninstructed
	 * otherwise.
	 */ "src": null,
    /**
	 * Index in the aoData array. This saves an indexOf lookup when we have the
	 * object, but want to know the index
	 */ "idx": -1,
    /**
	 * Cached display value
	 */ displayData: null
};
/**
 * Template object for the column information object in DataTables. This object
 * is held in the settings aoColumns array and contains all the information that
 * DataTables needs about each individual column.
 *
 * Note that this object is related to {@link DataTable.defaults.column}
 * but this one is the internal data store for DataTables's cache of columns.
 * It should NOT be manipulated outside of DataTables. Any configuration should
 * be done through the initialisation options.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models.oColumn = {
    /**
	 * Column index.
	 */ "idx": null,
    /**
	 * A list of the columns that sorting should occur on when this column
	 * is sorted. That this property is an array allows multi-column sorting
	 * to be defined for a column (for example first name / last name columns
	 * would benefit from this). The values are integers pointing to the
	 * columns to be sorted on (typically it will be a single integer pointing
	 * at itself, but that doesn't need to be the case).
	 */ "aDataSort": null,
    /**
	 * Define the sorting directions that are applied to the column, in sequence
	 * as the column is repeatedly sorted upon - i.e. the first value is used
	 * as the sorting direction when the column if first sorted (clicked on).
	 * Sort it again (click again) and it will move on to the next index.
	 * Repeat until loop.
	 */ "asSorting": null,
    /**
	 * Flag to indicate if the column is searchable, and thus should be included
	 * in the filtering or not.
	 */ "bSearchable": null,
    /**
	 * Flag to indicate if the column is sortable or not.
	 */ "bSortable": null,
    /**
	 * Flag to indicate if the column is currently visible in the table or not
	 */ "bVisible": null,
    /**
	 * Store for manual type assignment using the `column.type` option. This
	 * is held in store so we can manipulate the column's `sType` property.
	 */ "_sManualType": null,
    /**
	 * Flag to indicate if HTML5 data attributes should be used as the data
	 * source for filtering or sorting. True is either are.
	 */ "_bAttrSrc": false,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * Function to get data from a cell in a column. You should <b>never</b>
	 * access data directly through _aData internally in DataTables - always use
	 * the method attached to this property. It allows mData to function as
	 * required. This function is automatically assigned by the column
	 * initialisation method
	 */ "fnGetData": null,
    /**
	 * Function to set data for a cell in the column. You should <b>never</b>
	 * set the data directly to _aData internally in DataTables - always use
	 * this method. It allows mData to function as required. This function
	 * is automatically assigned by the column initialisation method
	 */ "fnSetData": null,
    /**
	 * Property to read the value for the cells in the column from the data
	 * source array / object. If null, then the default content is used, if a
	 * function is given then the return from the function is used.
	 */ "mData": null,
    /**
	 * Partner property to mData which is used (only when defined) to get
	 * the data - i.e. it is basically the same as mData, but without the
	 * 'set' option, and also the data fed to it is the result from mData.
	 * This is the rendering method to match the data method of mData.
	 */ "mRender": null,
    /**
	 * The class to apply to all TD elements in the table's TBODY for the column
	 */ "sClass": null,
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 */ "sContentPadding": null,
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because mData
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * Name for the column, allowing reference to the column by name as well as
	 * by index (needs a lookup to work by name).
	 */ "sName": null,
    /**
	 * Custom sorting data type - defines which of the available plug-ins in
	 * afnSortData the custom sorting will use - if any is defined.
	 */ "sSortDataType": 'std',
    /**
	 * Class to be applied to the header element when sorting on this column
	 */ "sSortingClass": null,
    /**
	 * Title of the column - what is seen in the TH element (nTh).
	 */ "sTitle": null,
    /**
	 * Column sorting and filtering type
	 */ "sType": null,
    /**
	 * Width of the column
	 */ "sWidth": null,
    /**
	 * Width of the column when it was first "encountered"
	 */ "sWidthOrig": null,
    /** Cached longest strings from a column */ wideStrings: null,
    /**
	 * Store for named searches
	 */ searchFixed: null
};
/*
 * Developer note: The properties of the object below are given in Hungarian
 * notation, that was used as the interface for DataTables prior to v1.10, however
 * from v1.10 onwards the primary interface is camel case. In order to avoid
 * breaking backwards compatibility utterly with this change, the Hungarian
 * version is still, internally the primary interface, but is is not documented
 * - hence the @name tags in each doc comment. This allows a JavaScript function
 * to create a map from Hungarian notation to camel case (going the other direction
 * would require each property to be listed, which would add around 3K to the size
 * of DataTables, while this method is about a 0.5K hit).
 *
 * Ultimately this does pave the way for Hungarian notation to be dropped
 * completely, but that is a massive amount of work and will break current
 * installs (therefore is on-hold until v2).
 */ /**
 * Initialisation options that can be given to DataTables at initialisation
 * time.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.defaults = {
    /**
	 * An array of data to use for the table, passed in at initialisation which
	 * will be used in preference to any data which is already in the DOM. This is
	 * particularly useful for constructing tables purely in JavaScript, for
	 * example with a custom Ajax call.
	 */ "aaData": null,
    /**
	 * If ordering is enabled, then DataTables will perform a first pass sort on
	 * initialisation. You can define which column(s) the sort is performed
	 * upon, and the sorting direction, with this variable. The `sorting` array
	 * should contain an array for each column to be sorted initially containing
	 * the column's index and a direction string ('asc' or 'desc').
	 */ "aaSorting": [
        [
            0,
            'asc'
        ]
    ],
    /**
	 * This parameter is basically identical to the `sorting` parameter, but
	 * cannot be overridden by user interaction with the table. What this means
	 * is that you could have a column (visible or hidden) which the sorting
	 * will always be forced on first - any sorting after that (from the user)
	 * will then be performed as required. This can be useful for grouping rows
	 * together.
	 */ "aaSortingFixed": [],
    /**
	 * DataTables can be instructed to load data to display in the table from a
	 * Ajax source. This option defines how that Ajax call is made and where to.
	 *
	 * The `ajax` property has three different modes of operation, depending on
	 * how it is defined. These are:
	 *
	 * * `string` - Set the URL from where the data should be loaded from.
	 * * `object` - Define properties for `jQuery.ajax`.
	 * * `function` - Custom data get function
	 *
	 * `string`
	 * --------
	 *
	 * As a string, the `ajax` property simply defines the URL from which
	 * DataTables will load data.
	 *
	 * `object`
	 * --------
	 *
	 * As an object, the parameters in the object are passed to
	 * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
	 * of the Ajax request. DataTables has a number of default parameters which
	 * you can override using this option. Please refer to the jQuery
	 * documentation for a full description of the options available, although
	 * the following parameters provide additional options in DataTables or
	 * require special consideration:
	 *
	 * * `data` - As with jQuery, `data` can be provided as an object, but it
	 *   can also be used as a function to manipulate the data DataTables sends
	 *   to the server. The function takes a single parameter, an object of
	 *   parameters with the values that DataTables has readied for sending. An
	 *   object may be returned which will be merged into the DataTables
	 *   defaults, or you can add the items to the object that was passed in and
	 *   not return anything from the function. This supersedes `fnServerParams`
	 *   from DataTables 1.9-.
	 *
	 * * `dataSrc` - By default DataTables will look for the property `data` (or
	 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	 *   from an Ajax source or for server-side processing - this parameter
	 *   allows that property to be changed. You can use JavaScript dotted
	 *   object notation to get a data source for multiple levels of nesting, or
	 *   it my be used as a function. As a function it takes a single parameter,
	 *   the JSON returned from the server, which can be manipulated as
	 *   required, with the returned value being that used by DataTables as the
	 *   data source for the table.
	 *
	 * * `success` - Should not be overridden it is used internally in
	 *   DataTables. To manipulate / transform the data returned by the server
	 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	 *
	 * `function`
	 * ----------
	 *
	 * As a function, making the Ajax call is left up to yourself allowing
	 * complete control of the Ajax request. Indeed, if desired, a method other
	 * than Ajax could be used to obtain the required data, such as Web storage
	 * or an AIR database.
	 *
	 * The function is given four parameters and no return is required. The
	 * parameters are:
	 *
	 * 1. _object_ - Data to send to the server
	 * 2. _function_ - Callback function that must be executed when the required
	 *    data has been obtained. That data should be passed into the callback
	 *    as the only parameter
	 * 3. _object_ - DataTables settings object for the table
	 */ "ajax": null,
    /**
	 * This parameter allows you to readily specify the entries in the length drop
	 * down menu that DataTables shows when pagination is enabled. It can be
	 * either a 1D array of options which will be used for both the displayed
	 * option and the value, or a 2D array which will use the array in the first
	 * position as the value, and the array in the second position as the
	 * displayed options (useful for language strings such as 'All').
	 *
	 * Note that the `pageLength` property will be automatically set to the
	 * first value given in this array, unless `pageLength` is also provided.
	 */ "aLengthMenu": [
        10,
        25,
        50,
        100
    ],
    /**
	 * The `columns` option in the initialisation parameter allows you to define
	 * details about the way individual columns behave. For a full list of
	 * column options that can be set, please see
	 * {@link DataTable.defaults.column}. Note that if you use `columns` to
	 * define your columns, you must have an entry in the array for every single
	 * column that you have in your table (these can be null if you don't which
	 * to specify any options).
	 */ "aoColumns": null,
    /**
	 * Very similar to `columns`, `columnDefs` allows you to target a specific
	 * column, multiple columns, or all columns, using the `targets` property of
	 * each object in the array. This allows great flexibility when creating
	 * tables, as the `columnDefs` arrays can be of any length, targeting the
	 * columns you specifically want. `columnDefs` may use any of the column
	 * options available: {@link DataTable.defaults.column}, but it _must_
	 * have `targets` defined in each object in the array. Values in the `targets`
	 * array may be:
	 *   <ul>
	 *     <li>a string - class name will be matched on the TH for the column</li>
	 *     <li>0 or a positive integer - column index counting from the left</li>
	 *     <li>a negative integer - column index counting from the right</li>
	 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	 *   </ul>
	 */ "aoColumnDefs": null,
    /**
	 * Basically the same as `search`, this parameter defines the individual column
	 * filtering state at initialisation time. The array must be of the same size
	 * as the number of columns, and each element be an object with the parameters
	 * `search` and `escapeRegex` (the latter is optional). 'null' is also
	 * accepted and the default will be used.
	 */ "aoSearchCols": [],
    /**
	 * Enable or disable automatic column width calculation. This can be disabled
	 * as an optimisation (it takes some time to calculate the widths) if the
	 * tables widths are passed in using `columns`.
	 */ "bAutoWidth": true,
    /**
	 * Deferred rendering can provide DataTables with a huge speed boost when you
	 * are using an Ajax or JS data source for the table. This option, when set to
	 * true, will cause DataTables to defer the creation of the table elements for
	 * each row until they are needed for a draw - saving a significant amount of
	 * time.
	 */ "bDeferRender": true,
    /**
	 * Replace a DataTable which matches the given selector and replace it with
	 * one which has the properties of the new initialisation object passed. If no
	 * table matches the selector, then the new DataTable will be constructed as
	 * per normal.
	 */ "bDestroy": false,
    /**
	 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	 * that it allows the end user to input multiple words (space separated) and
	 * will match a row containing those words, even if not in the order that was
	 * specified (this allow matching across multiple columns). Note that if you
	 * wish to use filtering in DataTables this must remain 'true' - to remove the
	 * default filtering input box and retain filtering abilities, please use
	 * {@link DataTable.defaults.dom}.
	 */ "bFilter": true,
    /**
	 * Used only for compatibility with DT1
	 * @deprecated
	 */ "bInfo": true,
    /**
	 * Used only for compatibility with DT1
	 * @deprecated
	 */ "bLengthChange": true,
    /**
	 * Enable or disable pagination.
	 */ "bPaginate": true,
    /**
	 * Enable or disable the display of a 'processing' indicator when the table is
	 * being processed (e.g. a sort). This is particularly useful for tables with
	 * large amounts of data where it can take a noticeable amount of time to sort
	 * the entries.
	 */ "bProcessing": false,
    /**
	 * Retrieve the DataTables object for the given selector. Note that if the
	 * table has already been initialised, this parameter will cause DataTables
	 * to simply return the object that has already been set up - it will not take
	 * account of any changes you might have made to the initialisation object
	 * passed to DataTables (setting this parameter to true is an acknowledgement
	 * that you understand this). `destroy` can be used to reinitialise a table if
	 * you need.
	 */ "bRetrieve": false,
    /**
	 * When vertical (y) scrolling is enabled, DataTables will force the height of
	 * the table's viewport to the given height at all times (useful for layout).
	 * However, this can look odd when filtering data down to a small data set,
	 * and the footer is left "floating" further down. This parameter (when
	 * enabled) will cause DataTables to collapse the table's viewport down when
	 * the result set will fit within the given Y height.
	 */ "bScrollCollapse": false,
    /**
	 * Configure DataTables to use server-side processing. Note that the
	 * `ajax` parameter must also be given in order to give DataTables a
	 * source to obtain the required data for each draw.
	 */ "bServerSide": false,
    /**
	 * Enable or disable sorting of columns. Sorting of individual columns can be
	 * disabled by the `sortable` option for each column.
	 */ "bSort": true,
    /**
	 * Enable or display DataTables' ability to sort multiple columns at the
	 * same time (activated by shift-click by the user).
	 */ "bSortMulti": true,
    /**
	 * Allows control over whether DataTables should use the top (true) unique
	 * cell that is found for a single column, or the bottom (false - default).
	 * This is useful when using complex headers.
	 */ "bSortCellsTop": null,
    /** Specify which row is the title row in the header. Replacement for bSortCellsTop */ titleRow: null,
    /**
	 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	 * `sorting\_3` to the columns which are currently being sorted on. This is
	 * presented as a feature switch as it can increase processing time (while
	 * classes are removed and added) so for large data sets you might want to
	 * turn this off.
	 */ "bSortClasses": true,
    /**
	 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	 * used to save table display information such as pagination information,
	 * display length, filtering and sorting. As such when the end user reloads
	 * the page the display will match what thy had previously set up.
	 */ "bStateSave": false,
    /**
	 * This function is called when a TR element is created (and all TD child
	 * elements have been inserted), or registered if using a DOM source, allowing
	 * manipulation of the TR element (adding classes etc).
	 */ "fnCreatedRow": null,
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify any aspect you want about the created DOM.
	 */ "fnDrawCallback": null,
    /**
	 * Identical to fnHeaderCallback() but for the table footer this function
	 * allows you to modify the table footer on every 'draw' event.
	 */ "fnFooterCallback": null,
    /**
	 * When rendering large numbers in the information element for the table
	 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	 * to have a comma separator for the 'thousands' units (e.g. 1 million is
	 * rendered as "1,000,000") to help readability for the end user. This
	 * function will override the default method DataTables uses.
	 */ "fnFormatNumber": function(toFormat) {
        return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
    },
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify the header row. This can be used to calculate and
	 * display useful information about the table.
	 */ "fnHeaderCallback": null,
    /**
	 * The information element can be used to convey information about the current
	 * state of the table. Although the internationalisation options presented by
	 * DataTables are quite capable of dealing with most customisations, there may
	 * be times where you wish to customise the string further. This callback
	 * allows you to do exactly that.
	 */ "fnInfoCallback": null,
    /**
	 * Called when the table has been initialised. Normally DataTables will
	 * initialise sequentially and there will be no need for this function,
	 * however, this does not hold true when using external language information
	 * since that is obtained using an async XHR call.
	 */ "fnInitComplete": null,
    /**
	 * Called at the very start of each table draw and can be used to cancel the
	 * draw by returning false, any other return (including undefined) results in
	 * the full draw occurring).
	 */ "fnPreDrawCallback": null,
    /**
	 * This function allows you to 'post process' each row after it have been
	 * generated for each table draw, but before it is rendered on screen. This
	 * function might be used for setting the row class name etc.
	 */ "fnRowCallback": null,
    /**
	 * Load the table state. With this function you can define from where, and how, the
	 * state of a table is loaded. By default DataTables will load from `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateLoadCallback": function(settings) {
        try {
            return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem('DataTables_' + settings.sInstance + '_' + location.pathname));
        } catch (e) {
            return {};
        }
    },
    /**
	 * Callback which allows modification of the saved state prior to loading that state.
	 * This callback is called when the table is loading state from the stored data, but
	 * prior to the settings object being modified by the saved state. Note that for
	 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	 * a plug-in.
	 */ "fnStateLoadParams": null,
    /**
	 * Callback that is called when the state has been loaded from the state saving method
	 * and the DataTables settings object has been modified as a result of the loaded state.
	 */ "fnStateLoaded": null,
    /**
	 * Save the table state. This function allows you to define where and how the state
	 * information for the table is stored By default DataTables will use `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateSaveCallback": function(settings, data) {
        try {
            (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem('DataTables_' + settings.sInstance + '_' + location.pathname, JSON.stringify(data));
        } catch (e) {
        // noop
        }
    },
    /**
	 * Callback which allows modification of the state to be saved. Called when the table
	 * has changed state a new state save is required. This method allows modification of
	 * the state saving object prior to actually doing the save, including addition or
	 * other state properties or modification. Note that for plug-in authors, you should
	 * use the `stateSaveParams` event to save parameters for a plug-in.
	 */ "fnStateSaveParams": null,
    /**
	 * Duration for which the saved state information is considered valid. After this period
	 * has elapsed the state will be returned to the default.
	 * Value is given in seconds.
	 */ "iStateDuration": 7200,
    /**
	 * Number of rows to display on a single page when using pagination. If
	 * feature enabled (`lengthChange`) then the end user will be able to override
	 * this to a custom setting using a pop-up menu.
	 */ "iDisplayLength": 10,
    /**
	 * Define the starting point for data display when using DataTables with
	 * pagination. Note that this parameter is the number of records, rather than
	 * the page number, so if you have 10 records per page and want to start on
	 * the third page, it should be "20".
	 */ "iDisplayStart": 0,
    /**
	 * By default DataTables allows keyboard navigation of the table (sorting, paging,
	 * and filtering) by adding a `tabindex` attribute to the required elements. This
	 * allows you to tab through the controls and press the enter key to activate them.
	 * The tabindex is default 0, meaning that the tab follows the flow of the document.
	 * You can overrule this using this parameter if you wish. Use a value of -1 to
	 * disable built-in keyboard navigation.
	 */ "iTabIndex": 0,
    /**
	 * Classes that DataTables assigns to the various components and features
	 * that it adds to the HTML table. This allows classes to be configured
	 * during initialisation in addition to through the static
	 * {@link DataTable.ext.oStdClasses} object).
	 */ "oClasses": {},
    /**
	 * All strings that DataTables uses in the user interface that it creates
	 * are defined in this object, allowing you to modified them individually or
	 * completely replace them all as required.
	 */ "oLanguage": {
        /**
		 * Strings that are used for WAI-ARIA labels and controls only (these are not
		 * actually visible on the page, but will be read by screenreaders, and thus
		 * must be internationalised as well).
		 */ "oAria": {
            /**
			 * ARIA label that is added to the table headers when the column may be sorted
			 */ "orderable": ": Activate to sort",
            /**
			 * ARIA label that is added to the table headers when the column is currently being sorted
			 */ "orderableReverse": ": Activate to invert sorting",
            /**
			 * ARIA label that is added to the table headers when the column is currently being 
			 * sorted and next step is to remove sorting
			 */ "orderableRemove": ": Activate to remove sorting",
            paginate: {
                first: 'First',
                last: 'Last',
                next: 'Next',
                previous: 'Previous',
                number: ''
            }
        },
        /**
		 * Pagination string used by DataTables for the built-in pagination
		 * control types.
		 */ "oPaginate": {
            /**
			 * Label and character for first page button («)
			 */ "sFirst": "\u00AB",
            /**
			 * Last page button (»)
			 */ "sLast": "\u00BB",
            /**
			 * Next page button (›)
			 */ "sNext": "\u203A",
            /**
			 * Previous page button (‹)
			 */ "sPrevious": "\u2039"
        },
        /**
		 * Plural object for the data type the table is showing
		 */ entries: {
            _: "entries",
            1: "entry"
        },
        /**
		 * Page length options
		 */ lengthLabels: {
            '-1': 'All'
        },
        /**
		 * This string is shown in preference to `zeroRecords` when the table is
		 * empty of data (regardless of filtering). Note that this is an optional
		 * parameter - if it is not given, the value of `zeroRecords` will be used
		 * instead (either the default or given value).
		 */ "sEmptyTable": "No data available in table",
        /**
		 * This string gives information to the end user about the information
		 * that is current on display on the page. The following tokens can be
		 * used in the string and will be dynamically replaced as the table
		 * display updates. This tokens can be placed anywhere in the string, or
		 * removed as needed by the language requires:
		 *
		 * * `\_START\_` - Display index of the first record on the current page
		 * * `\_END\_` - Display index of the last record on the current page
		 * * `\_TOTAL\_` - Number of records in the table after filtering
		 * * `\_MAX\_` - Number of records in the table without filtering
		 * * `\_PAGE\_` - Current page number
		 * * `\_PAGES\_` - Total number of pages of data in the table
		 */ "sInfo": "Showing _START_ to _END_ of _TOTAL_ _ENTRIES-TOTAL_",
        /**
		 * Display information string for when the table is empty. Typically the
		 * format of this string should match `info`.
		 */ "sInfoEmpty": "Showing 0 to 0 of 0 _ENTRIES-TOTAL_",
        /**
		 * When a user filters the information in a table, this string is appended
		 * to the information (`info`) to give an idea of how strong the filtering
		 * is. The variable _MAX_ is dynamically updated.
		 */ "sInfoFiltered": "(filtered from _MAX_ total _ENTRIES-MAX_)",
        /**
		 * If can be useful to append extra information to the info string at times,
		 * and this variable does exactly that. This information will be appended to
		 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
		 * being used) at all times.
		 */ "sInfoPostFix": "",
        /**
		 * This decimal place operator is a little different from the other
		 * language options since DataTables doesn't output floating point
		 * numbers, so it won't ever use this for display of a number. Rather,
		 * what this parameter does is modify the sort methods of the table so
		 * that numbers which are in a format which has a character other than
		 * a period (`.`) as a decimal place will be sorted numerically.
		 *
		 * Note that numbers with different decimal places cannot be shown in
		 * the same table and still be sortable, the table must be consistent.
		 * However, multiple different tables on the page can use different
		 * decimal place characters.
		 */ "sDecimal": "",
        /**
		 * DataTables has a build in number formatter (`formatNumber`) which is
		 * used to format large numbers that are used in the table information.
		 * By default a comma is used, but this can be trivially changed to any
		 * character you wish with this parameter.
		 */ "sThousands": ",",
        /**
		 * Detail the action that will be taken when the drop down menu for the
		 * pagination length option is changed. The '_MENU_' variable is replaced
		 * with a default select list of 10, 25, 50 and 100, and can be replaced
		 * with a custom select box if required.
		 */ "sLengthMenu": "_MENU_ _ENTRIES_ per page",
        /**
		 * When using Ajax sourced data and during the first draw when DataTables is
		 * gathering the data, this message is shown in an empty row in the table to
		 * indicate to the end user the data is being loaded. Note that this
		 * parameter is not used when loading data by server-side processing, just
		 * Ajax sourced data with client-side processing.
		 */ "sLoadingRecords": "Loading...",
        /**
		 * Text which is displayed when the table is processing a user action
		 * (usually a sort command or similar).
		 */ "sProcessing": "",
        /**
		 * Details the actions that will be taken when the user types into the
		 * filtering input text box. The variable "_INPUT_", if used in the string,
		 * is replaced with the HTML text box for the filtering input allowing
		 * control over where it appears in the string. If "_INPUT_" is not given
		 * then the input box is appended to the string automatically.
		 */ "sSearch": "Search:",
        /**
		 * Assign a `placeholder` attribute to the search `input` element
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.searchPlaceholder
		 */ "sSearchPlaceholder": "",
        /**
		 * All of the language information can be stored in a file on the
		 * server-side, which DataTables will look up if this parameter is passed.
		 * It must store the URL of the language file, which is in a JSON format,
		 * and the object has the same properties as the oLanguage object in the
		 * initialiser object (i.e. the above parameters). Please refer to one of
		 * the example language files to see how this works in action.
		 */ "sUrl": "",
        /**
		 * Text shown inside the table records when the is no information to be
		 * displayed after filtering. `emptyTable` is shown when there is simply no
		 * information in the table at all (regardless of filtering).
		 */ "sZeroRecords": "No matching records found"
    },
    /** The initial data order is reversed when `desc` ordering */ orderDescReverse: true,
    /**
	 * This parameter allows you to have define the global filtering state at
	 * initialisation time. As an object the `search` parameter must be
	 * defined, but all other parameters are optional. When `regex` is true,
	 * the search string will be treated as a regular expression, when false
	 * (default) it will be treated as a straight string. When `smart`
	 * DataTables will use it's smart filtering methods (to word match at
	 * any point in the data), when false this will not be done.
	 */ "oSearch": $44bb6d473543b89d$var$$.extend({}, $44bb6d473543b89d$var$DataTable.models.oSearch),
    /**
	 * Table and control layout. This replaces the legacy `dom` option.
	 */ layout: {
        topStart: 'pageLength',
        topEnd: 'search',
        bottomStart: 'info',
        bottomEnd: 'paging'
    },
    /**
	 * Legacy DOM layout option
	 */ "sDom": null,
    /**
	 * Search delay option. This will throttle full table searches that use the
	 * DataTables provided search input element (it does not effect calls to
	 * `dt-api search()`, providing a delay before the search is made.
	 */ "searchDelay": null,
    /**
	 * DataTables features six different built-in options for the buttons to
	 * display for pagination control:
	 *
	 * * `numbers` - Page number buttons only
	 * * `simple` - 'Previous' and 'Next' buttons only
	 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
	 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
	 */ "sPaginationType": "",
    /**
	 * Enable horizontal scrolling. When a table is too wide to fit into a
	 * certain layout, or you have a large number of columns in the table, you
	 * can enable x-scrolling to show the table in a viewport, which can be
	 * scrolled. This property can be `true` which will allow the table to
	 * scroll horizontally when needed, or any CSS unit, or a number (in which
	 * case it will be treated as a pixel measurement). Setting as simply `true`
	 * is recommended.
	 */ "sScrollX": "",
    /**
	 * This property can be used to force a DataTable to use more width than it
	 * might otherwise do when x-scrolling is enabled. For example if you have a
	 * table which requires to be well spaced, this parameter is useful for
	 * "over-sizing" the table, and thus forcing scrolling. This property can by
	 * any CSS unit, or a number (in which case it will be treated as a pixel
	 * measurement).
	 */ "sScrollXInner": "",
    /**
	 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	 * to the given height, and enable scrolling for any data which overflows the
	 * current viewport. This can be used as an alternative to paging to display
	 * a lot of data in a small area (although paging and scrolling can both be
	 * enabled at the same time). This property can be any CSS unit, or a number
	 * (in which case it will be treated as a pixel measurement).
	 */ "sScrollY": "",
    /**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * Set the HTTP method that is used to make the Ajax call for server-side
	 * processing or Ajax sourced data.
	 */ "sServerMethod": "GET",
    /**
	 * DataTables makes use of renderers when displaying HTML elements for
	 * a table. These renderers can be added or modified by plug-ins to
	 * generate suitable mark-up for a site. For example the Bootstrap
	 * integration plug-in for DataTables uses a paging button renderer to
	 * display pagination buttons in the mark-up required by Bootstrap.
	 *
	 * For further information about the renderers available see
	 * DataTable.ext.renderer
	 */ "renderer": null,
    /**
	 * Set the data property name that DataTables should use to get a row's id
	 * to set as the `id` property in the node.
	 */ "rowId": "DT_RowId",
    /**
	 * Caption value
	 */ "caption": null,
    /**
	 * For server-side processing - use the data from the DOM for the first draw
	 */ iDeferLoading: null,
    /** Event listeners */ on: null,
    /** Title wrapper element type */ columnTitleTag: 'span'
};
$44bb6d473543b89d$var$_fnHungarianMap($44bb6d473543b89d$var$DataTable.defaults);
/*
 * Developer note - See note in model.defaults.js about the use of Hungarian
 * notation and camel case.
 */ /**
 * Column options that can be given to DataTables at initialisation time.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.defaults.column = {
    /**
	 * Define which column(s) an order will occur on for this column. This
	 * allows a column's ordering to take multiple columns into account when
	 * doing a sort or use the data from a different column. For example first
	 * name / last name columns make sense to do a multi-column sort over the
	 * two columns.
	 */ "aDataSort": null,
    "iDataSort": -1,
    ariaTitle: '',
    /**
	 * You can control the default ordering direction, and even alter the
	 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	 * using this parameter.
	 */ "asSorting": [
        'asc',
        'desc',
        ''
    ],
    /**
	 * Enable or disable filtering on the data in this column.
	 */ "bSearchable": true,
    /**
	 * Enable or disable ordering on this column.
	 */ "bSortable": true,
    /**
	 * Enable or disable the display of this column.
	 */ "bVisible": true,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * This property can be used to read data from any data source property,
	 * including deeply nested objects / properties. `data` can be given in a
	 * number of different ways which effect its behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted JavaScript notation. Just as you use a `.` in
	 *      JavaScript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object. Note that
	 *      function notation is recommended for use in `render` rather than
	 *      `data` as it is much simpler to use as a renderer.
	 * * `null` - use the original data source for the row rather than plucking
	 *   data directly from it. This action has effects on two other
	 *   initialisation options:
	 *    * `defaultContent` - When null is given as the `data` option and
	 *      `defaultContent` is specified for the column, the value defined by
	 *      `defaultContent` will be used for the cell.
	 *    * `render` - When null is used for the `data` option and the `render`
	 *      option is specified for the column, the whole data source for the
	 *      row is used for the renderer.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * `{array|object}` The data source for the row
	 *      * `{string}` The type call data requested - this will be 'set' when
	 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	 *        when gathering data. Note that when `undefined` is given for the
	 *        type DataTables expects to get the raw data for the object back<
	 *      * `{*}` Data to set when the second parameter is 'set'.
	 *    * Return:
	 *      * The return value from the function is not required when 'set' is
	 *        the type of call, but otherwise the return is what will be used
	 *        for the data requested.
	 *
	 * Note that `data` is a getter and setter option. If you just require
	 * formatting of data for output, you will likely want to use `render` which
	 * is simply a getter and thus simpler to use.
	 *
	 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	 * name change reflects the flexibility of this property and is consistent
	 * with the naming of mRender. If 'mDataProp' is given, then it will still
	 * be used by DataTables, as it automatically maps the old name to the new
	 * if required.
	 */ "mData": null,
    /**
	 * This property is the rendering partner to `data` and it is suggested that
	 * when you want to manipulate data for display (including filtering,
	 * sorting etc) without altering the underlying data for the table, use this
	 * property. `render` can be considered to be the read only companion to
	 * `data` which is read / write (then as such more complex). Like `data`
	 * this option can be given in a number of different ways to effect its
	 * behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted JavaScript notation. Just as you use a `.` in
	 *      JavaScript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object.
	 * * `object` - use different data for the different data types requested by
	 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	 *   of the object is the data type the property refers to and the value can
	 *   defined using an integer, string or function using the same rules as
	 *   `render` normally does. Note that an `_` option _must_ be specified.
	 *   This is the default value to use if you haven't specified a value for
	 *   the data type requested by DataTables.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * {array|object} The data source for the row (based on `data`)
	 *      * {string} The type call data requested - this will be 'filter',
	 *        'display', 'type' or 'sort'.
	 *      * {array|object} The full data source for the row (not based on
	 *        `data`)
	 *    * Return:
	 *      * The return value from the function is what will be used for the
	 *        data requested.
	 */ "mRender": null,
    /**
	 * Change the cell type created for the column - either TD cells or TH cells. This
	 * can be useful as TH cells have semantic meaning in the table body, allowing them
	 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	 */ "sCellType": "td",
    /**
	 * Class to give to each cell in this column.
	 */ "sClass": "",
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 * Generally you shouldn't need this!
	 */ "sContentPadding": "",
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because `data`
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * This parameter is only used in DataTables' server-side processing. It can
	 * be exceptionally useful to know what columns are being displayed on the
	 * client side, and to map these to database fields. When defined, the names
	 * also allow DataTables to reorder information from the server if it comes
	 * back in an unexpected order (i.e. if you switch your columns around on the
	 * client-side, your server-side code does not also need updating).
	 */ "sName": "",
    /**
	 * Defines a data source type for the ordering which can be used to read
	 * real-time information from the table (updating the internally cached
	 * version) prior to ordering. This allows ordering to occur on user
	 * editable elements such as form inputs.
	 */ "sSortDataType": "std",
    /**
	 * The title of this column.
	 */ "sTitle": null,
    /**
	 * The type allows you to specify how the data for this column will be
	 * ordered. Four types (string, numeric, date and html (which will strip
	 * HTML tags before ordering)) are currently available. Note that only date
	 * formats understood by JavaScript's Date() object will be accepted as type
	 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	 * 'numeric', 'date' or 'html' (by default). Further types can be adding
	 * through plug-ins.
	 */ "sType": null,
    /**
	 * Defining the width of the column, this parameter may take any CSS value
	 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	 * been given a specific width through this interface ensuring that the table
	 * remains readable.
	 */ "sWidth": null
};
$44bb6d473543b89d$var$_fnHungarianMap($44bb6d473543b89d$var$DataTable.defaults.column);
/**
 * DataTables settings object - this holds all the information needed for a
 * given table, including configuration, data and current application of the
 * table options. DataTables does not have a single instance for each DataTable
 * with the settings attached to that instance, but rather instances of the
 * DataTable "class" are created on-the-fly as needed (typically by a
 * $().dataTable() call) and the settings object is then applied to that
 * instance.
 *
 * Note that this object is related to {@link DataTable.defaults} but this
 * one is the internal data store for DataTables's cache of columns. It should
 * NOT be manipulated outside of DataTables. Any configuration should be done
 * through the initialisation options.
 */ $44bb6d473543b89d$var$DataTable.models.oSettings = {
    /**
	 * Primary features of DataTables and their enablement state.
	 */ "oFeatures": {
        /**
		 * Flag to say if DataTables should automatically try to calculate the
		 * optimum table and columns widths (true) or not (false).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bAutoWidth": null,
        /**
		 * Delay the creation of TR and TD elements until they are actually
		 * needed by a driven page draw. This can give a significant speed
		 * increase for Ajax source and JavaScript source data, but makes no
		 * difference at all for DOM and server-side processing tables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bDeferRender": null,
        /**
		 * Enable filtering on the table or not. Note that if this is disabled
		 * then there is no filtering at all on the table, including fnFilter.
		 * To just remove the filtering input use sDom and remove the 'f' option.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bFilter": null,
        /**
		 * Used only for compatibility with DT1
		 * @deprecated
		 */ "bInfo": true,
        /**
		 * Used only for compatibility with DT1
		 * @deprecated
		 */ "bLengthChange": true,
        /**
		 * Pagination enabled or not. Note that if this is disabled then length
		 * changing must also be disabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bPaginate": null,
        /**
		 * Processing indicator enable flag whenever DataTables is enacting a
		 * user request - typically an Ajax request for server-side processing.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bProcessing": null,
        /**
		 * Server-side processing enabled flag - when enabled DataTables will
		 * get all data from the server for every draw - there is no filtering,
		 * sorting or paging done on the client-side.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bServerSide": null,
        /**
		 * Sorting enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSort": null,
        /**
		 * Multi-column sorting
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortMulti": null,
        /**
		 * Apply a class to the columns which are being sorted to provide a
		 * visual highlight or not. This can slow things down when enabled since
		 * there is a lot of DOM interaction.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortClasses": null,
        /**
		 * State saving enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bStateSave": null
    },
    /**
	 * Scrolling settings for a table.
	 */ "oScroll": {
        /**
		 * When the table is shorter in height than sScrollY, collapse the
		 * table container down to the height of the table (when true).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bCollapse": null,
        /**
		 * Width of the scrollbar for the web-browser's platform. Calculated
		 * during table initialisation.
		 */ "iBarWidth": 0,
        /**
		 * Viewport width for horizontal scrolling. Horizontal scrolling is
		 * disabled if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sX": null,
        /**
		 * Width to expand the table to when using x-scrolling. Typically you
		 * should not need to use this.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @deprecated
		 */ "sXInner": null,
        /**
		 * Viewport height for vertical scrolling. Vertical scrolling is disabled
		 * if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sY": null
    },
    /**
	 * Language information for the table.
	 */ "oLanguage": {
        /**
		 * Information callback function. See
		 * {@link DataTable.defaults.fnInfoCallback}
		 */ "fnInfoCallback": null
    },
    /**
	 * Browser support parameters
	 */ "oBrowser": {
        /**
		 * Determine if the vertical scrollbar is on the right or left of the
		 * scrolling container - needed for rtl language layout, although not
		 * all browsers move the scrollbar (Safari).
		 */ "bScrollbarLeft": false,
        /**
		 * Browser scrollbar width
		 */ "barWidth": 0
    },
    "ajax": null,
    /**
	 * Array referencing the nodes which are used for the features. The
	 * parameters of this object match what is allowed by sDom - i.e.
	 *   <ul>
	 *     <li>'l' - Length changing</li>
	 *     <li>'f' - Filtering input</li>
	 *     <li>'t' - The table!</li>
	 *     <li>'i' - Information</li>
	 *     <li>'p' - Pagination</li>
	 *     <li>'r' - pRocessing</li>
	 *   </ul>
	 */ "aanFeatures": [],
    /**
	 * Store data information - see {@link DataTable.models.oRow} for detailed
	 * information.
	 */ "aoData": [],
    /**
	 * Array of indexes which are in the current display (after filtering etc)
	 */ "aiDisplay": [],
    /**
	 * Array of indexes for display - no filtering
	 */ "aiDisplayMaster": [],
    /**
	 * Map of row ids to data indexes
	 */ "aIds": {},
    /**
	 * Store information about each column that is in use
	 */ "aoColumns": [],
    /**
	 * Store information about the table's header
	 */ "aoHeader": [],
    /**
	 * Store information about the table's footer
	 */ "aoFooter": [],
    /**
	 * Store the applied global search information in case we want to force a
	 * research or compare the old search to a new one.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "oPreviousSearch": {},
    /**
	 * Store for named searches
	 */ searchFixed: {},
    /**
	 * Store the applied search for each column - see
	 * {@link DataTable.models.oSearch} for the format that is used for the
	 * filtering information for each column.
	 */ "aoPreSearchCols": [],
    /**
	 * Sorting that is applied to the table. Note that the inner arrays are
	 * used in the following manner:
	 * <ul>
	 *   <li>Index 0 - column number</li>
	 *   <li>Index 1 - current sorting direction</li>
	 * </ul>
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSorting": null,
    /**
	 * Sorting that is always applied to the table (i.e. prefixed in front of
	 * aaSorting).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSortingFixed": [],
    /**
	 * If restoring a table - we should restore its width
	 */ "sDestroyWidth": 0,
    /**
	 * Callback functions array for every time a row is inserted (i.e. on a draw).
	 */ "aoRowCallback": [],
    /**
	 * Callback functions for the header on each draw.
	 */ "aoHeaderCallback": [],
    /**
	 * Callback function for the footer on each draw.
	 */ "aoFooterCallback": [],
    /**
	 * Array of callback functions for draw callback functions
	 */ "aoDrawCallback": [],
    /**
	 * Array of callback functions for row created function
	 */ "aoRowCreatedCallback": [],
    /**
	 * Callback functions for just before the table is redrawn. A return of
	 * false will be used to cancel the draw.
	 */ "aoPreDrawCallback": [],
    /**
	 * Callback functions for when the table has been initialised.
	 */ "aoInitComplete": [],
    /**
	 * Callbacks for modifying the settings to be stored for state saving, prior to
	 * saving state.
	 */ "aoStateSaveParams": [],
    /**
	 * Callbacks for modifying the settings that have been stored for state saving
	 * prior to using the stored values to restore the state.
	 */ "aoStateLoadParams": [],
    /**
	 * Callbacks for operating on the settings object once the saved state has been
	 * loaded
	 */ "aoStateLoaded": [],
    /**
	 * Cache the table ID for quick access
	 */ "sTableId": "",
    /**
	 * The TABLE node for the main table
	 */ "nTable": null,
    /**
	 * Permanent ref to the thead element
	 */ "nTHead": null,
    /**
	 * Permanent ref to the tfoot element - if it exists
	 */ "nTFoot": null,
    /**
	 * Permanent ref to the tbody element
	 */ "nTBody": null,
    /**
	 * Cache the wrapper node (contains all DataTables controlled elements)
	 */ "nTableWrapper": null,
    /**
	 * Indicate if all required information has been read in
	 */ "bInitialised": false,
    /**
	 * Information about open rows. Each object in the array has the parameters
	 * 'nTr' and 'nParent'
	 */ "aoOpenRows": [],
    /**
	 * Dictate the positioning of DataTables' control elements - see
	 * {@link DataTable.model.oInit.sDom}.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sDom": null,
    /**
	 * Search delay (in mS)
	 */ "searchDelay": null,
    /**
	 * Which type of pagination should be used.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sPaginationType": "two_button",
    /**
	 * Number of paging controls on the page. Only used for backwards compatibility
	 */ pagingControls: 0,
    /**
	 * The state duration (for `stateSave`) in seconds.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "iStateDuration": 0,
    /**
	 * Array of callback functions for state saving. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the JSON string to save that has been thus far created. Returns
	 *       a JSON string to be inserted into a json object
	 *       (i.e. '"param": [ 0, 1, 2]')</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateSave": [],
    /**
	 * Array of callback functions for state loading. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the object stored. May return false to cancel state loading</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateLoad": [],
    /**
	 * State that was saved. Useful for back reference
	 */ "oSavedState": null,
    /**
	 * State that was loaded. Useful for back reference
	 */ "oLoadedState": null,
    /**
	 * Note if draw should be blocked while getting data
	 */ "bAjaxDataGet": true,
    /**
	 * The last jQuery XHR object that was used for server-side data gathering.
	 * This can be used for working with the XHR information in one of the
	 * callbacks
	 */ "jqXHR": null,
    /**
	 * JSON returned from the server in the last Ajax request
	 */ "json": undefined,
    /**
	 * Data submitted as part of the last Ajax request
	 */ "oAjaxData": undefined,
    /**
	 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	 * required).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sServerMethod": null,
    /**
	 * Format numbers for display.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "fnFormatNumber": null,
    /**
	 * List of options that can be used for the user selectable length menu.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aLengthMenu": null,
    /**
	 * Counter for the draws that the table does. Also used as a tracker for
	 * server-side processing
	 */ "iDraw": 0,
    /**
	 * Indicate if a redraw is being done - useful for Ajax
	 */ "bDrawing": false,
    /**
	 * Draw index (iDraw) of the last error when parsing the returned data
	 */ "iDrawError": -1,
    /**
	 * Paging display length
	 */ "_iDisplayLength": 10,
    /**
	 * Paging start point - aiDisplay index
	 */ "_iDisplayStart": 0,
    /**
	 * Server-side processing - number of records in the result set
	 * (i.e. before filtering), Use fnRecordsTotal rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsTotal": 0,
    /**
	 * Server-side processing - number of records in the current display set
	 * (i.e. after filtering). Use fnRecordsDisplay rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsDisplay": 0,
    /**
	 * The classes to use for the table
	 */ "oClasses": {},
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if filtering has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bFiltered": false,
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if sorting has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bSorted": false,
    /**
	 * Indicate that if multiple rows are in the header and there is more than
	 * one unique cell per column. Replaced by titleRow
	 */ "bSortCellsTop": null,
    /**
	 * Initialisation object that is used for the table
	 */ "oInit": null,
    /**
	 * Destroy callback functions - for plug-ins to attach themselves to the
	 * destroy so they can clean up markup and events.
	 */ "aoDestroyCallback": [],
    /**
	 * Get the number of records in the current record set, before filtering
	 */ "fnRecordsTotal": function() {
        return $44bb6d473543b89d$var$_fnDataSource(this) == 'ssp' ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
    },
    /**
	 * Get the number of records in the current record set, after filtering
	 */ "fnRecordsDisplay": function() {
        return $44bb6d473543b89d$var$_fnDataSource(this) == 'ssp' ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
    },
    /**
	 * Get the display end point - aiDisplay index
	 */ "fnDisplayEnd": function() {
        var len = this._iDisplayLength, start = this._iDisplayStart, calc = start + len, records = this.aiDisplay.length, features = this.oFeatures, paginate = features.bPaginate;
        if (features.bServerSide) return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
        else return !paginate || calc > records || len === -1 ? records : calc;
    },
    /**
	 * The DataTables object for this table
	 */ "oInstance": null,
    /**
	 * Unique identifier for each instance of the DataTables object. If there
	 * is an ID on the table node, then it takes that value, otherwise an
	 * incrementing internal counter is used.
	 */ "sInstance": null,
    /**
	 * tabindex attribute value that is added to DataTables control elements, allowing
	 * keyboard navigation of the table and its controls.
	 */ "iTabIndex": 0,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollHead": null,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollFoot": null,
    /**
	 * Last applied sort
	 */ "aLastSort": [],
    /**
	 * Stored plug-in instances
	 */ "oPlugins": {},
    /**
	 * Function used to get a row's id from the row's data
	 */ "rowIdFn": null,
    /**
	 * Data location where to store a row's id
	 */ "rowId": null,
    caption: '',
    captionNode: null,
    colgroup: null,
    /** Delay loading of data */ deferLoading: null,
    /** Allow auto type detection */ typeDetect: true,
    /** ResizeObserver for the container div */ resizeObserver: null,
    /** Keep a record of the last size of the container, so we can skip duplicates */ containerWidth: -1,
    /** Reverse the initial order of the data set on desc ordering */ orderDescReverse: null,
    /** Show / hide ordering indicators in headers */ orderIndicators: true,
    /** Default ordering listener */ orderHandler: true,
    /** Title row indicator */ titleRow: null,
    /** Title wrapper element type */ columnTitleTag: 'span'
};
/**
 * Extension object for DataTables that is used to provide all extension
 * options.
 *
 * Note that the `DataTable.ext` object is available through
 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
 *  @namespace
 *  @extends DataTable.models.ext
 */ var $44bb6d473543b89d$var$extPagination = $44bb6d473543b89d$var$DataTable.ext.pager;
// Paging buttons configuration
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$extPagination, {
    simple: function() {
        return [
            'previous',
            'next'
        ];
    },
    full: function() {
        return [
            'first',
            'previous',
            'next',
            'last'
        ];
    },
    numbers: function() {
        return [
            'numbers'
        ];
    },
    simple_numbers: function() {
        return [
            'previous',
            'numbers',
            'next'
        ];
    },
    full_numbers: function() {
        return [
            'first',
            'previous',
            'numbers',
            'next',
            'last'
        ];
    },
    first_last: function() {
        return [
            'first',
            'last'
        ];
    },
    first_last_numbers: function() {
        return [
            'first',
            'numbers',
            'last'
        ];
    },
    // For testing and plug-ins to use
    _numbers: $44bb6d473543b89d$var$_pagingNumbers,
    // Number of number buttons - legacy, use `numbers` option for paging feature
    numbers_length: 7
});
$44bb6d473543b89d$var$$.extend(true, $44bb6d473543b89d$var$DataTable.ext.renderer, {
    pagingButton: {
        _: function(settings, buttonType, content, active, disabled) {
            var classes = settings.oClasses.paging;
            var btnClasses = [
                classes.button
            ];
            var btn;
            if (active) btnClasses.push(classes.active);
            if (disabled) btnClasses.push(classes.disabled);
            if (buttonType === 'ellipsis') btn = $44bb6d473543b89d$var$$('<span class="ellipsis"></span>').html(content)[0];
            else btn = $44bb6d473543b89d$var$$('<button>', {
                class: btnClasses.join(' '),
                role: 'link',
                type: 'button'
            }).html(content);
            return {
                display: btn,
                clicker: btn
            };
        }
    },
    pagingContainer: {
        _: function(settings, buttons) {
            // No wrapping element - just append directly to the host
            return buttons;
        }
    }
});
// Common function to remove new lines, strip HTML and diacritic control
var $44bb6d473543b89d$var$_filterString = function(stripHtml, normalize) {
    return function(str) {
        if ($44bb6d473543b89d$var$_empty(str) || typeof str !== 'string') return str;
        str = str.replace($44bb6d473543b89d$var$_re_new_lines, " ");
        if (stripHtml) str = $44bb6d473543b89d$var$_stripHtml(str);
        if (normalize) str = $44bb6d473543b89d$var$_normalize(str, false);
        return str;
    };
};
/*
 * Public helper functions. These aren't used internally by DataTables, or
 * called by any of the options passed into DataTables, but they can be used
 * externally by developers working with DataTables. They are helper functions
 * to make working with DataTables a little bit easier.
 */ /**
 * Common logic for moment, luxon or a date action.
 *
 * Happens after __mldObj, so don't need to call `resolveWindowsLibs` again
 */ function $44bb6d473543b89d$var$__mld(dtLib, momentFn, luxonFn, dateFn, arg1) {
    if ($44bb6d473543b89d$var$__moment) return dtLib[momentFn](arg1);
    else if ($44bb6d473543b89d$var$__luxon) return dtLib[luxonFn](arg1);
    return dateFn ? dtLib[dateFn](arg1) : dtLib;
}
var $44bb6d473543b89d$var$__mlWarning = false;
var $44bb6d473543b89d$var$__luxon; // Can be assigned in DateTable.use()
var $44bb6d473543b89d$var$__moment; // Can be assigned in DateTable.use()
var $44bb6d473543b89d$var$__reIsoTimezone = /[T\s]\d{2}.*?(Z|[+-]\d{2}(?::?\d{2})?)$/;
/**
 * 
 */ function $44bb6d473543b89d$var$resolveWindowLibs() {
    if (window.luxon && !$44bb6d473543b89d$var$__luxon) $44bb6d473543b89d$var$__luxon = window.luxon;
    if (window.moment && !$44bb6d473543b89d$var$__moment) $44bb6d473543b89d$var$__moment = window.moment;
}
function $44bb6d473543b89d$var$__mldObj(d, format, locale) {
    var dt;
    $44bb6d473543b89d$var$resolveWindowLibs();
    if ($44bb6d473543b89d$var$__moment) {
        dt = $44bb6d473543b89d$var$__moment(d, format, locale, true);
        if (!dt.isValid()) return null;
    } else if ($44bb6d473543b89d$var$__luxon) {
        dt = format && typeof d === 'string' ? $44bb6d473543b89d$var$__luxon.DateTime.fromFormat(d, format) : $44bb6d473543b89d$var$__luxon.DateTime.fromISO(d);
        if (!dt.isValid) return null;
        dt = dt.setLocale(locale);
    } else if (!format) // No format given, must be ISO
    dt = new Date(d);
    else {
        if (!$44bb6d473543b89d$var$__mlWarning) alert('DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17');
        $44bb6d473543b89d$var$__mlWarning = true;
    }
    return dt;
}
// Wrapper for date, datetime and time which all operate the same way with the exception of
// the output string for auto locale support
function $44bb6d473543b89d$var$__mlHelper(localeString) {
    return function(from, to, locale, def) {
        // Luxon and Moment support
        // Argument shifting
        if (arguments.length === 0) {
            locale = 'en';
            to = null; // means toLocaleString
            from = null; // means iso8601
        } else if (arguments.length === 1) {
            locale = 'en';
            to = from;
            from = null;
        } else if (arguments.length === 2) {
            locale = to;
            to = from;
            from = null;
        }
        var typeName = 'datetime' + (to ? '-' + to : '');
        // Add type detection and sorting specific to this date format - we need to be able to identify
        // date type columns as such, rather than as numbers in extensions. Hence the need for this.
        if (!$44bb6d473543b89d$var$DataTable.ext.type.order[typeName + '-pre']) $44bb6d473543b89d$var$DataTable.type(typeName, {
            detect: function(d) {
                // The renderer will give the value to type detect as the type!
                return d === typeName ? typeName : false;
            },
            order: {
                pre: function(d) {
                    // The renderer gives us Moment, Luxon or Date objects for the sorting, all of which have a
                    // `valueOf` which gives milliseconds epoch
                    return d.valueOf();
                }
            },
            className: 'dt-right'
        });
        return function(d, type) {
            // Allow for a default value
            if (d === null || d === undefined) {
                if (def === '--now') {
                    // We treat everything as UTC further down, so no changes are
                    // made, as such need to get the local date / time as if it were
                    // UTC
                    var local = new Date();
                    d = new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds()));
                } else d = '';
            }
            if (type === 'type') // Typing uses the type name for fast matching
            return typeName;
            if (d === '') return type !== 'sort' ? '' : $44bb6d473543b89d$var$__mldObj('0000-01-01 00:00:00', null, locale);
            // Shortcut. If `from` and `to` are the same, we are using the renderer to
            // format for ordering, not display - its already in the display format.
            if (to !== null && from === to && type !== 'sort' && type !== 'type' && !(d instanceof Date)) return d;
            // Determine if there is a timezone. If there is, we want to reuse
            // it for the output, so the timezone doesn't change between the
            // input and output.
            let options = {};
            let tzMatch = typeof d === 'string' ? d.match($44bb6d473543b89d$var$__reIsoTimezone) : null;
            if (tzMatch) options.timeZone = tzMatch[1] === 'Z' ? 'UTC' : tzMatch[1];
            var dt = $44bb6d473543b89d$var$__mldObj(d, from, locale);
            if (dt === null) return d;
            if (type === 'sort') return dt;
            var formatted = to === null ? $44bb6d473543b89d$var$__mld(dt, 'toDate', 'toJSDate', '')[localeString](navigator.language, options) : $44bb6d473543b89d$var$__mld(dt, 'format', 'toFormat', 'toISOString', to);
            // XSS protection
            return type === 'display' ? $44bb6d473543b89d$var$_escapeHtml(formatted) : formatted;
        };
    };
}
// Based on locale, determine standard number formatting
// Fallback for legacy browsers is US English
var $44bb6d473543b89d$var$__thousands = ',';
var $44bb6d473543b89d$var$__decimal = '.';
if (window.Intl !== undefined) try {
    var $44bb6d473543b89d$var$num = new Intl.NumberFormat().formatToParts(100000.1);
    for(var $44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < $44bb6d473543b89d$var$num.length; $44bb6d473543b89d$var$i++){
        if ($44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].type === 'group') $44bb6d473543b89d$var$__thousands = $44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].value;
        else if ($44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].type === 'decimal') $44bb6d473543b89d$var$__decimal = $44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].value;
    }
} catch (e) {
// noop
}
// Formatted date time detection - use by declaring the formats you are going to use
$44bb6d473543b89d$var$DataTable.datetime = function(format, locale) {
    var typeName = 'datetime-' + format;
    if (!locale) locale = 'en';
    if (!$44bb6d473543b89d$var$DataTable.ext.type.order[typeName]) $44bb6d473543b89d$var$DataTable.type(typeName, {
        detect: function(d) {
            var dt = $44bb6d473543b89d$var$__mldObj(d, format, locale);
            return d === '' || dt ? typeName : false;
        },
        order: {
            pre: function(d) {
                return $44bb6d473543b89d$var$__mldObj(d, format, locale) || 0;
            }
        },
        className: 'dt-right'
    });
};
/**
 * Helpers for `columns.render`.
 *
 * The options defined here can be used with the `columns.render` initialisation
 * option to provide a display renderer. The following functions are defined:
 *
 * * `moment` - Uses the MomentJS library to convert from a given format into another.
 * This renderer has three overloads:
 *   * 1 parameter:
 *     * `string` - Format to convert to (assumes input is ISO8601 and locale is `en`)
 *   * 2 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to. Assumes `en` locale
 *   * 3 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to
 *     * `string` - Locale
 * * `number` - Will format numeric data (defined by `columns.data`) for
 *   display, retaining the original unformatted data for sorting and filtering.
 *   It takes 5 parameters:
 *   * `string` - Thousands grouping separator
 *   * `string` - Decimal point indicator
 *   * `integer` - Number of decimal points to show
 *   * `string` (optional) - Prefix.
 *   * `string` (optional) - Postfix (/suffix).
 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
 *   parameters.
 *
 * @example
 *   // Column definition using the number renderer
 *   {
 *     data: "salary",
 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 *   }
 *
 * @namespace
 */ $44bb6d473543b89d$var$DataTable.render = {
    date: $44bb6d473543b89d$var$__mlHelper('toLocaleDateString'),
    datetime: $44bb6d473543b89d$var$__mlHelper('toLocaleString'),
    time: $44bb6d473543b89d$var$__mlHelper('toLocaleTimeString'),
    number: function(thousands, decimal, precision, prefix, postfix) {
        // Auto locale detection
        if (thousands === null || thousands === undefined) thousands = $44bb6d473543b89d$var$__thousands;
        if (decimal === null || decimal === undefined) decimal = $44bb6d473543b89d$var$__decimal;
        return {
            display: function(d) {
                if (typeof d !== 'number' && typeof d !== 'string') return d;
                if (d === '' || d === null) return d;
                var negative = d < 0 ? '-' : '';
                var flo = parseFloat(d);
                var abs = Math.abs(flo);
                // Scientific notation for large and small numbers
                if (abs >= 100000000000 || abs < 0.0001 && abs !== 0) {
                    var exp = flo.toExponential(precision).split(/e\+?/);
                    return exp[0] + ' x 10<sup>' + exp[1] + '</sup>';
                }
                // If NaN then there isn't much formatting that we can do - just
                // return immediately, escaping any HTML (this was supposed to
                // be a number after all)
                if (isNaN(flo)) return $44bb6d473543b89d$var$_escapeHtml(d);
                flo = flo.toFixed(precision);
                d = Math.abs(flo);
                var intPart = parseInt(d, 10);
                var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : '';
                // If zero, then can't have a negative prefix
                if (intPart === 0 && parseFloat(floatPart) === 0) negative = '';
                return negative + (prefix || '') + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart + (postfix || '');
            }
        };
    },
    text: function() {
        return {
            display: $44bb6d473543b89d$var$_escapeHtml,
            filter: $44bb6d473543b89d$var$_escapeHtml
        };
    }
};
var $44bb6d473543b89d$var$_extTypes = $44bb6d473543b89d$var$DataTable.ext.type;
// Get / set type
$44bb6d473543b89d$var$DataTable.type = function(name, prop, val) {
    if (!prop) return {
        className: $44bb6d473543b89d$var$_extTypes.className[name],
        detect: $44bb6d473543b89d$var$_extTypes.detect.find(function(fn) {
            return fn._name === name;
        }),
        order: {
            pre: $44bb6d473543b89d$var$_extTypes.order[name + '-pre'],
            asc: $44bb6d473543b89d$var$_extTypes.order[name + '-asc'],
            desc: $44bb6d473543b89d$var$_extTypes.order[name + '-desc']
        },
        render: $44bb6d473543b89d$var$_extTypes.render[name],
        search: $44bb6d473543b89d$var$_extTypes.search[name]
    };
    var setProp = function(prop, propVal) {
        $44bb6d473543b89d$var$_extTypes[prop][name] = propVal;
    };
    var setDetect = function(detect) {
        // `detect` can be a function or an object - we set a name
        // property for either - that is used for the detection
        Object.defineProperty(detect, "_name", {
            value: name
        });
        var idx = $44bb6d473543b89d$var$_extTypes.detect.findIndex(function(item) {
            return item._name === name;
        });
        if (idx === -1) $44bb6d473543b89d$var$_extTypes.detect.unshift(detect);
        else $44bb6d473543b89d$var$_extTypes.detect.splice(idx, 1, detect);
    };
    var setOrder = function(obj) {
        $44bb6d473543b89d$var$_extTypes.order[name + '-pre'] = obj.pre; // can be undefined
        $44bb6d473543b89d$var$_extTypes.order[name + '-asc'] = obj.asc; // can be undefined
        $44bb6d473543b89d$var$_extTypes.order[name + '-desc'] = obj.desc; // can be undefined
    };
    // prop is optional
    if (val === undefined) {
        val = prop;
        prop = null;
    }
    if (prop === 'className') setProp('className', val);
    else if (prop === 'detect') setDetect(val);
    else if (prop === 'order') setOrder(val);
    else if (prop === 'render') setProp('render', val);
    else if (prop === 'search') setProp('search', val);
    else if (!prop) {
        if (val.className) setProp('className', val.className);
        if (val.detect !== undefined) setDetect(val.detect);
        if (val.order) setOrder(val.order);
        if (val.render !== undefined) setProp('render', val.render);
        if (val.search !== undefined) setProp('search', val.search);
    }
};
// Get a list of types
$44bb6d473543b89d$var$DataTable.types = function() {
    return $44bb6d473543b89d$var$_extTypes.detect.map(function(fn) {
        return fn._name;
    });
};
var $44bb6d473543b89d$var$__diacriticSort = function(a, b) {
    a = a !== null && a !== undefined ? a.toString().toLowerCase() : '';
    b = b !== null && b !== undefined ? b.toString().toLowerCase() : '';
    // Checked for `navigator.languages` support in `oneOf` so this code can't execute in old
    // Safari and thus can disable this check
    // eslint-disable-next-line compat/compat
    return a.localeCompare(b, navigator.languages[0] || navigator.language, {
        numeric: true,
        ignorePunctuation: true
    });
};
var $44bb6d473543b89d$var$__diacriticHtmlSort = function(a, b) {
    a = $44bb6d473543b89d$var$_stripHtml(a);
    b = $44bb6d473543b89d$var$_stripHtml(b);
    return $44bb6d473543b89d$var$__diacriticSort(a, b);
};
//
// Built in data types
//
$44bb6d473543b89d$var$DataTable.type('string', {
    detect: function() {
        return 'string';
    },
    order: {
        pre: function(a) {
            // This is a little complex, but faster than always calling toString,
            // http://jsperf.com/tostring-v-check
            return $44bb6d473543b89d$var$_empty(a) && typeof a !== 'boolean' ? '' : typeof a === 'string' ? a.toLowerCase() : !a.toString ? '' : a.toString();
        }
    },
    search: $44bb6d473543b89d$var$_filterString(false, true)
});
$44bb6d473543b89d$var$DataTable.type('string-utf8', {
    detect: {
        allOf: function(d) {
            return true;
        },
        oneOf: function(d) {
            // At least one data point must contain a non-ASCII character
            // This line will also check if navigator.languages is supported or not. If not (Safari 10.0-)
            // this data type won't be supported.
            // eslint-disable-next-line compat/compat
            return !$44bb6d473543b89d$var$_empty(d) && navigator.languages && typeof d === 'string' && d.match(/[^\x00-\x7F]/);
        }
    },
    order: {
        asc: $44bb6d473543b89d$var$__diacriticSort,
        desc: function(a, b) {
            return $44bb6d473543b89d$var$__diacriticSort(a, b) * -1;
        }
    },
    search: $44bb6d473543b89d$var$_filterString(false, true)
});
$44bb6d473543b89d$var$DataTable.type('html', {
    detect: {
        allOf: function(d) {
            return $44bb6d473543b89d$var$_empty(d) || typeof d === 'string' && d.indexOf('<') !== -1;
        },
        oneOf: function(d) {
            // At least one data point must contain a `<`
            return !$44bb6d473543b89d$var$_empty(d) && typeof d === 'string' && d.indexOf('<') !== -1;
        }
    },
    order: {
        pre: function(a) {
            return $44bb6d473543b89d$var$_empty(a) ? '' : a.replace ? $44bb6d473543b89d$var$_stripHtml(a).trim().toLowerCase() : a + '';
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('html-utf8', {
    detect: {
        allOf: function(d) {
            return $44bb6d473543b89d$var$_empty(d) || typeof d === 'string' && d.indexOf('<') !== -1;
        },
        oneOf: function(d) {
            // At least one data point must contain a `<` and a non-ASCII character
            // eslint-disable-next-line compat/compat
            return navigator.languages && !$44bb6d473543b89d$var$_empty(d) && typeof d === 'string' && d.indexOf('<') !== -1 && typeof d === 'string' && d.match(/[^\x00-\x7F]/);
        }
    },
    order: {
        asc: $44bb6d473543b89d$var$__diacriticHtmlSort,
        desc: function(a, b) {
            return $44bb6d473543b89d$var$__diacriticHtmlSort(a, b) * -1;
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('date', {
    className: 'dt-type-date',
    detect: {
        allOf: function(d) {
            // V8 tries _very_ hard to make a string passed into `Date.parse()`
            // valid, so we need to use a regex to restrict date formats. Use a
            // plug-in for anything other than ISO8601 style strings
            if (d && !(d instanceof Date) && !$44bb6d473543b89d$var$_re_date.test(d)) return null;
            var parsed = Date.parse(d);
            return parsed !== null && !isNaN(parsed) || $44bb6d473543b89d$var$_empty(d);
        },
        oneOf: function(d) {
            // At least one entry must be a date or a string with a date
            return d instanceof Date || typeof d === 'string' && $44bb6d473543b89d$var$_re_date.test(d);
        }
    },
    order: {
        pre: function(d) {
            var ts = Date.parse(d);
            return isNaN(ts) ? -Infinity : ts;
        }
    }
});
$44bb6d473543b89d$var$DataTable.type('html-num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, true, false);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp, $44bb6d473543b89d$var$_re_html, $44bb6d473543b89d$var$_re_formatted_numeric);
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('html-num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp, $44bb6d473543b89d$var$_re_html);
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, true, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp, $44bb6d473543b89d$var$_re_formatted_numeric);
        }
    }
});
$44bb6d473543b89d$var$DataTable.type('num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp);
        }
    }
});
var $44bb6d473543b89d$var$__numericReplace = function(d, decimalPlace, re1, re2) {
    if (d !== 0 && (!d || d === '-')) return -Infinity;
    var type = typeof d;
    if (type === 'number' || type === 'bigint') return d;
    // If a decimal place other than `.` is used, it needs to be given to the
    // function so we can detect it and replace with a `.` which is the only
    // decimal place JavaScript recognises - it is not locale aware.
    if (decimalPlace) d = $44bb6d473543b89d$var$_numToDecimal(d, decimalPlace);
    if (d.replace) {
        if (re1) d = d.replace(re1, '');
        if (re2) d = d.replace(re2, '');
    }
    return d * 1;
};
$44bb6d473543b89d$var$$.extend(true, $44bb6d473543b89d$var$DataTable.ext.renderer, {
    footer: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.tfoot.cell);
        }
    },
    header: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.thead.cell);
            if (!settings.oFeatures.bSort) cell.addClass(classes.order.none);
            var titleRow = settings.titleRow;
            var headerRows = cell.closest('thead').find('tr');
            var rowIdx = cell.parent().index();
            // Conditions to not apply the ordering icons
            if (// Cells and rows which have the attribute to disable the icons
            cell.attr('data-dt-order') === 'disable' || cell.parent().attr('data-dt-order') === 'disable' || // titleRow support, for defining a specific row in the header
            titleRow === true && rowIdx !== 0 || titleRow === false && rowIdx !== headerRows.length - 1 || typeof titleRow === 'number' && rowIdx !== titleRow) return;
            // No additional mark-up required
            // Attach a sort listener to update on sort - note that using the
            // `DT` namespace will allow the event to be removed automatically
            // on destroy, while the `dt` namespaced event is the one we are
            // listening for
            $44bb6d473543b89d$var$$(settings.nTable).on('order.dt.DT column-visibility.dt.DT', function(e, ctx, column) {
                if (settings !== ctx) return; // table, not a nested one
                var sorting = ctx.sortDetails;
                if (!sorting) return;
                var orderedColumns = $44bb6d473543b89d$var$_pluck(sorting, 'col');
                // This handler is only needed on column visibility if the column is part of the
                // ordering. If it isn't, then we can bail out to save performance. It could be a
                // separate event handler, but this is a balance between code reuse / size and performance
                // console.log(e, e.name, column, orderedColumns, orderedColumns.includes(column))
                if (e.type === 'column-visibility' && !orderedColumns.includes(column)) return;
                var i;
                var orderClasses = classes.order;
                var columns = ctx.api.columns(cell);
                var col = settings.aoColumns[columns.flatten()[0]];
                var orderable = columns.orderable().includes(true);
                var ariaType = '';
                var indexes = columns.indexes();
                var sortDirs = columns.orderable(true).flatten();
                var tabIndex = settings.iTabIndex;
                var canOrder = ctx.orderHandler && orderable;
                cell.removeClass(orderClasses.isAsc + ' ' + orderClasses.isDesc).toggleClass(orderClasses.none, !orderable).toggleClass(orderClasses.canAsc, canOrder && sortDirs.includes('asc')).toggleClass(orderClasses.canDesc, canOrder && sortDirs.includes('desc'));
                // Determine if all of the columns that this cell covers are included in the
                // current ordering
                var isOrdering = true;
                for(i = 0; i < indexes.length; i++)if (!orderedColumns.includes(indexes[i])) isOrdering = false;
                if (isOrdering) {
                    // Get the ordering direction for the columns under this cell
                    // Note that it is possible for a cell to be asc and desc sorting
                    // (column spanning cells)
                    var orderDirs = columns.order();
                    cell.addClass(orderDirs.includes('asc') ? orderClasses.isAsc : '' + orderDirs.includes('desc') ? orderClasses.isDesc : '');
                }
                // Find the first visible column that has ordering applied to it - it get's
                // the aria information, as the ARIA spec says that only one column should
                // be marked with aria-sort
                var firstVis = -1; // column index
                for(i = 0; i < orderedColumns.length; i++)if (settings.aoColumns[orderedColumns[i]].bVisible) {
                    firstVis = orderedColumns[i];
                    break;
                }
                if (indexes[0] == firstVis) {
                    var firstSort = sorting[0];
                    var sortOrder = col.asSorting;
                    cell.attr('aria-sort', firstSort.dir === 'asc' ? 'ascending' : 'descending');
                    // Determine if the next click will remove sorting or change the sort
                    ariaType = !sortOrder[firstSort.index + 1] ? 'Remove' : 'Reverse';
                } else cell.removeAttr('aria-sort');
                // Make the headers tab-able for keyboard navigation
                if (orderable) {
                    var orderSpan = cell.find('.dt-column-order');
                    orderSpan.attr('role', 'button').attr('aria-label', orderable ? col.ariaTitle + ctx.api.i18n('oAria.orderable' + ariaType) : col.ariaTitle);
                    if (tabIndex !== -1) orderSpan.attr('tabindex', tabIndex);
                }
            });
        }
    },
    layout: {
        _: function(settings, container, items) {
            var classes = settings.oClasses.layout;
            var row = $44bb6d473543b89d$var$$('<div/>').attr('id', items.id || null).addClass(items.className || classes.row).appendTo(container);
            $44bb6d473543b89d$var$DataTable.ext.renderer.layout._forLayoutRow(items, function(key, val) {
                if (key === 'id' || key === 'className') return;
                var klass = '';
                if (val.table) {
                    row.addClass(classes.tableRow);
                    klass += classes.tableCell + ' ';
                }
                if (key === 'start') klass += classes.start;
                else if (key === 'end') klass += classes.end;
                else klass += classes.full;
                $44bb6d473543b89d$var$$('<div/>').attr({
                    id: val.id || null,
                    "class": val.className ? val.className : classes.cell + ' ' + klass
                }).append(val.contents).appendTo(row);
            });
        },
        // Shared for use by the styling frameworks
        _forLayoutRow: function(items, fn) {
            // As we are inserting dom elements, we need start / end in a
            // specific order, this function is used for sorting the layout
            // keys.
            var layoutEnum = function(x) {
                switch(x){
                    case '':
                        return 0;
                    case 'start':
                        return 1;
                    case 'end':
                        return 2;
                    default:
                        return 3;
                }
            };
            Object.keys(items).sort(function(a, b) {
                return layoutEnum(a) - layoutEnum(b);
            }).forEach(function(key) {
                fn(key, items[key]);
            });
        }
    }
});
$44bb6d473543b89d$var$DataTable.feature = {};
// Third parameter is internal only!
$44bb6d473543b89d$var$DataTable.feature.register = function(name, cb, legacy) {
    $44bb6d473543b89d$var$DataTable.ext.features[name] = cb;
    if (legacy) $44bb6d473543b89d$var$_ext.feature.push({
        cFeature: legacy,
        fnInit: cb
    });
};
function $44bb6d473543b89d$var$_divProp(el, prop, val) {
    if (val) el[prop] = val;
}
$44bb6d473543b89d$var$DataTable.feature.register('div', function(settings, opts) {
    var n = $44bb6d473543b89d$var$$('<div>')[0];
    if (opts) {
        $44bb6d473543b89d$var$_divProp(n, 'className', opts.className);
        $44bb6d473543b89d$var$_divProp(n, 'id', opts.id);
        $44bb6d473543b89d$var$_divProp(n, 'innerHTML', opts.html);
        $44bb6d473543b89d$var$_divProp(n, 'textContent', opts.text);
    }
    return n;
});
$44bb6d473543b89d$var$DataTable.feature.register('info', function(settings, opts) {
    // For compatibility with the legacy `info` top level option
    if (!settings.oFeatures.bInfo) return null;
    var lang = settings.oLanguage, tid = settings.sTableId, n = $44bb6d473543b89d$var$$('<div/>', {
        'class': settings.oClasses.info.container
    });
    opts = $44bb6d473543b89d$var$$.extend({
        callback: lang.fnInfoCallback,
        empty: lang.sInfoEmpty,
        postfix: lang.sInfoPostFix,
        search: lang.sInfoFiltered,
        text: lang.sInfo
    }, opts);
    // Update display on each draw
    settings.aoDrawCallback.push(function(s) {
        $44bb6d473543b89d$var$_fnUpdateInfo(s, opts, n);
    });
    // For the first info display in the table, we add a callback and aria information.
    if (!settings._infoEl) {
        n.attr({
            'aria-live': 'polite',
            id: tid + '_info',
            role: 'status'
        });
        // Table is described by our info div
        $44bb6d473543b89d$var$$(settings.nTable).attr('aria-describedby', tid + '_info');
        settings._infoEl = n;
    }
    return n;
}, 'i');
/**
 * Update the information elements in the display
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnUpdateInfo(settings, opts, node) {
    var start = settings._iDisplayStart + 1, end = settings.fnDisplayEnd(), max = settings.fnRecordsTotal(), total = settings.fnRecordsDisplay(), out = total ? opts.text : opts.empty;
    if (total !== max) // Record set after filtering
    out += ' ' + opts.search;
    // Convert the macros
    out += opts.postfix;
    out = $44bb6d473543b89d$var$_fnMacros(settings, out);
    if (opts.callback) out = opts.callback.call(settings.oInstance, settings, start, end, max, total, out);
    node.html(out);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'info', [
        settings,
        node[0],
        out
    ]);
}
var $44bb6d473543b89d$var$__searchCounter = 0;
// opts
// - text
// - placeholder
$44bb6d473543b89d$var$DataTable.feature.register('search', function(settings, opts) {
    // Don't show the input if filtering isn't available on the table
    if (!settings.oFeatures.bFilter) return null;
    var classes = settings.oClasses.search;
    var tableId = settings.sTableId;
    var language = settings.oLanguage;
    var previousSearch = settings.oPreviousSearch;
    var input = '<input type="search" class="' + classes.input + '"/>';
    opts = $44bb6d473543b89d$var$$.extend({
        placeholder: language.sSearchPlaceholder,
        processing: false,
        text: language.sSearch
    }, opts);
    // The _INPUT_ is optional - is appended if not present
    if (opts.text.indexOf('_INPUT_') === -1) opts.text += '_INPUT_';
    opts.text = $44bb6d473543b89d$var$_fnMacros(settings, opts.text);
    // We can put the <input> outside of the label if it is at the start or end
    // which helps improve accessability (not all screen readers like implicit
    // for elements).
    var end = opts.text.match(/_INPUT_$/);
    var start = opts.text.match(/^_INPUT_/);
    var removed = opts.text.replace(/_INPUT_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_INPUT_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_INPUT_';
    var filter = $44bb6d473543b89d$var$$('<div>').addClass(classes.container).append(str.replace(/_INPUT_/, input));
    // add for and id to label and input
    filter.find('label').attr('for', 'dt-search-' + $44bb6d473543b89d$var$__searchCounter);
    filter.find('input').attr('id', 'dt-search-' + $44bb6d473543b89d$var$__searchCounter);
    $44bb6d473543b89d$var$__searchCounter++;
    var searchFn = function(event) {
        var val = this.value;
        if (previousSearch.return && event.key !== "Enter") return;
        /* Now do the filter */ if (val != previousSearch.search) $44bb6d473543b89d$var$_fnProcessingRun(settings, opts.processing, function() {
            previousSearch.search = val;
            $44bb6d473543b89d$var$_fnFilterComplete(settings, previousSearch);
            // Need to redraw, without resorting
            settings._iDisplayStart = 0;
            $44bb6d473543b89d$var$_fnDraw(settings);
        });
    };
    var searchDelay = settings.searchDelay !== null ? settings.searchDelay : 0;
    var jqFilter = $44bb6d473543b89d$var$$('input', filter).val(previousSearch.search).attr('placeholder', opts.placeholder).on('keyup.DT search.DT input.DT paste.DT cut.DT', searchDelay ? $44bb6d473543b89d$var$DataTable.util.debounce(searchFn, searchDelay) : searchFn).on('mouseup.DT', function(e) {
        // Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
        // on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
        // checks the value to see if it has changed. In other browsers it won't have.
        setTimeout(function() {
            searchFn.call(jqFilter[0], e);
        }, 10);
    }).on('keypress.DT', function(e) {
        /* Prevent form submission */ if (e.keyCode == 13) return false;
    }).attr('aria-controls', tableId);
    // Update the input elements whenever the table is filtered
    $44bb6d473543b89d$var$$(settings.nTable).on('search.dt.DT', function(ev, s) {
        if (settings === s && jqFilter[0] !== document.activeElement) jqFilter.val(typeof previousSearch.search !== 'function' ? previousSearch.search : '');
    });
    return filter;
}, 'f');
// opts
// - type - button configuration
// - buttons - number of buttons to show - must be odd
$44bb6d473543b89d$var$DataTable.feature.register('paging', function(settings, opts) {
    // Don't show the paging input if the table doesn't have paging enabled
    if (!settings.oFeatures.bPaginate) return null;
    opts = $44bb6d473543b89d$var$$.extend({
        buttons: $44bb6d473543b89d$var$DataTable.ext.pager.numbers_length,
        type: settings.sPaginationType,
        boundaryNumbers: true,
        firstLast: true,
        previousNext: true,
        numbers: true
    }, opts);
    var host = $44bb6d473543b89d$var$$('<div/>').addClass(settings.oClasses.paging.container + (opts.type ? ' paging_' + opts.type : '')).append($44bb6d473543b89d$var$$('<nav>').attr('aria-label', 'pagination').addClass(settings.oClasses.paging.nav));
    var draw = function() {
        $44bb6d473543b89d$var$_pagingDraw(settings, host.children(), opts);
    };
    settings.aoDrawCallback.push(draw);
    // Responsive redraw of paging control
    $44bb6d473543b89d$var$$(settings.nTable).on('column-sizing.dt.DT', draw);
    return host;
}, 'p');
/**
 * Dynamically create the button type array based on the configuration options.
 * This will only happen if the paging type is not defined.
 */ function $44bb6d473543b89d$var$_pagingDynamic(opts) {
    var out = [];
    if (opts.numbers) out.push('numbers');
    if (opts.previousNext) {
        out.unshift('previous');
        out.push('next');
    }
    if (opts.firstLast) {
        out.unshift('first');
        out.push('last');
    }
    return out;
}
function $44bb6d473543b89d$var$_pagingDraw(settings, host, opts) {
    if (!settings._bInitComplete) return;
    var plugin = opts.type ? $44bb6d473543b89d$var$DataTable.ext.pager[opts.type] : $44bb6d473543b89d$var$_pagingDynamic, aria = settings.oLanguage.oAria.paginate || {}, start = settings._iDisplayStart, len = settings._iDisplayLength, visRecords = settings.fnRecordsDisplay(), all = len === -1, page = all ? 0 : Math.ceil(start / len), pages = all ? 1 : Math.ceil(visRecords / len), buttons = [], buttonEls = [], buttonsNested = plugin(opts).map(function(val) {
        return val === 'numbers' ? $44bb6d473543b89d$var$_pagingNumbers(page, pages, opts.buttons, opts.boundaryNumbers) : val;
    });
    // .flat() would be better, but not supported in old Safari
    buttons = buttons.concat.apply(buttons, buttonsNested);
    for(var i = 0; i < buttons.length; i++){
        var button = buttons[i];
        var btnInfo = $44bb6d473543b89d$var$_pagingButtonInfo(settings, button, page, pages);
        var btn = $44bb6d473543b89d$var$_fnRenderer(settings, 'pagingButton')(settings, button, btnInfo.display, btnInfo.active, btnInfo.disabled);
        var ariaLabel = typeof button === 'string' ? aria[button] : aria.number ? aria.number + (button + 1) : null;
        // Common attributes
        $44bb6d473543b89d$var$$(btn.clicker).attr({
            'aria-controls': settings.sTableId,
            'aria-disabled': btnInfo.disabled ? 'true' : null,
            'aria-current': btnInfo.active ? 'page' : null,
            'aria-label': ariaLabel,
            'data-dt-idx': button,
            'tabIndex': btnInfo.disabled ? -1 : settings.iTabIndex && btn.clicker[0].nodeName.toLowerCase() !== 'span' ? settings.iTabIndex : null
        });
        if (typeof button !== 'number') $44bb6d473543b89d$var$$(btn.clicker).addClass(button);
        $44bb6d473543b89d$var$_fnBindAction(btn.clicker, {
            action: button
        }, function(e) {
            e.preventDefault();
            $44bb6d473543b89d$var$_fnPageChange(settings, e.data.action, true);
        });
        buttonEls.push(btn.display);
    }
    var wrapped = $44bb6d473543b89d$var$_fnRenderer(settings, 'pagingContainer')(settings, buttonEls);
    var activeEl = host.find(document.activeElement).data('dt-idx');
    host.empty().append(wrapped);
    if (activeEl !== undefined) host.find('[data-dt-idx=' + activeEl + ']').trigger('focus');
    // Responsive - check if the buttons are over two lines based on the
    // height of the buttons and the container.
    if (buttonEls.length) {
        var outerHeight = $44bb6d473543b89d$var$$(buttonEls[0]).outerHeight();
        if (opts.buttons > 1 && // prevent infinite
        outerHeight > 0 && // will be 0 if hidden
        $44bb6d473543b89d$var$$(host).height() >= outerHeight * 2 - 10) $44bb6d473543b89d$var$_pagingDraw(settings, host, $44bb6d473543b89d$var$$.extend({}, opts, {
            buttons: opts.buttons - 2
        }));
    }
}
/**
 * Get properties for a button based on the current paging state of the table
 *
 * @param {*} settings DT settings object
 * @param {*} button The button type in question
 * @param {*} page Table's current page
 * @param {*} pages Number of pages
 * @returns Info object
 */ function $44bb6d473543b89d$var$_pagingButtonInfo(settings, button, page, pages) {
    var lang = settings.oLanguage.oPaginate;
    var o = {
        display: '',
        active: false,
        disabled: false
    };
    switch(button){
        case 'ellipsis':
            o.display = '&#x2026;';
            break;
        case 'first':
            o.display = lang.sFirst;
            if (page === 0) o.disabled = true;
            break;
        case 'previous':
            o.display = lang.sPrevious;
            if (page === 0) o.disabled = true;
            break;
        case 'next':
            o.display = lang.sNext;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        case 'last':
            o.display = lang.sLast;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        default:
            if (typeof button === 'number') {
                o.display = settings.fnFormatNumber(button + 1);
                if (page === button) o.active = true;
            }
            break;
    }
    return o;
}
/**
 * Compute what number buttons to show in the paging control
 *
 * @param {*} page Current page
 * @param {*} pages Total number of pages
 * @param {*} buttons Target number of number buttons
 * @param {boolean} addFirstLast Indicate if page 1 and end should be included
 * @returns Buttons to show
 */ function $44bb6d473543b89d$var$_pagingNumbers(page, pages, buttons, addFirstLast) {
    var numbers = [], half = Math.floor(buttons / 2), before = addFirstLast ? 2 : 1, after = addFirstLast ? 1 : 0;
    if (pages <= buttons) numbers = $44bb6d473543b89d$var$_range(0, pages);
    else if (buttons === 1) // Single button - current page only
    numbers = [
        page
    ];
    else if (buttons === 3) {
        // Special logic for just three buttons
        if (page <= 1) numbers = [
            0,
            1,
            'ellipsis'
        ];
        else if (page >= pages - 2) {
            numbers = $44bb6d473543b89d$var$_range(pages - 2, pages);
            numbers.unshift('ellipsis');
        } else numbers = [
            'ellipsis',
            page,
            'ellipsis'
        ];
    } else if (page <= half) {
        numbers = $44bb6d473543b89d$var$_range(0, buttons - before);
        numbers.push('ellipsis');
        if (addFirstLast) numbers.push(pages - 1);
    } else if (page >= pages - 1 - half) {
        numbers = $44bb6d473543b89d$var$_range(pages - (buttons - before), pages);
        numbers.unshift('ellipsis');
        if (addFirstLast) numbers.unshift(0);
    } else {
        numbers = $44bb6d473543b89d$var$_range(page - half + before, page + half - after);
        numbers.push('ellipsis');
        numbers.unshift('ellipsis');
        if (addFirstLast) {
            numbers.push(pages - 1);
            numbers.unshift(0);
        }
    }
    return numbers;
}
var $44bb6d473543b89d$var$__lengthCounter = 0;
// opts
// - menu
// - text
$44bb6d473543b89d$var$DataTable.feature.register('pageLength', function(settings, opts) {
    var features = settings.oFeatures;
    // For compatibility with the legacy `pageLength` top level option
    if (!features.bPaginate || !features.bLengthChange) return null;
    opts = $44bb6d473543b89d$var$$.extend({
        menu: settings.aLengthMenu,
        text: settings.oLanguage.sLengthMenu
    }, opts);
    var classes = settings.oClasses.length, tableId = settings.sTableId, menu = opts.menu, lengths = [], language = [], i;
    // Options can be given in a number of ways
    if (Array.isArray(menu[0])) {
        // Old 1.x style - 2D array
        lengths = menu[0];
        language = menu[1];
    } else {
        for(i = 0; i < menu.length; i++)// An object with different label and value
        if ($44bb6d473543b89d$var$$.isPlainObject(menu[i])) {
            lengths.push(menu[i].value);
            language.push(menu[i].label);
        } else {
            // Or just a number to display and use
            lengths.push(menu[i]);
            language.push(menu[i]);
        }
    }
    // We can put the <select> outside of the label if it is at the start or
    // end which helps improve accessability (not all screen readers like
    // implicit for elements).
    var end = opts.text.match(/_MENU_$/);
    var start = opts.text.match(/^_MENU_/);
    var removed = opts.text.replace(/_MENU_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_MENU_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_MENU_';
    // Wrapper element - use a span as a holder for where the select will go
    var tmpId = 'tmp-' + +new Date();
    var div = $44bb6d473543b89d$var$$('<div/>').addClass(classes.container).append(str.replace('_MENU_', '<span id="' + tmpId + '"></span>'));
    // Save text node content for macro updating
    var textNodes = [];
    Array.prototype.slice.call(div.find('label')[0].childNodes).forEach(function(el) {
        if (el.nodeType === Node.TEXT_NODE) textNodes.push({
            el: el,
            text: el.textContent
        });
    });
    // Update the label text in case it has an entries value
    var updateEntries = function(len) {
        textNodes.forEach(function(node) {
            node.el.textContent = $44bb6d473543b89d$var$_fnMacros(settings, node.text, len);
        });
    };
    // Next, the select itself, along with the options
    var select = $44bb6d473543b89d$var$$('<select/>', {
        'aria-controls': tableId,
        'class': classes.select
    });
    for(i = 0; i < lengths.length; i++){
        // Attempt to look up the length from the i18n options
        var label = settings.api.i18n('lengthLabels.' + lengths[i], null);
        if (label === null) // If not present, fallback to old style
        label = typeof language[i] === 'number' ? settings.fnFormatNumber(language[i]) : language[i];
        select[0][i] = new Option(label, lengths[i]);
    }
    // add for and id to label and input
    div.find('label').attr('for', 'dt-length-' + $44bb6d473543b89d$var$__lengthCounter);
    select.attr('id', 'dt-length-' + $44bb6d473543b89d$var$__lengthCounter);
    $44bb6d473543b89d$var$__lengthCounter++;
    // Swap in the select list
    div.find('#' + tmpId).replaceWith(select);
    // Can't use `select` variable as user might provide their own and the
    // reference is broken by the use of outerHTML
    $44bb6d473543b89d$var$$('select', div).val(settings._iDisplayLength).on('change.DT', function() {
        $44bb6d473543b89d$var$_fnLengthChange(settings, $44bb6d473543b89d$var$$(this).val());
        $44bb6d473543b89d$var$_fnDraw(settings);
    });
    // Update node value whenever anything changes the table's length
    $44bb6d473543b89d$var$$(settings.nTable).on('length.dt.DT', function(e, s, len) {
        if (settings === s) {
            $44bb6d473543b89d$var$$('select', div).val(len);
            // Resolve plurals in the text for the new length
            updateEntries(len);
        }
    });
    updateEntries(settings._iDisplayLength);
    return div;
}, 'l');
// jQuery access
$44bb6d473543b89d$var$$.fn.dataTable = $44bb6d473543b89d$var$DataTable;
// Provide access to the host jQuery object (circular reference)
$44bb6d473543b89d$var$DataTable.$ = $44bb6d473543b89d$var$$;
// Legacy aliases
$44bb6d473543b89d$var$$.fn.dataTableSettings = $44bb6d473543b89d$var$DataTable.settings;
$44bb6d473543b89d$var$$.fn.dataTableExt = $44bb6d473543b89d$var$DataTable.ext;
// With a capital `D` we return a DataTables API instance rather than a
// jQuery object
$44bb6d473543b89d$var$$.fn.DataTable = function(opts) {
    return $44bb6d473543b89d$var$$(this).dataTable(opts).api();
};
// All properties that are available to $.fn.dataTable should also be
// available on $.fn.DataTable
$44bb6d473543b89d$var$$.each($44bb6d473543b89d$var$DataTable, function(prop, val) {
    $44bb6d473543b89d$var$$.fn.DataTable[prop] = val;
});
var $44bb6d473543b89d$export$2e2bcd8739ae039 = $44bb6d473543b89d$var$DataTable;

});


parcelRegister("eAhT0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $401378214c585f43$export$2e2bcd8739ae039);
/*! Buttons for DataTables 3.2.6
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");

var $63jfO = parcelRequire("63jfO");
// Allow reassignment of the $ variable
let $401378214c585f43$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
// Used for namespacing events added to the document by each instance, so they
// can be removed on destroy
var $401378214c585f43$var$_instCounter = 0;
// Button namespacing counter for namespacing events on individual buttons
var $401378214c585f43$var$_buttonCounter = 0;
var $401378214c585f43$var$_dtButtons = (0, $63jfO.default).ext.buttons;
// Custom entity decoder for data export
var $401378214c585f43$var$_entityDecoder = null;
// Allow for jQuery slim
function $401378214c585f43$var$_fadeIn(el, duration, fn) {
    if ($401378214c585f43$var$$.fn.animate) el.stop().fadeIn(duration, fn);
    else {
        el.css('display', 'block');
        if (fn) fn.call(el);
    }
}
function $401378214c585f43$var$_fadeOut(el, duration, fn) {
    if ($401378214c585f43$var$$.fn.animate) el.stop().fadeOut(duration, fn);
    else {
        el.css('display', 'none');
        if (fn) fn.call(el);
    }
}
/**
 * [Buttons description]
 * @param {[type]}
 * @param {[type]}
 */ var $401378214c585f43$var$Buttons = function(dt, config) {
    if (!(0, $63jfO.default).versionCheck('2')) throw 'Warning: Buttons requires DataTables 2 or newer';
    // If not created with a `new` keyword then we return a wrapper function that
    // will take the settings object for a DT. This allows easy use of new instances
    // with the `layout` option - e.g. `topLeft: $.fn.dataTable.Buttons( ... )`.
    if (!(this instanceof $401378214c585f43$var$Buttons)) return function(settings) {
        return new $401378214c585f43$var$Buttons(settings, dt).container();
    };
    // If there is no config set it to an empty object
    if (typeof config === 'undefined') config = {};
    // Allow a boolean true for defaults
    if (config === true) config = {};
    // For easy configuration of buttons an array can be given
    if (Array.isArray(config)) config = {
        buttons: config
    };
    this.c = $401378214c585f43$var$$.extend(true, {}, $401378214c585f43$var$Buttons.defaults, config);
    // Don't want a deep copy for the buttons
    if (config.buttons) this.c.buttons = config.buttons;
    this.s = {
        dt: new (0, $63jfO.default).Api(dt),
        buttons: [],
        listenKeys: '',
        namespace: 'dtb' + $401378214c585f43$var$_instCounter++
    };
    this.dom = {
        container: $401378214c585f43$var$$('<' + this.c.dom.container.tag + '/>').addClass(this.c.dom.container.className)
    };
    this._constructor();
};
$401378214c585f43$var$$.extend($401378214c585f43$var$Buttons.prototype, {
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods
	 */ /**
	 * Get the action of a button
	 * @param  {int|string} Button index
	 * @return {function}
	 */ /**
	 * Set the action of a button
	 * @param  {node} node Button element
	 * @param  {function} action Function to set
	 * @return {Buttons} Self for chaining
	 */ action: function(node, action) {
        var button = this._nodeToButton(node);
        if (action === undefined) return button.conf.action;
        button.conf.action = action;
        return this;
    },
    /**
	 * Add an active class to the button to make to look active or get current
	 * active state.
	 * @param  {node} node Button element
	 * @param  {boolean} [flag] Enable / disable flag
	 * @return {Buttons} Self for chaining or boolean for getter
	 */ active: function(node, flag) {
        var button = this._nodeToButton(node);
        var klass = this.c.dom.button.active;
        var jqNode = $401378214c585f43$var$$(button.node);
        if (button.inCollection && this.c.dom.collection.button && this.c.dom.collection.button.active !== undefined) klass = this.c.dom.collection.button.active;
        if (flag === undefined) return jqNode.hasClass(klass);
        jqNode.toggleClass(klass, flag === undefined ? true : flag);
        return this;
    },
    /**
	 * Add a new button
	 * @param {object} config Button configuration object, base string name or function
	 * @param {int|string} [idx] Button index for where to insert the button
	 * @param {boolean} [draw=true] Trigger a draw. Set a false when adding
	 *   lots of buttons, until the last button.
	 * @return {Buttons} Self for chaining
	 */ add: function(config, idx, draw) {
        var buttons = this.s.buttons;
        if (typeof idx === 'string') {
            var split = idx.split('-');
            var base = this.s;
            for(var i = 0, ien = split.length - 1; i < ien; i++)base = base.buttons[split[i] * 1];
            buttons = base.buttons;
            idx = split[split.length - 1] * 1;
        }
        let node = this._expandButton(buttons, config, config !== undefined ? config.split : undefined, (config === undefined || config.split === undefined || config.split.length === 0) && base !== undefined, false, idx);
        if (draw === undefined || draw === true) this._draw();
        return node;
    },
    /**
	 * Clear buttons from a collection and then insert new buttons
	 */ collectionRebuild: function(node, newButtons) {
        var button = this._nodeToButton(node);
        if (newButtons !== undefined) {
            var i;
            // Need to reverse the array
            for(i = button.buttons.length - 1; i >= 0; i--)this.remove(button.buttons[i].node);
            // If the collection has prefix and / or postfix buttons we need to add them in
            if (button.conf.prefixButtons) newButtons.unshift.apply(newButtons, button.conf.prefixButtons);
            if (button.conf.postfixButtons) newButtons.push.apply(newButtons, button.conf.postfixButtons);
            for(i = 0; i < newButtons.length; i++){
                var newBtn = newButtons[i];
                this._expandButton(button.buttons, newBtn, newBtn !== undefined && newBtn.config !== undefined && newBtn.config.split !== undefined, true, newBtn.parentConf !== undefined && newBtn.parentConf.split !== undefined, null, newBtn.parentConf);
            }
        }
        this._draw(button.collection, button.buttons);
    },
    /**
	 * Get the container node for the buttons
	 * @return {jQuery} Buttons node
	 */ container: function() {
        return this.dom.container;
    },
    /**
	 * Disable a button
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */ disable: function(node) {
        var button = this._nodeToButton(node);
        if (button.isSplit) $401378214c585f43$var$$(button.node.childNodes[0]).addClass(this.c.dom.button.disabled).prop('disabled', true);
        else $401378214c585f43$var$$(button.node).addClass(this.c.dom.button.disabled).prop('disabled', true);
        button.disabled = true;
        this._checkSplitEnable();
        return this;
    },
    /**
	 * Destroy the instance, cleaning up event handlers and removing DOM
	 * elements
	 * @return {Buttons} Self for chaining
	 */ destroy: function() {
        // Key event listener
        $401378214c585f43$var$$('body').off('keyup.' + this.s.namespace);
        // Individual button destroy (so they can remove their own events if
        // needed). Take a copy as the array is modified by `remove`
        var buttons = this.s.buttons.slice();
        var i, ien;
        for(i = 0, ien = buttons.length; i < ien; i++)this.remove(buttons[i].node);
        // Container
        this.dom.container.remove();
        // Remove from the settings object collection
        var buttonInsts = this.s.dt.settings()[0];
        for(i = 0, ien = buttonInsts.length; i < ien; i++)if (buttonInsts.inst === this) {
            buttonInsts.splice(i, 1);
            break;
        }
        return this;
    },
    /**
	 * Enable / disable a button
	 * @param  {node} node Button node
	 * @param  {boolean} [flag=true] Enable / disable flag
	 * @return {Buttons} Self for chaining
	 */ enable: function(node, flag) {
        if (flag === false) return this.disable(node);
        var button = this._nodeToButton(node);
        if (button.isSplit) $401378214c585f43$var$$(button.node.childNodes[0]).removeClass(this.c.dom.button.disabled).prop('disabled', false);
        else $401378214c585f43$var$$(button.node).removeClass(this.c.dom.button.disabled).prop('disabled', false);
        button.disabled = false;
        this._checkSplitEnable();
        return this;
    },
    /**
	 * Get a button's index
	 *
	 * This is internally recursive
	 * @param {element} node Button to get the index of
	 * @return {string} Button index
	 */ index: function(node, nested, buttons) {
        if (!nested) {
            nested = '';
            buttons = this.s.buttons;
        }
        for(var i = 0, ien = buttons.length; i < ien; i++){
            var inner = buttons[i].buttons;
            if (buttons[i].node === node) return nested + i;
            if (inner && inner.length) {
                var match = this.index(node, i + '-', inner);
                if (match !== null) return match;
            }
        }
        return null;
    },
    /**
	 * Get the instance name for the button set selector
	 * @return {string} Instance name
	 */ name: function() {
        return this.c.name;
    },
    /**
	 * Get a button's node of the buttons container if no button is given
	 * @param  {node} [node] Button node
	 * @return {jQuery} Button element, or container
	 */ node: function(node) {
        if (!node) return this.dom.container;
        var button = this._nodeToButton(node);
        return $401378214c585f43$var$$(button.node);
    },
    /**
	 * Set / get a processing class on the selected button
	 * @param {element} node Triggering button node
	 * @param  {boolean} flag true to add, false to remove, undefined to get
	 * @return {boolean|Buttons} Getter value or this if a setter.
	 */ processing: function(node, flag) {
        var dt = this.s.dt;
        var button = this._nodeToButton(node);
        if (flag === undefined) return $401378214c585f43$var$$(button.node).hasClass('processing');
        $401378214c585f43$var$$(button.node).toggleClass('processing', flag);
        $401378214c585f43$var$$(dt.table().node()).triggerHandler('buttons-processing.dt', [
            flag,
            dt.button(node),
            dt,
            $401378214c585f43$var$$(node),
            button.conf
        ]);
        return this;
    },
    /**
	 * Remove a button.
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */ remove: function(node) {
        var button = this._nodeToButton(node);
        var host = this._nodeToHost(node);
        var dt = this.s.dt;
        // Remove any child buttons first
        if (button.buttons.length) for(var i = button.buttons.length - 1; i >= 0; i--)this.remove(button.buttons[i].node);
        button.conf.destroying = true;
        // Allow the button to remove event handlers, etc
        if (button.conf.destroy) button.conf.destroy.call(dt.button(node), dt, $401378214c585f43$var$$(node), button.conf);
        this._removeKey(button.conf);
        $401378214c585f43$var$$(button.node).remove();
        if (button.inserter) $401378214c585f43$var$$(button.inserter).remove();
        var idx = $401378214c585f43$var$$.inArray(button, host);
        host.splice(idx, 1);
        return this;
    },
    /**
	 * Get the text for a button
	 * @param  {int|string} node Button index
	 * @return {string} Button text
	 */ /**
	 * Set the text for a button
	 * @param  {int|string|function} node Button index
	 * @param  {string} label Text
	 * @return {Buttons} Self for chaining
	 */ text: function(node, label) {
        var button = this._nodeToButton(node);
        var textNode = button.textNode;
        var dt = this.s.dt;
        var jqNode = $401378214c585f43$var$$(button.node);
        var text = function(opt) {
            return typeof opt === 'function' ? opt(dt, jqNode, button.conf) : opt;
        };
        if (label === undefined) return text(button.conf.text);
        button.conf.text = label;
        textNode.html(text(label));
        return this;
    },
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */ /**
	 * Buttons constructor
	 * @private
	 */ _constructor: function() {
        var that = this;
        var dt = this.s.dt;
        var dtSettings = dt.settings()[0];
        var buttons = this.c.buttons;
        if (!dtSettings._buttons) dtSettings._buttons = [];
        dtSettings._buttons.push({
            inst: this,
            name: this.c.name
        });
        for(var i = 0, ien = buttons.length; i < ien; i++)this.add(buttons[i]);
        dt.on('destroy', function(e, settings) {
            if (settings === dtSettings) that.destroy();
        });
        // Global key event binding to listen for button keys
        $401378214c585f43$var$$('body').on('keyup.' + this.s.namespace, function(e) {
            if (!document.activeElement || document.activeElement === document.body) {
                // SUse a string of characters for fast lookup of if we need to
                // handle this
                var character = String.fromCharCode(e.keyCode).toLowerCase();
                if (that.s.listenKeys.toLowerCase().indexOf(character) !== -1) that._keypress(character, e);
            }
        });
    },
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */ /**
	 * Add a new button to the key press listener
	 * @param {object} conf Resolved button configuration object
	 * @private
	 */ _addKey: function(conf) {
        if (conf.key) this.s.listenKeys += $401378214c585f43$var$$.isPlainObject(conf.key) ? conf.key.key : conf.key;
    },
    /**
	 * Insert the buttons into the container. Call without parameters!
	 * @param  {node} [container] Recursive only - Insert point
	 * @param  {array} [buttons] Recursive only - Buttons array
	 * @private
	 */ _draw: function(container, buttons) {
        if (!container) {
            container = this.dom.container;
            buttons = this.s.buttons;
        }
        container.children().detach();
        for(var i = 0, ien = buttons.length; i < ien; i++){
            container.append(buttons[i].inserter);
            container.append(' ');
            if (buttons[i].buttons && buttons[i].buttons.length) this._draw(buttons[i].collection, buttons[i].buttons);
        }
    },
    /**
	 * Create buttons from an array of buttons
	 * @param  {array} attachTo Buttons array to attach to
	 * @param  {object} button Button definition
	 * @param  {boolean} inCollection true if the button is in a collection
	 * @private
	 */ _expandButton: function(attachTo, button, split, inCollection, inSplit, attachPoint, parentConf) {
        var dt = this.s.dt;
        var isSplit = false;
        var domCollection = this.c.dom.collection;
        var buttons = !Array.isArray(button) ? [
            button
        ] : button;
        var lastButton;
        if (button === undefined) buttons = !Array.isArray(split) ? [
            split
        ] : split;
        for(var i = 0, ien = buttons.length; i < ien; i++){
            var conf = this._resolveExtends(buttons[i]);
            if (!conf) continue;
            isSplit = conf.config && conf.config.split ? true : false;
            // If the configuration is an array, then expand the buttons at this
            // point
            if (Array.isArray(conf)) {
                this._expandButton(attachTo, conf, built !== undefined && built.conf !== undefined ? built.conf.split : undefined, inCollection, parentConf !== undefined && parentConf.split !== undefined, attachPoint, parentConf);
                continue;
            }
            var built = this._buildButton(conf, inCollection, conf.split !== undefined || conf.config !== undefined && conf.config.split !== undefined, inSplit);
            if (!built) continue;
            if (attachPoint !== undefined && attachPoint !== null) {
                attachTo.splice(attachPoint, 0, built);
                attachPoint++;
            } else attachTo.push(built);
            // Any button type can have a drop icon set
            if (built.conf.dropIcon && !built.conf.split) $401378214c585f43$var$$(built.node).addClass(this.c.dom.button.dropClass).append(this.c.dom.button.dropHtml);
            // Create the dropdown for a collection
            if (built.conf.buttons) {
                built.collection = $401378214c585f43$var$$('<' + domCollection.container.content.tag + '/>');
                built.conf._collection = built.collection;
                this._expandButton(built.buttons, built.conf.buttons, built.conf.split, !isSplit, isSplit, attachPoint, built.conf);
            }
            // And the split collection
            if (built.conf.split) {
                built.collection = $401378214c585f43$var$$('<' + domCollection.container.tag + '/>');
                built.conf._collection = built.collection;
                for(var j = 0; j < built.conf.split.length; j++){
                    var item = built.conf.split[j];
                    if (typeof item === 'object') {
                        item.parent = parentConf;
                        if (item.collectionLayout === undefined) item.collectionLayout = built.conf.collectionLayout;
                        if (item.dropup === undefined) item.dropup = built.conf.dropup;
                        if (item.fade === undefined) item.fade = built.conf.fade;
                    }
                }
                this._expandButton(built.buttons, built.conf.buttons, built.conf.split, !isSplit, isSplit, attachPoint, built.conf);
            }
            built.conf.parent = parentConf;
            // init call is made here, rather than buildButton as it needs to
            // be selectable, and for that it needs to be in the buttons array
            if (conf.init) conf.init.call(dt.button(built.node), dt, $401378214c585f43$var$$(built.node), conf);
            lastButton = built.node;
        }
        return lastButton;
    },
    /**
	 * Create an individual button
	 * @param  {object} config            Resolved button configuration
	 * @param  {boolean} inCollection `true` if a collection button
	 * @return {object} Completed button description object
	 * @private
	 */ _buildButton: function(config, inCollection, isSplit, inSplit) {
        var that = this;
        var configDom = this.c.dom;
        var textNode;
        var dt = this.s.dt;
        var setLinerTab = false;
        var text = function(opt) {
            return typeof opt === 'function' ? opt(dt, button, config) : opt;
        };
        // Create an object that describes the button which can be in `dom.button`, or
        // `dom.collection.button` or `dom.split.button` or `dom.collection.split.button`!
        // Each should extend from `dom.button`.
        var dom = $401378214c585f43$var$$.extend(true, {}, configDom.button);
        if (inCollection && isSplit && configDom.collection.split) $401378214c585f43$var$$.extend(true, dom, configDom.collection.split.action);
        else if (inSplit || inCollection) $401378214c585f43$var$$.extend(true, dom, configDom.collection.button);
        else if (isSplit) $401378214c585f43$var$$.extend(true, dom, configDom.split.button);
        // Spacers don't do much other than insert an element into the DOM
        if (config.spacer) {
            var spacer = $401378214c585f43$var$$('<' + dom.spacer.tag + '/>').addClass('dt-button-spacer ' + config.style + ' ' + dom.spacer.className).html(text(config.text));
            return {
                conf: config,
                node: spacer,
                nodeChild: null,
                inserter: spacer,
                buttons: [],
                inCollection: inCollection,
                isSplit: isSplit,
                collection: null,
                textNode: spacer
            };
        }
        // Make sure that the button is available based on whatever requirements
        // it has. For example, PDF button require pdfmake
        if (config.available && !config.available(dt, config) && !config.html) return false;
        var button;
        if (!config.html) {
            var run = function(e, dt, button, config, done) {
                config.action.call(dt.button(button), e, dt, button, config, done);
                $401378214c585f43$var$$(dt.table().node()).triggerHandler('buttons-action.dt', [
                    dt.button(button),
                    dt,
                    button,
                    config
                ]);
            };
            var action = function(e, dt, button, config) {
                if (config.async) {
                    that.processing(button[0], true);
                    setTimeout(function() {
                        run(e, dt, button, config, function() {
                            that.processing(button[0], false);
                        });
                    }, config.async);
                } else run(e, dt, button, config, function() {});
            };
            var tag = config.tag || dom.tag;
            var clickBlurs = config.clickBlurs === undefined ? true : config.clickBlurs;
            button = $401378214c585f43$var$$('<' + tag + '/>').addClass(dom.className).attr('aria-controls', this.s.dt.table().node().id).on('click.dtb', function(e) {
                e.preventDefault();
                if (!button.hasClass(dom.disabled) && config.action) action(e, dt, button, config);
                if (clickBlurs) button.trigger('blur');
            }).on('keypress.dtb', function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    if (!button.hasClass(dom.disabled) && config.action) action(e, dt, button, config);
                }
            });
            // Make `a` tags act like a link
            if (tag.toLowerCase() === 'a') button.attr('href', '#');
            // Button tags should have `type=button` so they don't have any default behaviour
            if (tag.toLowerCase() === 'button') button.attr('type', 'button');
            if (dom.liner.tag) {
                var lc = dom.liner.tag.toLowerCase();
                var liner = $401378214c585f43$var$$('<' + lc + '/>').html(text(config.text)).addClass(dom.liner.className);
                if (lc === 'a') liner.attr('href', '#');
                if (lc === 'a' || lc === 'button') {
                    liner.attr('tabindex', this.s.dt.settings()[0].iTabIndex);
                    setLinerTab = true;
                }
                button.append(liner);
                textNode = liner;
            } else {
                button.html(text(config.text));
                textNode = button;
            }
            if (!setLinerTab) button.attr('tabindex', this.s.dt.settings()[0].iTabIndex);
            if (config.enabled === false) button.addClass(dom.disabled);
            if (config.className) button.addClass(config.className);
            if (config.titleAttr) button.attr('title', text(config.titleAttr));
            if (config.attr) button.attr(config.attr);
            if (!config.namespace) config.namespace = '.dt-button-' + $401378214c585f43$var$_buttonCounter++;
            if (config.config !== undefined && config.config.split) config.split = config.config.split;
        } else button = $401378214c585f43$var$$(config.html);
        var buttonContainer = this.c.dom.buttonContainer;
        var inserter;
        if (buttonContainer && buttonContainer.tag) inserter = $401378214c585f43$var$$('<' + buttonContainer.tag + '/>').addClass(buttonContainer.className).append(button);
        else inserter = button;
        this._addKey(config);
        // Style integration callback for DOM manipulation
        // Note that this is _not_ documented. It is currently
        // for style integration only
        if (this.c.buttonCreated) inserter = this.c.buttonCreated(config, inserter);
        var splitDiv;
        if (isSplit) {
            var dropdownConf = inCollection ? $401378214c585f43$var$$.extend(true, this.c.dom.split, this.c.dom.collection.split) : this.c.dom.split;
            var wrapperConf = dropdownConf.wrapper;
            splitDiv = $401378214c585f43$var$$('<' + wrapperConf.tag + '/>').addClass(wrapperConf.className).append(button);
            var dropButtonConfig = $401378214c585f43$var$$.extend(config, {
                autoClose: true,
                align: dropdownConf.dropdown.align,
                attr: {
                    'aria-haspopup': 'dialog',
                    'aria-expanded': false
                },
                className: dropdownConf.dropdown.className,
                closeButton: false,
                splitAlignClass: dropdownConf.dropdown.splitAlignClass,
                text: dropdownConf.dropdown.text
            });
            this._addKey(dropButtonConfig);
            var splitAction = function(e, dt, button, config) {
                $401378214c585f43$var$_dtButtons.split.action.call(dt.button(splitDiv), e, dt, button, config);
                $401378214c585f43$var$$(dt.table().node()).triggerHandler('buttons-action.dt', [
                    dt.button(button),
                    dt,
                    button,
                    config
                ]);
                button.attr('aria-expanded', true);
            };
            var dropButton = $401378214c585f43$var$$('<button class="' + dropdownConf.dropdown.className + ' dt-button"></button>').html(this.c.dom.button.dropHtml).addClass(this.c.dom.button.dropClass).on('click.dtb', function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (!dropButton.hasClass(dom.disabled)) splitAction(e, dt, dropButton, dropButtonConfig);
                if (clickBlurs) dropButton.trigger('blur');
            }).on('keypress.dtb', function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    if (!dropButton.hasClass(dom.disabled)) splitAction(e, dt, dropButton, dropButtonConfig);
                }
            });
            if (config.split.length === 0) dropButton.addClass('dtb-hide-drop');
            splitDiv.append(dropButton).attr(dropButtonConfig.attr);
        }
        var node = isSplit ? splitDiv.get(0) : button.get(0);
        return {
            conf: config,
            node: node,
            nodeChild: node && node.children && node.children.length ? node.children[0] : null,
            inserter: isSplit ? splitDiv : inserter,
            buttons: [],
            inCollection: inCollection,
            isSplit: isSplit,
            inSplit: inSplit,
            collection: null,
            textNode: textNode
        };
    },
    /**
	 * Spin over buttons checking if splits should be enabled or not.
	 * @param {*} buttons Array of buttons to check
	 */ _checkSplitEnable: function(buttons) {
        if (!buttons) buttons = this.s.buttons;
        for(var i = 0; i < buttons.length; i++){
            var button = buttons[i];
            // Check if the button is a split one and if so, determine
            // its state
            if (button.isSplit) {
                var splitBtn = button.node.childNodes[1];
                if (this._checkAnyEnabled(button.buttons)) // Enable the split
                $401378214c585f43$var$$(splitBtn).removeClass(this.c.dom.button.disabled).prop('disabled', false);
                else $401378214c585f43$var$$(splitBtn).addClass(this.c.dom.button.disabled).prop('disabled', false);
            } else if (button.isCollection) // Nest down into collections
            this._checkSplitEnable(button.buttons);
        }
    },
    /**
	 * Check an array of buttons and see if any are enabled in it
	 * @param {*} buttons Button array
	 * @returns true if a button is enabled, false otherwise
	 */ _checkAnyEnabled: function(buttons) {
        for(var i = 0; i < buttons.length; i++){
            if (!buttons[i].disabled) return true;
        }
        return false;
    },
    /**
	 * Get the button object from a node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {object} Button object
	 * @private
	 */ _nodeToButton: function(node, buttons) {
        if (!buttons) buttons = this.s.buttons;
        for(var i = 0, ien = buttons.length; i < ien; i++){
            if (buttons[i].node === node || buttons[i].nodeChild === node) return buttons[i];
            if (buttons[i].buttons.length) {
                var ret = this._nodeToButton(node, buttons[i].buttons);
                if (ret) return ret;
            }
        }
    },
    /**
	 * Get container array for a button from a button node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {array} Button's host array
	 * @private
	 */ _nodeToHost: function(node, buttons) {
        if (!buttons) buttons = this.s.buttons;
        for(var i = 0, ien = buttons.length; i < ien; i++){
            if (buttons[i].node === node) return buttons;
            if (buttons[i].buttons.length) {
                var ret = this._nodeToHost(node, buttons[i].buttons);
                if (ret) return ret;
            }
        }
    },
    /**
	 * Handle a key press - determine if any button's key configured matches
	 * what was typed and trigger the action if so.
	 * @param  {string} character The character pressed
	 * @param  {object} e Key event that triggered this call
	 * @private
	 */ _keypress: function(character, e) {
        // Check if this button press already activated on another instance of Buttons
        if (e._buttonsHandled) return;
        var run = function(conf, node) {
            if (!conf.key) return;
            if (conf.key === character) {
                e._buttonsHandled = true;
                $401378214c585f43$var$$(node).click();
            } else if ($401378214c585f43$var$$.isPlainObject(conf.key)) {
                if (conf.key.key !== character) return;
                if (conf.key.shiftKey && !e.shiftKey) return;
                if (conf.key.altKey && !e.altKey) return;
                if (conf.key.ctrlKey && !e.ctrlKey) return;
                if (conf.key.metaKey && !e.metaKey) return;
                // Made it this far - it is good
                e._buttonsHandled = true;
                $401378214c585f43$var$$(node).click();
            }
        };
        var recurse = function(a) {
            for(var i = 0, ien = a.length; i < ien; i++){
                run(a[i].conf, a[i].node);
                if (a[i].buttons.length) recurse(a[i].buttons);
            }
        };
        recurse(this.s.buttons);
    },
    /**
	 * Remove a key from the key listener for this instance (to be used when a
	 * button is removed)
	 * @param  {object} conf Button configuration
	 * @private
	 */ _removeKey: function(conf) {
        if (conf.key) {
            var character = $401378214c585f43$var$$.isPlainObject(conf.key) ? conf.key.key : conf.key;
            // Remove only one character, as multiple buttons could have the
            // same listening key
            var a = this.s.listenKeys.split('');
            var idx = $401378214c585f43$var$$.inArray(character, a);
            a.splice(idx, 1);
            this.s.listenKeys = a.join('');
        }
    },
    /**
	 * Resolve a button configuration
	 * @param  {string|function|object} conf Button config to resolve
	 * @return {object} Button configuration
	 * @private
	 */ _resolveExtends: function(conf) {
        var that = this;
        var dt = this.s.dt;
        var i, ien;
        var toConfObject = function(base) {
            var loop = 0;
            // Loop until we have resolved to a button configuration, or an
            // array of button configurations (which will be iterated
            // separately)
            while(!$401378214c585f43$var$$.isPlainObject(base) && !Array.isArray(base)){
                if (base === undefined) return;
                if (typeof base === 'function') {
                    base = base.call(that, dt, conf);
                    if (!base) return false;
                } else if (typeof base === 'string') {
                    if (!$401378214c585f43$var$_dtButtons[base]) return {
                        html: base
                    };
                    base = $401378214c585f43$var$_dtButtons[base];
                }
                loop++;
                if (loop > 30) // Protect against misconfiguration killing the browser
                throw 'Buttons: Too many iterations';
            }
            return Array.isArray(base) ? base : $401378214c585f43$var$$.extend({}, base);
        };
        conf = toConfObject(conf);
        while(conf && conf.extend){
            // Use `toConfObject` in case the button definition being extended
            // is itself a string or a function
            if (!$401378214c585f43$var$_dtButtons[conf.extend]) throw 'Cannot extend unknown button type: ' + conf.extend;
            var objArray = toConfObject($401378214c585f43$var$_dtButtons[conf.extend]);
            if (Array.isArray(objArray)) return objArray;
            else if (!objArray) // This is a little brutal as it might be possible to have a
            // valid button without the extend, but if there is no extend
            // then the host button would be acting in an undefined state
            return false;
            // Stash the current class name
            var originalClassName = objArray.className;
            if (conf.config !== undefined && objArray.config !== undefined) conf.config = $401378214c585f43$var$$.extend({}, objArray.config, conf.config);
            conf = $401378214c585f43$var$$.extend({}, objArray, conf);
            // The extend will have overwritten the original class name if the
            // `conf` object also assigned a class, but we want to concatenate
            // them so they are list that is combined from all extended buttons
            if (originalClassName && conf.className !== originalClassName) conf.className = originalClassName + ' ' + conf.className;
            // Although we want the `conf` object to overwrite almost all of
            // the properties of the object being extended, the `extend`
            // property should come from the object being extended
            conf.extend = objArray.extend;
        }
        // Buttons to be added to a collection  -gives the ability to define
        // if buttons should be added to the start or end of a collection
        var postfixButtons = conf.postfixButtons;
        if (postfixButtons) {
            if (!conf.buttons) conf.buttons = [];
            for(i = 0, ien = postfixButtons.length; i < ien; i++)conf.buttons.push(postfixButtons[i]);
        }
        var prefixButtons = conf.prefixButtons;
        if (prefixButtons) {
            if (!conf.buttons) conf.buttons = [];
            for(i = 0, ien = prefixButtons.length; i < ien; i++)conf.buttons.splice(i, 0, prefixButtons[i]);
        }
        return conf;
    },
    /**
	 * Display (and replace if there is an existing one) a popover attached to a button
	 * @param {string|node} content Content to show
	 * @param {DataTable.Api} hostButton DT API instance of the button
	 * @param {object} inOpts Options (see object below for all options)
	 */ _popover: function(content, hostButton, inOpts) {
        var dt = hostButton;
        var c = this.c;
        var closed = false;
        var options = $401378214c585f43$var$$.extend({
            align: 'button-left',
            autoClose: false,
            background: true,
            backgroundClassName: 'dt-button-background',
            closeButton: true,
            containerClassName: c.dom.collection.container.className,
            contentClassName: c.dom.collection.container.content.className,
            collectionLayout: '',
            collectionTitle: '',
            dropup: false,
            fade: 400,
            popoverTitle: '',
            rightAlignClassName: 'dt-button-right',
            tag: c.dom.collection.container.tag
        }, inOpts);
        var containerSelector = options.tag + '.' + options.containerClassName.replace(/ /g, '.');
        var hostButtonNode = hostButton.node();
        var hostNode = options.collectionLayout.includes('fixed') ? $401378214c585f43$var$$('body') : hostButton.node();
        var close = function() {
            closed = true;
            $401378214c585f43$var$_fadeOut($401378214c585f43$var$$(containerSelector), options.fade, function() {
                $401378214c585f43$var$$(this).detach();
            });
            $401378214c585f43$var$$(dt.buttons('[aria-haspopup="dialog"][aria-expanded="true"]').nodes()).attr('aria-expanded', 'false');
            $401378214c585f43$var$$('div.dt-button-background').off('click.dtb-collection');
            $401378214c585f43$var$Buttons.background(false, options.backgroundClassName, options.fade, hostNode);
            $401378214c585f43$var$$(window).off('resize.resize.dtb-collection');
            $401378214c585f43$var$$('body').off('.dtb-collection');
            dt.off('buttons-action.b-internal');
            dt.off('destroy.dtb-popover');
            $401378214c585f43$var$$('body').trigger('buttons-popover-hide.dt');
        };
        if (content === false) {
            close();
            return;
        }
        var existingExpanded = $401378214c585f43$var$$(dt.buttons('[aria-haspopup="dialog"][aria-expanded="true"]').nodes());
        if (existingExpanded.length) {
            // Reuse the current position if the button that was triggered is inside an existing collection
            if (hostNode.closest(containerSelector).length) hostNode = existingExpanded.eq(0);
            close();
        }
        // Sort buttons if defined
        if (options.sort) {
            var elements = $401378214c585f43$var$$('button', content).map(function(idx, el) {
                return {
                    text: $401378214c585f43$var$$(el).text(),
                    el: el
                };
            }).toArray();
            elements.sort(function(a, b) {
                return a.text.localeCompare(b.text);
            });
            $401378214c585f43$var$$(content).append(elements.map(function(v) {
                return v.el;
            }));
        }
        // Try to be smart about the layout
        var cnt = $401378214c585f43$var$$('.dt-button', content).length;
        var mod = '';
        if (cnt === 3) mod = 'dtb-b3';
        else if (cnt === 2) mod = 'dtb-b2';
        else if (cnt === 1) mod = 'dtb-b1';
        var display = $401378214c585f43$var$$('<' + options.tag + '/>').addClass(options.containerClassName).addClass(options.collectionLayout).addClass(options.splitAlignClass).addClass(mod).css('display', 'none').attr({
            'aria-modal': true,
            role: 'dialog'
        });
        content = $401378214c585f43$var$$(content).addClass(options.contentClassName).attr('role', 'menu').appendTo(display);
        hostButtonNode.attr('aria-expanded', 'true');
        if (hostNode.parents('body')[0] !== document.body) hostNode = $401378214c585f43$var$$(document.body).children('div, section, p').last();
        if (options.popoverTitle) display.prepend('<div class="dt-button-collection-title">' + options.popoverTitle + '</div>');
        else if (options.collectionTitle) display.prepend('<div class="dt-button-collection-title">' + options.collectionTitle + '</div>');
        if (options.closeButton) display.prepend('<div class="dtb-popover-close">&times;</div>').addClass('dtb-collection-closeable');
        $401378214c585f43$var$_fadeIn(display.insertAfter(hostNode), options.fade);
        var tableContainer = $401378214c585f43$var$$(hostButton.table().container());
        var position = display.css('position');
        if (options.span === 'container' || options.align === 'dt-container') {
            hostNode = hostNode.parent();
            display.css('width', tableContainer.width());
        }
        // Align the popover relative to the DataTables container
        // Useful for wide popovers such as SearchPanes
        if (position === 'absolute') {
            // Align relative to the host button
            var offsetParent = $401378214c585f43$var$$(hostNode[0].offsetParent);
            var buttonPosition = hostNode.position();
            var buttonOffset = hostNode.offset();
            var tableSizes = offsetParent.offset();
            var containerPosition = offsetParent.position();
            var computed = window.getComputedStyle(offsetParent[0]);
            tableSizes.height = offsetParent.outerHeight();
            tableSizes.width = offsetParent.width() + parseFloat(computed.paddingLeft);
            tableSizes.right = tableSizes.left + tableSizes.width;
            tableSizes.bottom = tableSizes.top + tableSizes.height;
            // Set the initial position so we can read height / width
            var top = buttonPosition.top + hostNode.outerHeight();
            var left = buttonPosition.left;
            display.css({
                top: top,
                left: left
            });
            // Get the popover position
            computed = window.getComputedStyle(display[0]);
            var popoverSizes = display.offset();
            popoverSizes.height = display.outerHeight();
            popoverSizes.width = display.outerWidth();
            popoverSizes.right = popoverSizes.left + popoverSizes.width;
            popoverSizes.bottom = popoverSizes.top + popoverSizes.height;
            popoverSizes.marginTop = parseFloat(computed.marginTop);
            popoverSizes.marginBottom = parseFloat(computed.marginBottom);
            // First position per the class requirements - pop up and right align
            if (options.dropup) top = buttonPosition.top - popoverSizes.height - popoverSizes.marginTop - popoverSizes.marginBottom;
            if (options.align === 'button-right' || display.hasClass(options.rightAlignClassName)) left = buttonPosition.left - popoverSizes.width + hostNode.outerWidth();
            // Container alignment - make sure it doesn't overflow the table container
            if (options.align === 'dt-container' || options.align === 'container') {
                if (left < buttonPosition.left) left = -buttonPosition.left;
            }
            // Window adjustment
            if (containerPosition.left + left + popoverSizes.width > $401378214c585f43$var$$(window).width()) // Overflowing the document to the right
            left = $401378214c585f43$var$$(window).width() - popoverSizes.width - containerPosition.left;
            if (buttonOffset.left + left < 0) // Off to the left of the document
            left = -buttonOffset.left;
            if (containerPosition.top + top + popoverSizes.height > $401378214c585f43$var$$(window).height() + $401378214c585f43$var$$(window).scrollTop()) // Pop up if otherwise we'd need the user to scroll down
            top = buttonPosition.top - popoverSizes.height - popoverSizes.marginTop - popoverSizes.marginBottom;
            if (offsetParent.offset().top + top < $401378214c585f43$var$$(window).scrollTop()) // Correction for when the top is beyond the top of the page
            top = buttonPosition.top + hostNode.outerHeight();
            // Calculations all done - now set it
            display.css({
                top: top,
                left: left
            });
        } else {
            // Fix position - centre on screen
            var place = function() {
                var half = $401378214c585f43$var$$(window).height() / 2;
                var top = display.height() / 2;
                if (top > half) top = half;
                display.css('marginTop', top * -1);
            };
            place();
            $401378214c585f43$var$$(window).on('resize.dtb-collection', function() {
                place();
            });
        }
        if (options.background) $401378214c585f43$var$Buttons.background(true, options.backgroundClassName, options.fade, options.backgroundHost || hostNode);
        // This is bonkers, but if we don't have a click listener on the
        // background element, iOS Safari will ignore the body click
        // listener below. An empty function here is all that is
        // required to make it work...
        $401378214c585f43$var$$('div.dt-button-background').on('click.dtb-collection', function() {});
        if (options.autoClose) setTimeout(function() {
            dt.on('buttons-action.b-internal', function(e, btn, dt, node) {
                if (node[0] === hostNode[0]) return;
                close();
            });
        }, 0);
        $401378214c585f43$var$$(display).trigger('buttons-popover.dt');
        dt.on('destroy.dtb-popover', close);
        setTimeout(function() {
            closed = false;
            $401378214c585f43$var$$('body').on('click.dtb-collection', function(e) {
                if (closed) return;
                // andSelf is deprecated in jQ1.8, but we want 1.7 compat
                var back = $401378214c585f43$var$$.fn.addBack ? 'addBack' : 'andSelf';
                var parent = $401378214c585f43$var$$(e.target).parent()[0];
                if (!$401378214c585f43$var$$(e.target).parents()[back]().filter(content).length && !$401378214c585f43$var$$(parent).hasClass('dt-buttons') || $401378214c585f43$var$$(e.target).hasClass('dt-button-background')) close();
            }).on('keyup.dtb-collection', function(e) {
                if (e.keyCode === 27) close();
            }).on('keydown.dtb-collection', function(e) {
                // Focus trap for tab key
                var elements = $401378214c585f43$var$$('a, button', content);
                var active = document.activeElement;
                if (e.keyCode !== 9) // tab
                return;
                if (elements.index(active) === -1) {
                    // If current focus is not inside the popover
                    elements.first().focus();
                    e.preventDefault();
                } else if (e.shiftKey) // Reverse tabbing order when shift key is pressed
                {
                    if (active === elements[0]) {
                        elements.last().focus();
                        e.preventDefault();
                    }
                } else if (active === elements.last()[0]) {
                    elements.first().focus();
                    e.preventDefault();
                }
            });
        }, 0);
    }
});
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Statics
 */ /**
 * Show / hide a background layer behind a collection
 * @param  {boolean} Flag to indicate if the background should be shown or
 *   hidden
 * @param  {string} Class to assign to the background
 * @static
 */ $401378214c585f43$var$Buttons.background = function(show, className, fade, insertPoint) {
    if (fade === undefined) fade = 400;
    if (!insertPoint) insertPoint = document.body;
    if (show) $401378214c585f43$var$_fadeIn($401378214c585f43$var$$('<div/>').addClass(className).css('display', 'none').insertAfter(insertPoint), fade);
    else $401378214c585f43$var$_fadeOut($401378214c585f43$var$$('div.' + className), fade, function() {
        $401378214c585f43$var$$(this).removeClass(className).remove();
    });
};
/**
 * Instance selector - select Buttons instances based on an instance selector
 * value from the buttons assigned to a DataTable. This is only useful if
 * multiple instances are attached to a DataTable.
 * @param  {string|int|array} Instance selector - see `instance-selector`
 *   documentation on the DataTables site
 * @param  {array} Button instance array that was attached to the DataTables
 *   settings object
 * @return {array} Buttons instances
 * @static
 */ $401378214c585f43$var$Buttons.instanceSelector = function(group, buttons) {
    if (group === undefined || group === null) return $401378214c585f43$var$$.map(buttons, function(v) {
        return v.inst;
    });
    var ret = [];
    var names = $401378214c585f43$var$$.map(buttons, function(v) {
        return v.name;
    });
    // Flatten the group selector into an array of single options
    var process = function(input) {
        if (Array.isArray(input)) {
            for(var i = 0, ien = input.length; i < ien; i++)process(input[i]);
            return;
        }
        if (typeof input === 'string') {
            if (input.indexOf(',') !== -1) // String selector, list of names
            process(input.split(','));
            else {
                // String selector individual name
                var idx = $401378214c585f43$var$$.inArray(input.trim(), names);
                if (idx !== -1) ret.push(buttons[idx].inst);
            }
        } else if (typeof input === 'number') // Index selector
        ret.push(buttons[input].inst);
        else if (typeof input === 'object' && input.nodeName) {
            // Element selector
            for(var j = 0; j < buttons.length; j++)if (buttons[j].inst.dom.container[0] === input) ret.push(buttons[j].inst);
        } else if (typeof input === 'object') // Actual instance selector
        ret.push(input);
    };
    process(group);
    return ret;
};
/**
 * Button selector - select one or more buttons from a selector input so some
 * operation can be performed on them.
 * @param  {array} Button instances array that the selector should operate on
 * @param  {string|int|node|jQuery|array} Button selector - see
 *   `button-selector` documentation on the DataTables site
 * @return {array} Array of objects containing `inst` and `idx` properties of
 *   the selected buttons so you know which instance each button belongs to.
 * @static
 */ $401378214c585f43$var$Buttons.buttonSelector = function(insts, selector) {
    var ret = [];
    var nodeBuilder = function(a, buttons, baseIdx) {
        var button;
        var idx;
        for(var i = 0, ien = buttons.length; i < ien; i++){
            button = buttons[i];
            if (button) {
                idx = baseIdx !== undefined ? baseIdx + i : i + '';
                a.push({
                    node: button.node,
                    name: button.conf.name,
                    idx: idx
                });
                if (button.buttons) nodeBuilder(a, button.buttons, idx + '-');
            }
        }
    };
    var run = function(selector, inst) {
        var i, ien;
        var buttons = [];
        nodeBuilder(buttons, inst.s.buttons);
        var nodes = $401378214c585f43$var$$.map(buttons, function(v) {
            return v.node;
        });
        if (Array.isArray(selector) || selector instanceof $401378214c585f43$var$$) {
            for(i = 0, ien = selector.length; i < ien; i++)run(selector[i], inst);
            return;
        }
        if (selector === null || selector === undefined || selector === '*') // Select all
        for(i = 0, ien = buttons.length; i < ien; i++)ret.push({
            inst: inst,
            node: buttons[i].node
        });
        else if (typeof selector === 'number') // Main button index selector
        {
            if (inst.s.buttons[selector]) ret.push({
                inst: inst,
                node: inst.s.buttons[selector].node
            });
        } else if (typeof selector === 'string') {
            if (selector.indexOf(',') !== -1) {
                // Split
                var a = selector.split(',');
                for(i = 0, ien = a.length; i < ien; i++)run(a[i].trim(), inst);
            } else if (selector.match(/^\d+(\-\d+)*$/)) {
                // Sub-button index selector
                var indexes = $401378214c585f43$var$$.map(buttons, function(v) {
                    return v.idx;
                });
                ret.push({
                    inst: inst,
                    node: buttons[$401378214c585f43$var$$.inArray(selector, indexes)].node
                });
            } else if (selector.indexOf(':name') !== -1) {
                // Button name selector
                var name = selector.replace(':name', '');
                for(i = 0, ien = buttons.length; i < ien; i++)if (buttons[i].name === name) ret.push({
                    inst: inst,
                    node: buttons[i].node
                });
            } else // jQuery selector on the nodes
            $401378214c585f43$var$$(nodes).filter(selector).each(function() {
                ret.push({
                    inst: inst,
                    node: this
                });
            });
        } else if (typeof selector === 'object' && selector.nodeName) {
            // Node selector
            var idx = $401378214c585f43$var$$.inArray(selector, nodes);
            if (idx !== -1) ret.push({
                inst: inst,
                node: nodes[idx]
            });
        }
    };
    for(var i = 0, ien = insts.length; i < ien; i++){
        var inst = insts[i];
        run(selector, inst);
    }
    return ret;
};
/**
 * Default function used for formatting output data.
 * @param {*} str Data to strip
 */ $401378214c585f43$var$Buttons.stripData = function(str, config) {
    // If the input is an HTML element, we can use the HTML from it (HTML might be stripped below).
    if (str !== null && typeof str === 'object' && str.nodeName && str.nodeType) str = str.innerHTML;
    if (typeof str !== 'string') return str;
    // Always remove script tags
    str = $401378214c585f43$var$Buttons.stripHtmlScript(str);
    // Always remove comments
    str = $401378214c585f43$var$Buttons.stripHtmlComments(str);
    if (!config || config.stripHtml) str = (0, $63jfO.default).util.stripHtml(str);
    if (!config || config.trim) str = str.trim();
    if (!config || config.stripNewlines) str = str.replace(/\n/g, ' ');
    if (!config || config.decodeEntities) {
        if ($401378214c585f43$var$_entityDecoder) str = $401378214c585f43$var$_entityDecoder(str);
        else {
            $401378214c585f43$var$_exportTextarea.innerHTML = str;
            str = $401378214c585f43$var$_exportTextarea.value;
        }
    }
    // Prevent Excel from running a formula
    if (!config || config.escapeExcelFormula) {
        if (str.match(/^[=@\t\r]/)) str = "'" + str;
    }
    return str;
};
/**
 * Provide a custom entity decoding function - e.g. a regex one, which can be
 * much faster than the built in DOM option, but also larger code size.
 * @param {function} fn
 */ $401378214c585f43$var$Buttons.entityDecoder = function(fn) {
    $401378214c585f43$var$_entityDecoder = fn;
};
/**
 * Common function for stripping HTML comments
 *
 * @param {*} input 
 * @returns 
 */ $401378214c585f43$var$Buttons.stripHtmlComments = function(input) {
    var previous;
    do {
        previous = input;
        input = input.replace(/(<!--.*?--!?>)|(<!--[\S\s]+?--!?>)|(<!--[\S\s]*?$)/g, '');
    }while (input !== previous);
    return input;
};
/**
 * Common function for stripping HTML script tags
 *
 * @param {*} input 
 * @returns 
 */ $401378214c585f43$var$Buttons.stripHtmlScript = function(input) {
    var previous;
    do {
        previous = input;
        input = input.replace(/<script\b[^<]*(?:(?!<\/script[^>]*>)<[^<]*)*<\/script[^>]*>/gi, '');
    }while (input !== previous);
    return input;
};
/**
 * Buttons defaults. For full documentation, please refer to the docs/option
 * directory or the DataTables site.
 * @type {Object}
 * @static
 */ $401378214c585f43$var$Buttons.defaults = {
    buttons: [
        'copy',
        'excel',
        'csv',
        'pdf',
        'print'
    ],
    name: 'main',
    tabIndex: 0,
    dom: {
        container: {
            tag: 'div',
            className: 'dt-buttons'
        },
        collection: {
            container: {
                // The element used for the dropdown
                className: 'dt-button-collection',
                content: {
                    className: '',
                    tag: 'div'
                },
                tag: 'div'
            }
        },
        button: {
            tag: 'button',
            className: 'dt-button',
            active: 'dt-button-active',
            disabled: 'disabled',
            spacer: {
                className: 'dt-button-spacer',
                tag: 'span'
            },
            liner: {
                tag: 'span',
                className: ''
            },
            dropClass: '',
            dropHtml: '<span class="dt-button-down-arrow">&#x25BC;</span>'
        },
        split: {
            action: {
                // action button
                className: 'dt-button-split-drop-button dt-button',
                tag: 'button'
            },
            dropdown: {
                // button to trigger the dropdown
                align: 'split-right',
                className: 'dt-button-split-drop',
                splitAlignClass: 'dt-button-split-left',
                tag: 'button'
            },
            wrapper: {
                // wrap around both
                className: 'dt-button-split',
                tag: 'div'
            }
        }
    }
};
/**
 * Version information
 * @type {string}
 * @static
 */ $401378214c585f43$var$Buttons.version = '3.2.6';
$401378214c585f43$var$$.extend($401378214c585f43$var$_dtButtons, {
    collection: {
        text: function(dt) {
            return dt.i18n('buttons.collection', 'Collection');
        },
        className: 'buttons-collection',
        closeButton: false,
        dropIcon: true,
        init: function(dt, button) {
            button.attr('aria-expanded', false);
        },
        action: function(e, dt, button, config) {
            if (config._collection.parents('body').length) this.popover(false, config);
            else this.popover(config._collection, config);
            // When activated using a key - auto focus on the
            // first item in the popover
            if (e.type === 'keypress') $401378214c585f43$var$$('a, button', config._collection).eq(0).focus();
        },
        attr: {
            'aria-haspopup': 'dialog'
        }
    },
    split: {
        text: function(dt) {
            return dt.i18n('buttons.split', 'Split');
        },
        className: 'buttons-split',
        closeButton: false,
        init: function(dt, button) {
            return button.attr('aria-expanded', false);
        },
        action: function(e, dt, button, config) {
            this.popover(config._collection, config);
        },
        attr: {
            'aria-haspopup': 'dialog'
        }
    },
    copy: function() {
        if ($401378214c585f43$var$_dtButtons.copyHtml5) return 'copyHtml5';
    },
    csv: function(dt, conf) {
        if ($401378214c585f43$var$_dtButtons.csvHtml5 && $401378214c585f43$var$_dtButtons.csvHtml5.available(dt, conf)) return 'csvHtml5';
    },
    excel: function(dt, conf) {
        if ($401378214c585f43$var$_dtButtons.excelHtml5 && $401378214c585f43$var$_dtButtons.excelHtml5.available(dt, conf)) return 'excelHtml5';
    },
    pdf: function(dt, conf) {
        if ($401378214c585f43$var$_dtButtons.pdfHtml5 && $401378214c585f43$var$_dtButtons.pdfHtml5.available(dt, conf)) return 'pdfHtml5';
    },
    pageLength: function(dt) {
        var lengthMenu = dt.settings()[0].aLengthMenu;
        var vals = [];
        var lang = [];
        var text = function(dt) {
            return dt.i18n('buttons.pageLength', {
                '-1': 'Show all rows',
                _: 'Show %d rows'
            }, dt.page.len());
        };
        // Support for DataTables 1.x 2D array
        if (Array.isArray(lengthMenu[0])) {
            vals = lengthMenu[0];
            lang = lengthMenu[1];
        } else for(var i = 0; i < lengthMenu.length; i++){
            var option = lengthMenu[i];
            // Support for DataTables 2 object in the array
            if ($401378214c585f43$var$$.isPlainObject(option)) {
                vals.push(option.value);
                lang.push(option.label);
            } else {
                vals.push(option);
                lang.push(option);
            }
        }
        return {
            extend: 'collection',
            text: text,
            className: 'buttons-page-length',
            autoClose: true,
            buttons: $401378214c585f43$var$$.map(vals, function(val, i) {
                return {
                    text: lang[i],
                    className: 'button-page-length',
                    action: function(e, dt) {
                        dt.page.len(val).draw();
                    },
                    init: function(dt, node, conf) {
                        var that = this;
                        var fn = function() {
                            that.active(dt.page.len() === val);
                        };
                        dt.on('length.dt' + conf.namespace, fn);
                        fn();
                    },
                    destroy: function(dt, node, conf) {
                        dt.off('length.dt' + conf.namespace);
                    }
                };
            }),
            init: function(dt, node, conf) {
                var that = this;
                dt.on('length.dt' + conf.namespace, function() {
                    that.text(conf.text);
                });
            },
            destroy: function(dt, node, conf) {
                dt.off('length.dt' + conf.namespace);
            }
        };
    },
    spacer: {
        style: 'empty',
        spacer: true,
        text: function(dt) {
            return dt.i18n('buttons.spacer', '');
        }
    }
});
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables API
 *
 * For complete documentation, please refer to the docs/api directory or the
 * DataTables site
 */ // Buttons group and individual button selector
(0, $63jfO.default).Api.register('buttons()', function(group, selector) {
    // Argument shifting
    if (selector === undefined) {
        selector = group;
        group = undefined;
    }
    this.selector.buttonGroup = group;
    var res = this.iterator(true, 'table', function(ctx) {
        if (ctx._buttons) return $401378214c585f43$var$Buttons.buttonSelector($401378214c585f43$var$Buttons.instanceSelector(group, ctx._buttons), selector);
    }, true);
    res._groupSelector = group;
    return res;
});
// Individual button selector
(0, $63jfO.default).Api.register('button()', function(group, selector) {
    // just run buttons() and truncate
    var buttons = this.buttons(group, selector);
    if (buttons.length > 1) buttons.splice(1, buttons.length);
    return buttons;
});
// Active buttons
(0, $63jfO.default).Api.registerPlural('buttons().active()', 'button().active()', function(flag) {
    if (flag === undefined) return this.map(function(set) {
        return set.inst.active(set.node);
    });
    return this.each(function(set) {
        set.inst.active(set.node, flag);
    });
});
// Get / set button action
(0, $63jfO.default).Api.registerPlural('buttons().action()', 'button().action()', function(action) {
    if (action === undefined) return this.map(function(set) {
        return set.inst.action(set.node);
    });
    return this.each(function(set) {
        set.inst.action(set.node, action);
    });
});
// Collection control
(0, $63jfO.default).Api.registerPlural('buttons().collectionRebuild()', 'button().collectionRebuild()', function(buttons) {
    return this.each(function(set) {
        for(var i = 0; i < buttons.length; i++)if (typeof buttons[i] === 'object') buttons[i].parentConf = set;
        set.inst.collectionRebuild(set.node, buttons);
    });
});
// Enable / disable buttons
(0, $63jfO.default).Api.register([
    'buttons().enable()',
    'button().enable()'
], function(flag) {
    return this.each(function(set) {
        set.inst.enable(set.node, flag);
    });
});
// Disable buttons
(0, $63jfO.default).Api.register([
    'buttons().disable()',
    'button().disable()'
], function() {
    return this.each(function(set) {
        set.inst.disable(set.node);
    });
});
// Button index
(0, $63jfO.default).Api.register('button().index()', function() {
    var idx = null;
    this.each(function(set) {
        var res = set.inst.index(set.node);
        if (res !== null) idx = res;
    });
    return idx;
});
// Get button nodes
(0, $63jfO.default).Api.registerPlural('buttons().nodes()', 'button().node()', function() {
    var jq = $401378214c585f43$var$$();
    // jQuery will automatically reduce duplicates to a single entry
    $401378214c585f43$var$$(this.each(function(set) {
        jq = jq.add(set.inst.node(set.node));
    }));
    return jq;
});
// Get / set button processing state
(0, $63jfO.default).Api.registerPlural('buttons().processing()', 'button().processing()', function(flag) {
    if (flag === undefined) return this.map(function(set) {
        return set.inst.processing(set.node);
    });
    return this.each(function(set) {
        set.inst.processing(set.node, flag);
    });
});
// Get / set button text (i.e. the button labels)
(0, $63jfO.default).Api.registerPlural('buttons().text()', 'button().text()', function(label) {
    if (label === undefined) return this.map(function(set) {
        return set.inst.text(set.node);
    });
    return this.each(function(set) {
        set.inst.text(set.node, label);
    });
});
// Trigger a button's action
(0, $63jfO.default).Api.registerPlural('buttons().trigger()', 'button().trigger()', function() {
    return this.each(function(set) {
        set.inst.node(set.node).trigger('click');
    });
});
// Button resolver to the popover
(0, $63jfO.default).Api.register('button().popover()', function(content, options) {
    return this.map(function(set) {
        return set.inst._popover(content, this.button(this[0].node), options);
    });
});
// Get the container elements
(0, $63jfO.default).Api.register('buttons().containers()', function() {
    var jq = $401378214c585f43$var$$();
    var groupSelector = this._groupSelector;
    // We need to use the group selector directly, since if there are no buttons
    // the result set will be empty
    this.iterator(true, 'table', function(ctx) {
        if (ctx._buttons) {
            var insts = $401378214c585f43$var$Buttons.instanceSelector(groupSelector, ctx._buttons);
            for(var i = 0, ien = insts.length; i < ien; i++)jq = jq.add(insts[i].container());
        }
    });
    return jq;
});
(0, $63jfO.default).Api.register('buttons().container()', function() {
    // API level of nesting is `buttons()` so we can zip into the containers method
    return this.containers().eq(0);
});
// Add a new button
(0, $63jfO.default).Api.register('button().add()', function(idx, conf, draw) {
    var ctx = this.context;
    var node;
    // Don't use `this` as it could be empty - select the instances directly
    if (ctx.length) {
        var inst = $401378214c585f43$var$Buttons.instanceSelector(this._groupSelector, ctx[0]._buttons);
        if (inst.length) node = inst[0].add(conf, idx, draw);
    }
    return node ? this.button(this._groupSelector, node) : this;
});
// Destroy the button sets selected
(0, $63jfO.default).Api.register('buttons().destroy()', function() {
    this.pluck('inst').unique().each(function(inst) {
        inst.destroy();
    });
    return this;
});
// Remove a button
(0, $63jfO.default).Api.registerPlural('buttons().remove()', 'buttons().remove()', function() {
    this.each(function(set) {
        set.inst.remove(set.node);
    });
    return this;
});
// Information box that can be used by buttons
var $401378214c585f43$var$_infoTimer;
(0, $63jfO.default).Api.register('buttons.info()', function(title, message, time) {
    var that = this;
    if (title === false) {
        this.off('destroy.btn-info');
        $401378214c585f43$var$_fadeOut($401378214c585f43$var$$('#datatables_buttons_info'), 400, function() {
            $401378214c585f43$var$$(this).remove();
        });
        clearTimeout($401378214c585f43$var$_infoTimer);
        $401378214c585f43$var$_infoTimer = null;
        return this;
    }
    if ($401378214c585f43$var$_infoTimer) clearTimeout($401378214c585f43$var$_infoTimer);
    if ($401378214c585f43$var$$('#datatables_buttons_info').length) $401378214c585f43$var$$('#datatables_buttons_info').remove();
    title = title ? '<h2>' + title + '</h2>' : '';
    $401378214c585f43$var$_fadeIn($401378214c585f43$var$$('<div id="datatables_buttons_info" class="dt-button-info"/>').html(title).append($401378214c585f43$var$$('<div/>')[typeof message === 'string' ? 'html' : 'append'](message)).css('display', 'none').appendTo('body'));
    if (time !== undefined && time !== 0) $401378214c585f43$var$_infoTimer = setTimeout(function() {
        that.buttons.info(false);
    }, time);
    this.on('destroy.btn-info', function() {
        that.buttons.info(false);
    });
    return this;
});
// Get data from the table for export - this is common to a number of plug-in
// buttons so it is included in the Buttons core library
(0, $63jfO.default).Api.register('buttons.exportData()', function(options) {
    if (this.context.length) return $401378214c585f43$var$_exportData(new (0, $63jfO.default).Api(this.context[0]), options);
});
// Get information about the export that is common to many of the export data
// types (DRY)
(0, $63jfO.default).Api.register('buttons.exportInfo()', function(conf) {
    if (!conf) conf = {};
    return {
        filename: $401378214c585f43$var$_filename(conf, this),
        title: $401378214c585f43$var$_title(conf, this),
        messageTop: $401378214c585f43$var$_message(this, conf, conf.message || conf.messageTop, 'top'),
        messageBottom: $401378214c585f43$var$_message(this, conf, conf.messageBottom, 'bottom')
    };
});
/**
 * Get the file name for an exported file.
 *
 * @param {object} config Button configuration
 * @param {object} dt DataTable instance
 */ var $401378214c585f43$var$_filename = function(config, dt) {
    // Backwards compatibility
    var filename = config.filename === '*' && config.title !== '*' && config.title !== undefined && config.title !== null && config.title !== '' ? config.title : config.filename;
    if (typeof filename === 'function') filename = filename(config, dt);
    if (filename === undefined || filename === null) return null;
    if (filename.indexOf('*') !== -1) filename = filename.replace(/\*/g, $401378214c585f43$var$$('head > title').text()).trim();
    // Strip characters which the OS will object to
    filename = filename.replace(/[^a-zA-Z0-9_\u00A1-\uFFFF\.,\-_ !\(\)]/g, '');
    var extension = $401378214c585f43$var$_stringOrFunction(config.extension, config, dt);
    if (!extension) extension = '';
    return filename + extension;
};
/**
 * Simply utility method to allow parameters to be given as a function
 *
 * @param {undefined|string|function} option Option
 * @return {null|string} Resolved value
 */ var $401378214c585f43$var$_stringOrFunction = function(option, config, dt) {
    if (option === null || option === undefined) return null;
    else if (typeof option === 'function') return option(config, dt);
    return option;
};
/**
 * Get the title for an exported file.
 *
 * @param {object} config	Button configuration
 */ var $401378214c585f43$var$_title = function(config, dt) {
    var title = $401378214c585f43$var$_stringOrFunction(config.title, config, dt);
    return title === null ? null : title.indexOf('*') !== -1 ? title.replace(/\*/g, $401378214c585f43$var$$('head > title').text() || 'Exported data') : title;
};
var $401378214c585f43$var$_message = function(dt, config, option, position) {
    var message = $401378214c585f43$var$_stringOrFunction(option, config, dt);
    if (message === null) return null;
    var caption = $401378214c585f43$var$$('caption', dt.table().container()).eq(0);
    if (message === '*') {
        var side = caption.css('caption-side');
        if (side !== position) return null;
        return caption.length ? caption.text() : '';
    }
    return message;
};
var $401378214c585f43$var$_exportTextarea = $401378214c585f43$var$$('<textarea/>')[0];
var $401378214c585f43$var$_exportData = function(dt, inOpts) {
    var config = $401378214c585f43$var$$.extend(true, {}, {
        rows: null,
        columns: '',
        modifier: {
            search: 'applied',
            order: 'applied'
        },
        orthogonal: 'display',
        stripHtml: true,
        stripNewlines: true,
        decodeEntities: true,
        escapeExcelFormula: false,
        trim: true,
        format: {
            header: function(d) {
                return $401378214c585f43$var$Buttons.stripData(d, config);
            },
            footer: function(d) {
                return $401378214c585f43$var$Buttons.stripData(d, config);
            },
            body: function(d) {
                return $401378214c585f43$var$Buttons.stripData(d, config);
            }
        },
        customizeData: null,
        customizeZip: null
    }, inOpts);
    var header = dt.columns(config.columns).indexes().map(function(idx) {
        var col = dt.column(idx);
        return config.format.header(col.title(), idx, col.header());
    }).toArray();
    var footer = dt.table().footer() ? dt.columns(config.columns).indexes().map(function(idx) {
        var el = dt.column(idx).footer();
        var val = '';
        if (el) {
            var inner = $401378214c585f43$var$$('.dt-column-title', el);
            val = inner.length ? inner.html() : $401378214c585f43$var$$(el).html();
        }
        return config.format.footer(val, idx, el);
    }).toArray() : null;
    // If Select is available on this table, and any rows are selected, limit the export
    // to the selected rows. If no rows are selected, all rows will be exported. Specify
    // a `selected` modifier to control directly.
    var modifier = $401378214c585f43$var$$.extend({}, config.modifier);
    if (dt.select && typeof dt.select.info === 'function' && modifier.selected === undefined) {
        if (dt.rows(config.rows, $401378214c585f43$var$$.extend({
            selected: true
        }, modifier)).any()) $401378214c585f43$var$$.extend(modifier, {
            selected: true
        });
    }
    var rowIndexes = dt.rows(config.rows, modifier).indexes().toArray();
    var selectedCells = dt.cells(rowIndexes, config.columns, {
        order: modifier.order
    });
    var cells = selectedCells.render(config.orthogonal).toArray();
    var cellNodes = selectedCells.nodes().toArray();
    var cellIndexes = selectedCells.indexes().toArray();
    var columns = dt.columns(config.columns).count();
    var rows = columns > 0 ? cells.length / columns : 0;
    var body = [];
    var cellCounter = 0;
    for(var i = 0, ien = rows; i < ien; i++){
        var row = [
            columns
        ];
        for(var j = 0; j < columns; j++){
            row[j] = config.format.body(cells[cellCounter], cellIndexes[cellCounter].row, cellIndexes[cellCounter].column, cellNodes[cellCounter]);
            cellCounter++;
        }
        body[i] = row;
    }
    var data = {
        header: header,
        headerStructure: $401378214c585f43$var$_headerFormatter(config.format.header, dt.table().header.structure(config.columns)),
        footer: footer,
        footerStructure: $401378214c585f43$var$_headerFormatter(config.format.footer, dt.table().footer.structure(config.columns)),
        body: body
    };
    if (config.customizeData) config.customizeData(data);
    return data;
};
function $401378214c585f43$var$_headerFormatter(formatter, struct) {
    for(var i = 0; i < struct.length; i++)for(var j = 0; j < struct[i].length; j++){
        var item = struct[i][j];
        if (item) item.title = formatter(item.title, j, item.cell);
    }
    return struct;
}
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interface
 */ // Attach to DataTables objects for global access
$401378214c585f43$var$$.fn.dataTable.Buttons = $401378214c585f43$var$Buttons;
$401378214c585f43$var$$.fn.DataTable.Buttons = $401378214c585f43$var$Buttons;
// DataTables creation - check if the buttons have been defined for this table,
// they will have been if the `B` option was used in `dom`, otherwise we should
// create the buttons instance here so they can be inserted into the document
// using the API. Listen for `init` for compatibility with pre 1.10.10, but to
// be removed in future.
$401378214c585f43$var$$(document).on('init.dt plugin-init.dt', function(e, settings) {
    if (e.namespace !== 'dt') return;
    var opts = settings.oInit.buttons || (0, $63jfO.default).defaults.buttons;
    if (opts && !settings._buttons) new $401378214c585f43$var$Buttons(settings, opts).container();
});
function $401378214c585f43$var$_init(settings, options) {
    var api = new (0, $63jfO.default).Api(settings);
    var opts = options ? options : api.init().buttons || (0, $63jfO.default).defaults.buttons;
    return new $401378214c585f43$var$Buttons(api, opts).container();
}
// DataTables 1 `dom` feature option
(0, $63jfO.default).ext.feature.push({
    fnInit: $401378214c585f43$var$_init,
    cFeature: 'B'
});
// DataTables 2 layout feature
if ((0, $63jfO.default).feature) (0, $63jfO.default).feature.register('buttons', $401378214c585f43$var$_init);
var $401378214c585f43$export$2e2bcd8739ae039 = (0, $63jfO.default);

});


var $el0Ud = parcelRequire("el0Ud");
parcelRequire("fEUcM");

var $iUSsr = parcelRequire("iUSsr");
parcelRequire("lJx7k");
/*! Bootstrap integration for DataTables' Buttons
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");

var $lJx7k = parcelRequire("lJx7k");
parcelRequire("eAhT0");
// Allow reassignment of the $ variable
let $31e2fbc8385ed07f$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
$31e2fbc8385ed07f$var$$.extend(true, (0, $lJx7k.default).Buttons.defaults, {
    dom: {
        container: {
            className: 'dt-buttons btn-group flex-wrap'
        },
        button: {
            className: 'btn btn-secondary',
            active: 'active',
            dropHtml: '',
            dropClass: 'dropdown-toggle'
        },
        collection: {
            container: {
                tag: 'div',
                className: 'dropdown-menu dt-button-collection'
            },
            closeButton: false,
            button: {
                tag: 'a',
                className: 'dt-button dropdown-item',
                active: 'dt-button-active',
                disabled: 'disabled',
                spacer: {
                    className: 'dropdown-divider',
                    tag: 'hr'
                }
            }
        },
        split: {
            action: {
                tag: 'a',
                className: 'btn btn-secondary dt-button-split-drop-button',
                closeButton: false
            },
            dropdown: {
                tag: 'button',
                className: 'btn btn-secondary dt-button-split-drop dropdown-toggle-split',
                closeButton: false,
                align: 'split-left',
                splitAlignClass: 'dt-button-split-left'
            },
            wrapper: {
                tag: 'div',
                className: 'dt-button-split btn-group',
                closeButton: false
            }
        }
    },
    buttonCreated: function(config, button) {
        return config.buttons ? $31e2fbc8385ed07f$var$$('<div class="btn-group"/>').append(button) : button;
    }
});
(0, $lJx7k.default).ext.buttons.collection.rightAlignClassName = 'dropdown-menu-right';
var $31e2fbc8385ed07f$export$2e2bcd8739ae039 = (0, $lJx7k.default);


/*! Bootstrap 4 integration for DataTables' Responsive
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");

var $lJx7k = parcelRequire("lJx7k");
/*! Responsive 3.0.8
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");

var $63jfO = parcelRequire("63jfO");
// Allow reassignment of the $ variable
let $7a0fd6e3c2235ada$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
/**
 * @summary     Responsive
 * @description Responsive tables plug-in for DataTables
 * @version     3.0.8
 * @author      SpryMedia Ltd
 * @copyright   SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */ /**
 * Responsive is a plug-in for the DataTables library that makes use of
 * DataTables' ability to change the visibility of columns, changing the
 * visibility of columns so the displayed columns fit into the table container.
 * The end result is that complex tables will be dynamically adjusted to fit
 * into the viewport, be it on a desktop, tablet or mobile browser.
 *
 * Responsive for DataTables has two modes of operation, which can used
 * individually or combined:
 *
 * * Class name based control - columns assigned class names that match the
 *   breakpoint logic can be shown / hidden as required for each breakpoint.
 * * Automatic control - columns are automatically hidden when there is no
 *   room left to display them. Columns removed from the right.
 *
 * In additional to column visibility control, Responsive also has built into
 * options to use DataTables' child row display to show / hide the information
 * from the table that has been hidden. There are also two modes of operation
 * for this child row display:
 *
 * * Inline - when the control element that the user can use to show / hide
 *   child rows is displayed inside the first column of the table.
 * * Column - where a whole column is dedicated to be the show / hide control.
 *
 * Initialisation of Responsive is performed by:
 *
 * * Adding the class `responsive` or `dt-responsive` to the table. In this case
 *   Responsive will automatically be initialised with the default configuration
 *   options when the DataTable is created.
 * * Using the `responsive` option in the DataTables configuration options. This
 *   can also be used to specify the configuration options, or simply set to
 *   `true` to use the defaults.
 *
 *  @class
 *  @param {object} settings DataTables settings object for the host table
 *  @param {object} [opts] Configuration options
 *  @requires jQuery 1.7+
 *  @requires DataTables 2.0.0+
 *
 *  @example
 *      $('#example').DataTable( {
 *        responsive: true
 *      } );
 *    } );
 */ var $7a0fd6e3c2235ada$var$Responsive = function(settings, opts) {
    // Sanity check that we are using DataTables 2.0.0 or newer
    if (!(0, $63jfO.default).versionCheck || !(0, $63jfO.default).versionCheck('2')) throw 'DataTables Responsive requires DataTables 2 or newer';
    this.s = {
        childNodeStore: {},
        columns: [],
        current: [],
        dt: new (0, $63jfO.default).Api(settings)
    };
    // Check if responsive has already been initialised on this table
    if (this.s.dt.settings()[0].responsive) return;
    // details is an object, but for simplicity the user can give it as a string
    // or a boolean
    if (opts && typeof opts.details === 'string') opts.details = {
        type: opts.details
    };
    else if (opts && opts.details === false) opts.details = {
        type: false
    };
    else if (opts && opts.details === true) opts.details = {
        type: 'inline'
    };
    this.c = $7a0fd6e3c2235ada$var$$.extend(true, {}, $7a0fd6e3c2235ada$var$Responsive.defaults, (0, $63jfO.default).defaults.responsive, opts);
    settings.responsive = this;
    this._constructor();
};
$7a0fd6e3c2235ada$var$$.extend($7a0fd6e3c2235ada$var$Responsive.prototype, {
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */ /**
	 * Initialise the Responsive instance
	 *
	 * @private
	 */ _constructor: function() {
        var that = this;
        var dt = this.s.dt;
        var oldWindowWidth = $7a0fd6e3c2235ada$var$$(window).innerWidth();
        dt.settings()[0]._responsive = this;
        // Use DataTables' throttle function to avoid processor thrashing
        $7a0fd6e3c2235ada$var$$(window).on('orientationchange.dtr', (0, $63jfO.default).util.throttle(function() {
            // iOS has a bug whereby resize can fire when only scrolling
            // See: http://stackoverflow.com/questions/8898412
            var width = $7a0fd6e3c2235ada$var$$(window).innerWidth();
            if (width !== oldWindowWidth) {
                that._resize();
                oldWindowWidth = width;
            }
        }));
        // Handle new rows being dynamically added - needed as responsive
        // updates all rows (shown or not) a responsive change, rather than
        // per draw.
        dt.on('row-created.dtr', function(e, tr, data, idx) {
            if ($7a0fd6e3c2235ada$var$$.inArray(false, that.s.current) !== -1) $7a0fd6e3c2235ada$var$$('>td, >th', tr).each(function(i) {
                var idx = dt.column.index('toData', i);
                if (that.s.current[idx] === false) $7a0fd6e3c2235ada$var$$(this).css('display', 'none').addClass('dtr-hidden');
            });
        });
        // Destroy event handler
        dt.on('destroy.dtr', function() {
            dt.off('.dtr');
            $7a0fd6e3c2235ada$var$$(dt.table().body()).off('.dtr');
            $7a0fd6e3c2235ada$var$$(window).off('resize.dtr orientationchange.dtr');
            dt.cells('.dtr-control').nodes().to$().removeClass('dtr-control');
            $7a0fd6e3c2235ada$var$$(dt.table().node()).removeClass('dtr-inline collapsed');
            // Restore the columns that we've hidden
            $7a0fd6e3c2235ada$var$$.each(that.s.current, function(i, val) {
                if (val === false) that._setColumnVis(i, true);
            });
        });
        // Reorder the breakpoints array here in case they have been added out
        // of order
        this.c.breakpoints.sort(function(a, b) {
            return a.width < b.width ? 1 : a.width > b.width ? -1 : 0;
        });
        this._classLogic();
        // Details handler
        var details = this.c.details;
        if (details.type !== false) {
            that._detailsInit();
            // DataTables will trigger this event on every column it shows and
            // hides individually
            dt.on('column-visibility.dtr', function() {
                // Use a small debounce to allow multiple columns to be set together
                if (that._timer) clearTimeout(that._timer);
                that._timer = setTimeout(function() {
                    that._timer = null;
                    that._classLogic();
                    that._resizeAuto();
                    that._resize(true);
                    that._redrawChildren();
                }, 100);
            });
            // Redraw the details box on each draw which will happen if the data
            // has changed. This is used until DataTables implements a native
            // `updated` event for rows
            dt.on('draw.dtr', function() {
                that._redrawChildren();
            });
            $7a0fd6e3c2235ada$var$$(dt.table().node()).addClass('dtr-' + details.type);
        }
        // DT2 let's us tell it if we are hiding columns
        dt.on('column-calc.dt', function(e, d) {
            var curr = that.s.current;
            for(var i = 0; i < curr.length; i++){
                var idx = d.visible.indexOf(i);
                if (curr[i] === false && idx >= 0) d.visible.splice(idx, 1);
            }
        });
        // On Ajax reload we want to reopen any child rows which are displayed
        // by responsive
        dt.on('preXhr.dtr', function() {
            var rowIds = [];
            dt.rows().every(function() {
                if (this.child.isShown()) rowIds.push(this.id(true));
            });
            dt.one('draw.dtr', function() {
                that._resizeAuto();
                that._resize();
                dt.rows(rowIds).every(function() {
                    that._detailsDisplay(this, false);
                });
            });
        });
        // First pass when the table is ready
        dt.on('draw.dtr', function() {
            // For server-side tables, each draw needs the child node
            // cache to be cleared since it is no longer relevant. We can
            // create a new object for speed in this case - no mutation.
            if (dt.page.info().serverSide) that.s.childNodeStore = {};
            that._controlClass();
        }).ready(function() {
            that._resizeAuto();
            that._resize();
            // Change in column sizes means we need to calc
            dt.on('column-sizing.dtr', function() {
                that._resizeAuto();
                that._resize();
            });
        });
        // Attach listeners after first pass
        dt.on('column-reorder.dtr', function(e, settings, details) {
            that._classLogic();
            that._resizeAuto();
            that._resize(true);
        });
    },
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */ /**
	 * Insert a `col` tag into the correct location in a `colgroup`.
	 *
	 * @param {jQuery} colGroup The `colgroup` tag
	 * @param {jQuery} colEl The `col` tag
	 */ _colGroupAttach: function(colGroup, colEls, idx) {
        var found = null;
        // No need to do anything if already attached
        if (colEls[idx].get(0).parentNode === colGroup[0]) return;
        // Find the first `col` after our own which is already attached
        for(var i = idx + 1; i < colEls.length; i++)if (colGroup[0] === colEls[i].get(0).parentNode) {
            found = i;
            break;
        }
        if (found !== null) // Insert before
        colEls[idx].insertBefore(colEls[found][0]);
        else // If wasn't found, insert at the end
        colGroup.append(colEls[idx]);
    },
    /**
	 * Get and store nodes from a cell - use for node moving renderers
	 *
	 * @param {*} dt DT instance
	 * @param {*} row Row index
	 * @param {*} col Column index
	 */ _childNodes: function(dt, row, col) {
        var name = row + '-' + col;
        if (this.s.childNodeStore[name]) return this.s.childNodeStore[name];
        // https://jsperf.com/childnodes-array-slice-vs-loop
        var nodes = [];
        var children = dt.cell(row, col).node().childNodes;
        for(var i = 0, iLen = children.length; i < iLen; i++)nodes.push(children[i]);
        this.s.childNodeStore[name] = nodes;
        return nodes;
    },
    /**
	 * Restore nodes from the cache to a table cell
	 *
	 * @param {*} dt DT instance
	 * @param {*} row Row index
	 * @param {*} col Column index
	 */ _childNodesRestore: function(dt, row, col) {
        var name = row + '-' + col;
        if (!this.s.childNodeStore[name]) return;
        var node = dt.cell(row, col).node();
        var store = this.s.childNodeStore[name];
        if (store.length > 0) {
            var parent = store[0].parentNode;
            var parentChildren = parent.childNodes;
            var a = [];
            for(var i = 0, iLen = parentChildren.length; i < iLen; i++)a.push(parentChildren[i]);
            for(var j = 0, jen = a.length; j < jen; j++)node.appendChild(a[j]);
        }
        this.s.childNodeStore[name] = undefined;
    },
    /**
	 * Calculate the visibility for the columns in a table for a given
	 * breakpoint. The result is pre-determined based on the class logic if
	 * class names are used to control all columns, but the width of the table
	 * is also used if there are columns which are to be automatically shown
	 * and hidden.
	 *
	 * @param  {string} breakpoint Breakpoint name to use for the calculation
	 * @return {array} Array of boolean values initiating the visibility of each
	 *   column.
	 *  @private
	 */ _columnsVisibility: function(breakpoint) {
        var dt = this.s.dt;
        var columns = this.s.columns;
        var i, iLen;
        // Create an array that defines the column ordering based first on the
        // column's priority, and secondly the column index. This allows the
        // columns to be removed from the right if the priority matches
        var order = columns.map(function(col, idx) {
            return {
                columnIdx: idx,
                priority: col.priority
            };
        }).sort(function(a, b) {
            if (a.priority !== b.priority) return a.priority - b.priority;
            return a.columnIdx - b.columnIdx;
        });
        // Class logic - determine which columns are in this breakpoint based
        // on the classes. If no class control (i.e. `auto`) then `-` is used
        // to indicate this to the rest of the function
        var display = $7a0fd6e3c2235ada$var$$.map(columns, function(col, i) {
            if (dt.column(i).visible() === false) return 'not-visible';
            return col.auto && col.minWidth === null ? false : col.auto === true ? '-' : $7a0fd6e3c2235ada$var$$.inArray(breakpoint, col.includeIn) !== -1;
        });
        // Auto column control - first pass: how much width is taken by the
        // ones that must be included from the non-auto columns
        var requiredWidth = 0;
        for(i = 0, iLen = display.length; i < iLen; i++)if (display[i] === true) requiredWidth += columns[i].minWidth;
        // Second pass, use up any remaining width for other columns. For
        // scrolling tables we need to subtract the width of the scrollbar. It
        // may not be requires which makes this sub-optimal, but it would
        // require another full redraw to make complete use of those extra few
        // pixels
        var scrolling = dt.settings()[0].oScroll;
        var bar = scrolling.sY || scrolling.sX ? scrolling.iBarWidth : 0;
        var widthAvailable = dt.table().container().offsetWidth - bar;
        var usedWidth = widthAvailable - requiredWidth;
        // Control column needs to always be included. This makes it sub-
        // optimal in terms of using the available with, but to stop layout
        // thrashing or overflow. Also we need to account for the control column
        // width first so we know how much width is available for the other
        // columns, since the control column might not be the first one shown
        for(i = 0, iLen = display.length; i < iLen; i++)if (columns[i].control) usedWidth -= columns[i].minWidth;
        // Allow columns to be shown (counting by priority and then right to
        // left) until we run out of room
        var empty = false;
        for(i = 0, iLen = order.length; i < iLen; i++){
            var colIdx = order[i].columnIdx;
            if (display[colIdx] === '-' && !columns[colIdx].control && columns[colIdx].minWidth) {
                // Once we've found a column that won't fit we don't let any
                // others display either, or columns might disappear in the
                // middle of the table
                if (empty || usedWidth - columns[colIdx].minWidth < 0) {
                    empty = true;
                    display[colIdx] = false;
                } else display[colIdx] = true;
                usedWidth -= columns[colIdx].minWidth;
            }
        }
        // Determine if the 'control' column should be shown (if there is one).
        // This is the case when there is a hidden column (that is not the
        // control column). The two loops look inefficient here, but they are
        // trivial and will fly through. We need to know the outcome from the
        // first , before the action in the second can be taken
        var showControl = false;
        for(i = 0, iLen = columns.length; i < iLen; i++)if (!columns[i].control && !columns[i].never && display[i] === false) {
            showControl = true;
            break;
        }
        for(i = 0, iLen = columns.length; i < iLen; i++){
            if (columns[i].control) display[i] = showControl;
            // Replace not visible string with false from the control column detection above
            if (display[i] === 'not-visible') display[i] = false;
        }
        // Finally we need to make sure that there is at least one column that
        // is visible
        if ($7a0fd6e3c2235ada$var$$.inArray(true, display) === -1) display[0] = true;
        return display;
    },
    /**
	 * Create the internal `columns` array with information about the columns
	 * for the table. This includes determining which breakpoints the column
	 * will appear in, based upon class names in the column, which makes up the
	 * vast majority of this method.
	 *
	 * @private
	 */ _classLogic: function() {
        var that = this;
        var breakpoints = this.c.breakpoints;
        var dt = this.s.dt;
        var columns = dt.columns().eq(0).map(function(i) {
            var column = this.column(i);
            var className = column.header().className;
            var priority = column.init().responsivePriority;
            var dataPriority = column.header().getAttribute('data-priority');
            if (priority === undefined) priority = dataPriority === undefined || dataPriority === null ? 10000 : dataPriority * 1;
            return {
                className: className,
                includeIn: [],
                auto: false,
                control: false,
                never: className.match(/\b(dtr\-)?never\b/) ? true : false,
                priority: priority
            };
        });
        // Simply add a breakpoint to `includeIn` array, ensuring that there are
        // no duplicates
        var add = function(colIdx, name) {
            var includeIn = columns[colIdx].includeIn;
            if ($7a0fd6e3c2235ada$var$$.inArray(name, includeIn) === -1) includeIn.push(name);
        };
        var column = function(colIdx, name, operator, matched) {
            var size, i, iLen;
            if (!operator) columns[colIdx].includeIn.push(name);
            else if (operator === 'max-') {
                // Add this breakpoint and all smaller
                size = that._find(name).width;
                for(i = 0, iLen = breakpoints.length; i < iLen; i++)if (breakpoints[i].width <= size) add(colIdx, breakpoints[i].name);
            } else if (operator === 'min-') {
                // Add this breakpoint and all larger
                size = that._find(name).width;
                for(i = 0, iLen = breakpoints.length; i < iLen; i++)if (breakpoints[i].width >= size) add(colIdx, breakpoints[i].name);
            } else if (operator === 'not-') {
                // Add all but this breakpoint
                for(i = 0, iLen = breakpoints.length; i < iLen; i++)if (breakpoints[i].name.indexOf(matched) === -1) add(colIdx, breakpoints[i].name);
            }
        };
        // Loop over each column and determine if it has a responsive control
        // class
        columns.each(function(col, i) {
            var classNames = col.className.split(' ');
            var hasClass = false;
            // Split the class name up so multiple rules can be applied if needed
            for(var k = 0, ken = classNames.length; k < ken; k++){
                var className = classNames[k].trim();
                if (className === 'all' || className === 'dtr-all') {
                    // Include in all
                    hasClass = true;
                    col.includeIn = $7a0fd6e3c2235ada$var$$.map(breakpoints, function(a) {
                        return a.name;
                    });
                    return;
                } else if (className === 'none' || className === 'dtr-none' || col.never) {
                    // Include in none (default) and no auto
                    hasClass = true;
                    return;
                } else if (className === 'control' || className === 'dtr-control') {
                    // Special column that is only visible, when one of the other
                    // columns is hidden. This is used for the details control
                    hasClass = true;
                    col.control = true;
                    return;
                }
                $7a0fd6e3c2235ada$var$$.each(breakpoints, function(j, breakpoint) {
                    // Does this column have a class that matches this breakpoint?
                    var brokenPoint = breakpoint.name.split('-');
                    var re = new RegExp('(min\\-|max\\-|not\\-)?(' + brokenPoint[0] + ')(\\-[_a-zA-Z0-9])?');
                    var match = className.match(re);
                    if (match) {
                        hasClass = true;
                        if (match[2] === brokenPoint[0] && match[3] === '-' + brokenPoint[1]) // Class name matches breakpoint name fully
                        column(i, breakpoint.name, match[1], match[2] + match[3]);
                        else if (match[2] === brokenPoint[0] && !match[3]) // Class name matched primary breakpoint name with no qualifier
                        column(i, breakpoint.name, match[1], match[2]);
                    }
                });
            }
            // If there was no control class, then automatic sizing is used
            if (!hasClass) col.auto = true;
        });
        this.s.columns = columns;
    },
    /**
	 * Update the cells to show the correct control class / button
	 * @private
	 */ _controlClass: function() {
        if (this.c.details.type === 'inline') {
            var dt = this.s.dt;
            var columnsVis = this.s.current;
            var firstVisible = $7a0fd6e3c2235ada$var$$.inArray(true, columnsVis);
            // Remove from any cells which shouldn't have it
            dt.cells(null, function(idx) {
                return idx !== firstVisible;
            }, {
                page: 'current'
            }).nodes().to$().filter('.dtr-control').removeClass('dtr-control');
            if (firstVisible >= 0) dt.cells(null, firstVisible, {
                page: 'current'
            }).nodes().to$().addClass('dtr-control');
        }
        this._tabIndexes();
    },
    /**
	 * Show the details for the child row
	 *
	 * @param  {DataTables.Api} row    API instance for the row
	 * @param  {boolean}        update Update flag
	 * @private
	 */ _detailsDisplay: function(row, update) {
        var that = this;
        var dt = this.s.dt;
        var details = this.c.details;
        var event = function(res) {
            $7a0fd6e3c2235ada$var$$(row.node()).toggleClass('dtr-expanded', res !== false);
            $7a0fd6e3c2235ada$var$$(dt.table().node()).triggerHandler('responsive-display.dt', [
                dt,
                row,
                res,
                update
            ]);
        };
        if (details && details.type !== false) {
            var renderer = typeof details.renderer === 'string' ? $7a0fd6e3c2235ada$var$Responsive.renderer[details.renderer]() : details.renderer;
            var res = details.display(row, update, function() {
                return renderer.call(that, dt, row[0][0], that._detailsObj(row[0]));
            }, function() {
                event(false);
            });
            if (typeof res === 'boolean') event(res);
        }
    },
    /**
	 * Initialisation for the details handler
	 *
	 * @private
	 */ _detailsInit: function() {
        var that = this;
        var dt = this.s.dt;
        var details = this.c.details;
        // The inline type always uses the first child as the target
        if (details.type === 'inline') details.target = 'td.dtr-control, th.dtr-control';
        $7a0fd6e3c2235ada$var$$(dt.table().body()).on('keyup.dtr', 'td, th', function(e) {
            let activeNodeName = document.activeElement.nodeName.toLowerCase();
            if (e.keyCode === 13 && $7a0fd6e3c2235ada$var$$(this).data('dtr-keyboard') && (activeNodeName === 'td' || activeNodeName === 'th')) $7a0fd6e3c2235ada$var$$(this).click();
        });
        // type.target can be a string jQuery selector or a column index
        var target = details.target;
        var selector = typeof target === 'string' ? target : 'td, th';
        if (target !== undefined || target !== null) // Click handler to show / hide the details rows when they are available
        $7a0fd6e3c2235ada$var$$(dt.table().body()).on('click.dtr mousedown.dtr mouseup.dtr', selector, function(e) {
            // If the table is not collapsed (i.e. there is no hidden columns)
            // then take no action
            if (!$7a0fd6e3c2235ada$var$$(dt.table().node()).hasClass('collapsed')) return;
            // Check that the row is actually a DataTable's controlled node
            if ($7a0fd6e3c2235ada$var$$.inArray($7a0fd6e3c2235ada$var$$(this).closest('tr').get(0), dt.rows().nodes().toArray()) === -1) return;
            // For column index, we determine if we should act or not in the
            // handler - otherwise it is already okay
            if (typeof target === 'number') {
                var targetIdx = target < 0 ? dt.columns().eq(0).length + target : target;
                if (dt.cell(this).index().column !== targetIdx) return;
            }
            // $().closest() includes itself in its check
            var row = dt.row($7a0fd6e3c2235ada$var$$(this).closest('tr'));
            // Check event type to do an action
            if (e.type === 'click') // The renderer is given as a function so the caller can execute it
            // only when they need (i.e. if hiding there is no point is running
            // the renderer)
            that._detailsDisplay(row, false);
            else if (e.type === 'mousedown') // For mouse users, prevent the focus ring from showing
            $7a0fd6e3c2235ada$var$$(this).css('outline', 'none');
            else if (e.type === 'mouseup') // And then re-allow at the end of the click
            $7a0fd6e3c2235ada$var$$(this).trigger('blur').css('outline', '');
        });
    },
    /**
	 * Get the details to pass to a renderer for a row
	 * @param  {int} rowIdx Row index
	 * @private
	 */ _detailsObj: function(rowIdx) {
        var that = this;
        var dt = this.s.dt;
        var columnApis = [];
        let settings = dt.settings()[0];
        return $7a0fd6e3c2235ada$var$$.map(this.s.columns, function(col, i) {
            // Never and control columns should not be passed to the renderer
            if (col.never || col.control) return;
            var dtCol = settings.aoColumns[i];
            if (!columnApis[i]) columnApis[i] = dt.column(i);
            return {
                className: dtCol.sClass,
                columnIndex: i,
                data: settings.fastData(rowIdx, i, that.c.orthogonal),
                hidden: columnApis[i].visible() && !that.s.current[i],
                rowIndex: rowIdx,
                title: columnApis[i].title()
            };
        });
    },
    /**
	 * Find a breakpoint object from a name
	 *
	 * @param  {string} name Breakpoint name to find
	 * @return {object}      Breakpoint description object
	 * @private
	 */ _find: function(name) {
        var breakpoints = this.c.breakpoints;
        for(var i = 0, iLen = breakpoints.length; i < iLen; i++){
            if (breakpoints[i].name === name) return breakpoints[i];
        }
    },
    /**
	 * Re-create the contents of the child rows as the display has changed in
	 * some way.
	 *
	 * @private
	 */ _redrawChildren: function() {
        var that = this;
        var dt = this.s.dt;
        dt.rows({
            page: 'current'
        }).iterator('row', function(settings, idx) {
            that._detailsDisplay(dt.row(idx), true);
        });
    },
    /**
	 * Alter the table display for a resized viewport. This involves first
	 * determining what breakpoint the window currently is in, getting the
	 * column visibilities to apply and then setting them.
	 *
	 * @param  {boolean} forceRedraw Force a redraw
	 * @private
	 */ _resize: function(forceRedraw) {
        var that = this;
        var dt = this.s.dt;
        var width = $7a0fd6e3c2235ada$var$$(window).innerWidth();
        var breakpoints = this.c.breakpoints;
        var breakpoint = breakpoints[0].name;
        var columns = this.s.columns;
        var i, iLen;
        var oldVis = this.s.current.slice();
        // Determine what breakpoint we are currently at
        for(i = breakpoints.length - 1; i >= 0; i--)if (width <= breakpoints[i].width) {
            breakpoint = breakpoints[i].name;
            break;
        }
        // Show the columns for that break point
        var columnsVis = this._columnsVisibility(breakpoint);
        this.s.current = columnsVis;
        // Set the class before the column visibility is changed so event
        // listeners know what the state is. Need to determine if there are
        // any columns that are not visible but can be shown
        var collapsedClass = false;
        for(i = 0, iLen = columns.length; i < iLen; i++)if (columnsVis[i] === false && !columns[i].never && !columns[i].control && !dt.column(i).visible() === false) {
            collapsedClass = true;
            break;
        }
        $7a0fd6e3c2235ada$var$$(dt.table().node()).toggleClass('collapsed', collapsedClass);
        var changed = false;
        var visible = 0;
        var dtSettings = dt.settings()[0];
        var colGroup = $7a0fd6e3c2235ada$var$$(dt.table().node()).children('colgroup');
        var colEls = dtSettings.aoColumns.map(function(col) {
            return col.colEl;
        });
        dt.columns().eq(0).each(function(colIdx, i) {
            // Do nothing on DataTables' hidden column - DT removes it from the table
            // so we need to slide back
            if (!dt.column(colIdx).visible()) return;
            if (columnsVis[i] === true) visible++;
            if (forceRedraw || columnsVis[i] !== oldVis[i]) {
                changed = true;
                that._setColumnVis(colIdx, columnsVis[i]);
            }
            // DataTables 2 uses `col` to define the width for a column
            // and this needs to run each time, as DataTables will change
            // the column width. We may need to reattach if we've removed
            // an element previously.
            if (!columnsVis[i]) colEls[i].detach();
            else that._colGroupAttach(colGroup, colEls, i);
        });
        if (changed) {
            dt.columns.adjust();
            this._redrawChildren();
            // Inform listeners of the change
            $7a0fd6e3c2235ada$var$$(dt.table().node()).trigger('responsive-resize.dt', [
                dt,
                this._responsiveOnlyHidden()
            ]);
            // If no records, update the "No records" display element
            if (dt.page.info().recordsDisplay === 0) $7a0fd6e3c2235ada$var$$('td', dt.table().body()).eq(0).attr('colspan', visible);
        }
        that._controlClass();
    },
    /**
	 * Determine the width of each column in the table so the auto column hiding
	 * has that information to work with. This method is never going to be 100%
	 * perfect since column widths can change slightly per page, but without
	 * seriously compromising performance this is quite effective.
	 *
	 * @private
	 */ _resizeAuto: function() {
        var dt = this.s.dt;
        var columns = this.s.columns;
        var that = this;
        var visibleColumns = dt.columns().indexes().filter(function(idx) {
            return dt.column(idx).visible();
        });
        // Are we allowed to do auto sizing?
        if (!this.c.auto) return;
        // Are there any columns that actually need auto-sizing, or do they all
        // have classes defined
        if ($7a0fd6e3c2235ada$var$$.inArray(true, $7a0fd6e3c2235ada$var$$.map(columns, function(c) {
            return c.auto;
        })) === -1) return;
        // Clone the table with the current data in it
        var clonedTable = dt.table().node().cloneNode(false);
        var clonedHeader = $7a0fd6e3c2235ada$var$$(dt.table().header().cloneNode(false)).appendTo(clonedTable);
        var clonedFooter = $7a0fd6e3c2235ada$var$$(dt.table().footer().cloneNode(false)).appendTo(clonedTable);
        var clonedBody = $7a0fd6e3c2235ada$var$$(dt.table().body()).clone(false, false).empty().appendTo(clonedTable); // use jQuery because of IE8
        clonedTable.style.width = 'auto';
        // Header
        dt.table().header.structure(visibleColumns).forEach((row)=>{
            var cells = row.filter(function(el) {
                return el ? true : false;
            }).map(function(el) {
                return $7a0fd6e3c2235ada$var$$(el.cell).clone(false).css('display', 'table-cell').css('width', 'auto').css('min-width', 0);
            });
            $7a0fd6e3c2235ada$var$$('<tr/>').append(cells).appendTo(clonedHeader);
        });
        // Always need an empty row that we can read widths from
        var emptyRow = $7a0fd6e3c2235ada$var$$('<tr/>').appendTo(clonedBody);
        for(var i = 0; i < visibleColumns.count(); i++)emptyRow.append('<td/>');
        // Body rows
        if (this.c.details.renderer._responsiveMovesNodes) // Slow but it allows for moving elements around the document
        dt.rows({
            page: 'current'
        }).every(function(rowIdx) {
            var node = this.node();
            if (!node) return;
            // We clone the table's rows and cells to create the sizing table
            var tr = node.cloneNode(false);
            dt.cells(rowIdx, visibleColumns).every(function(rowIdx2, colIdx) {
                // If nodes have been moved out (listHiddenNodes), we need to
                // clone from the store
                var store = that.s.childNodeStore[rowIdx + '-' + colIdx];
                if (store) $7a0fd6e3c2235ada$var$$(this.node().cloneNode(false)).append($7a0fd6e3c2235ada$var$$(store).clone()).appendTo(tr);
                else $7a0fd6e3c2235ada$var$$(this.node()).clone(false).appendTo(tr);
            });
            clonedBody.append(tr);
        });
        else // This is much faster, but it doesn't account for moving nodes around
        $7a0fd6e3c2235ada$var$$(clonedBody).append($7a0fd6e3c2235ada$var$$(dt.rows({
            page: 'current'
        }).nodes()).clone(false)).find('th, td').css('display', '');
        // Any cells which were hidden by Responsive in the host table, need to
        // be visible here for the calculations
        clonedBody.find('th, td').css('display', '');
        // Footer
        dt.table().footer.structure(visibleColumns).forEach((row)=>{
            var cells = row.filter(function(el) {
                return el ? true : false;
            }).map(function(el) {
                return $7a0fd6e3c2235ada$var$$(el.cell).clone(false).css('display', 'table-cell').css('width', 'auto').css('min-width', 0);
            });
            $7a0fd6e3c2235ada$var$$('<tr/>').append(cells).appendTo(clonedFooter);
        });
        // In the inline case extra padding is applied to the first column to
        // give space for the show / hide icon. We need to use this in the
        // calculation
        if (this.c.details.type === 'inline') $7a0fd6e3c2235ada$var$$(clonedTable).addClass('dtr-inline collapsed');
        // It is unsafe to insert elements with the same name into the DOM
        // multiple times. For example, cloning and inserting a checked radio
        // clears the checked state of the original radio.
        $7a0fd6e3c2235ada$var$$(clonedTable).find('[name]').removeAttr('name');
        // A position absolute table would take the table out of the flow of
        // our container element, bypassing the height and width (Scroller)
        $7a0fd6e3c2235ada$var$$(clonedTable).css('position', 'relative');
        var inserted = $7a0fd6e3c2235ada$var$$('<div/>').css({
            width: 1,
            height: 1,
            overflow: 'hidden',
            clear: 'both'
        }).append(clonedTable);
        inserted.insertBefore(dt.table().node());
        // The cloned table now contains the smallest that each column can be
        emptyRow.children().each(function(i) {
            var idx = dt.column.index('fromVisible', i);
            columns[idx].minWidth = this.offsetWidth || 0;
        });
        inserted.remove();
    },
    /**
	 * Get the state of the current hidden columns - controlled by Responsive only
	 */ _responsiveOnlyHidden: function() {
        var dt = this.s.dt;
        return $7a0fd6e3c2235ada$var$$.map(this.s.current, function(v, i) {
            // If the column is hidden by DataTables then it can't be hidden by
            // Responsive!
            if (dt.column(i).visible() === false) return true;
            return v;
        });
    },
    /**
	 * Set a column's visibility.
	 *
	 * We don't use DataTables' column visibility controls in order to ensure
	 * that column visibility can Responsive can no-exist. Since only IE8+ is
	 * supported (and all evergreen browsers of course) the control of the
	 * display attribute works well.
	 *
	 * @param {integer} col      Column index
	 * @param {boolean} showHide Show or hide (true or false)
	 * @private
	 */ _setColumnVis: function(col, showHide) {
        var that = this;
        var dt = this.s.dt;
        var display = showHide ? '' : 'none'; // empty string will remove the attr
        this._setHeaderVis(col, showHide, dt.table().header.structure());
        this._setHeaderVis(col, showHide, dt.table().footer.structure());
        dt.column(col).nodes().to$().css('display', display).toggleClass('dtr-hidden', !showHide);
        // We need to set a variable that DT can use when selecting visible
        // columns without needing to query the DOM
        dt.settings()[0].aoColumns[col].responsiveVisible = showHide;
        // If the are child nodes stored, we might need to reinsert them
        if (!$7a0fd6e3c2235ada$var$$.isEmptyObject(this.s.childNodeStore)) dt.cells(null, col).indexes().each(function(idx) {
            that._childNodesRestore(dt, idx.row, idx.column);
        });
    },
    /**
	 * Set a column's visibility, taking into account multiple rows
	 * in a header / footer and colspan attributes
	 * @param {*} col
	 * @param {*} showHide
	 * @param {*} structure
	 */ _setHeaderVis: function(col, showHide, structure) {
        var that = this;
        var display = showHide ? '' : 'none';
        // We use the `null`s in the structure array to indicate that a cell
        // should expand over that one if there is a colspan, but it might
        // also have been filled by a rowspan, so we need to expand the
        // rowspan cells down through the structure
        structure.forEach(function(row, rowIdx) {
            for(var col = 0; col < row.length; col++)if (row[col] && row[col].rowspan > 1) {
                var span = row[col].rowspan;
                for(var i = 1; i < span; i++)structure[rowIdx + i][col] = {};
            }
        });
        structure.forEach(function(row) {
            if (row[col] && row[col].cell) $7a0fd6e3c2235ada$var$$(row[col].cell).css('display', display).toggleClass('dtr-hidden', !showHide);
            else {
                // In a colspan - need to rewind calc the new span since
                // display:none elements do not count as being spanned over
                var search = col;
                while(search >= 0){
                    if (row[search] && row[search].cell) {
                        row[search].cell.colSpan = that._colspan(row, search);
                        break;
                    }
                    search--;
                }
            }
        });
    },
    /**
	 * How many columns should this cell span
	 *
	 * @param {*} row Header structure row
	 * @param {*} idx The column index of the cell to span
	 */ _colspan: function(row, idx) {
        var colspan = 1;
        for(var col = idx + 1; col < row.length; col++){
            if (row[col] === null && this.s.current[col]) // colspan and not hidden by Responsive
            colspan++;
            else if (row[col]) break;
        }
        return colspan;
    },
    /**
	 * Update the cell tab indexes for keyboard accessibility. This is called on
	 * every table draw - that is potentially inefficient, but also the least
	 * complex option given that column visibility can change on the fly. Its a
	 * shame user-focus was removed from CSS 3 UI, as it would have solved this
	 * issue with a single CSS statement.
	 *
	 * @private
	 */ _tabIndexes: function() {
        var dt = this.s.dt;
        var cells = dt.cells({
            page: 'current'
        }).nodes().to$();
        var ctx = dt.settings()[0];
        var target = this.c.details.target;
        cells.filter('[data-dtr-keyboard]').removeData('[data-dtr-keyboard]');
        if (typeof target === 'number') dt.cells(null, target, {
            page: 'current'
        }).nodes().to$().attr('tabIndex', ctx.iTabIndex).data('dtr-keyboard', 1);
        else {
            // This is a bit of a hack - we need to limit the selected nodes to just
            // those of this table
            if (target === 'td:first-child, th:first-child') target = '>td:first-child, >th:first-child';
            var rows = dt.rows({
                page: 'current'
            }).nodes();
            var nodes = target === 'tr' ? $7a0fd6e3c2235ada$var$$(rows) : $7a0fd6e3c2235ada$var$$(target, rows);
            nodes.attr('tabIndex', ctx.iTabIndex).data('dtr-keyboard', 1);
        }
    }
});
/**
 * List of default breakpoints. Each item in the array is an object with two
 * properties:
 *
 * * `name` - the breakpoint name.
 * * `width` - the breakpoint width
 *
 * @name Responsive.breakpoints
 * @static
 */ $7a0fd6e3c2235ada$var$Responsive.breakpoints = [
    {
        name: 'desktop',
        width: Infinity
    },
    {
        name: 'tablet-l',
        width: 1024
    },
    {
        name: 'tablet-p',
        width: 768
    },
    {
        name: 'mobile-l',
        width: 480
    },
    {
        name: 'mobile-p',
        width: 320
    }
];
/**
 * Display methods - functions which define how the hidden data should be shown
 * in the table.
 *
 * @namespace
 * @name Responsive.defaults
 * @static
 */ $7a0fd6e3c2235ada$var$Responsive.display = {
    childRow: function(row, update, render) {
        var rowNode = $7a0fd6e3c2235ada$var$$(row.node());
        if (update) {
            if (rowNode.hasClass('dtr-expanded')) {
                row.child(render(), 'child').show();
                return true;
            }
        } else if (!rowNode.hasClass('dtr-expanded')) {
            var rendered = render();
            if (rendered === false) return false;
            row.child(rendered, 'child').show();
            return true;
        } else {
            row.child(false);
            return false;
        }
    },
    childRowImmediate: function(row, update, render) {
        var rowNode = $7a0fd6e3c2235ada$var$$(row.node());
        if (!update && rowNode.hasClass('dtr-expanded') || !row.responsive.hasHidden()) {
            // User interaction and the row is show, or nothing to show
            row.child(false);
            return false;
        } else {
            // Display
            var rendered = render();
            if (rendered === false) return false;
            row.child(rendered, 'child').show();
            return true;
        }
    },
    // This is a wrapper so the modal options for Bootstrap and jQuery UI can
    // have options passed into them. This specific one doesn't need to be a
    // function but it is for consistency in the `modal` name
    modal: function(options) {
        return function(row, update, render, closeCallback) {
            var modal;
            var rendered = render();
            if (rendered === false) return false;
            if (!update) {
                // Show a modal
                var close = function() {
                    modal.remove(); // will tidy events for us
                    $7a0fd6e3c2235ada$var$$(document).off('keypress.dtr');
                    $7a0fd6e3c2235ada$var$$(row.node()).removeClass('dtr-expanded');
                    closeCallback();
                };
                modal = $7a0fd6e3c2235ada$var$$('<div class="dtr-modal"/>').append($7a0fd6e3c2235ada$var$$('<div class="dtr-modal-display"/>').append($7a0fd6e3c2235ada$var$$('<div class="dtr-modal-content"/>').data('dtr-row-idx', row.index()).append(rendered)).append($7a0fd6e3c2235ada$var$$('<div class="dtr-modal-close">&times;</div>').click(function() {
                    close();
                }))).append($7a0fd6e3c2235ada$var$$('<div class="dtr-modal-background"/>').click(function() {
                    close();
                })).appendTo('body');
                $7a0fd6e3c2235ada$var$$(row.node()).addClass('dtr-expanded');
                $7a0fd6e3c2235ada$var$$(document).on('keyup.dtr', function(e) {
                    if (e.keyCode === 27) {
                        e.stopPropagation();
                        close();
                    }
                });
            } else {
                modal = $7a0fd6e3c2235ada$var$$('div.dtr-modal-content');
                if (modal.length && row.index() === modal.data('dtr-row-idx')) modal.empty().append(rendered);
                else // Modal not shown, nothing to update
                return null;
            }
            if (options && options.header) $7a0fd6e3c2235ada$var$$('div.dtr-modal-content').prepend('<h2>' + options.header(row) + '</h2>');
            return true;
        };
    }
};
/**
 * Display methods - functions which define how the hidden data should be shown
 * in the table.
 *
 * @namespace
 * @name Responsive.defaults
 * @static
 */ $7a0fd6e3c2235ada$var$Responsive.renderer = {
    listHiddenNodes: function() {
        var fn = function(api, rowIdx, columns) {
            var that = this;
            var ul = $7a0fd6e3c2235ada$var$$('<ul data-dtr-index="' + rowIdx + '" class="dtr-details"/>');
            var found = false;
            $7a0fd6e3c2235ada$var$$.each(columns, function(i, col) {
                if (col.hidden) {
                    var klass = col.className ? 'class="' + col.className + '"' : '';
                    $7a0fd6e3c2235ada$var$$('<li ' + klass + ' data-dtr-index="' + col.columnIndex + '" data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' + '<span class="dtr-title">' + col.title + '</span> ' + '</li>').append($7a0fd6e3c2235ada$var$$('<span class="dtr-data"/>').append(that._childNodes(api, col.rowIndex, col.columnIndex))) // api.cell( col.rowIndex, col.columnIndex ).node().childNodes ) )
                    .appendTo(ul);
                    found = true;
                }
            });
            return found ? ul : false;
        };
        fn._responsiveMovesNodes = true;
        return fn;
    },
    listHidden: function() {
        return function(api, rowIdx, columns) {
            var data = $7a0fd6e3c2235ada$var$$.map(columns, function(col) {
                var klass = col.className ? 'class="' + col.className + '"' : '';
                return col.hidden ? '<li ' + klass + ' data-dtr-index="' + col.columnIndex + '" data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' + '<span class="dtr-title">' + col.title + '</span> ' + '<span class="dtr-data">' + col.data + '</span>' + '</li>' : '';
            }).join('');
            return data ? $7a0fd6e3c2235ada$var$$('<ul data-dtr-index="' + rowIdx + '" class="dtr-details"/>').append(data) : false;
        };
    },
    tableAll: function(options) {
        options = $7a0fd6e3c2235ada$var$$.extend({
            tableClass: ''
        }, options);
        return function(api, rowIdx, columns) {
            var data = $7a0fd6e3c2235ada$var$$.map(columns, function(col) {
                var klass = col.className ? 'class="' + col.className + '"' : '';
                return '<tr ' + klass + ' data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' + '<td>' + ('' !== col.title ? col.title + ':' : '') + '</td> ' + '<td>' + col.data + '</td>' + '</tr>';
            }).join('');
            return $7a0fd6e3c2235ada$var$$('<table class="' + options.tableClass + ' dtr-details" width="100%"/>').append(data);
        };
    }
};
/**
 * Responsive default settings for initialisation
 *
 * @namespace
 * @name Responsive.defaults
 * @static
 */ $7a0fd6e3c2235ada$var$Responsive.defaults = {
    /**
	 * List of breakpoints for the instance. Note that this means that each
	 * instance can have its own breakpoints. Additionally, the breakpoints
	 * cannot be changed once an instance has been creased.
	 *
	 * @type {Array}
	 * @default Takes the value of `Responsive.breakpoints`
	 */ breakpoints: $7a0fd6e3c2235ada$var$Responsive.breakpoints,
    /**
	 * Enable / disable auto hiding calculations. It can help to increase
	 * performance slightly if you disable this option, but all columns would
	 * need to have breakpoint classes assigned to them
	 *
	 * @type {Boolean}
	 * @default  `true`
	 */ auto: true,
    /**
	 * Details control. If given as a string value, the `type` property of the
	 * default object is set to that value, and the defaults used for the rest
	 * of the object - this is for ease of implementation.
	 *
	 * The object consists of the following properties:
	 *
	 * * `display` - A function that is used to show and hide the hidden details
	 * * `renderer` - function that is called for display of the child row data.
	 *   The default function will show the data from the hidden columns
	 * * `target` - Used as the selector for what objects to attach the child
	 *   open / close to
	 * * `type` - `false` to disable the details display, `inline` or `column`
	 *   for the two control types
	 *
	 * @type {Object|string}
	 */ details: {
        display: $7a0fd6e3c2235ada$var$Responsive.display.childRow,
        renderer: $7a0fd6e3c2235ada$var$Responsive.renderer.listHidden(),
        target: 0,
        type: 'inline'
    },
    /**
	 * Orthogonal data request option. This is used to define the data type
	 * requested when Responsive gets the data to show in the child row.
	 *
	 * @type {String}
	 */ orthogonal: 'display'
};
/*
 * API
 */ var $7a0fd6e3c2235ada$var$Api = $7a0fd6e3c2235ada$var$$.fn.dataTable.Api;
// Doesn't do anything - workaround for a bug in DT... Not documented
$7a0fd6e3c2235ada$var$Api.register('responsive()', function() {
    return this;
});
$7a0fd6e3c2235ada$var$Api.register('responsive.index()', function(li) {
    li = $7a0fd6e3c2235ada$var$$(li);
    return {
        column: li.data('dtr-index'),
        row: li.parent().data('dtr-index')
    };
});
$7a0fd6e3c2235ada$var$Api.register('responsive.rebuild()', function() {
    return this.iterator('table', function(ctx) {
        if (ctx._responsive) ctx._responsive._classLogic();
    });
});
$7a0fd6e3c2235ada$var$Api.register('responsive.recalc()', function() {
    return this.iterator('table', function(ctx) {
        if (ctx._responsive) {
            ctx._responsive._resizeAuto();
            ctx._responsive._resize();
        }
    });
});
$7a0fd6e3c2235ada$var$Api.register('responsive.hasHidden()', function() {
    var ctx = this.context[0];
    return ctx._responsive ? $7a0fd6e3c2235ada$var$$.inArray(false, ctx._responsive._responsiveOnlyHidden()) !== -1 : false;
});
$7a0fd6e3c2235ada$var$Api.registerPlural('columns().responsiveHidden()', 'column().responsiveHidden()', function() {
    return this.iterator('column', function(settings, column) {
        return settings._responsive ? settings._responsive._responsiveOnlyHidden()[column] : false;
    }, 1);
});
/**
 * Version information
 *
 * @name Responsive.version
 * @static
 */ $7a0fd6e3c2235ada$var$Responsive.version = '3.0.8';
$7a0fd6e3c2235ada$var$$.fn.dataTable.Responsive = $7a0fd6e3c2235ada$var$Responsive;
$7a0fd6e3c2235ada$var$$.fn.DataTable.Responsive = $7a0fd6e3c2235ada$var$Responsive;
// Attach a listener to the document which listens for DataTables initialisation
// events so we can automatically initialise
$7a0fd6e3c2235ada$var$$(document).on('preInit.dt.dtr', function(e, settings, json) {
    if (e.namespace !== 'dt') return;
    if ($7a0fd6e3c2235ada$var$$(settings.nTable).hasClass('responsive') || $7a0fd6e3c2235ada$var$$(settings.nTable).hasClass('dt-responsive') || settings.oInit.responsive || (0, $63jfO.default).defaults.responsive) {
        var init = settings.oInit.responsive;
        if (init !== false) new $7a0fd6e3c2235ada$var$Responsive(settings, $7a0fd6e3c2235ada$var$$.isPlainObject(init) ? init : {});
    }
});
var $7a0fd6e3c2235ada$export$2e2bcd8739ae039 = (0, $63jfO.default);


// Allow reassignment of the $ variable
let $d7c629cbe244fb5b$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
var $d7c629cbe244fb5b$var$_display = (0, $lJx7k.default).Responsive.display;
var $d7c629cbe244fb5b$var$_original = $d7c629cbe244fb5b$var$_display.modal;
var $d7c629cbe244fb5b$var$_modal = $d7c629cbe244fb5b$var$$('<div class="modal fade dtr-bs-modal" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"/></div></div></div>');
$d7c629cbe244fb5b$var$_display.modal = function(options) {
    return function(row, update, render, closeCallback) {
        if (!$d7c629cbe244fb5b$var$$.fn.modal) return $d7c629cbe244fb5b$var$_original(row, update, render, closeCallback);
        else {
            var rendered = render();
            if (rendered === false) return false;
            if (!update) {
                if (options && options.header) {
                    var header = $d7c629cbe244fb5b$var$_modal.find('div.modal-header');
                    var button = header.find('button').detach();
                    header.empty().append('<h4 class="modal-title">' + options.header(row) + '</h4>').append(button);
                }
                $d7c629cbe244fb5b$var$_modal.find('div.modal-body').empty().append(rendered);
                $d7c629cbe244fb5b$var$_modal.data('dtr-row-idx', row.index()).one('hidden.bs.modal', closeCallback).appendTo('body').modal();
            } else {
                if ($d7c629cbe244fb5b$var$$.contains(document, $d7c629cbe244fb5b$var$_modal[0]) && row.index() === $d7c629cbe244fb5b$var$_modal.data('dtr-row-idx')) $d7c629cbe244fb5b$var$_modal.find('div.modal-body').empty().append(rendered);
                else // Modal not shown - do nothing
                return null;
            }
            return true;
        }
    };
};
var $d7c629cbe244fb5b$export$2e2bcd8739ae039 = (0, $lJx7k.default);


var $7a8eefcb5eec2d19$exports = {};



/*!
 * HTML5 export buttons for Buttons and DataTables.
 * © SpryMedia Ltd - datatables.net/license
 *
 * FileSaver.js (1.3.3) - MIT license
 * Copyright © 2016 Eli Grey - http://eligrey.com
 */ (function(factory) {
    if (typeof define === 'function' && define.amd) // AMD
    define([
        'jquery',
        'datatables.net',
        'datatables.net-buttons'
    ], function($) {
        return factory($, window, document);
    });
    else {
        // CommonJS
        var jq = (parcelRequire("iUSsr"));
        var cjsRequires = function(root, $) {
            if (!$.fn.dataTable) (parcelRequire("63jfO"))(root, $);
            if (!$.fn.dataTable.Buttons) (parcelRequire("eAhT0"))(root, $);
        };
        if (typeof window === 'undefined') $7a8eefcb5eec2d19$exports = function(root, $) {
            if (!root) // CommonJS environments without a window global must pass a
            // root. This will give an error otherwise
            root = window;
            if (!$) $ = jq(root);
            cjsRequires(root, $);
            return factory($, root, root.document);
        };
        else {
            cjsRequires(window, jq);
            $7a8eefcb5eec2d19$exports = factory(jq, window, window.document);
        }
    }
})(function($, window1, document1) {
    'use strict';
    var DataTable = $.fn.dataTable;
    // Allow the constructor to pass in JSZip and PDFMake from external requires.
    // Otherwise, use globally defined variables, if they are available.
    var useJszip;
    var usePdfmake;
    function _jsZip() {
        return useJszip || window1.JSZip;
    }
    function _pdfMake() {
        return usePdfmake || window1.pdfMake;
    }
    DataTable.Buttons.pdfMake = function(_) {
        if (!_) return _pdfMake();
        usePdfmake = _;
    };
    DataTable.Buttons.jszip = function(_) {
        if (!_) return _jsZip();
        useJszip = _;
    };
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * FileSaver.js dependency
 */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ var _saveAs = function(view) {
        'use strict';
        // IE <10 is explicitly unsupported
        if (typeof view === 'undefined' || typeof navigator !== 'undefined' && /MSIE [1-9]\./.test(navigator.userAgent)) return;
        var doc = view.document, // only get URL when necessary in case Blob.js hasn't overridden it yet
        get_URL = function() {
            return view.URL || view.webkitURL || view;
        }, save_link = doc.createElementNS('http://www.w3.org/1999/xhtml', 'a'), can_use_save_link = 'download' in save_link, click = function(node) {
            var event = new MouseEvent('click');
            node.dispatchEvent(event);
        }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
            (view.setImmediate || view.setTimeout)(function() {
                throw ex;
            }, 0);
        }, force_saveable_type = 'application/octet-stream', // the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
        arbitrary_revoke_timeout = 40000, revoke = function(file) {
            var revoker = function() {
                if (typeof file === 'string') // file is an object URL
                get_URL().revokeObjectURL(file);
                else // file is a File
                file.remove();
            };
            setTimeout(revoker, arbitrary_revoke_timeout);
        }, dispatch = function(filesaver, event_types, event) {
            event_types = [].concat(event_types);
            var i = event_types.length;
            while(i--){
                var listener = filesaver['on' + event_types[i]];
                if (typeof listener === 'function') try {
                    listener.call(filesaver, event || filesaver);
                } catch (ex) {
                    throw_outside(ex);
                }
            }
        }, auto_bom = function(blob) {
            // prepend BOM for UTF-8 XML and text/* types (including HTML)
            // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
            if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
                String.fromCharCode(0xfeff),
                blob
            ], {
                type: blob.type
            });
            return blob;
        }, FileSaver = function(blob, name, no_auto_bom) {
            if (!no_auto_bom) blob = auto_bom(blob);
            // First try a.download, then web filesystem, then object URLs
            var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
                dispatch(filesaver, 'writestart progress write writeend'.split(' '));
            }, // on any filesys errors revert to saving with object URLs
            fs_error = function() {
                if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                    // Safari doesn't allow downloading of blob urls
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                        var popup = view.open(url, '_blank');
                        if (!popup) view.location.href = url;
                        url = undefined; // release reference before dispatching
                        filesaver.readyState = filesaver.DONE;
                        dispatch_all();
                    };
                    reader.readAsDataURL(blob);
                    filesaver.readyState = filesaver.INIT;
                    return;
                }
                // don't create more object URLs than needed
                if (!object_url) object_url = get_URL().createObjectURL(blob);
                if (force) view.location.href = object_url;
                else {
                    var opened = view.open(object_url, '_blank');
                    if (!opened) // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                    view.location.href = object_url;
                }
                filesaver.readyState = filesaver.DONE;
                dispatch_all();
                revoke(object_url);
            };
            filesaver.readyState = filesaver.INIT;
            if (can_use_save_link) {
                object_url = get_URL().createObjectURL(blob);
                setTimeout(function() {
                    save_link.href = object_url;
                    save_link.download = name;
                    click(save_link);
                    dispatch_all();
                    revoke(object_url);
                    filesaver.readyState = filesaver.DONE;
                });
                return;
            }
            fs_error();
        }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
            return new FileSaver(blob, name || blob.name || 'download', no_auto_bom);
        };
        // IE 10+ (native saveAs)
        if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
            name = name || blob.name || 'download';
            if (!no_auto_bom) blob = auto_bom(blob);
            return navigator.msSaveOrOpenBlob(blob, name);
        };
        FS_proto.abort = function() {};
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;
        FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
        return saveAs;
    }(typeof self !== 'undefined' && self || typeof window1 !== 'undefined' && window1 || this.content);
    // Expose file saver on the DataTables API. Can't attach to `DataTables.Buttons`
    // since this file can be loaded before Button's core!
    DataTable.fileSave = _saveAs;
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Local (private) functions
 */ /**
 * Get the sheet name for Excel exports.
 *
 * @param {object}	config Button configuration
 */ var _sheetname = function(config) {
        var sheetName = 'Sheet1';
        if (config.sheetName) sheetName = config.sheetName.replace(/[\[\]\*\/\\\?\:]/g, '');
        return sheetName;
    };
    /**
 * Get the newline character(s)
 *
 * @param {object}	config Button configuration
 * @return {string}				Newline character
 */ var _newLine = function(config) {
        return config.newline ? config.newline : navigator.userAgent.match(/Windows/) ? '\r\n' : '\n';
    };
    /**
 * Combine the data from the `buttons.exportData` method into a string that
 * will be used in the export file.
 *
 * @param	{DataTable.Api} dt		 DataTables API instance
 * @param	{object}				config Button configuration
 * @return {object}							 The data to export
 */ var _exportData = function(dt, config) {
        var newLine = _newLine(config);
        var data = dt.buttons.exportData(config.exportOptions);
        var boundary = config.fieldBoundary;
        var separator = config.fieldSeparator;
        var reBoundary = new RegExp(boundary, 'g');
        var escapeChar = config.escapeChar !== undefined ? config.escapeChar : '\\';
        var join = function(a) {
            var s = '';
            // If there is a field boundary, then we might need to escape it in
            // the source data
            for(var i = 0, ien = a.length; i < ien; i++){
                if (i > 0) s += separator;
                s += boundary ? boundary + ('' + a[i]).replace(reBoundary, escapeChar + boundary) + boundary : a[i];
            }
            return s;
        };
        var header = '';
        var footer = '';
        var body = [];
        if (config.header) header = data.headerStructure.map(function(row) {
            return join(row.map(function(cell) {
                return cell ? cell.title : '';
            }));
        }).join(newLine) + newLine;
        if (config.footer && data.footer) footer = data.footerStructure.map(function(row) {
            return join(row.map(function(cell) {
                return cell ? cell.title : '';
            }));
        }).join(newLine) + newLine;
        for(var i = 0, ien = data.body.length; i < ien; i++)body.push(join(data.body[i]));
        return {
            str: header + body.join(newLine) + newLine + footer,
            rows: body.length
        };
    };
    /**
 * Older versions of Safari (prior to tech preview 18) don't support the
 * download option required.
 *
 * @return {Boolean} `true` if old Safari
 */ var _isDuffSafari = function() {
        var safari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 && navigator.userAgent.indexOf('Opera') === -1;
        if (!safari) return false;
        var version = navigator.userAgent.match(/AppleWebKit\/(\d+\.\d+)/);
        if (version && version.length > 1 && version[1] * 1 < 603.1) return true;
        return false;
    };
    /**
 * Convert from numeric position to letter for column names in Excel
 * @param  {int} n Column number
 * @return {string} Column letter(s) name
 */ function createCellPos(n) {
        var ordA = 'A'.charCodeAt(0);
        var ordZ = 'Z'.charCodeAt(0);
        var len = ordZ - ordA + 1;
        var s = '';
        while(n >= 0){
            s = String.fromCharCode(n % len + ordA) + s;
            n = Math.floor(n / len) - 1;
        }
        return s;
    }
    try {
        var _serialiser = new XMLSerializer();
        var _ieExcel;
    } catch (t) {
    // noop
    }
    /**
 * Recursively add XML files from an object's structure to a ZIP file. This
 * allows the XSLX file to be easily defined with an object's structure matching
 * the files structure.
 *
 * @param {JSZip} zip ZIP package
 * @param {object} obj Object to add (recursive)
 */ function _addToZip(zip, obj) {
        if (_ieExcel === undefined) // Detect if we are dealing with IE's _awful_ serialiser by seeing if it
        // drop attributes
        _ieExcel = _serialiser.serializeToString(new window1.DOMParser().parseFromString(excelStrings['xl/worksheets/sheet1.xml'], 'text/xml')).indexOf('xmlns:r') === -1;
        $.each(obj, function(name, val) {
            if ($.isPlainObject(val)) {
                var newDir = zip.folder(name);
                _addToZip(newDir, val);
            } else {
                if (_ieExcel) {
                    // IE's XML serialiser will drop some name space attributes from
                    // from the root node, so we need to save them. Do this by
                    // replacing the namespace nodes with a regular attribute that
                    // we convert back when serialised. Edge does not have this
                    // issue
                    var worksheet = val.childNodes[0];
                    var i, ien;
                    var attrs = [];
                    for(i = worksheet.attributes.length - 1; i >= 0; i--){
                        var attrName = worksheet.attributes[i].nodeName;
                        var attrValue = worksheet.attributes[i].nodeValue;
                        if (attrName.indexOf(':') !== -1) {
                            attrs.push({
                                name: attrName,
                                value: attrValue
                            });
                            worksheet.removeAttribute(attrName);
                        }
                    }
                    for(i = 0, ien = attrs.length; i < ien; i++){
                        var attr = val.createAttribute(attrs[i].name.replace(':', '_dt_b_namespace_token_'));
                        attr.value = attrs[i].value;
                        worksheet.setAttributeNode(attr);
                    }
                }
                var str = _serialiser.serializeToString(val);
                // Fix IE's XML
                if (_ieExcel) {
                    // IE doesn't include the XML declaration
                    if (str.indexOf('<?xml') === -1) str = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + str;
                    // Return namespace attributes to being as such
                    str = str.replace(/_dt_b_namespace_token_/g, ':');
                    // Remove testing name space that IE puts into the space preserve attr
                    str = str.replace(/xmlns:NS[\d]+="" NS[\d]+:/g, '');
                }
                // Safari, IE and Edge will put empty name space attributes onto
                // various elements making them useless. This strips them out
                str = str.replace(/<([^<>]*?) xmlns=""([^<>]*?)>/g, '<$1 $2>');
                zip.file(name, str);
            }
        });
    }
    /**
 * Create an XML node and add any children, attributes, etc without needing to
 * be verbose in the DOM.
 *
 * @param  {object} doc      XML document
 * @param  {string} nodeName Node name
 * @param  {object} opts     Options - can be `attr` (attributes), `children`
 *   (child nodes) and `text` (text content)
 * @return {node}            Created node
 */ function _createNode(doc, nodeName, opts) {
        var tempNode = doc.createElement(nodeName);
        if (opts) {
            if (opts.attr) $(tempNode).attr(opts.attr);
            if (opts.children) $.each(opts.children, function(key, value) {
                tempNode.appendChild(value);
            });
            if (opts.text !== null && opts.text !== undefined) tempNode.appendChild(doc.createTextNode(opts.text));
        }
        return tempNode;
    }
    /**
 * Get the width for an Excel column based on the contents of that column
 * @param  {object} data Data for export
 * @param  {int}    col  Column index
 * @return {int}         Column width
 */ function _excelColWidth(data, col) {
        var max = data.header[col].length;
        var len, lineSplit, str;
        if (data.footer && data.footer[col] && data.footer[col].length > max) max = data.footer[col].length;
        for(var i = 0, ien = data.body.length; i < ien; i++){
            var point = data.body[i][col];
            str = point !== null && point !== undefined ? point.toString() : '';
            // If there is a newline character, workout the width of the column
            // based on the longest line in the string
            if (str.indexOf('\n') !== -1) {
                lineSplit = str.split('\n');
                lineSplit.sort(function(a, b) {
                    return b.length - a.length;
                });
                len = lineSplit[0].length;
            } else len = str.length;
            if (len > max) max = len;
            // Max width rather than having potentially massive column widths
            if (max > 40) return 54; // 40 * 1.35
        }
        max *= 1.35;
        // And a min width
        return max > 6 ? max : 6;
    }
    // Excel - Pre-defined strings to build a basic XLSX file
    var excelStrings = {
        '_rels/.rels': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>',
        'xl/_rels/workbook.xml.rels': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>',
        '[Content_Types].xml': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="xml" ContentType="application/xml" /><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" /><Default Extension="jpeg" ContentType="image/jpeg" /><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" /><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" /><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" /></Types>',
        'xl/workbook.xml': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="24816"/><workbookPr showInkAnnotation="0" autoCompressPictures="0"/><bookViews><workbookView xWindow="0" yWindow="0" windowWidth="25600" windowHeight="19020" tabRatio="500"/></bookViews><sheets><sheet name="Sheet1" sheetId="1" r:id="rId1"/></sheets><definedNames/></workbook>',
        'xl/worksheets/sheet1.xml': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"><sheetData/><mergeCells count="0"/></worksheet>',
        'xl/styles.xml': '<?xml version="1.0" encoding="UTF-8"?><styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"><numFmts count="6"><numFmt numFmtId="164" formatCode="[$$-409]#,##0.00;-[$$-409]#,##0.00"/><numFmt numFmtId="165" formatCode="&quot;\xa3&quot;#,##0.00"/><numFmt numFmtId="166" formatCode="[$\u20AC-2] #,##0.00"/><numFmt numFmtId="167" formatCode="0.0%"/><numFmt numFmtId="168" formatCode="#,##0;(#,##0)"/><numFmt numFmtId="169" formatCode="#,##0.00;(#,##0.00)"/></numFmts><fonts count="5" x14ac:knownFonts="1"><font><sz val="11" /><name val="Calibri" /></font><font><sz val="11" /><name val="Calibri" /><color rgb="FFFFFFFF" /></font><font><sz val="11" /><name val="Calibri" /><b /></font><font><sz val="11" /><name val="Calibri" /><i /></font><font><sz val="11" /><name val="Calibri" /><u /></font></fonts><fills count="6"><fill><patternFill patternType="none" /></fill><fill><patternFill patternType="none" /></fill><fill><patternFill patternType="solid"><fgColor rgb="FFD9D9D9" /><bgColor indexed="64" /></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FFD99795" /><bgColor indexed="64" /></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="ffc6efce" /><bgColor indexed="64" /></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="ffc6cfef" /><bgColor indexed="64" /></patternFill></fill></fills><borders count="2"><border><left /><right /><top /><bottom /><diagonal /></border><border diagonalUp="false" diagonalDown="false"><left style="thin"><color auto="1" /></left><right style="thin"><color auto="1" /></right><top style="thin"><color auto="1" /></top><bottom style="thin"><color auto="1" /></bottom><diagonal /></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" /></cellStyleXfs><cellXfs count="68"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="1" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="2" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="3" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="4" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1"><alignment horizontal="left"/></xf><xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1"><alignment horizontal="center"/></xf><xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1"><alignment horizontal="right"/></xf><xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1"><alignment horizontal="fill"/></xf><xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1"><alignment textRotation="90"/></xf><xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1"><alignment wrapText="1"/></xf><xf numFmtId="9"   fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="164" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="165" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="166" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="167" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="168" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="169" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="3" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="4" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="1" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="2" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/><xf numFmtId="14" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/></cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0" /></cellStyles><dxfs count="0" /><tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4" /></styleSheet>'
    };
    // Note we could use 3 `for` loops for the styles, but when gzipped there is
    // virtually no difference in size, since the above can be easily compressed
    // Pattern matching for special number formats. Perhaps this should be exposed
    // via an API in future?
    // Ref: section 3.8.30 - built in formatters in open spreadsheet
    //   https://www.ecma-international.org/news/TC45_current_work/Office%20Open%20XML%20Part%204%20-%20Markup%20Language%20Reference.pdf
    var _excelSpecials = [
        {
            match: /^\-?\d+\.\d%$/,
            style: 60,
            fmt: function(d) {
                return d / 100;
            }
        },
        {
            match: /^\-?\d+\.?\d*%$/,
            style: 56,
            fmt: function(d) {
                return d / 100;
            }
        },
        {
            match: /^\-?\$[\d,]+.?\d*$/,
            style: 57
        },
        {
            match: /^\-?£[\d,]+.?\d*$/,
            style: 58
        },
        {
            match: /^\-?€[\d,]+.?\d*$/,
            style: 59
        },
        {
            match: /^\-?\d+$/,
            style: 65
        },
        {
            match: /^\-?\d+\.\d{2}$/,
            style: 66
        },
        {
            match: /^\([\d,]+\)$/,
            style: 61,
            fmt: function(d) {
                return -1 * d.replace(/[\(\)]/g, '');
            }
        },
        {
            match: /^\([\d,]+\.\d{2}\)$/,
            style: 62,
            fmt: function(d) {
                return -1 * d.replace(/[\(\)]/g, '');
            }
        },
        {
            match: /^\-?[\d,]+$/,
            style: 63
        },
        {
            match: /^\-?[\d,]+\.\d{2}$/,
            style: 64
        },
        {
            match: /^(19\d\d|[2-9]\d\d\d)\-(0\d|1[012])\-[0123][\d]$/,
            style: 67,
            fmt: function(d) {
                return Math.round(25569 + Date.parse(d) / 86400000);
            }
        } //Date yyyy-mm-dd
    ];
    var _excelMergeCells = function(rels, row, column, rowspan, colspan) {
        var mergeCells = $('mergeCells', rels);
        mergeCells[0].appendChild(_createNode(rels, 'mergeCell', {
            attr: {
                ref: createCellPos(column) + row + ':' + createCellPos(column + colspan - 1) + (row + rowspan - 1)
            }
        }));
        mergeCells.attr('count', parseFloat(mergeCells.attr('count')) + 1);
    };
    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Buttons
 */ //
    // Copy to clipboard
    //
    DataTable.ext.buttons.copyHtml5 = {
        className: 'buttons-copy buttons-html5',
        text: function(dt) {
            return dt.i18n('buttons.copy', 'Copy');
        },
        action: function(e, dt, button, config, cb) {
            var exportData = _exportData(dt, config);
            var info = dt.buttons.exportInfo(config);
            var newline = _newLine(config);
            var output = exportData.str;
            var hiddenDiv = $('<div/>').css({
                height: 1,
                width: 1,
                overflow: 'hidden',
                position: 'fixed',
                top: 0,
                left: 0
            });
            if (info.title) output = info.title + newline + newline + output;
            if (info.messageTop) output = info.messageTop + newline + newline + output;
            if (info.messageBottom) output = output + newline + newline + info.messageBottom;
            if (config.customize) output = config.customize(output, config, dt);
            var textarea = $('<textarea readonly/>').val(output).appendTo(hiddenDiv);
            // For browsers that support the copy execCommand, try to use it
            if (document1.queryCommandSupported('copy')) {
                hiddenDiv.appendTo(dt.table().container());
                textarea[0].focus();
                textarea[0].select();
                try {
                    var successful = document1.execCommand('copy');
                    hiddenDiv.remove();
                    if (successful) {
                        if (config.copySuccess) dt.buttons.info(dt.i18n('buttons.copyTitle', 'Copy to clipboard'), dt.i18n('buttons.copySuccess', {
                            1: 'Copied one row to clipboard',
                            _: 'Copied %d rows to clipboard'
                        }, exportData.rows), 2000);
                        cb();
                        return;
                    }
                } catch (t) {
                // noop
                }
            }
            // Otherwise we show the text box and instruct the user to use it
            var message = $('<span>' + dt.i18n('buttons.copyKeys', "Press <i>ctrl</i> or <i>\u2318</i> + <i>C</i> to copy the table data<br>to your system clipboard.<br><br>To cancel, click this message or press escape.") + '</span>').append(hiddenDiv);
            dt.buttons.info(dt.i18n('buttons.copyTitle', 'Copy to clipboard'), message, 0);
            // Select the text so when the user activates their system clipboard
            // it will copy that text
            textarea[0].focus();
            textarea[0].select();
            // Event to hide the message when the user is done
            var container = $(message).closest('.dt-button-info');
            var close = function() {
                container.off('click.buttons-copy');
                $(document1).off('.buttons-copy');
                dt.buttons.info(false);
            };
            container.on('click.buttons-copy', function() {
                close();
                cb();
            });
            $(document1).on('keydown.buttons-copy', function(e) {
                if (e.keyCode === 27) {
                    // esc
                    close();
                    cb();
                }
            }).on('copy.buttons-copy cut.buttons-copy', function() {
                close();
                cb();
            });
        },
        async: 100,
        copySuccess: true,
        exportOptions: {},
        fieldSeparator: '\t',
        fieldBoundary: '',
        header: true,
        footer: true,
        title: '*',
        messageTop: '*',
        messageBottom: '*'
    };
    //
    // CSV export
    //
    DataTable.ext.buttons.csvHtml5 = {
        bom: false,
        className: 'buttons-csv buttons-html5',
        available: function() {
            return window1.FileReader !== undefined && window1.Blob;
        },
        text: function(dt) {
            return dt.i18n('buttons.csv', 'CSV');
        },
        action: function(e, dt, button, config, cb) {
            // Set the text
            var output = _exportData(dt, config).str;
            var info = dt.buttons.exportInfo(config);
            var charset = config.charset;
            if (config.customize) output = config.customize(output, config, dt);
            if (charset !== false) {
                if (!charset) charset = document1.characterSet || document1.charset;
                if (charset) charset = ';charset=' + charset;
            } else charset = '';
            if (config.bom) output = String.fromCharCode(0xfeff) + output;
            _saveAs(new Blob([
                output
            ], {
                type: 'text/csv' + charset
            }), info.filename, true);
            cb();
        },
        async: 100,
        filename: '*',
        extension: '.csv',
        exportOptions: {
            escapeExcelFormula: true
        },
        fieldSeparator: ',',
        fieldBoundary: '"',
        escapeChar: '"',
        charset: null,
        header: true,
        footer: true
    };
    //
    // Excel (xlsx) export
    //
    DataTable.ext.buttons.excelHtml5 = {
        className: 'buttons-excel buttons-html5',
        available: function() {
            return window1.FileReader !== undefined && _jsZip() !== undefined && !_isDuffSafari() && _serialiser;
        },
        text: function(dt) {
            return dt.i18n('buttons.excel', 'Excel');
        },
        action: function(e, dt, button, config, cb) {
            var rowPos = 0;
            var dataStartRow, dataEndRow;
            var getXml = function(type) {
                var str = excelStrings[type];
                //str = str.replace( /xmlns:/g, 'xmlns_' ).replace( /mc:/g, 'mc_' );
                return $.parseXML(str);
            };
            var rels = getXml('xl/worksheets/sheet1.xml');
            var relsGet = rels.getElementsByTagName('sheetData')[0];
            var xlsx = {
                _rels: {
                    '.rels': getXml('_rels/.rels')
                },
                xl: {
                    _rels: {
                        'workbook.xml.rels': getXml('xl/_rels/workbook.xml.rels')
                    },
                    'workbook.xml': getXml('xl/workbook.xml'),
                    'styles.xml': getXml('xl/styles.xml'),
                    worksheets: {
                        'sheet1.xml': rels
                    }
                },
                '[Content_Types].xml': getXml('[Content_Types].xml')
            };
            var data = dt.buttons.exportData(config.exportOptions);
            var currentRow, rowNode;
            var addRow = function(row) {
                currentRow = rowPos + 1;
                rowNode = _createNode(rels, 'row', {
                    attr: {
                        r: currentRow
                    }
                });
                for(var i = 0, ien = row.length; i < ien; i++){
                    // Concat both the Cell Columns as a letter and the Row of the cell.
                    var cellId = createCellPos(i) + '' + currentRow;
                    var cell = null;
                    // For null, undefined of blank cell, continue so it doesn't create the _createNode
                    if (row[i] === null || row[i] === undefined || row[i] === '') {
                        if (config.createEmptyCells === true) row[i] = '';
                        else continue;
                    }
                    var originalContent = row[i];
                    row[i] = typeof row[i].trim === 'function' ? row[i].trim() : row[i];
                    // Special number formatting options
                    for(var j = 0, jen = _excelSpecials.length; j < jen; j++){
                        var special = _excelSpecials[j];
                        // TODO Need to provide the ability for the specials to say
                        // if they are returning a string, since at the moment it is
                        // assumed to be a number
                        if (row[i].match && !row[i].match(/^0\d+/) && row[i].match(special.match)) {
                            var val = row[i].replace(/[^\d\.\-]/g, '');
                            if (special.fmt) val = special.fmt(val);
                            cell = _createNode(rels, 'c', {
                                attr: {
                                    r: cellId,
                                    s: special.style
                                },
                                children: [
                                    _createNode(rels, 'v', {
                                        text: val
                                    })
                                ]
                            });
                            break;
                        }
                    }
                    if (!cell) {
                        if (typeof row[i] === 'number' || row[i].match && row[i].match(/^-?\d+(\.\d+)?([eE]\-?\d+)?$/) && // Includes exponential format
                        !row[i].match(/^0\d+/)) // Detect numbers - don't match numbers with leading zeros
                        // or a negative anywhere but the start
                        cell = _createNode(rels, 'c', {
                            attr: {
                                t: 'n',
                                r: cellId
                            },
                            children: [
                                _createNode(rels, 'v', {
                                    text: row[i]
                                })
                            ]
                        });
                        else {
                            // String output - replace non standard characters for text output
                            /*eslint no-control-regex: "off"*/ var text = !originalContent.replace ? originalContent : originalContent.replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '');
                            cell = _createNode(rels, 'c', {
                                attr: {
                                    t: 'inlineStr',
                                    r: cellId
                                },
                                children: {
                                    row: _createNode(rels, 'is', {
                                        children: {
                                            row: _createNode(rels, 't', {
                                                text: text,
                                                attr: {
                                                    'xml:space': 'preserve'
                                                }
                                            })
                                        }
                                    })
                                }
                            });
                        }
                    }
                    rowNode.appendChild(cell);
                }
                relsGet.appendChild(rowNode);
                rowPos++;
            };
            var addHeader = function(structure) {
                structure.forEach(function(row) {
                    addRow(row.map(function(cell) {
                        return cell ? cell.title : '';
                    }), rowPos);
                    $('row:last c', rels).attr('s', '2'); // bold
                    // Add any merge cells
                    row.forEach(function(cell, columnCounter) {
                        if (cell && (cell.colSpan > 1 || cell.rowSpan > 1)) _excelMergeCells(rels, rowPos, columnCounter, cell.rowSpan, cell.colSpan);
                    });
                });
            };
            // Title and top messages
            var exportInfo = dt.buttons.exportInfo(config);
            if (exportInfo.title) {
                addRow([
                    exportInfo.title
                ], rowPos);
                _excelMergeCells(rels, rowPos, 0, 1, data.header.length);
                $('row:last c', rels).attr('s', '51'); // centre
            }
            if (exportInfo.messageTop) {
                addRow([
                    exportInfo.messageTop
                ], rowPos);
                _excelMergeCells(rels, rowPos, 0, 1, data.header.length);
            }
            // Table header
            if (config.header) addHeader(data.headerStructure);
            dataStartRow = rowPos;
            // Table body
            for(var n = 0, ie = data.body.length; n < ie; n++)addRow(data.body[n], rowPos);
            dataEndRow = rowPos;
            // Table footer
            if (config.footer && data.footer) addHeader(data.footerStructure);
            // Below the table
            if (exportInfo.messageBottom) {
                addRow([
                    exportInfo.messageBottom
                ], rowPos);
                _excelMergeCells(rels, rowPos, 0, 1, data.header.length);
            }
            // Set column widths
            var cols = _createNode(rels, 'cols');
            $('worksheet', rels).prepend(cols);
            for(var i = 0, ien = data.header.length; i < ien; i++)cols.appendChild(_createNode(rels, 'col', {
                attr: {
                    min: i + 1,
                    max: i + 1,
                    width: _excelColWidth(data, i),
                    customWidth: 1
                }
            }));
            // Workbook modifications
            var workbook = xlsx.xl['workbook.xml'];
            $('sheets sheet', workbook).attr('name', _sheetname(config));
            // Auto filter for columns
            if (config.autoFilter) {
                $('mergeCells', rels).before(_createNode(rels, 'autoFilter', {
                    attr: {
                        ref: 'A' + dataStartRow + ':' + createCellPos(data.header.length - 1) + dataEndRow
                    }
                }));
                $('definedNames', workbook).append(_createNode(workbook, 'definedName', {
                    attr: {
                        name: '_xlnm._FilterDatabase',
                        localSheetId: '0',
                        hidden: 1
                    },
                    text: '\'' + _sheetname(config).replace(/'/g, '\'\'') + '\'!$A$' + dataStartRow + ':$' + createCellPos(data.header.length - 1) + '$' + dataEndRow
                }));
            }
            // Let the developer customise the document if they want to
            if (config.customize) config.customize(xlsx, config, dt);
            // Excel doesn't like an empty mergeCells tag
            if ($('mergeCells', rels).children().length === 0) $('mergeCells', rels).remove();
            var jszip = _jsZip();
            var zip = new jszip();
            var zipConfig = {
                compression: 'DEFLATE',
                type: 'blob',
                mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            };
            _addToZip(zip, xlsx);
            // Modern Excel has a 218 character limit on the file name + path of the file (why!?)
            // https://support.microsoft.com/en-us/office/excel-specifications-and-limits-1672b34d-7043-467e-8e27-269d656771c3
            // So we truncate to allow for this.
            var filename = exportInfo.filename;
            if (filename > 175) filename = filename.substr(0, 175);
            // Let the developer customize the final zip file if they want to before it is generated and sent to the browser
            if (config.customizeZip) config.customizeZip(zip, data, filename);
            if (zip.generateAsync) // JSZip 3+
            zip.generateAsync(zipConfig).then(function(blob) {
                _saveAs(blob, filename);
                cb();
            });
            else {
                // JSZip 2.5
                _saveAs(zip.generate(zipConfig), filename);
                cb();
            }
        },
        async: 100,
        filename: '*',
        extension: '.xlsx',
        exportOptions: {},
        header: true,
        footer: true,
        title: '*',
        messageTop: '*',
        messageBottom: '*',
        createEmptyCells: false,
        autoFilter: false,
        sheetName: ''
    };
    //
    // PDF export - using pdfMake - http://pdfmake.org
    //
    DataTable.ext.buttons.pdfHtml5 = {
        className: 'buttons-pdf buttons-html5',
        available: function() {
            return window1.FileReader !== undefined && _pdfMake();
        },
        text: function(dt) {
            return dt.i18n('buttons.pdf', 'PDF');
        },
        action: function(e, dt, button, config, cb) {
            var data = dt.buttons.exportData(config.exportOptions);
            var info = dt.buttons.exportInfo(config);
            var rows = [];
            if (config.header) data.headerStructure.forEach(function(row) {
                rows.push(row.map(function(cell) {
                    return cell ? {
                        text: cell.title,
                        colSpan: cell.colspan,
                        rowSpan: cell.rowspan,
                        style: 'tableHeader'
                    } : {};
                }));
            });
            for(var i = 0, ien = data.body.length; i < ien; i++)rows.push(data.body[i].map(function(d) {
                return {
                    text: d === null || d === undefined ? '' : typeof d === 'string' ? d : d.toString()
                };
            }));
            if (config.footer) data.footerStructure.forEach(function(row) {
                rows.push(row.map(function(cell) {
                    return cell ? {
                        text: cell.title,
                        colSpan: cell.colspan,
                        rowSpan: cell.rowspan,
                        style: 'tableFooter'
                    } : {};
                }));
            });
            var doc = {
                pageSize: config.pageSize,
                pageOrientation: config.orientation,
                content: [
                    {
                        style: 'table',
                        table: {
                            headerRows: config.header ? data.headerStructure.length : 0,
                            footerRows: config.footer // Used for styling, doesn't do anything in pdfmake
                             ? data.footerStructure.length : 0,
                            body: rows
                        },
                        layout: {
                            hLineWidth: function(i, node) {
                                if (i === 0 || i === node.table.body.length) return 0;
                                return 0.5;
                            },
                            vLineWidth: function() {
                                return 0;
                            },
                            hLineColor: function(i, node) {
                                return i === node.table.headerRows || i === node.table.body.length - node.table.footerRows ? '#333' : '#ddd';
                            },
                            fillColor: function(rowIndex) {
                                if (rowIndex < data.headerStructure.length) return '#fff';
                                return rowIndex % 2 === 0 ? '#f3f3f3' : null;
                            },
                            paddingTop: function() {
                                return 5;
                            },
                            paddingBottom: function() {
                                return 5;
                            }
                        }
                    }
                ],
                styles: {
                    tableHeader: {
                        bold: true,
                        fontSize: 11,
                        alignment: 'center'
                    },
                    tableFooter: {
                        bold: true,
                        fontSize: 11,
                        alignment: 'center'
                    },
                    table: {
                        margin: [
                            0,
                            5,
                            0,
                            5
                        ]
                    },
                    title: {
                        alignment: 'center',
                        fontSize: 13
                    },
                    message: {}
                },
                defaultStyle: {
                    fontSize: 10
                }
            };
            if (info.messageTop) doc.content.unshift({
                text: info.messageTop,
                style: 'message',
                margin: [
                    0,
                    0,
                    0,
                    12
                ]
            });
            if (info.messageBottom) doc.content.push({
                text: info.messageBottom,
                style: 'message',
                margin: [
                    0,
                    0,
                    0,
                    12
                ]
            });
            if (info.title) doc.content.unshift({
                text: info.title,
                style: 'title',
                margin: [
                    0,
                    0,
                    0,
                    12
                ]
            });
            if (config.customize) config.customize(doc, config, dt);
            var pdf = _pdfMake().createPdf(doc);
            if (config.download === 'open' && !_isDuffSafari()) pdf.open();
            else pdf.download(info.filename);
            cb();
        },
        async: 100,
        title: '*',
        filename: '*',
        extension: '.pdf',
        exportOptions: {},
        orientation: 'portrait',
        // This isn't perfect, but it is close
        pageSize: navigator.language === 'en-US' || navigator.language === 'en-CA' ? 'LETTER' : 'A4',
        header: true,
        footer: true,
        messageTop: '*',
        messageBottom: '*',
        customize: null,
        download: 'download'
    };
    return DataTable;
});




const $eee63e0b98919cae$var$SunsetSunrise7 = [
    "#33608c",
    "#9768a5",
    "#e7718a",
    "#f6ba57",
    "#ed7846",
    "#d54c45",
    "#b81840"
];
const $eee63e0b98919cae$var$HueCircle19 = [
    "#1ba3c6",
    "#2cb5c0",
    "#30bcad",
    "#21B087",
    "#33a65c",
    "#57a337",
    "#a2b627",
    "#d5bb21",
    "#f8b620",
    "#f89217",
    "#f06719",
    "#e03426",
    "#f64971",
    "#fc719e",
    "#eb73b3",
    "#ce69be",
    "#a26dc2",
    "#7873c0",
    "#4f7cba"
];
const $eee63e0b98919cae$var$PRGn10 = [
    "#40004b",
    "#762a83",
    "#9970ab",
    "#c2a5cf",
    "#e7d4e8",
    "#d9f0d3",
    "#a6dba0",
    "#5aae61",
    "#1b7837",
    "#00441b"
];
// Initialize Chartkick
(0, $el0Ud.default).options = {
    colors: $eee63e0b98919cae$var$SunsetSunrise7,
    maintainAspectRatio: false,
    donut: true
};
// Initialize DataTables
// DataTables();
// DataTablesButtons();
// DataTablesResponsive();
// DataTablesButtonsHtml5();
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).extend(true, (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).fn.dataTable.defaults, {
    dom: "Bfrtip",
    searching: false,
    responsive: true,
    paging: false,
    info: false,
    buttons: [
        {
            extend: "csv",
            text: "Scarica i dati in formato CSV",
            className: "btn btn-secondary float-end btn-sm"
        }
    ]
});
// Quote di mercato
new (0, $el0Ud.default).PieChart("quote-mercato", "/get_stat/stats_quote_mercato/", {
    legend: "left"
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-quote-mercato").DataTable({
    ajax: {
        url: "/get_stat/stats_quote_mercato/",
        dataSrc: ""
    }
});
// Utenti registrati
new (0, $el0Ud.default).BarChart("utenti", "/get_stat/stats_utenti/");
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-utenti").DataTable({
    ajax: {
        url: "/get_stat/stats_utenti/",
        dataSrc: ""
    },
    columns: [
        {
            data: "name"
        },
        {
            data: "data.Utenti"
        }
    ]
});
new (0, $el0Ud.default).LineChart("andamento-mensile-registrazioni", "/get_stat/andamento_mensile_registrazioni/");
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-andamento-mensile-registrazioni").DataTable({
    ordering: false,
    ajax: {
        url: "/get_stat/andamento_mensile_registrazioni/",
        dataSrc: ""
    }
});
new (0, $el0Ud.default).PieChart("utenti-per-operatore", "/get_stat/utenti_per_operatore/", {
    legend: "left"
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-utenti-per-operatore").DataTable({
    ajax: {
        url: "/get_stat/utenti_per_operatore/",
        dataSrc: ""
    }
});
new (0, $el0Ud.default).BarChart("certificati", "/get_stat/stats_certificati/");
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-certificati").DataTable({
    ajax: {
        url: "/get_stat/stats_certificati/",
        dataSrc: ""
    },
    columns: [
        {
            data: "name"
        },
        {
            data: "data.Certificati"
        }
    ]
});
new (0, $el0Ud.default).LineChart("andamento-mensile-certificati", "/get_stat/andamento_mensile_certificati/");
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-andamento-mensile-certificati").DataTable({
    ordering: false,
    ajax: {
        url: "/get_stat/andamento_mensile_certificati/",
        dataSrc: ""
    }
});
new (0, $el0Ud.default).PieChart("certificati-per-operatore", "/get_stat/certificati_per_operatore/", {
    legend: "left"
});
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-certificati-per-operatore").DataTable({
    ajax: {
        url: "/get_stat/certificati_per_operatore/",
        dataSrc: ""
    }
});
new (0, $el0Ud.default).ColumnChart("certificati-per-provincia", "/get_stat/certificati_per_provincia/");
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-certificati-per-provincia").DataTable({
    ajax: {
        url: "/get_stat/certificati_per_provincia/",
        dataSrc: ""
    }
});
new (0, $el0Ud.default).ColumnChart("nemesys-per-provincia", "/get_stat/misure_nemesys_per_provincia/");
(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#table-nemesys-per-provincia").DataTable({
    ajax: {
        url: "/get_stat/misure_nemesys_per_provincia/",
        dataSrc: ""
    }
});

})();
//# sourceMappingURL=statistiche.js.map
